//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class HealthClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    health_Monitor(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/health/monitor";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHealth_Monitor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHealth_Monitor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processHealth_Monitor(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AcknowledgmentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    acknowledgment_PostDeliveryAcknowledgment(acknowledgmentDTO: AcknowledgmentDTO): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/acknowledgment/delivery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(acknowledgmentDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcknowledgment_PostDeliveryAcknowledgment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcknowledgment_PostDeliveryAcknowledgment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAcknowledgment_PostDeliveryAcknowledgment(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    acknowledgment_PostPickupAcknowledgment(acknowledgmentDTO: AcknowledgmentDTO): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/acknowledgment/pickup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(acknowledgmentDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcknowledgment_PostPickupAcknowledgment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcknowledgment_PostPickupAcknowledgment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAcknowledgment_PostPickupAcknowledgment(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AuditClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    audit_AddAuditEvents(audit: AddAuditEventStoreDTO): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/audit/auditevents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(audit);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAudit_AddAuditEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAudit_AddAuditEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAudit_AddAuditEvents(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Download Asset Placard
     */
    audit_DownloadPlacard(assetId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/audit/{assetId}/downloadplacard";
        if (assetId === undefined || assetId === null)
            throw new globalThis.Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAudit_DownloadPlacard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAudit_DownloadPlacard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAudit_DownloadPlacard(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Get Audit Temperature Variance Reasons
     */
    audit_GetVarianceReasons(): Observable<AuditVarianceReason[]> {
        let url_ = this.baseUrl + "/api/v2/audit/variancereasons";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAudit_GetVarianceReasons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAudit_GetVarianceReasons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditVarianceReason[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditVarianceReason[]>;
        }));
    }

    protected processAudit_GetVarianceReasons(response: HttpResponseBase): Observable<AuditVarianceReason[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuditVarianceReason.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param customerId (optional) 
     * @return Get Customer Schedules
     */
    audit_GetAuditSchedules(customerId: string | null | undefined): Observable<AuditSchedule[]> {
        let url_ = this.baseUrl + "/api/v2/audit/schedules?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAudit_GetAuditSchedules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAudit_GetAuditSchedules(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditSchedule[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditSchedule[]>;
        }));
    }

    protected processAudit_GetAuditSchedules(response: HttpResponseBase): Observable<AuditSchedule[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuditSchedule.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param assetId (optional) 
     * @return Get Asset Trailer Summary
     */
    audit_GetTrailerSummary(assetId: number | undefined): Observable<TrailerSummaryDTO> {
        let url_ = this.baseUrl + "/api/v2/audit/trailersummary?";
        if (assetId === null)
            throw new globalThis.Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAudit_GetTrailerSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAudit_GetTrailerSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrailerSummaryDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrailerSummaryDTO>;
        }));
    }

    protected processAudit_GetTrailerSummary(response: HttpResponseBase): Observable<TrailerSummaryDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrailerSummaryDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Get Asset Trailer Summary
     */
    audit_GetTrailerSummaryByLocationID(locID: number): Observable<TrailerSummaryDTO[]> {
        let url_ = this.baseUrl + "/api/v2/audit/trailersummary-location/{locID}";
        if (locID === undefined || locID === null)
            throw new globalThis.Error("The parameter 'locID' must be defined.");
        url_ = url_.replace("{locID}", encodeURIComponent("" + locID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAudit_GetTrailerSummaryByLocationID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAudit_GetTrailerSummaryByLocationID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrailerSummaryDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrailerSummaryDTO[]>;
        }));
    }

    protected processAudit_GetTrailerSummaryByLocationID(response: HttpResponseBase): Observable<TrailerSummaryDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrailerSummaryDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    audit_GetStoreTrailerSettings(locID: number, assetID: number | null | undefined): Observable<StoreTrailerSettingsDTO[]> {
        let url_ = this.baseUrl + "/api/v2/audit/trailer-settings/{locID}?";
        if (locID === undefined || locID === null)
            throw new globalThis.Error("The parameter 'locID' must be defined.");
        url_ = url_.replace("{locID}", encodeURIComponent("" + locID));
        if (assetID !== undefined && assetID !== null)
            url_ += "assetID=" + encodeURIComponent("" + assetID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAudit_GetStoreTrailerSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAudit_GetStoreTrailerSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreTrailerSettingsDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreTrailerSettingsDTO[]>;
        }));
    }

    protected processAudit_GetStoreTrailerSettings(response: HttpResponseBase): Observable<StoreTrailerSettingsDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoreTrailerSettingsDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    audit_UpsertAuditAssetDetails(assetid: string, model: AuditAssetDetailDTO): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v2/audit/{assetid}/assetdetails";
        if (assetid === undefined || assetid === null)
            throw new globalThis.Error("The parameter 'assetid' must be defined.");
        url_ = url_.replace("{assetid}", encodeURIComponent("" + assetid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAudit_UpsertAuditAssetDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAudit_UpsertAuditAssetDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAudit_UpsertAuditAssetDetails(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param customerId (optional) 
     * @return Get Asset Trailer Summary
     */
    audit_GetTempRanges(customerId: string | null | undefined): Observable<AuditTempRange[]> {
        let url_ = this.baseUrl + "/api/v2/audit/tempranges?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAudit_GetTempRanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAudit_GetTempRanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditTempRange[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditTempRange[]>;
        }));
    }

    protected processAudit_GetTempRanges(response: HttpResponseBase): Observable<AuditTempRange[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuditTempRange.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    audit_PostStoreSchedule(data: LocationTrailerSetupRequestDTO): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/audit/store-schedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAudit_PostStoreSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAudit_PostStoreSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAudit_PostStoreSchedule(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CustomerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    customer_GetCustomer(id: string): Observable<StoreCustomerDTO> {
        let url_ = this.baseUrl + "/api/v2/customer/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomer_GetCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomer_GetCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreCustomerDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreCustomerDTO>;
        }));
    }

    protected processCustomer_GetCustomer(response: HttpResponseBase): Observable<StoreCustomerDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreCustomerDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customer_RequestInformation(activeLanguage: string | null | undefined, request: RequestInformationDTO): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/customer/requestinfo?";
        if (activeLanguage !== undefined && activeLanguage !== null)
            url_ += "activeLanguage=" + encodeURIComponent("" + activeLanguage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomer_RequestInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomer_RequestInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCustomer_RequestInformation(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customer_GetCustomerId(email: string): Observable<string> {
        let url_ = this.baseUrl + "/api/v2/customer/id/email/{email}";
        if (email === undefined || email === null)
            throw new globalThis.Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomer_GetCustomerId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomer_GetCustomerId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCustomer_GetCustomerId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customer_GetCustomersWithStorePortal(): Observable<StorePortalCustomerDTO[]> {
        let url_ = this.baseUrl + "/api/v2/customer/list/store-portal";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomer_GetCustomersWithStorePortal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomer_GetCustomersWithStorePortal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StorePortalCustomerDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StorePortalCustomerDTO[]>;
        }));
    }

    protected processCustomer_GetCustomersWithStorePortal(response: HttpResponseBase): Observable<StorePortalCustomerDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StorePortalCustomerDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customer_GetCustomerCategories(id: string): Observable<CustomerOrderCategory[]> {
        let url_ = this.baseUrl + "/api/v2/customer/order-categories/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomer_GetCustomerCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomer_GetCustomerCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerOrderCategory[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerOrderCategory[]>;
        }));
    }

    protected processCustomer_GetCustomerCategories(response: HttpResponseBase): Observable<CustomerOrderCategory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerOrderCategory.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DashboardClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    dashboard_GetDashboardOrderSummary2(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/dashboard/ordersummary2";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboard_GetDashboardOrderSummary2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboard_GetDashboardOrderSummary2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDashboard_GetDashboardOrderSummary2(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    dashboard_GetDashboardOrderDetails(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/dashboard/orderdetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboard_GetDashboardOrderDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboard_GetDashboardOrderDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDashboard_GetDashboardOrderDetails(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    dashboard_GetOrderDetails(start: Date | undefined, end: Date | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/dashboard/orderdetails2?";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new globalThis.Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboard_GetOrderDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboard_GetOrderDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDashboard_GetOrderDetails(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    dashboard_GetDashboardEmergencyDetails(start: Date | undefined, end: Date | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/dashboard/emergencydetails?";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new globalThis.Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboard_GetDashboardEmergencyDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboard_GetDashboardEmergencyDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDashboard_GetDashboardEmergencyDetails(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    dashboard_GetEmergencyAssetsByMonth(start: Date | undefined, end: Date | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/dashboard/emergenciesbymonth?";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new globalThis.Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboard_GetEmergencyAssetsByMonth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboard_GetEmergencyAssetsByMonth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDashboard_GetEmergencyAssetsByMonth(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    dashboard_GetEmergencyAssetsAverageDaysOnsite(start: Date | undefined, end: Date | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/dashboard/emergenciesdaysonsite?";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new globalThis.Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboard_GetEmergencyAssetsAverageDaysOnsite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboard_GetEmergencyAssetsAverageDaysOnsite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDashboard_GetEmergencyAssetsAverageDaysOnsite(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    dashboard_GetEmergencyAssetsTimeOfDay(start: Date | undefined, end: Date | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/dashboard/emergenciestimeofday?";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new globalThis.Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboard_GetEmergencyAssetsTimeOfDay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboard_GetEmergencyAssetsTimeOfDay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDashboard_GetEmergencyAssetsTimeOfDay(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    dashboard_GetEmergencyAssetsTimeOfDayByMonth(start: Date | undefined, end: Date | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/dashboard/emergenciestimeofdaybymonth?";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new globalThis.Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboard_GetEmergencyAssetsTimeOfDayByMonth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboard_GetEmergencyAssetsTimeOfDayByMonth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDashboard_GetEmergencyAssetsTimeOfDayByMonth(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    dashboard_GetEmergencyAssetsStatusCount(start: Date | undefined, end: Date | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/dashboard/emergenciesstatuscount?";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new globalThis.Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboard_GetEmergencyAssetsStatusCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboard_GetEmergencyAssetsStatusCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDashboard_GetEmergencyAssetsStatusCount(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    dashboard_GetEmergencyDayType(start: Date | undefined, end: Date | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/dashboard/emergenciesdaytype?";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new globalThis.Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboard_GetEmergencyDayType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboard_GetEmergencyDayType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDashboard_GetEmergencyDayType(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    dashboard_EmergencyListExport(power: string | null | undefined, status: string | null | undefined, requestDayType: string | null | undefined, requestTimeOfDay: string | null | undefined, year: number | null | undefined, month: number | null | undefined, start: Date | null | undefined, end: Date | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/dashboard/emergencyexport?";
        if (power !== undefined && power !== null)
            url_ += "Power=" + encodeURIComponent("" + power) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (requestDayType !== undefined && requestDayType !== null)
            url_ += "RequestDayType=" + encodeURIComponent("" + requestDayType) + "&";
        if (requestTimeOfDay !== undefined && requestTimeOfDay !== null)
            url_ += "RequestTimeOfDay=" + encodeURIComponent("" + requestTimeOfDay) + "&";
        if (year !== undefined && year !== null)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (month !== undefined && month !== null)
            url_ += "Month=" + encodeURIComponent("" + month) + "&";
        if (start !== undefined && start !== null)
            url_ += "Start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end !== undefined && end !== null)
            url_ += "End=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboard_EmergencyListExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboard_EmergencyListExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDashboard_EmergencyListExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    dashboard_AssetListExport(power: string | null | undefined, status: string | null | undefined, requestDayType: string | null | undefined, requestTimeOfDay: string | null | undefined, year: number | null | undefined, month: number | null | undefined, start: Date | null | undefined, end: Date | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/dashboard/assetexport?";
        if (power !== undefined && power !== null)
            url_ += "Power=" + encodeURIComponent("" + power) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (requestDayType !== undefined && requestDayType !== null)
            url_ += "RequestDayType=" + encodeURIComponent("" + requestDayType) + "&";
        if (requestTimeOfDay !== undefined && requestTimeOfDay !== null)
            url_ += "RequestTimeOfDay=" + encodeURIComponent("" + requestTimeOfDay) + "&";
        if (year !== undefined && year !== null)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (month !== undefined && month !== null)
            url_ += "Month=" + encodeURIComponent("" + month) + "&";
        if (start !== undefined && start !== null)
            url_ += "Start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end !== undefined && end !== null)
            url_ += "End=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboard_AssetListExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboard_AssetListExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDashboard_AssetListExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    dashboard_GetDashboardLocationSummary2(category: string, status: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/dashboard/locationsummary/{category}/{status}";
        if (category === undefined || category === null)
            throw new globalThis.Error("The parameter 'category' must be defined.");
        url_ = url_.replace("{category}", encodeURIComponent("" + category));
        if (status === undefined || status === null)
            throw new globalThis.Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboard_GetDashboardLocationSummary2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboard_GetDashboardLocationSummary2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDashboard_GetDashboardLocationSummary2(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    dashboard_GetDashboardDistanceSummary(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/dashboard/distancesummary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboard_GetDashboardDistanceSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboard_GetDashboardDistanceSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDashboard_GetDashboardDistanceSummary(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    dashboard_GetCallSummary(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/dashboard/callsummary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboard_GetCallSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboard_GetCallSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDashboard_GetCallSummary(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LocationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    location_GetLocation(locID: number): Observable<LocationDto> {
        let url_ = this.baseUrl + "/api/v2/location/{locID}";
        if (locID === undefined || locID === null)
            throw new globalThis.Error("The parameter 'locID' must be defined.");
        url_ = url_.replace("{locID}", encodeURIComponent("" + locID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocation_GetLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocation_GetLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationDto>;
        }));
    }

    protected processLocation_GetLocation(response: HttpResponseBase): Observable<LocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    location_GetLocationInformation(locID: number): Observable<StoreLocationInformationDto> {
        let url_ = this.baseUrl + "/api/v2/location/{locID}/location-information";
        if (locID === undefined || locID === null)
            throw new globalThis.Error("The parameter 'locID' must be defined.");
        url_ = url_.replace("{locID}", encodeURIComponent("" + locID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocation_GetLocationInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocation_GetLocationInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreLocationInformationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreLocationInformationDto>;
        }));
    }

    protected processLocation_GetLocationInformation(response: HttpResponseBase): Observable<StoreLocationInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreLocationInformationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    location_GetLocationWithCounts(id: number): Observable<StorePortalLocationDTO> {
        let url_ = this.baseUrl + "/api/v2/location/{id}/withcounts";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocation_GetLocationWithCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocation_GetLocationWithCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StorePortalLocationDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StorePortalLocationDTO>;
        }));
    }

    protected processLocation_GetLocationWithCounts(response: HttpResponseBase): Observable<StorePortalLocationDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StorePortalLocationDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    location_GetLocationUnapprovedChanges(id: number): Observable<AssetChangeForApprovalDTO[]> {
        let url_ = this.baseUrl + "/api/v2/location/{id}/changes";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocation_GetLocationUnapprovedChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocation_GetLocationUnapprovedChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetChangeForApprovalDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetChangeForApprovalDTO[]>;
        }));
    }

    protected processLocation_GetLocationUnapprovedChanges(response: HttpResponseBase): Observable<AssetChangeForApprovalDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssetChangeForApprovalDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    location_PutLocationUnapprovedChanges(id: number, dto: AssetChangeForApprovalDTO): Observable<AssetChangeForApprovalDTO[]> {
        let url_ = this.baseUrl + "/api/v2/location/{id}/changes";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocation_PutLocationUnapprovedChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocation_PutLocationUnapprovedChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetChangeForApprovalDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetChangeForApprovalDTO[]>;
        }));
    }

    protected processLocation_PutLocationUnapprovedChanges(response: HttpResponseBase): Observable<AssetChangeForApprovalDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssetChangeForApprovalDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    location_GetAlerts(id: number): Observable<LocationAlertDTO[]> {
        let url_ = this.baseUrl + "/api/v2/location/{id}/alerts";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocation_GetAlerts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocation_GetAlerts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationAlertDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationAlertDTO[]>;
        }));
    }

    protected processLocation_GetAlerts(response: HttpResponseBase): Observable<LocationAlertDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationAlertDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    location_SearchLocations(customerIDs: string[] | null | undefined, idx: string): Observable<Location[]> {
        let url_ = this.baseUrl + "/api/v2/location/search/{idx}?";
        if (idx === undefined || idx === null)
            throw new globalThis.Error("The parameter 'idx' must be defined.");
        url_ = url_.replace("{idx}", encodeURIComponent("" + idx));
        if (customerIDs !== undefined && customerIDs !== null)
            customerIDs && customerIDs.forEach(item => { url_ += "customerIDs=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocation_SearchLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocation_SearchLocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Location[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Location[]>;
        }));
    }

    protected processLocation_SearchLocations(response: HttpResponseBase): Observable<Location[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Location.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    location_GetLocationsByCustomerID(customerID: string): Observable<StoreSelectionLocationDto[]> {
        let url_ = this.baseUrl + "/api/v2/location/customer/{customerID}";
        if (customerID === undefined || customerID === null)
            throw new globalThis.Error("The parameter 'customerID' must be defined.");
        url_ = url_.replace("{customerID}", encodeURIComponent("" + customerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocation_GetLocationsByCustomerID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocation_GetLocationsByCustomerID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreSelectionLocationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreSelectionLocationDto[]>;
        }));
    }

    protected processLocation_GetLocationsByCustomerID(response: HttpResponseBase): Observable<StoreSelectionLocationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoreSelectionLocationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    location_GetOnSiteAssets(id: number): Observable<AssetDTO[]> {
        let url_ = this.baseUrl + "/api/v2/location/{id}/assets/onsite";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocation_GetOnSiteAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocation_GetOnSiteAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDTO[]>;
        }));
    }

    protected processLocation_GetOnSiteAssets(response: HttpResponseBase): Observable<AssetDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssetDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    location_GetOnSiteAssetsForDeliveryInspection(id: number): Observable<AssetDTO[]> {
        let url_ = this.baseUrl + "/api/v2/location/{id}/assets/onsite/delivery-inspection";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocation_GetOnSiteAssetsForDeliveryInspection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocation_GetOnSiteAssetsForDeliveryInspection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDTO[]>;
        }));
    }

    protected processLocation_GetOnSiteAssetsForDeliveryInspection(response: HttpResponseBase): Observable<AssetDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssetDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    location_GetAuditablOnsiteAssets(id: number): Observable<AssetDTO[]> {
        let url_ = this.baseUrl + "/api/v2/location/{id}/assets/onsite/audit-assets";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocation_GetAuditablOnsiteAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocation_GetAuditablOnsiteAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDTO[]>;
        }));
    }

    protected processLocation_GetAuditablOnsiteAssets(response: HttpResponseBase): Observable<AssetDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssetDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    location_GetScheduledAssets(id: number): Observable<ScheduledAssetRequestDTO> {
        let url_ = this.baseUrl + "/api/v2/location/{id}/assets/scheduled";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocation_GetScheduledAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocation_GetScheduledAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduledAssetRequestDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduledAssetRequestDTO>;
        }));
    }

    protected processLocation_GetScheduledAssets(response: HttpResponseBase): Observable<ScheduledAssetRequestDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduledAssetRequestDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    location_PostScheduledAssets(id: number, dto: ScheduledAssetRequestDTO): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v2/location/{id}/assets/scheduled";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocation_PostScheduledAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocation_PostScheduledAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processLocation_PostScheduledAssets(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    location_GetLocationContacts(id: number): Observable<LocationContactDTO[]> {
        let url_ = this.baseUrl + "/api/v2/location/{id}/contacts";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocation_GetLocationContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocation_GetLocationContacts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationContactDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationContactDTO[]>;
        }));
    }

    protected processLocation_GetLocationContacts(response: HttpResponseBase): Observable<LocationContactDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationContactDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    location_DeletelocationContact(id: number): Observable<LocationContactDTO> {
        let url_ = this.baseUrl + "/api/v2/location/delete-contact/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocation_DeletelocationContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocation_DeletelocationContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationContactDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationContactDTO>;
        }));
    }

    protected processLocation_DeletelocationContact(response: HttpResponseBase): Observable<LocationContactDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationContactDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    location_GetLocationContactList(id: number, filter: PrimeGridRequest): Observable<PrimeGridResultOfLocationContactDTO> {
        let url_ = this.baseUrl + "/api/v2/location/{id}/contacts-grid-list";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocation_GetLocationContactList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocation_GetLocationContactList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrimeGridResultOfLocationContactDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrimeGridResultOfLocationContactDTO>;
        }));
    }

    protected processLocation_GetLocationContactList(response: HttpResponseBase): Observable<PrimeGridResultOfLocationContactDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrimeGridResultOfLocationContactDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    location_AddLocationContact(dto: LocationContactDTO): Observable<LocationContactDTO> {
        let url_ = this.baseUrl + "/api/v2/location/contacts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocation_AddLocationContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocation_AddLocationContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationContactDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationContactDTO>;
        }));
    }

    protected processLocation_AddLocationContact(response: HttpResponseBase): Observable<LocationContactDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationContactDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    location_UpdateLocationContact(locID: number, dto: LocationContactDTO): Observable<LocationContactDTO> {
        let url_ = this.baseUrl + "/api/v2/location/contacts/{locID}";
        if (locID === undefined || locID === null)
            throw new globalThis.Error("The parameter 'locID' must be defined.");
        url_ = url_.replace("{locID}", encodeURIComponent("" + locID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocation_UpdateLocationContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocation_UpdateLocationContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationContactDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationContactDTO>;
        }));
    }

    protected processLocation_UpdateLocationContact(response: HttpResponseBase): Observable<LocationContactDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationContactDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    location_AddUserToLocationContact(auth0UserDto: Auth0UserDto): Observable<LocationContactDTO> {
        let url_ = this.baseUrl + "/api/v2/location/auth0/add-contact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(auth0UserDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocation_AddUserToLocationContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocation_AddUserToLocationContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationContactDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationContactDTO>;
        }));
    }

    protected processLocation_AddUserToLocationContact(response: HttpResponseBase): Observable<LocationContactDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationContactDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class NotificationsV2Client {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    notificationsV2_GetInbox(type: NotificationTypeEnum | null | undefined, status: NotificationDeliveryStatus | undefined, skip: number | undefined, take: number | undefined): Observable<PagedResponseDtoOfNotificationV2DeliveryDto> {
        let url_ = this.baseUrl + "/api/notifications/v2/inbox?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationsV2_GetInbox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationsV2_GetInbox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseDtoOfNotificationV2DeliveryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseDtoOfNotificationV2DeliveryDto>;
        }));
    }

    protected processNotificationsV2_GetInbox(response: HttpResponseBase): Observable<PagedResponseDtoOfNotificationV2DeliveryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseDtoOfNotificationV2DeliveryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    notificationsV2_GetUnreadCount(type: NotificationTypeEnum | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/notifications/v2/count?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationsV2_GetUnreadCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationsV2_GetUnreadCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processNotificationsV2_GetUnreadCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    notificationsV2_View(deliveryId: string): Observable<NotificationV2DeliveryDto> {
        let url_ = this.baseUrl + "/api/notifications/v2/deliveries/{deliveryId}/view";
        if (deliveryId === undefined || deliveryId === null)
            throw new globalThis.Error("The parameter 'deliveryId' must be defined.");
        url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationsV2_View(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationsV2_View(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationV2DeliveryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationV2DeliveryDto>;
        }));
    }

    protected processNotificationsV2_View(response: HttpResponseBase): Observable<NotificationV2DeliveryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationV2DeliveryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    notificationsV2_Dismiss(deliveryId: string): Observable<NotificationV2DeliveryDto> {
        let url_ = this.baseUrl + "/api/notifications/v2/deliveries/{deliveryId}/dismiss";
        if (deliveryId === undefined || deliveryId === null)
            throw new globalThis.Error("The parameter 'deliveryId' must be defined.");
        url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationsV2_Dismiss(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationsV2_Dismiss(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationV2DeliveryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationV2DeliveryDto>;
        }));
    }

    protected processNotificationsV2_Dismiss(response: HttpResponseBase): Observable<NotificationV2DeliveryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationV2DeliveryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    notificationsV2_Snooze(deliveryId: string, request: NotificationV2SnoozeRequest): Observable<NotificationV2DeliveryDto> {
        let url_ = this.baseUrl + "/api/notifications/v2/deliveries/{deliveryId}/snooze";
        if (deliveryId === undefined || deliveryId === null)
            throw new globalThis.Error("The parameter 'deliveryId' must be defined.");
        url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationsV2_Snooze(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationsV2_Snooze(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationV2DeliveryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationV2DeliveryDto>;
        }));
    }

    protected processNotificationsV2_Snooze(response: HttpResponseBase): Observable<NotificationV2DeliveryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationV2DeliveryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    notificationsV2_GetDispatches(deliveryId: string): Observable<NotificationV2DispatchDto[]> {
        let url_ = this.baseUrl + "/api/notifications/v2/deliveries/{deliveryId}/dispatches";
        if (deliveryId === undefined || deliveryId === null)
            throw new globalThis.Error("The parameter 'deliveryId' must be defined.");
        url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationsV2_GetDispatches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationsV2_GetDispatches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationV2DispatchDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationV2DispatchDto[]>;
        }));
    }

    protected processNotificationsV2_GetDispatches(response: HttpResponseBase): Observable<NotificationV2DispatchDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationV2DispatchDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OrderClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    order_CreateOrder(activeLanguage: string | null | undefined, model: CreateOrderDTO): Observable<Order> {
        let url_ = this.baseUrl + "/api/v2/order?";
        if (activeLanguage !== undefined && activeLanguage !== null)
            url_ += "activeLanguage=" + encodeURIComponent("" + activeLanguage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrder_CreateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrder_CreateOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Order>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Order>;
        }));
    }

    protected processOrder_CreateOrder(response: HttpResponseBase): Observable<Order> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Order.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = OrderSubmissionError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = OrderSubmissionError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    order_GetMinimumScheduledDate(today: Date | undefined, daysToAdd: number | undefined): Observable<Date> {
        let url_ = this.baseUrl + "/api/v2/order/min-sched-date?";
        if (today === null)
            throw new globalThis.Error("The parameter 'today' cannot be null.");
        else if (today !== undefined)
            url_ += "today=" + encodeURIComponent(today ? "" + today.toISOString() : "") + "&";
        if (daysToAdd === null)
            throw new globalThis.Error("The parameter 'daysToAdd' cannot be null.");
        else if (daysToAdd !== undefined)
            url_ += "daysToAdd=" + encodeURIComponent("" + daysToAdd) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrder_GetMinimumScheduledDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrder_GetMinimumScheduledDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Date>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Date>;
        }));
    }

    protected processOrder_GetMinimumScheduledDate(response: HttpResponseBase): Observable<Date> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? new Date(resultData200.toString()) : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    order_GetTempRanges(customerID: string): Observable<AuditTempRange[]> {
        let url_ = this.baseUrl + "/api/v2/order/{customerID}/tempranges";
        if (customerID === undefined || customerID === null)
            throw new globalThis.Error("The parameter 'customerID' must be defined.");
        url_ = url_.replace("{customerID}", encodeURIComponent("" + customerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrder_GetTempRanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrder_GetTempRanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditTempRange[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditTempRange[]>;
        }));
    }

    protected processOrder_GetTempRanges(response: HttpResponseBase): Observable<AuditTempRange[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuditTempRange.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    order_RequestRemovals(assets: AssetRemovalDTO[]): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/order/requestremoval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assets);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrder_RequestRemovals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrder_RequestRemovals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processOrder_RequestRemovals(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    order_RequestRepair(activeLanguage: string | null | undefined, requestDTO: RequestDTO): Observable<string> {
        let url_ = this.baseUrl + "/api/v2/order/request-service?";
        if (activeLanguage !== undefined && activeLanguage !== null)
            url_ += "activeLanguage=" + encodeURIComponent("" + activeLanguage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrder_RequestRepair(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrder_RequestRepair(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processOrder_RequestRepair(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    order_GetIssueTypes(): Observable<IssueType[]> {
        let url_ = this.baseUrl + "/api/v2/order/service-issue-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrder_GetIssueTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrder_GetIssueTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IssueType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IssueType[]>;
        }));
    }

    protected processOrder_GetIssueTypes(response: HttpResponseBase): Observable<IssueType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IssueType.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    order_GetReorderList(locID: number): Observable<ReorderDefaultValuesDTO[]> {
        let url_ = this.baseUrl + "/api/v2/order/reorder-list/{locID}";
        if (locID === undefined || locID === null)
            throw new globalThis.Error("The parameter 'locID' must be defined.");
        url_ = url_.replace("{locID}", encodeURIComponent("" + locID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrder_GetReorderList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrder_GetReorderList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReorderDefaultValuesDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReorderDefaultValuesDTO[]>;
        }));
    }

    protected processOrder_GetReorderList(response: HttpResponseBase): Observable<ReorderDefaultValuesDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReorderDefaultValuesDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    order_GetOrderAssets(orderID: number): Observable<AssetDto[]> {
        let url_ = this.baseUrl + "/api/v2/order/{orderID}/assets";
        if (orderID === undefined || orderID === null)
            throw new globalThis.Error("The parameter 'orderID' must be defined.");
        url_ = url_.replace("{orderID}", encodeURIComponent("" + orderID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrder_GetOrderAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrder_GetOrderAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDto[]>;
        }));
    }

    protected processOrder_GetOrderAssets(response: HttpResponseBase): Observable<AssetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssetDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    order_AddNewOrderAsset(orderID: number, assetDto: AssetDto): Observable<AssetDto> {
        let url_ = this.baseUrl + "/api/v2/order/{orderID}/assets";
        if (orderID === undefined || orderID === null)
            throw new globalThis.Error("The parameter 'orderID' must be defined.");
        url_ = url_.replace("{orderID}", encodeURIComponent("" + orderID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assetDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrder_AddNewOrderAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrder_AddNewOrderAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDto>;
        }));
    }

    protected processOrder_AddNewOrderAsset(response: HttpResponseBase): Observable<AssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    order_UpsertOrderAsset(orderID: number, assetID: number, assetDto: AssetDto): Observable<AssetDto> {
        let url_ = this.baseUrl + "/api/v2/order/{orderID}/assets/{assetID}";
        if (orderID === undefined || orderID === null)
            throw new globalThis.Error("The parameter 'orderID' must be defined.");
        url_ = url_.replace("{orderID}", encodeURIComponent("" + orderID));
        if (assetID === undefined || assetID === null)
            throw new globalThis.Error("The parameter 'assetID' must be defined.");
        url_ = url_.replace("{assetID}", encodeURIComponent("" + assetID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assetDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrder_UpsertOrderAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrder_UpsertOrderAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDto>;
        }));
    }

    protected processOrder_UpsertOrderAsset(response: HttpResponseBase): Observable<AssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    order_DeleteOrderAsset(orderID: number, assetID: number, lastModifiedDate: Date | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v2/order/{orderID}/assets/{assetID}?";
        if (orderID === undefined || orderID === null)
            throw new globalThis.Error("The parameter 'orderID' must be defined.");
        url_ = url_.replace("{orderID}", encodeURIComponent("" + orderID));
        if (assetID === undefined || assetID === null)
            throw new globalThis.Error("The parameter 'assetID' must be defined.");
        url_ = url_.replace("{assetID}", encodeURIComponent("" + assetID));
        if (lastModifiedDate === null)
            throw new globalThis.Error("The parameter 'lastModifiedDate' cannot be null.");
        else if (lastModifiedDate !== undefined)
            url_ += "lastModifiedDate=" + encodeURIComponent(lastModifiedDate ? "" + lastModifiedDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrder_DeleteOrderAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrder_DeleteOrderAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processOrder_DeleteOrderAsset(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    order_CancelOrderAsset(orderID: number, assetID: number, lastModifiedDate: Date | undefined): Observable<AssetDto> {
        let url_ = this.baseUrl + "/api/v2/order/{orderID}/assets/{assetID}/cancel?";
        if (orderID === undefined || orderID === null)
            throw new globalThis.Error("The parameter 'orderID' must be defined.");
        url_ = url_.replace("{orderID}", encodeURIComponent("" + orderID));
        if (assetID === undefined || assetID === null)
            throw new globalThis.Error("The parameter 'assetID' must be defined.");
        url_ = url_.replace("{assetID}", encodeURIComponent("" + assetID));
        if (lastModifiedDate === null)
            throw new globalThis.Error("The parameter 'lastModifiedDate' cannot be null.");
        else if (lastModifiedDate !== undefined)
            url_ += "lastModifiedDate=" + encodeURIComponent(lastModifiedDate ? "" + lastModifiedDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrder_CancelOrderAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrder_CancelOrderAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDto>;
        }));
    }

    protected processOrder_CancelOrderAsset(response: HttpResponseBase): Observable<AssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    order_UpdateAssetSelectedProvider(assetID: number, providerID: string | null | undefined, lastModifiedDate: Date | undefined, mileage: number | null | undefined, noteMessage: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/order/assets/{assetID}/provider?";
        if (assetID === undefined || assetID === null)
            throw new globalThis.Error("The parameter 'assetID' must be defined.");
        url_ = url_.replace("{assetID}", encodeURIComponent("" + assetID));
        if (providerID !== undefined && providerID !== null)
            url_ += "providerID=" + encodeURIComponent("" + providerID) + "&";
        if (lastModifiedDate === null)
            throw new globalThis.Error("The parameter 'lastModifiedDate' cannot be null.");
        else if (lastModifiedDate !== undefined)
            url_ += "lastModifiedDate=" + encodeURIComponent(lastModifiedDate ? "" + lastModifiedDate.toISOString() : "") + "&";
        if (mileage !== undefined && mileage !== null)
            url_ += "mileage=" + encodeURIComponent("" + mileage) + "&";
        if (noteMessage !== undefined && noteMessage !== null)
            url_ += "noteMessage=" + encodeURIComponent("" + noteMessage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrder_UpdateAssetSelectedProvider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrder_UpdateAssetSelectedProvider(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOrder_UpdateAssetSelectedProvider(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    order_RemoveAssetSelectedProvider(assetID: number, lastModifiedDate: Date | undefined, noteMessage: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/order/assets/{assetID}/provider?";
        if (assetID === undefined || assetID === null)
            throw new globalThis.Error("The parameter 'assetID' must be defined.");
        url_ = url_.replace("{assetID}", encodeURIComponent("" + assetID));
        if (lastModifiedDate === null)
            throw new globalThis.Error("The parameter 'lastModifiedDate' cannot be null.");
        else if (lastModifiedDate !== undefined)
            url_ += "lastModifiedDate=" + encodeURIComponent(lastModifiedDate ? "" + lastModifiedDate.toISOString() : "") + "&";
        if (noteMessage !== undefined && noteMessage !== null)
            url_ += "noteMessage=" + encodeURIComponent("" + noteMessage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrder_RemoveAssetSelectedProvider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrder_RemoveAssetSelectedProvider(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOrder_RemoveAssetSelectedProvider(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    order_UpsertAssetNoDrop(orderID: number, assetID: number, dto: AssetNoDropDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/order/{orderID}/assets/{assetID}/nodrop";
        if (orderID === undefined || orderID === null)
            throw new globalThis.Error("The parameter 'orderID' must be defined.");
        url_ = url_.replace("{orderID}", encodeURIComponent("" + orderID));
        if (assetID === undefined || assetID === null)
            throw new globalThis.Error("The parameter 'assetID' must be defined.");
        url_ = url_.replace("{assetID}", encodeURIComponent("" + assetID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrder_UpsertAssetNoDrop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrder_UpsertAssetNoDrop(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOrder_UpsertAssetNoDrop(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    order_RequestAssetRemoval(orderID: number, dto: AssetRequestRemovalDto): Observable<number> {
        let url_ = this.baseUrl + "/api/v2/order/{orderID}/assets/request-removal";
        if (orderID === undefined || orderID === null)
            throw new globalThis.Error("The parameter 'orderID' must be defined.");
        url_ = url_.replace("{orderID}", encodeURIComponent("" + orderID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrder_RequestAssetRemoval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrder_RequestAssetRemoval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processOrder_RequestAssetRemoval(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    order_CloneAsset(orderID: number, assetID: number): Observable<AssetDto> {
        let url_ = this.baseUrl + "/api/v2/order/{orderID}/assets/{assetID}/clone";
        if (orderID === undefined || orderID === null)
            throw new globalThis.Error("The parameter 'orderID' must be defined.");
        url_ = url_.replace("{orderID}", encodeURIComponent("" + orderID));
        if (assetID === undefined || assetID === null)
            throw new globalThis.Error("The parameter 'assetID' must be defined.");
        url_ = url_.replace("{assetID}", encodeURIComponent("" + assetID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrder_CloneAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrder_CloneAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDto>;
        }));
    }

    protected processOrder_CloneAsset(response: HttpResponseBase): Observable<AssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    order_SetProviderForMultipleAssets(orderID: number, dto: AssetBulkProviderUpdateDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/order/{orderID}/assets/bulk-provider";
        if (orderID === undefined || orderID === null)
            throw new globalThis.Error("The parameter 'orderID' must be defined.");
        url_ = url_.replace("{orderID}", encodeURIComponent("" + orderID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrder_SetProviderForMultipleAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrder_SetProviderForMultipleAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOrder_SetProviderForMultipleAssets(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SystemsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    systems_GetMessage(type: string): Observable<SystemMessage> {
        let url_ = this.baseUrl + "/api/v2/systems/system-messages/type/{type}";
        if (type === undefined || type === null)
            throw new globalThis.Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSystems_GetMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSystems_GetMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SystemMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SystemMessage>;
        }));
    }

    protected processSystems_GetMessage(response: HttpResponseBase): Observable<SystemMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    systems_GetSeasonalMinimumInformation(): Observable<SeasonalOrderInfo> {
        let url_ = this.baseUrl + "/api/v2/systems/system-messages/seasonal-minimum-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSystems_GetSeasonalMinimumInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSystems_GetSeasonalMinimumInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SeasonalOrderInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SeasonalOrderInfo>;
        }));
    }

    protected processSystems_GetSeasonalMinimumInformation(response: HttpResponseBase): Observable<SeasonalOrderInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SeasonalOrderInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    systems_GetHolidayDates(): Observable<Date[]> {
        let url_ = this.baseUrl + "/api/v2/systems/holiday-dates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSystems_GetHolidayDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSystems_GetHolidayDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Date[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Date[]>;
        }));
    }

    protected processSystems_GetHolidayDates(response: HttpResponseBase): Observable<Date[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(new Date(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UsersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    users_GetCurrentUser(storeId: string | null | undefined): Observable<UserDTO> {
        let url_ = this.baseUrl + "/api/v2/users/me?";
        if (storeId !== undefined && storeId !== null)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsers_GetCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsers_GetCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDTO>;
        }));
    }

    protected processUsers_GetCurrentUser(response: HttpResponseBase): Observable<UserDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    users_GetUser(username: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/users?";
        if (username !== undefined && username !== null)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsers_GetUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsers_GetUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUsers_GetUser(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    users_UpsertUser(data: UserDTO): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsers_UpsertUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsers_UpsertUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUsers_UpsertUser(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    users_UpdateUser(dto: Auth0UserDto): Observable<Auth0UserUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v2/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsers_UpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsers_UpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Auth0UserUpdateResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Auth0UserUpdateResponseDto>;
        }));
    }

    protected processUsers_UpdateUser(response: HttpResponseBase): Observable<Auth0UserUpdateResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Auth0UserUpdateResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    users_GetUsers(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/users/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsers_GetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsers_GetUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUsers_GetUsers(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    users_PostUserSetting(data: UserSetting): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/users/me/settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsers_PostUserSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsers_PostUserSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUsers_PostUserSetting(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    users_GetUserSettings(key: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/users/me/settings/{key}";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsers_GetUserSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsers_GetUserSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUsers_GetUserSettings(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    users_GetAuth0User(id: string): Observable<Auth0User> {
        let url_ = this.baseUrl + "/api/v2/users/auth0/user/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsers_GetAuth0User(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsers_GetAuth0User(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Auth0User>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Auth0User>;
        }));
    }

    protected processUsers_GetAuth0User(response: HttpResponseBase): Observable<Auth0User> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Auth0User.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    users_GetAuth0UserByEmail(email: string): Observable<Auth0User> {
        let url_ = this.baseUrl + "/api/v2/users/auth0/user/email/{email}";
        if (email === undefined || email === null)
            throw new globalThis.Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsers_GetAuth0UserByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsers_GetAuth0UserByEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Auth0User>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Auth0User>;
        }));
    }

    protected processUsers_GetAuth0UserByEmail(response: HttpResponseBase): Observable<Auth0User> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Auth0User.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    users_EnsureStoreLocation(): Observable<Auth0UserUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v2/users/auth0/ensure-store-location";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsers_EnsureStoreLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsers_EnsureStoreLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Auth0UserUpdateResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Auth0UserUpdateResponseDto>;
        }));
    }

    protected processUsers_EnsureStoreLocation(response: HttpResponseBase): Observable<Auth0UserUpdateResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Auth0UserUpdateResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WhatsNewClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    whatsNew_Feed(): Observable<WhatsNewDto[]> {
        let url_ = this.baseUrl + "/api/whats-new";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWhatsNew_Feed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWhatsNew_Feed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WhatsNewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WhatsNewDto[]>;
        }));
    }

    protected processWhatsNew_Feed(response: HttpResponseBase): Observable<WhatsNewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WhatsNewDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    whatsNew_UnreadCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/whats-new/unread-count";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWhatsNew_UnreadCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWhatsNew_UnreadCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processWhatsNew_UnreadCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    whatsNew_Detail(id: string): Observable<WhatsNewDto> {
        let url_ = this.baseUrl + "/api/whats-new/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWhatsNew_Detail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWhatsNew_Detail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WhatsNewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WhatsNewDto>;
        }));
    }

    protected processWhatsNew_Detail(response: HttpResponseBase): Observable<WhatsNewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WhatsNewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    whatsNew_MarkRead(id: string, dismiss: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/whats-new/{id}/read?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (dismiss === null)
            throw new globalThis.Error("The parameter 'dismiss' cannot be null.");
        else if (dismiss !== undefined)
            url_ += "dismiss=" + encodeURIComponent("" + dismiss) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWhatsNew_MarkRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWhatsNew_MarkRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processWhatsNew_MarkRead(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    whatsNew_Image(id: string, featureId: string, imageId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/whats-new/{id}/features/{featureId}/images/{imageId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (featureId === undefined || featureId === null)
            throw new globalThis.Error("The parameter 'featureId' must be defined.");
        url_ = url_.replace("{featureId}", encodeURIComponent("" + featureId));
        if (imageId === undefined || imageId === null)
            throw new globalThis.Error("The parameter 'imageId' must be defined.");
        url_ = url_.replace("{imageId}", encodeURIComponent("" + imageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWhatsNew_Image(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWhatsNew_Image(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processWhatsNew_Image(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AcknowledgmentDTO implements IAcknowledgmentDTO {
    id?: number;
    locationID?: string | undefined;
    locID?: number | undefined;
    orderID?: number | undefined;
    assetIDs?: number[] | undefined;
    fullName?: string | undefined;
    trailerNumber?: string | undefined;
    notes?: string | undefined;
    createdDate?: string | undefined;
    ipStamp?: string | undefined;
    acknowledgmentTypeName?: string | undefined;
    issue?: boolean;
    deleted?: boolean;
    employeeNumber?: string | undefined;
    email?: string | undefined;
    type?: string | undefined;
    location?: LocationDTO | undefined;
    order?: OrderDTO | undefined;
    assetInspections?: AssetInspectionDTO[] | undefined;
    isVerifiedTrailerNumber?: boolean;
    fuelReading?: number;
    isDoorOperational?: boolean;
    isBulkheadCorrect?: boolean;
    controlPanelDocumentID?: string | undefined;
    fuelGaugeDocumentID?: string | undefined;
    verifiedBy?: string | undefined;
    verifiedOn?: Date;

    constructor(data?: IAcknowledgmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationID = _data["locationID"];
            this.locID = _data["locID"];
            this.orderID = _data["orderID"];
            if (Array.isArray(_data["assetIDs"])) {
                this.assetIDs = [] as any;
                for (let item of _data["assetIDs"])
                    this.assetIDs!.push(item);
            }
            this.fullName = _data["fullName"];
            this.trailerNumber = _data["trailerNumber"];
            this.notes = _data["notes"];
            this.createdDate = _data["createdDate"];
            this.ipStamp = _data["ipStamp"];
            this.acknowledgmentTypeName = _data["acknowledgmentTypeName"];
            this.issue = _data["issue"];
            this.deleted = _data["deleted"];
            this.employeeNumber = _data["employeeNumber"];
            this.email = _data["email"];
            this.type = _data["type"];
            this.location = _data["location"] ? LocationDTO.fromJS(_data["location"]) : undefined as any;
            this.order = _data["order"] ? OrderDTO.fromJS(_data["order"]) : undefined as any;
            if (Array.isArray(_data["assetInspections"])) {
                this.assetInspections = [] as any;
                for (let item of _data["assetInspections"])
                    this.assetInspections!.push(AssetInspectionDTO.fromJS(item));
            }
            this.isVerifiedTrailerNumber = _data["isVerifiedTrailerNumber"];
            this.fuelReading = _data["fuelReading"];
            this.isDoorOperational = _data["isDoorOperational"];
            this.isBulkheadCorrect = _data["isBulkheadCorrect"];
            this.controlPanelDocumentID = _data["controlPanelDocumentID"];
            this.fuelGaugeDocumentID = _data["fuelGaugeDocumentID"];
            this.verifiedBy = _data["verifiedBy"];
            this.verifiedOn = _data["verifiedOn"] ? new Date(_data["verifiedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AcknowledgmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AcknowledgmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationID"] = this.locationID;
        data["locID"] = this.locID;
        data["orderID"] = this.orderID;
        if (Array.isArray(this.assetIDs)) {
            data["assetIDs"] = [];
            for (let item of this.assetIDs)
                data["assetIDs"].push(item);
        }
        data["fullName"] = this.fullName;
        data["trailerNumber"] = this.trailerNumber;
        data["notes"] = this.notes;
        data["createdDate"] = this.createdDate;
        data["ipStamp"] = this.ipStamp;
        data["acknowledgmentTypeName"] = this.acknowledgmentTypeName;
        data["issue"] = this.issue;
        data["deleted"] = this.deleted;
        data["employeeNumber"] = this.employeeNumber;
        data["email"] = this.email;
        data["type"] = this.type;
        data["location"] = this.location ? this.location.toJSON() : undefined as any;
        data["order"] = this.order ? this.order.toJSON() : undefined as any;
        if (Array.isArray(this.assetInspections)) {
            data["assetInspections"] = [];
            for (let item of this.assetInspections)
                data["assetInspections"].push(item ? item.toJSON() : undefined as any);
        }
        data["isVerifiedTrailerNumber"] = this.isVerifiedTrailerNumber;
        data["fuelReading"] = this.fuelReading;
        data["isDoorOperational"] = this.isDoorOperational;
        data["isBulkheadCorrect"] = this.isBulkheadCorrect;
        data["controlPanelDocumentID"] = this.controlPanelDocumentID;
        data["fuelGaugeDocumentID"] = this.fuelGaugeDocumentID;
        data["verifiedBy"] = this.verifiedBy;
        data["verifiedOn"] = this.verifiedOn ? this.verifiedOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IAcknowledgmentDTO {
    id?: number;
    locationID?: string | undefined;
    locID?: number | undefined;
    orderID?: number | undefined;
    assetIDs?: number[] | undefined;
    fullName?: string | undefined;
    trailerNumber?: string | undefined;
    notes?: string | undefined;
    createdDate?: string | undefined;
    ipStamp?: string | undefined;
    acknowledgmentTypeName?: string | undefined;
    issue?: boolean;
    deleted?: boolean;
    employeeNumber?: string | undefined;
    email?: string | undefined;
    type?: string | undefined;
    location?: LocationDTO | undefined;
    order?: OrderDTO | undefined;
    assetInspections?: AssetInspectionDTO[] | undefined;
    isVerifiedTrailerNumber?: boolean;
    fuelReading?: number;
    isDoorOperational?: boolean;
    isBulkheadCorrect?: boolean;
    controlPanelDocumentID?: string | undefined;
    fuelGaugeDocumentID?: string | undefined;
    verifiedBy?: string | undefined;
    verifiedOn?: Date;
}

export class LocationDTO implements ILocationDTO {
    storeNumber?: string | undefined;
    region?: string | undefined;
    district?: string | undefined;
    name?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    contact?: string | undefined;
    phone?: string | undefined;
    customerID?: string | undefined;
    customer?: STMCustomerDTO | undefined;
    categories?: LocationCategoryDTO[] | undefined;

    constructor(data?: ILocationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeNumber = _data["storeNumber"];
            this.region = _data["region"];
            this.district = _data["district"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.contact = _data["contact"];
            this.phone = _data["phone"];
            this.customerID = _data["customerID"];
            this.customer = _data["customer"] ? STMCustomerDTO.fromJS(_data["customer"]) : undefined as any;
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(LocationCategoryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LocationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeNumber"] = this.storeNumber;
        data["region"] = this.region;
        data["district"] = this.district;
        data["name"] = this.name;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["contact"] = this.contact;
        data["phone"] = this.phone;
        data["customerID"] = this.customerID;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILocationDTO {
    storeNumber?: string | undefined;
    region?: string | undefined;
    district?: string | undefined;
    name?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    contact?: string | undefined;
    phone?: string | undefined;
    customerID?: string | undefined;
    customer?: STMCustomerDTO | undefined;
    categories?: LocationCategoryDTO[] | undefined;
}

export class STMCustomerDTO implements ISTMCustomerDTO {
    id?: string | undefined;
    name?: string | undefined;
    fuelIVRPhoneNumber?: string | undefined;
    auditIVRPhoneNumber?: string | undefined;

    constructor(data?: ISTMCustomerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fuelIVRPhoneNumber = _data["fuelIVRPhoneNumber"];
            this.auditIVRPhoneNumber = _data["auditIVRPhoneNumber"];
        }
    }

    static fromJS(data: any): STMCustomerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new STMCustomerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fuelIVRPhoneNumber"] = this.fuelIVRPhoneNumber;
        data["auditIVRPhoneNumber"] = this.auditIVRPhoneNumber;
        return data;
    }
}

export interface ISTMCustomerDTO {
    id?: string | undefined;
    name?: string | undefined;
    fuelIVRPhoneNumber?: string | undefined;
    auditIVRPhoneNumber?: string | undefined;
}

export class LocationCategoryDTO implements ILocationCategoryDTO {
    category?: string | undefined;
    value?: string | undefined;

    constructor(data?: ILocationCategoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): LocationCategoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LocationCategoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["value"] = this.value;
        return data;
    }
}

export interface ILocationCategoryDTO {
    category?: string | undefined;
    value?: string | undefined;
}

export class OrderDTO implements IOrderDTO {
    id?: number;
    idx?: string | undefined;
    status?: string | undefined;
    category?: string | undefined;
    customer?: OrderDTOReference | undefined;
    location?: OrderDTOLocationReference | undefined;
    request?: OrderDTORequestReference | undefined;
    fulfillment?: OrderDTOFulfillment | undefined;
    assets?: OrderDTOAsset[] | undefined;
    deletedAssets?: OrderDTOAsset[] | undefined;
    fuelProviders?: OrderDTOProviderReference[] | undefined;
    serviceProviders?: OrderDTOProviderReference[] | undefined;
    tags?: string[] | undefined;
    notes?: string | undefined;
    ponumber?: string | undefined;
    requiresReview?: boolean;
    requireReviewNote?: string | undefined;
    trailerNumber?: string | undefined;
    tag?: string | undefined;
    originalCategory?: string | undefined;
    serviceChannelStatus?: string | undefined;
    serviceChannelLastUpdate?: string | undefined;
    serviceChannelLastUpdateDate?: Date | undefined;
    cancelResolution?: string | undefined;
    pricingModel?: string | undefined;
    orderNotice?: string | undefined;
    orderModificationNotes?: string | undefined;
    linkedOrderID?: number | undefined;
    approvedBy?: string | undefined;
    lastModifiedDate?: Date;
    salesRepId?: number | undefined;

    constructor(data?: IOrderDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idx = _data["idx"];
            this.status = _data["status"];
            this.category = _data["category"];
            this.customer = _data["customer"] ? OrderDTOReference.fromJS(_data["customer"]) : undefined as any;
            this.location = _data["location"] ? OrderDTOLocationReference.fromJS(_data["location"]) : undefined as any;
            this.request = _data["request"] ? OrderDTORequestReference.fromJS(_data["request"]) : undefined as any;
            this.fulfillment = _data["fulfillment"] ? OrderDTOFulfillment.fromJS(_data["fulfillment"]) : undefined as any;
            if (Array.isArray(_data["assets"])) {
                this.assets = [] as any;
                for (let item of _data["assets"])
                    this.assets!.push(OrderDTOAsset.fromJS(item));
            }
            if (Array.isArray(_data["deletedAssets"])) {
                this.deletedAssets = [] as any;
                for (let item of _data["deletedAssets"])
                    this.deletedAssets!.push(OrderDTOAsset.fromJS(item));
            }
            if (Array.isArray(_data["fuelProviders"])) {
                this.fuelProviders = [] as any;
                for (let item of _data["fuelProviders"])
                    this.fuelProviders!.push(OrderDTOProviderReference.fromJS(item));
            }
            if (Array.isArray(_data["serviceProviders"])) {
                this.serviceProviders = [] as any;
                for (let item of _data["serviceProviders"])
                    this.serviceProviders!.push(OrderDTOProviderReference.fromJS(item));
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.notes = _data["notes"];
            this.ponumber = _data["ponumber"];
            this.requiresReview = _data["requiresReview"];
            this.requireReviewNote = _data["requireReviewNote"];
            this.trailerNumber = _data["trailerNumber"];
            this.tag = _data["tag"];
            this.originalCategory = _data["originalCategory"];
            this.serviceChannelStatus = _data["serviceChannelStatus"];
            this.serviceChannelLastUpdate = _data["serviceChannelLastUpdate"];
            this.serviceChannelLastUpdateDate = _data["serviceChannelLastUpdateDate"] ? new Date(_data["serviceChannelLastUpdateDate"].toString()) : undefined as any;
            this.cancelResolution = _data["cancelResolution"];
            this.pricingModel = _data["pricingModel"];
            this.orderNotice = _data["orderNotice"];
            this.orderModificationNotes = _data["orderModificationNotes"];
            this.linkedOrderID = _data["linkedOrderID"];
            this.approvedBy = _data["approvedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.salesRepId = _data["salesRepId"];
        }
    }

    static fromJS(data: any): OrderDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idx"] = this.idx;
        data["status"] = this.status;
        data["category"] = this.category;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["location"] = this.location ? this.location.toJSON() : undefined as any;
        data["request"] = this.request ? this.request.toJSON() : undefined as any;
        data["fulfillment"] = this.fulfillment ? this.fulfillment.toJSON() : undefined as any;
        if (Array.isArray(this.assets)) {
            data["assets"] = [];
            for (let item of this.assets)
                data["assets"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.deletedAssets)) {
            data["deletedAssets"] = [];
            for (let item of this.deletedAssets)
                data["deletedAssets"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.fuelProviders)) {
            data["fuelProviders"] = [];
            for (let item of this.fuelProviders)
                data["fuelProviders"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.serviceProviders)) {
            data["serviceProviders"] = [];
            for (let item of this.serviceProviders)
                data["serviceProviders"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["notes"] = this.notes;
        data["ponumber"] = this.ponumber;
        data["requiresReview"] = this.requiresReview;
        data["requireReviewNote"] = this.requireReviewNote;
        data["trailerNumber"] = this.trailerNumber;
        data["tag"] = this.tag;
        data["originalCategory"] = this.originalCategory;
        data["serviceChannelStatus"] = this.serviceChannelStatus;
        data["serviceChannelLastUpdate"] = this.serviceChannelLastUpdate;
        data["serviceChannelLastUpdateDate"] = this.serviceChannelLastUpdateDate ? this.serviceChannelLastUpdateDate.toISOString() : undefined as any;
        data["cancelResolution"] = this.cancelResolution;
        data["pricingModel"] = this.pricingModel;
        data["orderNotice"] = this.orderNotice;
        data["orderModificationNotes"] = this.orderModificationNotes;
        data["linkedOrderID"] = this.linkedOrderID;
        data["approvedBy"] = this.approvedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["salesRepId"] = this.salesRepId;
        return data;
    }
}

export interface IOrderDTO {
    id?: number;
    idx?: string | undefined;
    status?: string | undefined;
    category?: string | undefined;
    customer?: OrderDTOReference | undefined;
    location?: OrderDTOLocationReference | undefined;
    request?: OrderDTORequestReference | undefined;
    fulfillment?: OrderDTOFulfillment | undefined;
    assets?: OrderDTOAsset[] | undefined;
    deletedAssets?: OrderDTOAsset[] | undefined;
    fuelProviders?: OrderDTOProviderReference[] | undefined;
    serviceProviders?: OrderDTOProviderReference[] | undefined;
    tags?: string[] | undefined;
    notes?: string | undefined;
    ponumber?: string | undefined;
    requiresReview?: boolean;
    requireReviewNote?: string | undefined;
    trailerNumber?: string | undefined;
    tag?: string | undefined;
    originalCategory?: string | undefined;
    serviceChannelStatus?: string | undefined;
    serviceChannelLastUpdate?: string | undefined;
    serviceChannelLastUpdateDate?: Date | undefined;
    cancelResolution?: string | undefined;
    pricingModel?: string | undefined;
    orderNotice?: string | undefined;
    orderModificationNotes?: string | undefined;
    linkedOrderID?: number | undefined;
    approvedBy?: string | undefined;
    lastModifiedDate?: Date;
    salesRepId?: number | undefined;
}

export class OrderDTOReference implements IOrderDTOReference {
    id?: string | undefined;
    idx?: string | undefined;
    name?: string | undefined;
    usesNumber?: boolean;

    constructor(data?: IOrderDTOReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idx = _data["idx"];
            this.name = _data["name"];
            this.usesNumber = _data["usesNumber"];
        }
    }

    static fromJS(data: any): OrderDTOReference {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDTOReference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idx"] = this.idx;
        data["name"] = this.name;
        data["usesNumber"] = this.usesNumber;
        return data;
    }
}

export interface IOrderDTOReference {
    id?: string | undefined;
    idx?: string | undefined;
    name?: string | undefined;
    usesNumber?: boolean;
}

export class OrderDTOLocationReference extends OrderDTOReference implements IOrderDTOLocationReference {
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    latitude?: number;
    longitude?: number;
    timeZone?: string | undefined;
    locID?: number | undefined;
    statusNowID?: number | undefined;
    primaryContact?: string | undefined;

    constructor(data?: IOrderDTOLocationReference) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.street = _data["street"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.timeZone = _data["timeZone"];
            this.locID = _data["locID"];
            this.statusNowID = _data["statusNowID"];
            this.primaryContact = _data["primaryContact"];
        }
    }

    static override fromJS(data: any): OrderDTOLocationReference {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDTOLocationReference();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["timeZone"] = this.timeZone;
        data["locID"] = this.locID;
        data["statusNowID"] = this.statusNowID;
        data["primaryContact"] = this.primaryContact;
        super.toJSON(data);
        return data;
    }
}

export interface IOrderDTOLocationReference extends IOrderDTOReference {
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    latitude?: number;
    longitude?: number;
    timeZone?: string | undefined;
    locID?: number | undefined;
    statusNowID?: number | undefined;
    primaryContact?: string | undefined;
}

export class OrderDTORequestReference extends OrderDTOReference implements IOrderDTORequestReference {
    requirement?: string | undefined;
    priority?: string | undefined;
    quantity?: number | undefined;
    received?: Date | undefined;
    description?: string | undefined;
    orderedBy?: string | undefined;
    orderedByDirector?: string | undefined;
    orderedByEmail?: string | undefined;
    orderedByPhone?: string | undefined;
    reminderSent?: Date | undefined;

    constructor(data?: IOrderDTORequestReference) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.requirement = _data["requirement"];
            this.priority = _data["priority"];
            this.quantity = _data["quantity"];
            this.received = _data["received"] ? new Date(_data["received"].toString()) : undefined as any;
            this.description = _data["description"];
            this.orderedBy = _data["orderedBy"];
            this.orderedByDirector = _data["orderedByDirector"];
            this.orderedByEmail = _data["orderedByEmail"];
            this.orderedByPhone = _data["orderedByPhone"];
            this.reminderSent = _data["reminderSent"] ? new Date(_data["reminderSent"].toString()) : undefined as any;
        }
    }

    static override fromJS(data: any): OrderDTORequestReference {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDTORequestReference();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requirement"] = this.requirement;
        data["priority"] = this.priority;
        data["quantity"] = this.quantity;
        data["received"] = this.received ? this.received.toISOString() : undefined as any;
        data["description"] = this.description;
        data["orderedBy"] = this.orderedBy;
        data["orderedByDirector"] = this.orderedByDirector;
        data["orderedByEmail"] = this.orderedByEmail;
        data["orderedByPhone"] = this.orderedByPhone;
        data["reminderSent"] = this.reminderSent ? this.reminderSent.toISOString() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IOrderDTORequestReference extends IOrderDTOReference {
    requirement?: string | undefined;
    priority?: string | undefined;
    quantity?: number | undefined;
    received?: Date | undefined;
    description?: string | undefined;
    orderedBy?: string | undefined;
    orderedByDirector?: string | undefined;
    orderedByEmail?: string | undefined;
    orderedByPhone?: string | undefined;
    reminderSent?: Date | undefined;
}

export class OrderDTOFulfillment implements IOrderDTOFulfillment {
    delivery?: OrderDTOFulfillmentReference | undefined;
    pickup?: OrderDTOFulfillmentReference | undefined;

    constructor(data?: IOrderDTOFulfillment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.delivery = _data["delivery"] ? OrderDTOFulfillmentReference.fromJS(_data["delivery"]) : undefined as any;
            this.pickup = _data["pickup"] ? OrderDTOFulfillmentReference.fromJS(_data["pickup"]) : undefined as any;
        }
    }

    static fromJS(data: any): OrderDTOFulfillment {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDTOFulfillment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["delivery"] = this.delivery ? this.delivery.toJSON() : undefined as any;
        data["pickup"] = this.pickup ? this.pickup.toJSON() : undefined as any;
        return data;
    }
}

export interface IOrderDTOFulfillment {
    delivery?: OrderDTOFulfillmentReference | undefined;
    pickup?: OrderDTOFulfillmentReference | undefined;
}

export class OrderDTOFulfillmentReference extends OrderDTOReference implements IOrderDTOFulfillmentReference {
    status?: string | undefined;
    bid?: OrderDTOBidReference | undefined;
    quote?: OrderDTOQuoteReference | undefined;
    invoice?: OrderDTOMoneyReference | undefined;

    constructor(data?: IOrderDTOFulfillmentReference) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
            this.bid = _data["bid"] ? OrderDTOBidReference.fromJS(_data["bid"]) : undefined as any;
            this.quote = _data["quote"] ? OrderDTOQuoteReference.fromJS(_data["quote"]) : undefined as any;
            this.invoice = _data["invoice"] ? OrderDTOMoneyReference.fromJS(_data["invoice"]) : undefined as any;
        }
    }

    static override fromJS(data: any): OrderDTOFulfillmentReference {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDTOFulfillmentReference();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["bid"] = this.bid ? this.bid.toJSON() : undefined as any;
        data["quote"] = this.quote ? this.quote.toJSON() : undefined as any;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IOrderDTOFulfillmentReference extends IOrderDTOReference {
    status?: string | undefined;
    bid?: OrderDTOBidReference | undefined;
    quote?: OrderDTOQuoteReference | undefined;
    invoice?: OrderDTOMoneyReference | undefined;
}

export class OrderDTOMoneyReference extends OrderDTOReference implements IOrderDTOMoneyReference {
    amount?: number | undefined;
    tax?: number | undefined;
    total?: number | undefined;

    constructor(data?: IOrderDTOMoneyReference) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.amount = _data["amount"];
            this.tax = _data["tax"];
            this.total = _data["total"];
        }
    }

    static override fromJS(data: any): OrderDTOMoneyReference {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDTOMoneyReference();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["tax"] = this.tax;
        data["total"] = this.total;
        super.toJSON(data);
        return data;
    }
}

export interface IOrderDTOMoneyReference extends IOrderDTOReference {
    amount?: number | undefined;
    tax?: number | undefined;
    total?: number | undefined;
}

export class OrderDTOBidReference extends OrderDTOMoneyReference implements IOrderDTOBidReference {
    quantity?: number | undefined;

    constructor(data?: IOrderDTOBidReference) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.quantity = _data["quantity"];
        }
    }

    static override fromJS(data: any): OrderDTOBidReference {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDTOBidReference();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity;
        super.toJSON(data);
        return data;
    }
}

export interface IOrderDTOBidReference extends IOrderDTOMoneyReference {
    quantity?: number | undefined;
}

export class OrderDTOQuoteReference extends OrderDTOReference implements IOrderDTOQuoteReference {
    nte?: number | undefined;

    constructor(data?: IOrderDTOQuoteReference) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nte = _data["nte"];
        }
    }

    static override fromJS(data: any): OrderDTOQuoteReference {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDTOQuoteReference();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nte"] = this.nte;
        super.toJSON(data);
        return data;
    }
}

export interface IOrderDTOQuoteReference extends IOrderDTOReference {
    nte?: number | undefined;
}

export class OrderDTOAsset implements IOrderDTOAsset {
    id?: string | undefined;
    idx?: string | undefined;
    newAssetId?: number;
    poLineItem?: number | undefined;
    type?: string | undefined;
    provider?: OrderDTOProviderReference | undefined;
    size?: number | undefined;
    sizeNote?: string | undefined;
    tankSize?: number | undefined;
    monitoredTankCategory?: string | undefined;
    telemetryProvider?: string | undefined;
    telemetryVendorDeviceId?: string | undefined;
    telemetryMinimumFuelPercent?: number | undefined;
    telemetryActive?: boolean;
    voltage?: number | undefined;
    temperature?: string | undefined;
    power?: string | undefined;
    door?: string | undefined;
    requestDoor?: string | undefined;
    refrigerator?: string | undefined;
    engineHoursOut?: number | undefined;
    engineHoursIn?: number | undefined;
    fuelOut?: number | undefined;
    fuelIn?: number | undefined;
    noDrop?: boolean;
    costs?: OrderDTOAssetCosts | undefined;
    delivery?: OrderDTODrop | undefined;
    pickup?: OrderDTODrop | undefined;
    verificationDate?: Date | undefined;
    notes?: string | undefined;
    deliveryComplete?: boolean;
    noDropReason?: string | undefined;
    noDropReasonID?: number | undefined;
    noDropNotes?: string | undefined;
    status?: string | undefined;
    notMaintained?: boolean | undefined;
    providerDeliveryEstimate?: number | undefined;
    providerPickupEstimate?: number | undefined;
    unitValue?: number | undefined;
    requestStairs?: boolean;
    mileageIn?: number | undefined;
    mileageOut?: number | undefined;
    exceptions?: string[] | undefined;
    fuelProviders?: string[] | undefined;
    noPickup?: boolean;
    associatedAssetID?: number | undefined;
    accessoryType?: string | undefined;
    monthlyBillRate?: number | undefined;
    modDeclined?: boolean;
    turnedOn?: boolean;
    isTelematicsOn?: boolean;
    lastModifiedDate?: Date;
    expectedTurnOnDate?: Date | undefined;
    isVerifiedTrailerNumber?: boolean | undefined;
    fuelReading?: number | undefined;
    isDoorOperational?: boolean | undefined;
    isBulkheadCorrect?: boolean | undefined;
    verifiedBy?: string | undefined;
    verifiedOn?: Date | undefined;
    requestRamps?: boolean;
    requestLiftGate?: boolean;
    rescheduledDeliveryDate?: Date | undefined;

    constructor(data?: IOrderDTOAsset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idx = _data["idx"];
            this.newAssetId = _data["newAssetId"];
            this.poLineItem = _data["poLineItem"];
            this.type = _data["type"];
            this.provider = _data["provider"] ? OrderDTOProviderReference.fromJS(_data["provider"]) : undefined as any;
            this.size = _data["size"];
            this.sizeNote = _data["sizeNote"];
            this.tankSize = _data["tankSize"];
            this.monitoredTankCategory = _data["monitoredTankCategory"];
            this.telemetryProvider = _data["telemetryProvider"];
            this.telemetryVendorDeviceId = _data["telemetryVendorDeviceId"];
            this.telemetryMinimumFuelPercent = _data["telemetryMinimumFuelPercent"];
            this.telemetryActive = _data["telemetryActive"];
            this.voltage = _data["voltage"];
            this.temperature = _data["temperature"];
            this.power = _data["power"];
            this.door = _data["door"];
            this.requestDoor = _data["requestDoor"];
            this.refrigerator = _data["refrigerator"];
            this.engineHoursOut = _data["engineHoursOut"];
            this.engineHoursIn = _data["engineHoursIn"];
            this.fuelOut = _data["fuelOut"];
            this.fuelIn = _data["fuelIn"];
            this.noDrop = _data["noDrop"];
            this.costs = _data["costs"] ? OrderDTOAssetCosts.fromJS(_data["costs"]) : undefined as any;
            this.delivery = _data["delivery"] ? OrderDTODrop.fromJS(_data["delivery"]) : undefined as any;
            this.pickup = _data["pickup"] ? OrderDTODrop.fromJS(_data["pickup"]) : undefined as any;
            this.verificationDate = _data["verificationDate"] ? new Date(_data["verificationDate"].toString()) : undefined as any;
            this.notes = _data["notes"];
            this.deliveryComplete = _data["deliveryComplete"];
            this.noDropReason = _data["noDropReason"];
            this.noDropReasonID = _data["noDropReasonID"];
            this.noDropNotes = _data["noDropNotes"];
            this.status = _data["status"];
            this.notMaintained = _data["notMaintained"];
            this.providerDeliveryEstimate = _data["providerDeliveryEstimate"];
            this.providerPickupEstimate = _data["providerPickupEstimate"];
            this.unitValue = _data["unitValue"];
            this.requestStairs = _data["requestStairs"];
            this.mileageIn = _data["mileageIn"];
            this.mileageOut = _data["mileageOut"];
            if (Array.isArray(_data["exceptions"])) {
                this.exceptions = [] as any;
                for (let item of _data["exceptions"])
                    this.exceptions!.push(item);
            }
            if (Array.isArray(_data["fuelProviders"])) {
                this.fuelProviders = [] as any;
                for (let item of _data["fuelProviders"])
                    this.fuelProviders!.push(item);
            }
            this.noPickup = _data["noPickup"];
            this.associatedAssetID = _data["associatedAssetID"];
            this.accessoryType = _data["accessoryType"];
            this.monthlyBillRate = _data["monthlyBillRate"];
            this.modDeclined = _data["modDeclined"];
            this.turnedOn = _data["turnedOn"];
            this.isTelematicsOn = _data["isTelematicsOn"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.expectedTurnOnDate = _data["expectedTurnOnDate"] ? new Date(_data["expectedTurnOnDate"].toString()) : undefined as any;
            this.isVerifiedTrailerNumber = _data["isVerifiedTrailerNumber"];
            this.fuelReading = _data["fuelReading"];
            this.isDoorOperational = _data["isDoorOperational"];
            this.isBulkheadCorrect = _data["isBulkheadCorrect"];
            this.verifiedBy = _data["verifiedBy"];
            this.verifiedOn = _data["verifiedOn"] ? new Date(_data["verifiedOn"].toString()) : undefined as any;
            this.requestRamps = _data["requestRamps"];
            this.requestLiftGate = _data["requestLiftGate"];
            this.rescheduledDeliveryDate = _data["rescheduledDeliveryDate"] ? new Date(_data["rescheduledDeliveryDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): OrderDTOAsset {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDTOAsset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idx"] = this.idx;
        data["newAssetId"] = this.newAssetId;
        data["poLineItem"] = this.poLineItem;
        data["type"] = this.type;
        data["provider"] = this.provider ? this.provider.toJSON() : undefined as any;
        data["size"] = this.size;
        data["sizeNote"] = this.sizeNote;
        data["tankSize"] = this.tankSize;
        data["monitoredTankCategory"] = this.monitoredTankCategory;
        data["telemetryProvider"] = this.telemetryProvider;
        data["telemetryVendorDeviceId"] = this.telemetryVendorDeviceId;
        data["telemetryMinimumFuelPercent"] = this.telemetryMinimumFuelPercent;
        data["telemetryActive"] = this.telemetryActive;
        data["voltage"] = this.voltage;
        data["temperature"] = this.temperature;
        data["power"] = this.power;
        data["door"] = this.door;
        data["requestDoor"] = this.requestDoor;
        data["refrigerator"] = this.refrigerator;
        data["engineHoursOut"] = this.engineHoursOut;
        data["engineHoursIn"] = this.engineHoursIn;
        data["fuelOut"] = this.fuelOut;
        data["fuelIn"] = this.fuelIn;
        data["noDrop"] = this.noDrop;
        data["costs"] = this.costs ? this.costs.toJSON() : undefined as any;
        data["delivery"] = this.delivery ? this.delivery.toJSON() : undefined as any;
        data["pickup"] = this.pickup ? this.pickup.toJSON() : undefined as any;
        data["verificationDate"] = this.verificationDate ? this.verificationDate.toISOString() : undefined as any;
        data["notes"] = this.notes;
        data["deliveryComplete"] = this.deliveryComplete;
        data["noDropReason"] = this.noDropReason;
        data["noDropReasonID"] = this.noDropReasonID;
        data["noDropNotes"] = this.noDropNotes;
        data["status"] = this.status;
        data["notMaintained"] = this.notMaintained;
        data["providerDeliveryEstimate"] = this.providerDeliveryEstimate;
        data["providerPickupEstimate"] = this.providerPickupEstimate;
        data["unitValue"] = this.unitValue;
        data["requestStairs"] = this.requestStairs;
        data["mileageIn"] = this.mileageIn;
        data["mileageOut"] = this.mileageOut;
        if (Array.isArray(this.exceptions)) {
            data["exceptions"] = [];
            for (let item of this.exceptions)
                data["exceptions"].push(item);
        }
        if (Array.isArray(this.fuelProviders)) {
            data["fuelProviders"] = [];
            for (let item of this.fuelProviders)
                data["fuelProviders"].push(item);
        }
        data["noPickup"] = this.noPickup;
        data["associatedAssetID"] = this.associatedAssetID;
        data["accessoryType"] = this.accessoryType;
        data["monthlyBillRate"] = this.monthlyBillRate;
        data["modDeclined"] = this.modDeclined;
        data["turnedOn"] = this.turnedOn;
        data["isTelematicsOn"] = this.isTelematicsOn;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["expectedTurnOnDate"] = this.expectedTurnOnDate ? this.expectedTurnOnDate.toISOString() : undefined as any;
        data["isVerifiedTrailerNumber"] = this.isVerifiedTrailerNumber;
        data["fuelReading"] = this.fuelReading;
        data["isDoorOperational"] = this.isDoorOperational;
        data["isBulkheadCorrect"] = this.isBulkheadCorrect;
        data["verifiedBy"] = this.verifiedBy;
        data["verifiedOn"] = this.verifiedOn ? this.verifiedOn.toISOString() : undefined as any;
        data["requestRamps"] = this.requestRamps;
        data["requestLiftGate"] = this.requestLiftGate;
        data["rescheduledDeliveryDate"] = this.rescheduledDeliveryDate ? this.rescheduledDeliveryDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IOrderDTOAsset {
    id?: string | undefined;
    idx?: string | undefined;
    newAssetId?: number;
    poLineItem?: number | undefined;
    type?: string | undefined;
    provider?: OrderDTOProviderReference | undefined;
    size?: number | undefined;
    sizeNote?: string | undefined;
    tankSize?: number | undefined;
    monitoredTankCategory?: string | undefined;
    telemetryProvider?: string | undefined;
    telemetryVendorDeviceId?: string | undefined;
    telemetryMinimumFuelPercent?: number | undefined;
    telemetryActive?: boolean;
    voltage?: number | undefined;
    temperature?: string | undefined;
    power?: string | undefined;
    door?: string | undefined;
    requestDoor?: string | undefined;
    refrigerator?: string | undefined;
    engineHoursOut?: number | undefined;
    engineHoursIn?: number | undefined;
    fuelOut?: number | undefined;
    fuelIn?: number | undefined;
    noDrop?: boolean;
    costs?: OrderDTOAssetCosts | undefined;
    delivery?: OrderDTODrop | undefined;
    pickup?: OrderDTODrop | undefined;
    verificationDate?: Date | undefined;
    notes?: string | undefined;
    deliveryComplete?: boolean;
    noDropReason?: string | undefined;
    noDropReasonID?: number | undefined;
    noDropNotes?: string | undefined;
    status?: string | undefined;
    notMaintained?: boolean | undefined;
    providerDeliveryEstimate?: number | undefined;
    providerPickupEstimate?: number | undefined;
    unitValue?: number | undefined;
    requestStairs?: boolean;
    mileageIn?: number | undefined;
    mileageOut?: number | undefined;
    exceptions?: string[] | undefined;
    fuelProviders?: string[] | undefined;
    noPickup?: boolean;
    associatedAssetID?: number | undefined;
    accessoryType?: string | undefined;
    monthlyBillRate?: number | undefined;
    modDeclined?: boolean;
    turnedOn?: boolean;
    isTelematicsOn?: boolean;
    lastModifiedDate?: Date;
    expectedTurnOnDate?: Date | undefined;
    isVerifiedTrailerNumber?: boolean | undefined;
    fuelReading?: number | undefined;
    isDoorOperational?: boolean | undefined;
    isBulkheadCorrect?: boolean | undefined;
    verifiedBy?: string | undefined;
    verifiedOn?: Date | undefined;
    requestRamps?: boolean;
    requestLiftGate?: boolean;
    rescheduledDeliveryDate?: Date | undefined;
}

export class OrderDTOProviderReference extends OrderDTOReference implements IOrderDTOProviderReference {
    mileage?: number | undefined;
    initialized?: boolean;
    cid?: string | undefined;

    constructor(data?: IOrderDTOProviderReference) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.mileage = _data["mileage"];
            this.initialized = _data["initialized"];
            this.cid = _data["cid"];
        }
    }

    static override fromJS(data: any): OrderDTOProviderReference {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDTOProviderReference();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mileage"] = this.mileage;
        data["initialized"] = this.initialized;
        data["cid"] = this.cid;
        super.toJSON(data);
        return data;
    }
}

export interface IOrderDTOProviderReference extends IOrderDTOReference {
    mileage?: number | undefined;
    initialized?: boolean;
    cid?: string | undefined;
}

export class OrderDTOAssetCosts implements IOrderDTOAssetCosts {
    rental?: OrderDTOAssetRentalCosts | undefined;
    hourlyRuntime?: number | undefined;
    mileageCost?: number | undefined;

    constructor(data?: IOrderDTOAssetCosts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rental = _data["rental"] ? OrderDTOAssetRentalCosts.fromJS(_data["rental"]) : undefined as any;
            this.hourlyRuntime = _data["hourlyRuntime"];
            this.mileageCost = _data["mileageCost"];
        }
    }

    static fromJS(data: any): OrderDTOAssetCosts {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDTOAssetCosts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rental"] = this.rental ? this.rental.toJSON() : undefined as any;
        data["hourlyRuntime"] = this.hourlyRuntime;
        data["mileageCost"] = this.mileageCost;
        return data;
    }
}

export interface IOrderDTOAssetCosts {
    rental?: OrderDTOAssetRentalCosts | undefined;
    hourlyRuntime?: number | undefined;
    mileageCost?: number | undefined;
}

export class OrderDTOAssetRentalCosts implements IOrderDTOAssetRentalCosts {
    daily?: number | undefined;
    weekly?: number | undefined;
    monthly?: number | undefined;

    constructor(data?: IOrderDTOAssetRentalCosts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.daily = _data["daily"];
            this.weekly = _data["weekly"];
            this.monthly = _data["monthly"];
        }
    }

    static fromJS(data: any): OrderDTOAssetRentalCosts {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDTOAssetRentalCosts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["daily"] = this.daily;
        data["weekly"] = this.weekly;
        data["monthly"] = this.monthly;
        return data;
    }
}

export interface IOrderDTOAssetRentalCosts {
    daily?: number | undefined;
    weekly?: number | undefined;
    monthly?: number | undefined;
}

export class OrderDTODrop implements IOrderDTODrop {
    driver?: string | undefined;
    prophesy?: OrderDTOReference | undefined;
    required?: Date | undefined;
    scheduled?: Date | undefined;
    actual?: Date | undefined;
    billingEnd?: Date | undefined;
    contractedRemoval?: Date | undefined;
    anticipatedRemoval?: Date | undefined;
    requestedRemoval?: Date | undefined;
    miles?: number | undefined;
    quote?: number | undefined;
    cost?: number | undefined;
    emergency?: boolean;
    lateReason?: string | undefined;

    constructor(data?: IOrderDTODrop) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.driver = _data["driver"];
            this.prophesy = _data["prophesy"] ? OrderDTOReference.fromJS(_data["prophesy"]) : undefined as any;
            this.required = _data["required"] ? new Date(_data["required"].toString()) : undefined as any;
            this.scheduled = _data["scheduled"] ? new Date(_data["scheduled"].toString()) : undefined as any;
            this.actual = _data["actual"] ? new Date(_data["actual"].toString()) : undefined as any;
            this.billingEnd = _data["billingEnd"] ? new Date(_data["billingEnd"].toString()) : undefined as any;
            this.contractedRemoval = _data["contractedRemoval"] ? new Date(_data["contractedRemoval"].toString()) : undefined as any;
            this.anticipatedRemoval = _data["anticipatedRemoval"] ? new Date(_data["anticipatedRemoval"].toString()) : undefined as any;
            this.requestedRemoval = _data["requestedRemoval"] ? new Date(_data["requestedRemoval"].toString()) : undefined as any;
            this.miles = _data["miles"];
            this.quote = _data["quote"];
            this.cost = _data["cost"];
            this.emergency = _data["emergency"];
            this.lateReason = _data["lateReason"];
        }
    }

    static fromJS(data: any): OrderDTODrop {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDTODrop();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["driver"] = this.driver;
        data["prophesy"] = this.prophesy ? this.prophesy.toJSON() : undefined as any;
        data["required"] = this.required ? this.required.toISOString() : undefined as any;
        data["scheduled"] = this.scheduled ? this.scheduled.toISOString() : undefined as any;
        data["actual"] = this.actual ? this.actual.toISOString() : undefined as any;
        data["billingEnd"] = this.billingEnd ? this.billingEnd.toISOString() : undefined as any;
        data["contractedRemoval"] = this.contractedRemoval ? this.contractedRemoval.toISOString() : undefined as any;
        data["anticipatedRemoval"] = this.anticipatedRemoval ? this.anticipatedRemoval.toISOString() : undefined as any;
        data["requestedRemoval"] = this.requestedRemoval ? this.requestedRemoval.toISOString() : undefined as any;
        data["miles"] = this.miles;
        data["quote"] = this.quote;
        data["cost"] = this.cost;
        data["emergency"] = this.emergency;
        data["lateReason"] = this.lateReason;
        return data;
    }
}

export interface IOrderDTODrop {
    driver?: string | undefined;
    prophesy?: OrderDTOReference | undefined;
    required?: Date | undefined;
    scheduled?: Date | undefined;
    actual?: Date | undefined;
    billingEnd?: Date | undefined;
    contractedRemoval?: Date | undefined;
    anticipatedRemoval?: Date | undefined;
    requestedRemoval?: Date | undefined;
    miles?: number | undefined;
    quote?: number | undefined;
    cost?: number | undefined;
    emergency?: boolean;
    lateReason?: string | undefined;
}

export class AssetInspectionDTO implements IAssetInspectionDTO {
    id?: number | undefined;
    assetID?: number;
    isVerifiedTrailerNumber?: boolean;
    fuelReading?: number;
    isDoorOperational?: boolean;
    isBulkheadCorrect?: boolean | undefined;
    controlPanelDocumentID?: string | undefined;
    fuelGaugeDocumentID?: string | undefined;
    acknowledgementID?: number | undefined;
    verifiedBy?: string | undefined;
    verifiedOn?: Date | undefined;
    controlPanelDocumentData?: string | undefined;
    controlPanelDocumentName?: string | undefined;
    controlPanelContentType?: string | undefined;
    fuelGaugeDocumentData?: string | undefined;
    fuelGaugeDocumentName?: string | undefined;
    fuelGaugeContentType?: string | undefined;
    assetNote?: string | undefined;
    supportingImages?: InspectionSupportingImages[] | undefined;

    constructor(data?: IAssetInspectionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assetID = _data["assetID"];
            this.isVerifiedTrailerNumber = _data["isVerifiedTrailerNumber"];
            this.fuelReading = _data["fuelReading"];
            this.isDoorOperational = _data["isDoorOperational"];
            this.isBulkheadCorrect = _data["isBulkheadCorrect"];
            this.controlPanelDocumentID = _data["controlPanelDocumentID"];
            this.fuelGaugeDocumentID = _data["fuelGaugeDocumentID"];
            this.acknowledgementID = _data["acknowledgementID"];
            this.verifiedBy = _data["verifiedBy"];
            this.verifiedOn = _data["verifiedOn"] ? new Date(_data["verifiedOn"].toString()) : undefined as any;
            this.controlPanelDocumentData = _data["controlPanelDocumentData"];
            this.controlPanelDocumentName = _data["controlPanelDocumentName"];
            this.controlPanelContentType = _data["controlPanelContentType"];
            this.fuelGaugeDocumentData = _data["fuelGaugeDocumentData"];
            this.fuelGaugeDocumentName = _data["fuelGaugeDocumentName"];
            this.fuelGaugeContentType = _data["fuelGaugeContentType"];
            this.assetNote = _data["assetNote"];
            if (Array.isArray(_data["supportingImages"])) {
                this.supportingImages = [] as any;
                for (let item of _data["supportingImages"])
                    this.supportingImages!.push(InspectionSupportingImages.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetInspectionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssetInspectionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assetID"] = this.assetID;
        data["isVerifiedTrailerNumber"] = this.isVerifiedTrailerNumber;
        data["fuelReading"] = this.fuelReading;
        data["isDoorOperational"] = this.isDoorOperational;
        data["isBulkheadCorrect"] = this.isBulkheadCorrect;
        data["controlPanelDocumentID"] = this.controlPanelDocumentID;
        data["fuelGaugeDocumentID"] = this.fuelGaugeDocumentID;
        data["acknowledgementID"] = this.acknowledgementID;
        data["verifiedBy"] = this.verifiedBy;
        data["verifiedOn"] = this.verifiedOn ? this.verifiedOn.toISOString() : undefined as any;
        data["controlPanelDocumentData"] = this.controlPanelDocumentData;
        data["controlPanelDocumentName"] = this.controlPanelDocumentName;
        data["controlPanelContentType"] = this.controlPanelContentType;
        data["fuelGaugeDocumentData"] = this.fuelGaugeDocumentData;
        data["fuelGaugeDocumentName"] = this.fuelGaugeDocumentName;
        data["fuelGaugeContentType"] = this.fuelGaugeContentType;
        data["assetNote"] = this.assetNote;
        if (Array.isArray(this.supportingImages)) {
            data["supportingImages"] = [];
            for (let item of this.supportingImages)
                data["supportingImages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAssetInspectionDTO {
    id?: number | undefined;
    assetID?: number;
    isVerifiedTrailerNumber?: boolean;
    fuelReading?: number;
    isDoorOperational?: boolean;
    isBulkheadCorrect?: boolean | undefined;
    controlPanelDocumentID?: string | undefined;
    fuelGaugeDocumentID?: string | undefined;
    acknowledgementID?: number | undefined;
    verifiedBy?: string | undefined;
    verifiedOn?: Date | undefined;
    controlPanelDocumentData?: string | undefined;
    controlPanelDocumentName?: string | undefined;
    controlPanelContentType?: string | undefined;
    fuelGaugeDocumentData?: string | undefined;
    fuelGaugeDocumentName?: string | undefined;
    fuelGaugeContentType?: string | undefined;
    assetNote?: string | undefined;
    supportingImages?: InspectionSupportingImages[] | undefined;
}

export class InspectionSupportingImages implements IInspectionSupportingImages {
    data?: string | undefined;
    name?: string | undefined;
    contentType?: string | undefined;

    constructor(data?: IInspectionSupportingImages) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
            this.name = _data["name"];
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): InspectionSupportingImages {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionSupportingImages();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        data["name"] = this.name;
        data["contentType"] = this.contentType;
        return data;
    }
}

export interface IInspectionSupportingImages {
    data?: string | undefined;
    name?: string | undefined;
    contentType?: string | undefined;
}

export class AddAuditEventStoreDTO implements IAddAuditEventStoreDTO {
    auditorName?: string | undefined;
    auditEvents?: AddAuditEventDTO[] | undefined;

    constructor(data?: IAddAuditEventStoreDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditorName = _data["auditorName"];
            if (Array.isArray(_data["auditEvents"])) {
                this.auditEvents = [] as any;
                for (let item of _data["auditEvents"])
                    this.auditEvents!.push(AddAuditEventDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddAuditEventStoreDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddAuditEventStoreDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditorName"] = this.auditorName;
        if (Array.isArray(this.auditEvents)) {
            data["auditEvents"] = [];
            for (let item of this.auditEvents)
                data["auditEvents"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAddAuditEventStoreDTO {
    auditorName?: string | undefined;
    auditEvents?: AddAuditEventDTO[] | undefined;
}

export class AddAuditEventDTO implements IAddAuditEventDTO {
    assetID?: number;
    fuelReading?: number;
    zone1Temperature?: number | undefined;
    zone2Temperature?: number | undefined;
    auditVarianceReasonID?: number;
    auditVarianceReasonNote?: string | undefined;
    isSkippedAlarmCreation?: boolean | undefined;
    varianceStatus?: string | undefined;

    constructor(data?: IAddAuditEventDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetID = _data["assetID"];
            this.fuelReading = _data["fuelReading"];
            this.zone1Temperature = _data["zone1Temperature"];
            this.zone2Temperature = _data["zone2Temperature"];
            this.auditVarianceReasonID = _data["auditVarianceReasonID"];
            this.auditVarianceReasonNote = _data["auditVarianceReasonNote"];
            this.isSkippedAlarmCreation = _data["isSkippedAlarmCreation"];
            this.varianceStatus = _data["varianceStatus"];
        }
    }

    static fromJS(data: any): AddAuditEventDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddAuditEventDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetID"] = this.assetID;
        data["fuelReading"] = this.fuelReading;
        data["zone1Temperature"] = this.zone1Temperature;
        data["zone2Temperature"] = this.zone2Temperature;
        data["auditVarianceReasonID"] = this.auditVarianceReasonID;
        data["auditVarianceReasonNote"] = this.auditVarianceReasonNote;
        data["isSkippedAlarmCreation"] = this.isSkippedAlarmCreation;
        data["varianceStatus"] = this.varianceStatus;
        return data;
    }
}

export interface IAddAuditEventDTO {
    assetID?: number;
    fuelReading?: number;
    zone1Temperature?: number | undefined;
    zone2Temperature?: number | undefined;
    auditVarianceReasonID?: number;
    auditVarianceReasonNote?: string | undefined;
    isSkippedAlarmCreation?: boolean | undefined;
    varianceStatus?: string | undefined;
}

export class AuditVarianceReason implements IAuditVarianceReason {
    auditVarianceReasonID?: number;
    description!: string;
    allowNotes?: boolean;

    constructor(data?: IAuditVarianceReason) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditVarianceReasonID = _data["auditVarianceReasonID"];
            this.description = _data["description"];
            this.allowNotes = _data["allowNotes"];
        }
    }

    static fromJS(data: any): AuditVarianceReason {
        data = typeof data === 'object' ? data : {};
        let result = new AuditVarianceReason();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditVarianceReasonID"] = this.auditVarianceReasonID;
        data["description"] = this.description;
        data["allowNotes"] = this.allowNotes;
        return data;
    }
}

export interface IAuditVarianceReason {
    auditVarianceReasonID?: number;
    description: string;
    allowNotes?: boolean;
}

export class AuditSchedule implements IAuditSchedule {
    auditScheduleID?: number | undefined;
    customerID?: string | undefined;
    description?: string | undefined;
    placardText?: string | undefined;
    isDefault?: boolean;

    constructor(data?: IAuditSchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditScheduleID = _data["auditScheduleID"];
            this.customerID = _data["customerID"];
            this.description = _data["description"];
            this.placardText = _data["placardText"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): AuditSchedule {
        data = typeof data === 'object' ? data : {};
        let result = new AuditSchedule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditScheduleID"] = this.auditScheduleID;
        data["customerID"] = this.customerID;
        data["description"] = this.description;
        data["placardText"] = this.placardText;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IAuditSchedule {
    auditScheduleID?: number | undefined;
    customerID?: string | undefined;
    description?: string | undefined;
    placardText?: string | undefined;
    isDefault?: boolean;
}

export class TrailerSummaryDTO implements ITrailerSummaryDTO {
    location?: TrailerSummaryLocationDto | undefined;
    asset?: OrderList | undefined;
    provider?: TrailerSummaryProviderDto | undefined;
    fuelProvider?: TrailerSummaryProviderDto | undefined;
    deliverySchedule?: number;
    deliveryScheduleString?: string | undefined;
    fuelDelivery?: FuelDeliveryDTO | undefined;
    currentTemp?: number | undefined;
    zone1TempRangeID?: number | undefined;
    zone1TemperatureRange?: string | undefined;
    zone2TempRangeID?: number | undefined;
    zone2TemperatureRange?: string | undefined;
    zone1Min?: number | undefined;
    zone1Max?: number | undefined;
    zone2Min?: number | undefined;
    zone2Max?: number | undefined;
    expectedTurnOnDate?: Date | undefined;
    fuelServiceActive?: boolean;
    locationAssetCount?: number | undefined;

    constructor(data?: ITrailerSummaryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"] ? TrailerSummaryLocationDto.fromJS(_data["location"]) : undefined as any;
            this.asset = _data["asset"] ? OrderList.fromJS(_data["asset"]) : undefined as any;
            this.provider = _data["provider"] ? TrailerSummaryProviderDto.fromJS(_data["provider"]) : undefined as any;
            this.fuelProvider = _data["fuelProvider"] ? TrailerSummaryProviderDto.fromJS(_data["fuelProvider"]) : undefined as any;
            this.deliverySchedule = _data["deliverySchedule"];
            this.deliveryScheduleString = _data["deliveryScheduleString"];
            this.fuelDelivery = _data["fuelDelivery"] ? FuelDeliveryDTO.fromJS(_data["fuelDelivery"]) : undefined as any;
            this.currentTemp = _data["currentTemp"];
            this.zone1TempRangeID = _data["zone1TempRangeID"];
            this.zone1TemperatureRange = _data["zone1TemperatureRange"];
            this.zone2TempRangeID = _data["zone2TempRangeID"];
            this.zone2TemperatureRange = _data["zone2TemperatureRange"];
            this.zone1Min = _data["zone1Min"];
            this.zone1Max = _data["zone1Max"];
            this.zone2Min = _data["zone2Min"];
            this.zone2Max = _data["zone2Max"];
            this.expectedTurnOnDate = _data["expectedTurnOnDate"] ? new Date(_data["expectedTurnOnDate"].toString()) : undefined as any;
            this.fuelServiceActive = _data["fuelServiceActive"];
            this.locationAssetCount = _data["locationAssetCount"];
        }
    }

    static fromJS(data: any): TrailerSummaryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TrailerSummaryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location ? this.location.toJSON() : undefined as any;
        data["asset"] = this.asset ? this.asset.toJSON() : undefined as any;
        data["provider"] = this.provider ? this.provider.toJSON() : undefined as any;
        data["fuelProvider"] = this.fuelProvider ? this.fuelProvider.toJSON() : undefined as any;
        data["deliverySchedule"] = this.deliverySchedule;
        data["deliveryScheduleString"] = this.deliveryScheduleString;
        data["fuelDelivery"] = this.fuelDelivery ? this.fuelDelivery.toJSON() : undefined as any;
        data["currentTemp"] = this.currentTemp;
        data["zone1TempRangeID"] = this.zone1TempRangeID;
        data["zone1TemperatureRange"] = this.zone1TemperatureRange;
        data["zone2TempRangeID"] = this.zone2TempRangeID;
        data["zone2TemperatureRange"] = this.zone2TemperatureRange;
        data["zone1Min"] = this.zone1Min;
        data["zone1Max"] = this.zone1Max;
        data["zone2Min"] = this.zone2Min;
        data["zone2Max"] = this.zone2Max;
        data["expectedTurnOnDate"] = this.expectedTurnOnDate ? this.expectedTurnOnDate.toISOString() : undefined as any;
        data["fuelServiceActive"] = this.fuelServiceActive;
        data["locationAssetCount"] = this.locationAssetCount;
        return data;
    }
}

export interface ITrailerSummaryDTO {
    location?: TrailerSummaryLocationDto | undefined;
    asset?: OrderList | undefined;
    provider?: TrailerSummaryProviderDto | undefined;
    fuelProvider?: TrailerSummaryProviderDto | undefined;
    deliverySchedule?: number;
    deliveryScheduleString?: string | undefined;
    fuelDelivery?: FuelDeliveryDTO | undefined;
    currentTemp?: number | undefined;
    zone1TempRangeID?: number | undefined;
    zone1TemperatureRange?: string | undefined;
    zone2TempRangeID?: number | undefined;
    zone2TemperatureRange?: string | undefined;
    zone1Min?: number | undefined;
    zone1Max?: number | undefined;
    zone2Min?: number | undefined;
    zone2Max?: number | undefined;
    expectedTurnOnDate?: Date | undefined;
    fuelServiceActive?: boolean;
    locationAssetCount?: number | undefined;
}

export class TrailerSummaryLocationDto implements ITrailerSummaryLocationDto {
    id?: string | undefined;
    locID?: number;
    idx?: string | undefined;
    name?: string | undefined;
    customerId?: string | undefined;
    newCustomerId?: number | undefined;
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    primaryPhone?: string | undefined;
    primaryPhoneExt?: string | undefined;
    email?: string | undefined;
    longitude?: number;
    latitude?: number;
    weekdayAuditScheduleID?: number | undefined;
    weekendAuditScheduleID?: number | undefined;
    ianaZoneName?: string | undefined;
    shouldAudit?: string | undefined;
    shouldRemindEmail?: boolean | undefined;
    shouldRemindNumber?: boolean | undefined;
    shouldRemindPortal?: boolean | undefined;
    lastNote?: string | undefined;
    lastNoteDate?: Date | undefined;
    weekdayAuditSchedule?: AuditSchedule | undefined;
    weekendAuditSchedule?: AuditSchedule | undefined;

    constructor(data?: ITrailerSummaryLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locID = _data["locID"];
            this.idx = _data["idx"];
            this.name = _data["name"];
            this.customerId = _data["customerId"];
            this.newCustomerId = _data["newCustomerId"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.primaryPhone = _data["primaryPhone"];
            this.primaryPhoneExt = _data["primaryPhoneExt"];
            this.email = _data["email"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.weekdayAuditScheduleID = _data["weekdayAuditScheduleID"];
            this.weekendAuditScheduleID = _data["weekendAuditScheduleID"];
            this.ianaZoneName = _data["ianaZoneName"];
            this.shouldAudit = _data["shouldAudit"];
            this.shouldRemindEmail = _data["shouldRemindEmail"];
            this.shouldRemindNumber = _data["shouldRemindNumber"];
            this.shouldRemindPortal = _data["shouldRemindPortal"];
            this.lastNote = _data["lastNote"];
            this.lastNoteDate = _data["lastNoteDate"] ? new Date(_data["lastNoteDate"].toString()) : undefined as any;
            this.weekdayAuditSchedule = _data["weekdayAuditSchedule"] ? AuditSchedule.fromJS(_data["weekdayAuditSchedule"]) : undefined as any;
            this.weekendAuditSchedule = _data["weekendAuditSchedule"] ? AuditSchedule.fromJS(_data["weekendAuditSchedule"]) : undefined as any;
        }
    }

    static fromJS(data: any): TrailerSummaryLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrailerSummaryLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locID"] = this.locID;
        data["idx"] = this.idx;
        data["name"] = this.name;
        data["customerId"] = this.customerId;
        data["newCustomerId"] = this.newCustomerId;
        data["street"] = this.street;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["primaryPhone"] = this.primaryPhone;
        data["primaryPhoneExt"] = this.primaryPhoneExt;
        data["email"] = this.email;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["weekdayAuditScheduleID"] = this.weekdayAuditScheduleID;
        data["weekendAuditScheduleID"] = this.weekendAuditScheduleID;
        data["ianaZoneName"] = this.ianaZoneName;
        data["shouldAudit"] = this.shouldAudit;
        data["shouldRemindEmail"] = this.shouldRemindEmail;
        data["shouldRemindNumber"] = this.shouldRemindNumber;
        data["shouldRemindPortal"] = this.shouldRemindPortal;
        data["lastNote"] = this.lastNote;
        data["lastNoteDate"] = this.lastNoteDate ? this.lastNoteDate.toISOString() : undefined as any;
        data["weekdayAuditSchedule"] = this.weekdayAuditSchedule ? this.weekdayAuditSchedule.toJSON() : undefined as any;
        data["weekendAuditSchedule"] = this.weekendAuditSchedule ? this.weekendAuditSchedule.toJSON() : undefined as any;
        return data;
    }
}

export interface ITrailerSummaryLocationDto {
    id?: string | undefined;
    locID?: number;
    idx?: string | undefined;
    name?: string | undefined;
    customerId?: string | undefined;
    newCustomerId?: number | undefined;
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    primaryPhone?: string | undefined;
    primaryPhoneExt?: string | undefined;
    email?: string | undefined;
    longitude?: number;
    latitude?: number;
    weekdayAuditScheduleID?: number | undefined;
    weekendAuditScheduleID?: number | undefined;
    ianaZoneName?: string | undefined;
    shouldAudit?: string | undefined;
    shouldRemindEmail?: boolean | undefined;
    shouldRemindNumber?: boolean | undefined;
    shouldRemindPortal?: boolean | undefined;
    lastNote?: string | undefined;
    lastNoteDate?: Date | undefined;
    weekdayAuditSchedule?: AuditSchedule | undefined;
    weekendAuditSchedule?: AuditSchedule | undefined;
}

export class OrderList implements IOrderList {
    assetID?: number;
    orderID?: number;
    legacyAssetID?: string | undefined;
    trailerNumber?: string | undefined;
    assetType?: string | undefined;
    temperatureType?: string | undefined;
    doorType?: string | undefined;
    requestDoorType?: string | undefined;
    powerType?: string | undefined;
    refrigeratorType?: string | undefined;
    poLineItem?: number | undefined;
    providerID?: string | undefined;
    legacyProviderID?: string | undefined;
    providerName?: string | undefined;
    size?: number | undefined;
    sizeNote?: string | undefined;
    tankSize?: number | undefined;
    voltage?: number | undefined;
    engineHoursIn?: number | undefined;
    engineHoursOut?: number | undefined;
    noDrop?: boolean;
    rentalCostDaily?: number | undefined;
    rentalCostWeekly?: number | undefined;
    rentalCostMonthly?: number | undefined;
    hourlyRuntimeRate?: number | undefined;
    deliveryDriverType?: string | undefined;
    deliveryRequiredDate?: Date | undefined;
    deliveryScheduledDate?: Date | undefined;
    deliveryActualDate?: Date | undefined;
    deliveryMiles?: number | undefined;
    deliveryQuote?: number | undefined;
    deliveryCost?: number | undefined;
    deliveryEmergency?: boolean;
    pickupDriverType?: string | undefined;
    pickupScheduledDate?: Date | undefined;
    pickupActualDate?: Date | undefined;
    pickupBillingEnd?: Date | undefined;
    pickupContractedRemoval?: Date | undefined;
    pickupRequestedRemoval?: Date | undefined;
    pickupMiles?: number | undefined;
    pickupQuote?: number | undefined;
    pickupCost?: number | undefined;
    pickupEmergency?: boolean;
    verificationDate?: Date | undefined;
    notes?: string | undefined;
    deliveryComplete?: boolean;
    deleted?: boolean;
    assetStatus?: string | undefined;
    orderIDX?: string | undefined;
    customerID?: string | undefined;
    customerName?: string | undefined;
    locationID?: string | undefined;
    storeNumber?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    taxRate?: number | undefined;
    legacyLocationID?: string | undefined;
    orderStatus?: string | undefined;
    category?: string | undefined;
    poNumber?: string | undefined;
    requiresReview?: boolean;
    requestRequirement?: string | undefined;
    requestPriority?: string | undefined;
    requestQuantity?: number | undefined;
    requestReceived?: Date | undefined;
    requestDescription?: string | undefined;
    requestOrderedBy?: string | undefined;
    deliveryFulfillmentBidQuantity?: number | undefined;
    deliveryFulfillmentBidAmount?: number | undefined;
    deliveryFulfillmentBidTax?: number | undefined;
    deliveryFulfillmentBidTotal?: number | undefined;
    deliveryFulfillmentQuoteNTE?: number | undefined;
    createdDate?: Date;
    zone1TempRangeID?: number | undefined;
    zone2TempRangeID?: number | undefined;
    deliverySchedule?: number;
    turnedOn?: boolean;
    orderTags?: string | undefined;
    orderTagIDs?: string | undefined;
    notMaintained?: boolean | undefined;
    auditNotes?: string | undefined;
    noDropReason?: string | undefined;
    unitValue?: number | undefined;
    anticipatedRemovalDate?: Date | undefined;
    mileageOut?: number | undefined;
    mileageIn?: number | undefined;
    mileageCost?: number | undefined;
    fuelOut?: number | undefined;
    fuelIn?: number | undefined;
    serviceChannelLastUpdateDate?: Date | undefined;
    noPickup?: boolean;
    locID?: number | undefined;
    deliveryLoad?: number | undefined;
    pickupLoad?: number | undefined;
    assetRequestReminderSent?: Date | undefined;
    expectedTurnOnDate?: Date | undefined;
    lastTelematicsReceived?: Date | undefined;
    unitModeDetail?: string | undefined;
    zone1SetPoint?: number | undefined;
    zone2SetPoint?: number | undefined;
    zone3SetPoint?: number | undefined;
    fuelProviderID?: string | undefined;
    fuelProviderName?: string | undefined;
    isEmergency?: boolean | undefined;
    assetSizeType?: string | undefined;
    originalAssetType?: string | undefined;
    originalAssetTypeDescription?: string | undefined;
    serviceChannelRecentUpdateFlag?: boolean;
    isTelematicsOn?: boolean;
    assetExceptions?: AssetException[] | undefined;

    constructor(data?: IOrderList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetID = _data["assetID"];
            this.orderID = _data["orderID"];
            this.legacyAssetID = _data["legacyAssetID"];
            this.trailerNumber = _data["trailerNumber"];
            this.assetType = _data["assetType"];
            this.temperatureType = _data["temperatureType"];
            this.doorType = _data["doorType"];
            this.requestDoorType = _data["requestDoorType"];
            this.powerType = _data["powerType"];
            this.refrigeratorType = _data["refrigeratorType"];
            this.poLineItem = _data["poLineItem"];
            this.providerID = _data["providerID"];
            this.legacyProviderID = _data["legacyProviderID"];
            this.providerName = _data["providerName"];
            this.size = _data["size"];
            this.sizeNote = _data["sizeNote"];
            this.tankSize = _data["tankSize"];
            this.voltage = _data["voltage"];
            this.engineHoursIn = _data["engineHoursIn"];
            this.engineHoursOut = _data["engineHoursOut"];
            this.noDrop = _data["noDrop"];
            this.rentalCostDaily = _data["rentalCostDaily"];
            this.rentalCostWeekly = _data["rentalCostWeekly"];
            this.rentalCostMonthly = _data["rentalCostMonthly"];
            this.hourlyRuntimeRate = _data["hourlyRuntimeRate"];
            this.deliveryDriverType = _data["deliveryDriverType"];
            this.deliveryRequiredDate = _data["deliveryRequiredDate"] ? new Date(_data["deliveryRequiredDate"].toString()) : undefined as any;
            this.deliveryScheduledDate = _data["deliveryScheduledDate"] ? new Date(_data["deliveryScheduledDate"].toString()) : undefined as any;
            this.deliveryActualDate = _data["deliveryActualDate"] ? new Date(_data["deliveryActualDate"].toString()) : undefined as any;
            this.deliveryMiles = _data["deliveryMiles"];
            this.deliveryQuote = _data["deliveryQuote"];
            this.deliveryCost = _data["deliveryCost"];
            this.deliveryEmergency = _data["deliveryEmergency"];
            this.pickupDriverType = _data["pickupDriverType"];
            this.pickupScheduledDate = _data["pickupScheduledDate"] ? new Date(_data["pickupScheduledDate"].toString()) : undefined as any;
            this.pickupActualDate = _data["pickupActualDate"] ? new Date(_data["pickupActualDate"].toString()) : undefined as any;
            this.pickupBillingEnd = _data["pickupBillingEnd"] ? new Date(_data["pickupBillingEnd"].toString()) : undefined as any;
            this.pickupContractedRemoval = _data["pickupContractedRemoval"] ? new Date(_data["pickupContractedRemoval"].toString()) : undefined as any;
            this.pickupRequestedRemoval = _data["pickupRequestedRemoval"] ? new Date(_data["pickupRequestedRemoval"].toString()) : undefined as any;
            this.pickupMiles = _data["pickupMiles"];
            this.pickupQuote = _data["pickupQuote"];
            this.pickupCost = _data["pickupCost"];
            this.pickupEmergency = _data["pickupEmergency"];
            this.verificationDate = _data["verificationDate"] ? new Date(_data["verificationDate"].toString()) : undefined as any;
            this.notes = _data["notes"];
            this.deliveryComplete = _data["deliveryComplete"];
            this.deleted = _data["deleted"];
            this.assetStatus = _data["assetStatus"];
            this.orderIDX = _data["orderIDX"];
            this.customerID = _data["customerID"];
            this.customerName = _data["customerName"];
            this.locationID = _data["locationID"];
            this.storeNumber = _data["storeNumber"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.taxRate = _data["taxRate"];
            this.legacyLocationID = _data["legacyLocationID"];
            this.orderStatus = _data["orderStatus"];
            this.category = _data["category"];
            this.poNumber = _data["poNumber"];
            this.requiresReview = _data["requiresReview"];
            this.requestRequirement = _data["requestRequirement"];
            this.requestPriority = _data["requestPriority"];
            this.requestQuantity = _data["requestQuantity"];
            this.requestReceived = _data["requestReceived"] ? new Date(_data["requestReceived"].toString()) : undefined as any;
            this.requestDescription = _data["requestDescription"];
            this.requestOrderedBy = _data["requestOrderedBy"];
            this.deliveryFulfillmentBidQuantity = _data["deliveryFulfillmentBidQuantity"];
            this.deliveryFulfillmentBidAmount = _data["deliveryFulfillmentBidAmount"];
            this.deliveryFulfillmentBidTax = _data["deliveryFulfillmentBidTax"];
            this.deliveryFulfillmentBidTotal = _data["deliveryFulfillmentBidTotal"];
            this.deliveryFulfillmentQuoteNTE = _data["deliveryFulfillmentQuoteNTE"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.zone1TempRangeID = _data["zone1TempRangeID"];
            this.zone2TempRangeID = _data["zone2TempRangeID"];
            this.deliverySchedule = _data["deliverySchedule"];
            this.turnedOn = _data["turnedOn"];
            this.orderTags = _data["orderTags"];
            this.orderTagIDs = _data["orderTagIDs"];
            this.notMaintained = _data["notMaintained"];
            this.auditNotes = _data["auditNotes"];
            this.noDropReason = _data["noDropReason"];
            this.unitValue = _data["unitValue"];
            this.anticipatedRemovalDate = _data["anticipatedRemovalDate"] ? new Date(_data["anticipatedRemovalDate"].toString()) : undefined as any;
            this.mileageOut = _data["mileageOut"];
            this.mileageIn = _data["mileageIn"];
            this.mileageCost = _data["mileageCost"];
            this.fuelOut = _data["fuelOut"];
            this.fuelIn = _data["fuelIn"];
            this.serviceChannelLastUpdateDate = _data["serviceChannelLastUpdateDate"] ? new Date(_data["serviceChannelLastUpdateDate"].toString()) : undefined as any;
            this.noPickup = _data["noPickup"];
            this.locID = _data["locID"];
            this.deliveryLoad = _data["deliveryLoad"];
            this.pickupLoad = _data["pickupLoad"];
            this.assetRequestReminderSent = _data["assetRequestReminderSent"] ? new Date(_data["assetRequestReminderSent"].toString()) : undefined as any;
            this.expectedTurnOnDate = _data["expectedTurnOnDate"] ? new Date(_data["expectedTurnOnDate"].toString()) : undefined as any;
            this.lastTelematicsReceived = _data["lastTelematicsReceived"] ? new Date(_data["lastTelematicsReceived"].toString()) : undefined as any;
            this.unitModeDetail = _data["unitModeDetail"];
            this.zone1SetPoint = _data["zone1SetPoint"];
            this.zone2SetPoint = _data["zone2SetPoint"];
            this.zone3SetPoint = _data["zone3SetPoint"];
            this.fuelProviderID = _data["fuelProviderID"];
            this.fuelProviderName = _data["fuelProviderName"];
            this.isEmergency = _data["isEmergency"];
            this.assetSizeType = _data["assetSizeType"];
            this.originalAssetType = _data["originalAssetType"];
            this.originalAssetTypeDescription = _data["originalAssetTypeDescription"];
            this.serviceChannelRecentUpdateFlag = _data["serviceChannelRecentUpdateFlag"];
            this.isTelematicsOn = _data["isTelematicsOn"];
            if (Array.isArray(_data["assetExceptions"])) {
                this.assetExceptions = [] as any;
                for (let item of _data["assetExceptions"])
                    this.assetExceptions!.push(AssetException.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderList {
        data = typeof data === 'object' ? data : {};
        let result = new OrderList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetID"] = this.assetID;
        data["orderID"] = this.orderID;
        data["legacyAssetID"] = this.legacyAssetID;
        data["trailerNumber"] = this.trailerNumber;
        data["assetType"] = this.assetType;
        data["temperatureType"] = this.temperatureType;
        data["doorType"] = this.doorType;
        data["requestDoorType"] = this.requestDoorType;
        data["powerType"] = this.powerType;
        data["refrigeratorType"] = this.refrigeratorType;
        data["poLineItem"] = this.poLineItem;
        data["providerID"] = this.providerID;
        data["legacyProviderID"] = this.legacyProviderID;
        data["providerName"] = this.providerName;
        data["size"] = this.size;
        data["sizeNote"] = this.sizeNote;
        data["tankSize"] = this.tankSize;
        data["voltage"] = this.voltage;
        data["engineHoursIn"] = this.engineHoursIn;
        data["engineHoursOut"] = this.engineHoursOut;
        data["noDrop"] = this.noDrop;
        data["rentalCostDaily"] = this.rentalCostDaily;
        data["rentalCostWeekly"] = this.rentalCostWeekly;
        data["rentalCostMonthly"] = this.rentalCostMonthly;
        data["hourlyRuntimeRate"] = this.hourlyRuntimeRate;
        data["deliveryDriverType"] = this.deliveryDriverType;
        data["deliveryRequiredDate"] = this.deliveryRequiredDate ? this.deliveryRequiredDate.toISOString() : undefined as any;
        data["deliveryScheduledDate"] = this.deliveryScheduledDate ? this.deliveryScheduledDate.toISOString() : undefined as any;
        data["deliveryActualDate"] = this.deliveryActualDate ? this.deliveryActualDate.toISOString() : undefined as any;
        data["deliveryMiles"] = this.deliveryMiles;
        data["deliveryQuote"] = this.deliveryQuote;
        data["deliveryCost"] = this.deliveryCost;
        data["deliveryEmergency"] = this.deliveryEmergency;
        data["pickupDriverType"] = this.pickupDriverType;
        data["pickupScheduledDate"] = this.pickupScheduledDate ? this.pickupScheduledDate.toISOString() : undefined as any;
        data["pickupActualDate"] = this.pickupActualDate ? this.pickupActualDate.toISOString() : undefined as any;
        data["pickupBillingEnd"] = this.pickupBillingEnd ? this.pickupBillingEnd.toISOString() : undefined as any;
        data["pickupContractedRemoval"] = this.pickupContractedRemoval ? this.pickupContractedRemoval.toISOString() : undefined as any;
        data["pickupRequestedRemoval"] = this.pickupRequestedRemoval ? this.pickupRequestedRemoval.toISOString() : undefined as any;
        data["pickupMiles"] = this.pickupMiles;
        data["pickupQuote"] = this.pickupQuote;
        data["pickupCost"] = this.pickupCost;
        data["pickupEmergency"] = this.pickupEmergency;
        data["verificationDate"] = this.verificationDate ? this.verificationDate.toISOString() : undefined as any;
        data["notes"] = this.notes;
        data["deliveryComplete"] = this.deliveryComplete;
        data["deleted"] = this.deleted;
        data["assetStatus"] = this.assetStatus;
        data["orderIDX"] = this.orderIDX;
        data["customerID"] = this.customerID;
        data["customerName"] = this.customerName;
        data["locationID"] = this.locationID;
        data["storeNumber"] = this.storeNumber;
        data["street"] = this.street;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["taxRate"] = this.taxRate;
        data["legacyLocationID"] = this.legacyLocationID;
        data["orderStatus"] = this.orderStatus;
        data["category"] = this.category;
        data["poNumber"] = this.poNumber;
        data["requiresReview"] = this.requiresReview;
        data["requestRequirement"] = this.requestRequirement;
        data["requestPriority"] = this.requestPriority;
        data["requestQuantity"] = this.requestQuantity;
        data["requestReceived"] = this.requestReceived ? this.requestReceived.toISOString() : undefined as any;
        data["requestDescription"] = this.requestDescription;
        data["requestOrderedBy"] = this.requestOrderedBy;
        data["deliveryFulfillmentBidQuantity"] = this.deliveryFulfillmentBidQuantity;
        data["deliveryFulfillmentBidAmount"] = this.deliveryFulfillmentBidAmount;
        data["deliveryFulfillmentBidTax"] = this.deliveryFulfillmentBidTax;
        data["deliveryFulfillmentBidTotal"] = this.deliveryFulfillmentBidTotal;
        data["deliveryFulfillmentQuoteNTE"] = this.deliveryFulfillmentQuoteNTE;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["zone1TempRangeID"] = this.zone1TempRangeID;
        data["zone2TempRangeID"] = this.zone2TempRangeID;
        data["deliverySchedule"] = this.deliverySchedule;
        data["turnedOn"] = this.turnedOn;
        data["orderTags"] = this.orderTags;
        data["orderTagIDs"] = this.orderTagIDs;
        data["notMaintained"] = this.notMaintained;
        data["auditNotes"] = this.auditNotes;
        data["noDropReason"] = this.noDropReason;
        data["unitValue"] = this.unitValue;
        data["anticipatedRemovalDate"] = this.anticipatedRemovalDate ? this.anticipatedRemovalDate.toISOString() : undefined as any;
        data["mileageOut"] = this.mileageOut;
        data["mileageIn"] = this.mileageIn;
        data["mileageCost"] = this.mileageCost;
        data["fuelOut"] = this.fuelOut;
        data["fuelIn"] = this.fuelIn;
        data["serviceChannelLastUpdateDate"] = this.serviceChannelLastUpdateDate ? this.serviceChannelLastUpdateDate.toISOString() : undefined as any;
        data["noPickup"] = this.noPickup;
        data["locID"] = this.locID;
        data["deliveryLoad"] = this.deliveryLoad;
        data["pickupLoad"] = this.pickupLoad;
        data["assetRequestReminderSent"] = this.assetRequestReminderSent ? this.assetRequestReminderSent.toISOString() : undefined as any;
        data["expectedTurnOnDate"] = this.expectedTurnOnDate ? this.expectedTurnOnDate.toISOString() : undefined as any;
        data["lastTelematicsReceived"] = this.lastTelematicsReceived ? this.lastTelematicsReceived.toISOString() : undefined as any;
        data["unitModeDetail"] = this.unitModeDetail;
        data["zone1SetPoint"] = this.zone1SetPoint;
        data["zone2SetPoint"] = this.zone2SetPoint;
        data["zone3SetPoint"] = this.zone3SetPoint;
        data["fuelProviderID"] = this.fuelProviderID;
        data["fuelProviderName"] = this.fuelProviderName;
        data["isEmergency"] = this.isEmergency;
        data["assetSizeType"] = this.assetSizeType;
        data["originalAssetType"] = this.originalAssetType;
        data["originalAssetTypeDescription"] = this.originalAssetTypeDescription;
        data["serviceChannelRecentUpdateFlag"] = this.serviceChannelRecentUpdateFlag;
        data["isTelematicsOn"] = this.isTelematicsOn;
        if (Array.isArray(this.assetExceptions)) {
            data["assetExceptions"] = [];
            for (let item of this.assetExceptions)
                data["assetExceptions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOrderList {
    assetID?: number;
    orderID?: number;
    legacyAssetID?: string | undefined;
    trailerNumber?: string | undefined;
    assetType?: string | undefined;
    temperatureType?: string | undefined;
    doorType?: string | undefined;
    requestDoorType?: string | undefined;
    powerType?: string | undefined;
    refrigeratorType?: string | undefined;
    poLineItem?: number | undefined;
    providerID?: string | undefined;
    legacyProviderID?: string | undefined;
    providerName?: string | undefined;
    size?: number | undefined;
    sizeNote?: string | undefined;
    tankSize?: number | undefined;
    voltage?: number | undefined;
    engineHoursIn?: number | undefined;
    engineHoursOut?: number | undefined;
    noDrop?: boolean;
    rentalCostDaily?: number | undefined;
    rentalCostWeekly?: number | undefined;
    rentalCostMonthly?: number | undefined;
    hourlyRuntimeRate?: number | undefined;
    deliveryDriverType?: string | undefined;
    deliveryRequiredDate?: Date | undefined;
    deliveryScheduledDate?: Date | undefined;
    deliveryActualDate?: Date | undefined;
    deliveryMiles?: number | undefined;
    deliveryQuote?: number | undefined;
    deliveryCost?: number | undefined;
    deliveryEmergency?: boolean;
    pickupDriverType?: string | undefined;
    pickupScheduledDate?: Date | undefined;
    pickupActualDate?: Date | undefined;
    pickupBillingEnd?: Date | undefined;
    pickupContractedRemoval?: Date | undefined;
    pickupRequestedRemoval?: Date | undefined;
    pickupMiles?: number | undefined;
    pickupQuote?: number | undefined;
    pickupCost?: number | undefined;
    pickupEmergency?: boolean;
    verificationDate?: Date | undefined;
    notes?: string | undefined;
    deliveryComplete?: boolean;
    deleted?: boolean;
    assetStatus?: string | undefined;
    orderIDX?: string | undefined;
    customerID?: string | undefined;
    customerName?: string | undefined;
    locationID?: string | undefined;
    storeNumber?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    taxRate?: number | undefined;
    legacyLocationID?: string | undefined;
    orderStatus?: string | undefined;
    category?: string | undefined;
    poNumber?: string | undefined;
    requiresReview?: boolean;
    requestRequirement?: string | undefined;
    requestPriority?: string | undefined;
    requestQuantity?: number | undefined;
    requestReceived?: Date | undefined;
    requestDescription?: string | undefined;
    requestOrderedBy?: string | undefined;
    deliveryFulfillmentBidQuantity?: number | undefined;
    deliveryFulfillmentBidAmount?: number | undefined;
    deliveryFulfillmentBidTax?: number | undefined;
    deliveryFulfillmentBidTotal?: number | undefined;
    deliveryFulfillmentQuoteNTE?: number | undefined;
    createdDate?: Date;
    zone1TempRangeID?: number | undefined;
    zone2TempRangeID?: number | undefined;
    deliverySchedule?: number;
    turnedOn?: boolean;
    orderTags?: string | undefined;
    orderTagIDs?: string | undefined;
    notMaintained?: boolean | undefined;
    auditNotes?: string | undefined;
    noDropReason?: string | undefined;
    unitValue?: number | undefined;
    anticipatedRemovalDate?: Date | undefined;
    mileageOut?: number | undefined;
    mileageIn?: number | undefined;
    mileageCost?: number | undefined;
    fuelOut?: number | undefined;
    fuelIn?: number | undefined;
    serviceChannelLastUpdateDate?: Date | undefined;
    noPickup?: boolean;
    locID?: number | undefined;
    deliveryLoad?: number | undefined;
    pickupLoad?: number | undefined;
    assetRequestReminderSent?: Date | undefined;
    expectedTurnOnDate?: Date | undefined;
    lastTelematicsReceived?: Date | undefined;
    unitModeDetail?: string | undefined;
    zone1SetPoint?: number | undefined;
    zone2SetPoint?: number | undefined;
    zone3SetPoint?: number | undefined;
    fuelProviderID?: string | undefined;
    fuelProviderName?: string | undefined;
    isEmergency?: boolean | undefined;
    assetSizeType?: string | undefined;
    originalAssetType?: string | undefined;
    originalAssetTypeDescription?: string | undefined;
    serviceChannelRecentUpdateFlag?: boolean;
    isTelematicsOn?: boolean;
    assetExceptions?: AssetException[] | undefined;
}

export class AssetException implements IAssetException {
    assetExceptionID?: number;
    assetID?: number;
    exception?: string | undefined;
    asset?: Asset | undefined;
    orderList?: OrderList | undefined;
    createdDate?: Date | undefined;

    constructor(data?: IAssetException) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetExceptionID = _data["assetExceptionID"];
            this.assetID = _data["assetID"];
            this.exception = _data["exception"];
            this.asset = _data["asset"] ? Asset.fromJS(_data["asset"]) : undefined as any;
            this.orderList = _data["orderList"] ? OrderList.fromJS(_data["orderList"]) : undefined as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AssetException {
        data = typeof data === 'object' ? data : {};
        let result = new AssetException();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetExceptionID"] = this.assetExceptionID;
        data["assetID"] = this.assetID;
        data["exception"] = this.exception;
        data["asset"] = this.asset ? this.asset.toJSON() : undefined as any;
        data["orderList"] = this.orderList ? this.orderList.toJSON() : undefined as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IAssetException {
    assetExceptionID?: number;
    assetID?: number;
    exception?: string | undefined;
    asset?: Asset | undefined;
    orderList?: OrderList | undefined;
    createdDate?: Date | undefined;
}

export class Asset implements IAsset {
    assetID?: number;
    orderID?: number;
    lateReason?: string | undefined;
    legacyAssetID?: string | undefined;
    trailerNumber?: string | undefined;
    trailerNumberOverrideNote?: string | undefined;
    status?: string | undefined;
    assetType?: string | undefined;
    temperatureType?: string | undefined;
    doorType?: string | undefined;
    requestDoorType?: string | undefined;
    powerType?: string | undefined;
    refrigeratorType?: string | undefined;
    poLineItem?: number | undefined;
    providerID?: string | undefined;
    providerMileage?: number | undefined;
    size?: number | undefined;
    sizeNote?: string | undefined;
    tankSize?: number | undefined;
    monitoredTankCategory?: string | undefined;
    telemetryProvider?: string | undefined;
    telemetryVendorDeviceId?: string | undefined;
    telemetryMinimumFuelPercent?: number | undefined;
    telemetryActive?: boolean;
    voltage?: number | undefined;
    engineHoursIn?: number | undefined;
    engineHoursOut?: number | undefined;
    noDrop?: boolean;
    rentalCostDaily?: number | undefined;
    rentalCostWeekly?: number | undefined;
    rentalCostMonthly?: number | undefined;
    hourlyRuntimeRate?: number | undefined;
    mileageCost?: number | undefined;
    deliveryDriverType?: string | undefined;
    deliveryRequiredDate?: Date | undefined;
    deliveryScheduledDate?: Date | undefined;
    deliveryActualDate?: Date | undefined;
    deliveryMiles?: number | undefined;
    deliveryQuote?: number | undefined;
    deliveryCost?: number | undefined;
    deliveryEmergency?: boolean;
    pickupDriverType?: string | undefined;
    pickupScheduledDate?: Date | undefined;
    pickupActualDate?: Date | undefined;
    pickupBillingEnd?: Date | undefined;
    pickupContractedRemoval?: Date | undefined;
    pickupRequestedRemoval?: Date | undefined;
    pickupMiles?: number | undefined;
    pickupQuote?: number | undefined;
    pickupCost?: number | undefined;
    pickupEmergency?: boolean;
    verificationDate?: Date | undefined;
    notes?: string | undefined;
    auditNotes?: string | undefined;
    deliveryComplete?: boolean;
    noDropReasonID?: number | undefined;
    noDropNotes?: string | undefined;
    deleted?: boolean;
    assetExceptions?: AssetException[] | undefined;
    serviceEvents?: ServiceEvent[] | undefined;
    onPeriods?: OnPeriod[] | undefined;
    ambientTemperatures?: AssetAmbientTemps[] | undefined;
    provider?: Provider | undefined;
    order?: Order | undefined;
    noDropReason?: NoDropReason | undefined;
    turnedOn?: boolean;
    fuelServiceActive?: boolean;
    zone1TempRangeID?: number | undefined;
    zone2TempRangeID?: number | undefined;
    zone3TempRangeID?: number | undefined;
    fuelBurnRateDays?: number | undefined;
    fuelBurnRateHours?: number | undefined;
    fuelOut?: number | undefined;
    fuelIn?: number | undefined;
    fuelSchedule?: FuelDeliveryDaysEnum;
    createdDate?: Date;
    createdUser?: string | undefined;
    lastModifiedDate?: Date;
    lastModifiedUser?: string | undefined;
    noDropDate?: Date | undefined;
    anticipatedRemovalDate?: Date | undefined;
    notMaintained?: boolean | undefined;
    unitValue?: number | undefined;
    requestStairs?: boolean;
    mileageIn?: number | undefined;
    mileageOut?: number | undefined;
    noPickup?: boolean;
    associatedAssetID?: number | undefined;
    accessoryType?: string | undefined;
    monthlyBillRate?: number | undefined;
    modName?: string | undefined;
    modDeclined?: boolean;
    requestReminderSent?: Date | undefined;
    noiseOrdinance?: string | undefined;
    endOfLife?: string | undefined;
    expectedTurnOnDate?: Date | undefined;
    requestRamps?: boolean;
    requestLiftGate?: boolean;
    lastTelematicsReceived?: Date | undefined;
    unitModeDetail?: string | undefined;
    zone1SetPoint?: number | undefined;
    zone2SetPoint?: number | undefined;
    zone3SetPoint?: number | undefined;
    operatingMode1?: string | undefined;
    operatingMode2?: string | undefined;
    operatingMode3?: string | undefined;
    zone1DischargeAir?: number | undefined;
    zone1ReturnAir?: number | undefined;
    zone2DischargeAir?: number | undefined;
    zone2ReturnAir?: number | undefined;
    zone3DischargeAir?: number | undefined;
    zone3ReturnAir?: number | undefined;
    activeAlarms?: AssetActiveAlarm[] | undefined;
    isTelematicsOn?: boolean;
    rescheduledDeliveryDate?: Date | undefined;
    lastTelemetryRefuelDate?: Date | undefined;
    invoiceDelivery?: boolean;
    invoicePickup?: boolean;
    invoiceRentalRuntime?: boolean;
    deliveryInvoiceNumber?: string | undefined;
    pickupInvoiceNumber?: string | undefined;
    deliveryInvoicedDate?: Date | undefined;
    deliveryCosmosInvoiceId?: string | undefined;
    pickupInvoicedDate?: Date | undefined;
    pickupCosmosInvoiceId?: string | undefined;
    emergencyInvoicedDate?: Date | undefined;
    emergencyCosmosInvoiceId?: string | undefined;
    loads?: AssetLoad[] | undefined;
    charges?: AssetCharges[] | undefined;

    constructor(data?: IAsset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetID = _data["assetID"];
            this.orderID = _data["orderID"];
            this.lateReason = _data["lateReason"];
            this.legacyAssetID = _data["legacyAssetID"];
            this.trailerNumber = _data["trailerNumber"];
            this.trailerNumberOverrideNote = _data["trailerNumberOverrideNote"];
            this.status = _data["status"];
            this.assetType = _data["assetType"];
            this.temperatureType = _data["temperatureType"];
            this.doorType = _data["doorType"];
            this.requestDoorType = _data["requestDoorType"];
            this.powerType = _data["powerType"];
            this.refrigeratorType = _data["refrigeratorType"];
            this.poLineItem = _data["poLineItem"];
            this.providerID = _data["providerID"];
            this.providerMileage = _data["providerMileage"];
            this.size = _data["size"];
            this.sizeNote = _data["sizeNote"];
            this.tankSize = _data["tankSize"];
            this.monitoredTankCategory = _data["monitoredTankCategory"];
            this.telemetryProvider = _data["telemetryProvider"];
            this.telemetryVendorDeviceId = _data["telemetryVendorDeviceId"];
            this.telemetryMinimumFuelPercent = _data["telemetryMinimumFuelPercent"];
            this.telemetryActive = _data["telemetryActive"];
            this.voltage = _data["voltage"];
            this.engineHoursIn = _data["engineHoursIn"];
            this.engineHoursOut = _data["engineHoursOut"];
            this.noDrop = _data["noDrop"];
            this.rentalCostDaily = _data["rentalCostDaily"];
            this.rentalCostWeekly = _data["rentalCostWeekly"];
            this.rentalCostMonthly = _data["rentalCostMonthly"];
            this.hourlyRuntimeRate = _data["hourlyRuntimeRate"];
            this.mileageCost = _data["mileageCost"];
            this.deliveryDriverType = _data["deliveryDriverType"];
            this.deliveryRequiredDate = _data["deliveryRequiredDate"] ? new Date(_data["deliveryRequiredDate"].toString()) : undefined as any;
            this.deliveryScheduledDate = _data["deliveryScheduledDate"] ? new Date(_data["deliveryScheduledDate"].toString()) : undefined as any;
            this.deliveryActualDate = _data["deliveryActualDate"] ? new Date(_data["deliveryActualDate"].toString()) : undefined as any;
            this.deliveryMiles = _data["deliveryMiles"];
            this.deliveryQuote = _data["deliveryQuote"];
            this.deliveryCost = _data["deliveryCost"];
            this.deliveryEmergency = _data["deliveryEmergency"];
            this.pickupDriverType = _data["pickupDriverType"];
            this.pickupScheduledDate = _data["pickupScheduledDate"] ? new Date(_data["pickupScheduledDate"].toString()) : undefined as any;
            this.pickupActualDate = _data["pickupActualDate"] ? new Date(_data["pickupActualDate"].toString()) : undefined as any;
            this.pickupBillingEnd = _data["pickupBillingEnd"] ? new Date(_data["pickupBillingEnd"].toString()) : undefined as any;
            this.pickupContractedRemoval = _data["pickupContractedRemoval"] ? new Date(_data["pickupContractedRemoval"].toString()) : undefined as any;
            this.pickupRequestedRemoval = _data["pickupRequestedRemoval"] ? new Date(_data["pickupRequestedRemoval"].toString()) : undefined as any;
            this.pickupMiles = _data["pickupMiles"];
            this.pickupQuote = _data["pickupQuote"];
            this.pickupCost = _data["pickupCost"];
            this.pickupEmergency = _data["pickupEmergency"];
            this.verificationDate = _data["verificationDate"] ? new Date(_data["verificationDate"].toString()) : undefined as any;
            this.notes = _data["notes"];
            this.auditNotes = _data["auditNotes"];
            this.deliveryComplete = _data["deliveryComplete"];
            this.noDropReasonID = _data["noDropReasonID"];
            this.noDropNotes = _data["noDropNotes"];
            this.deleted = _data["deleted"];
            if (Array.isArray(_data["assetExceptions"])) {
                this.assetExceptions = [] as any;
                for (let item of _data["assetExceptions"])
                    this.assetExceptions!.push(AssetException.fromJS(item));
            }
            if (Array.isArray(_data["serviceEvents"])) {
                this.serviceEvents = [] as any;
                for (let item of _data["serviceEvents"])
                    this.serviceEvents!.push(ServiceEvent.fromJS(item));
            }
            if (Array.isArray(_data["onPeriods"])) {
                this.onPeriods = [] as any;
                for (let item of _data["onPeriods"])
                    this.onPeriods!.push(OnPeriod.fromJS(item));
            }
            if (Array.isArray(_data["ambientTemperatures"])) {
                this.ambientTemperatures = [] as any;
                for (let item of _data["ambientTemperatures"])
                    this.ambientTemperatures!.push(AssetAmbientTemps.fromJS(item));
            }
            this.provider = _data["provider"] ? Provider.fromJS(_data["provider"]) : undefined as any;
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : undefined as any;
            this.noDropReason = _data["noDropReason"] ? NoDropReason.fromJS(_data["noDropReason"]) : undefined as any;
            this.turnedOn = _data["turnedOn"];
            this.fuelServiceActive = _data["fuelServiceActive"];
            this.zone1TempRangeID = _data["zone1TempRangeID"];
            this.zone2TempRangeID = _data["zone2TempRangeID"];
            this.zone3TempRangeID = _data["zone3TempRangeID"];
            this.fuelBurnRateDays = _data["fuelBurnRateDays"];
            this.fuelBurnRateHours = _data["fuelBurnRateHours"];
            this.fuelOut = _data["fuelOut"];
            this.fuelIn = _data["fuelIn"];
            this.fuelSchedule = _data["fuelSchedule"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.lastModifiedUser = _data["lastModifiedUser"];
            this.noDropDate = _data["noDropDate"] ? new Date(_data["noDropDate"].toString()) : undefined as any;
            this.anticipatedRemovalDate = _data["anticipatedRemovalDate"] ? new Date(_data["anticipatedRemovalDate"].toString()) : undefined as any;
            this.notMaintained = _data["notMaintained"];
            this.unitValue = _data["unitValue"];
            this.requestStairs = _data["requestStairs"];
            this.mileageIn = _data["mileageIn"];
            this.mileageOut = _data["mileageOut"];
            this.noPickup = _data["noPickup"];
            this.associatedAssetID = _data["associatedAssetID"];
            this.accessoryType = _data["accessoryType"];
            this.monthlyBillRate = _data["monthlyBillRate"];
            this.modName = _data["modName"];
            this.modDeclined = _data["modDeclined"];
            this.requestReminderSent = _data["requestReminderSent"] ? new Date(_data["requestReminderSent"].toString()) : undefined as any;
            this.noiseOrdinance = _data["noiseOrdinance"];
            this.endOfLife = _data["endOfLife"];
            this.expectedTurnOnDate = _data["expectedTurnOnDate"] ? new Date(_data["expectedTurnOnDate"].toString()) : undefined as any;
            this.requestRamps = _data["requestRamps"];
            this.requestLiftGate = _data["requestLiftGate"];
            this.lastTelematicsReceived = _data["lastTelematicsReceived"] ? new Date(_data["lastTelematicsReceived"].toString()) : undefined as any;
            this.unitModeDetail = _data["unitModeDetail"];
            this.zone1SetPoint = _data["zone1SetPoint"];
            this.zone2SetPoint = _data["zone2SetPoint"];
            this.zone3SetPoint = _data["zone3SetPoint"];
            this.operatingMode1 = _data["operatingMode1"];
            this.operatingMode2 = _data["operatingMode2"];
            this.operatingMode3 = _data["operatingMode3"];
            this.zone1DischargeAir = _data["zone1DischargeAir"];
            this.zone1ReturnAir = _data["zone1ReturnAir"];
            this.zone2DischargeAir = _data["zone2DischargeAir"];
            this.zone2ReturnAir = _data["zone2ReturnAir"];
            this.zone3DischargeAir = _data["zone3DischargeAir"];
            this.zone3ReturnAir = _data["zone3ReturnAir"];
            if (Array.isArray(_data["activeAlarms"])) {
                this.activeAlarms = [] as any;
                for (let item of _data["activeAlarms"])
                    this.activeAlarms!.push(AssetActiveAlarm.fromJS(item));
            }
            this.isTelematicsOn = _data["isTelematicsOn"];
            this.rescheduledDeliveryDate = _data["rescheduledDeliveryDate"] ? new Date(_data["rescheduledDeliveryDate"].toString()) : undefined as any;
            this.lastTelemetryRefuelDate = _data["lastTelemetryRefuelDate"] ? new Date(_data["lastTelemetryRefuelDate"].toString()) : undefined as any;
            this.invoiceDelivery = _data["invoiceDelivery"];
            this.invoicePickup = _data["invoicePickup"];
            this.invoiceRentalRuntime = _data["invoiceRentalRuntime"];
            this.deliveryInvoiceNumber = _data["deliveryInvoiceNumber"];
            this.pickupInvoiceNumber = _data["pickupInvoiceNumber"];
            this.deliveryInvoicedDate = _data["deliveryInvoicedDate"] ? new Date(_data["deliveryInvoicedDate"].toString()) : undefined as any;
            this.deliveryCosmosInvoiceId = _data["deliveryCosmosInvoiceId"];
            this.pickupInvoicedDate = _data["pickupInvoicedDate"] ? new Date(_data["pickupInvoicedDate"].toString()) : undefined as any;
            this.pickupCosmosInvoiceId = _data["pickupCosmosInvoiceId"];
            this.emergencyInvoicedDate = _data["emergencyInvoicedDate"] ? new Date(_data["emergencyInvoicedDate"].toString()) : undefined as any;
            this.emergencyCosmosInvoiceId = _data["emergencyCosmosInvoiceId"];
            if (Array.isArray(_data["loads"])) {
                this.loads = [] as any;
                for (let item of _data["loads"])
                    this.loads!.push(AssetLoad.fromJS(item));
            }
            if (Array.isArray(_data["charges"])) {
                this.charges = [] as any;
                for (let item of _data["charges"])
                    this.charges!.push(AssetCharges.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Asset {
        data = typeof data === 'object' ? data : {};
        let result = new Asset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetID"] = this.assetID;
        data["orderID"] = this.orderID;
        data["lateReason"] = this.lateReason;
        data["legacyAssetID"] = this.legacyAssetID;
        data["trailerNumber"] = this.trailerNumber;
        data["trailerNumberOverrideNote"] = this.trailerNumberOverrideNote;
        data["status"] = this.status;
        data["assetType"] = this.assetType;
        data["temperatureType"] = this.temperatureType;
        data["doorType"] = this.doorType;
        data["requestDoorType"] = this.requestDoorType;
        data["powerType"] = this.powerType;
        data["refrigeratorType"] = this.refrigeratorType;
        data["poLineItem"] = this.poLineItem;
        data["providerID"] = this.providerID;
        data["providerMileage"] = this.providerMileage;
        data["size"] = this.size;
        data["sizeNote"] = this.sizeNote;
        data["tankSize"] = this.tankSize;
        data["monitoredTankCategory"] = this.monitoredTankCategory;
        data["telemetryProvider"] = this.telemetryProvider;
        data["telemetryVendorDeviceId"] = this.telemetryVendorDeviceId;
        data["telemetryMinimumFuelPercent"] = this.telemetryMinimumFuelPercent;
        data["telemetryActive"] = this.telemetryActive;
        data["voltage"] = this.voltage;
        data["engineHoursIn"] = this.engineHoursIn;
        data["engineHoursOut"] = this.engineHoursOut;
        data["noDrop"] = this.noDrop;
        data["rentalCostDaily"] = this.rentalCostDaily;
        data["rentalCostWeekly"] = this.rentalCostWeekly;
        data["rentalCostMonthly"] = this.rentalCostMonthly;
        data["hourlyRuntimeRate"] = this.hourlyRuntimeRate;
        data["mileageCost"] = this.mileageCost;
        data["deliveryDriverType"] = this.deliveryDriverType;
        data["deliveryRequiredDate"] = this.deliveryRequiredDate ? this.deliveryRequiredDate.toISOString() : undefined as any;
        data["deliveryScheduledDate"] = this.deliveryScheduledDate ? this.deliveryScheduledDate.toISOString() : undefined as any;
        data["deliveryActualDate"] = this.deliveryActualDate ? this.deliveryActualDate.toISOString() : undefined as any;
        data["deliveryMiles"] = this.deliveryMiles;
        data["deliveryQuote"] = this.deliveryQuote;
        data["deliveryCost"] = this.deliveryCost;
        data["deliveryEmergency"] = this.deliveryEmergency;
        data["pickupDriverType"] = this.pickupDriverType;
        data["pickupScheduledDate"] = this.pickupScheduledDate ? this.pickupScheduledDate.toISOString() : undefined as any;
        data["pickupActualDate"] = this.pickupActualDate ? this.pickupActualDate.toISOString() : undefined as any;
        data["pickupBillingEnd"] = this.pickupBillingEnd ? this.pickupBillingEnd.toISOString() : undefined as any;
        data["pickupContractedRemoval"] = this.pickupContractedRemoval ? this.pickupContractedRemoval.toISOString() : undefined as any;
        data["pickupRequestedRemoval"] = this.pickupRequestedRemoval ? this.pickupRequestedRemoval.toISOString() : undefined as any;
        data["pickupMiles"] = this.pickupMiles;
        data["pickupQuote"] = this.pickupQuote;
        data["pickupCost"] = this.pickupCost;
        data["pickupEmergency"] = this.pickupEmergency;
        data["verificationDate"] = this.verificationDate ? this.verificationDate.toISOString() : undefined as any;
        data["notes"] = this.notes;
        data["auditNotes"] = this.auditNotes;
        data["deliveryComplete"] = this.deliveryComplete;
        data["noDropReasonID"] = this.noDropReasonID;
        data["noDropNotes"] = this.noDropNotes;
        data["deleted"] = this.deleted;
        if (Array.isArray(this.assetExceptions)) {
            data["assetExceptions"] = [];
            for (let item of this.assetExceptions)
                data["assetExceptions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.serviceEvents)) {
            data["serviceEvents"] = [];
            for (let item of this.serviceEvents)
                data["serviceEvents"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.onPeriods)) {
            data["onPeriods"] = [];
            for (let item of this.onPeriods)
                data["onPeriods"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ambientTemperatures)) {
            data["ambientTemperatures"] = [];
            for (let item of this.ambientTemperatures)
                data["ambientTemperatures"].push(item ? item.toJSON() : undefined as any);
        }
        data["provider"] = this.provider ? this.provider.toJSON() : undefined as any;
        data["order"] = this.order ? this.order.toJSON() : undefined as any;
        data["noDropReason"] = this.noDropReason ? this.noDropReason.toJSON() : undefined as any;
        data["turnedOn"] = this.turnedOn;
        data["fuelServiceActive"] = this.fuelServiceActive;
        data["zone1TempRangeID"] = this.zone1TempRangeID;
        data["zone2TempRangeID"] = this.zone2TempRangeID;
        data["zone3TempRangeID"] = this.zone3TempRangeID;
        data["fuelBurnRateDays"] = this.fuelBurnRateDays;
        data["fuelBurnRateHours"] = this.fuelBurnRateHours;
        data["fuelOut"] = this.fuelOut;
        data["fuelIn"] = this.fuelIn;
        data["fuelSchedule"] = this.fuelSchedule;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdUser"] = this.createdUser;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["lastModifiedUser"] = this.lastModifiedUser;
        data["noDropDate"] = this.noDropDate ? this.noDropDate.toISOString() : undefined as any;
        data["anticipatedRemovalDate"] = this.anticipatedRemovalDate ? this.anticipatedRemovalDate.toISOString() : undefined as any;
        data["notMaintained"] = this.notMaintained;
        data["unitValue"] = this.unitValue;
        data["requestStairs"] = this.requestStairs;
        data["mileageIn"] = this.mileageIn;
        data["mileageOut"] = this.mileageOut;
        data["noPickup"] = this.noPickup;
        data["associatedAssetID"] = this.associatedAssetID;
        data["accessoryType"] = this.accessoryType;
        data["monthlyBillRate"] = this.monthlyBillRate;
        data["modName"] = this.modName;
        data["modDeclined"] = this.modDeclined;
        data["requestReminderSent"] = this.requestReminderSent ? this.requestReminderSent.toISOString() : undefined as any;
        data["noiseOrdinance"] = this.noiseOrdinance;
        data["endOfLife"] = this.endOfLife;
        data["expectedTurnOnDate"] = this.expectedTurnOnDate ? this.expectedTurnOnDate.toISOString() : undefined as any;
        data["requestRamps"] = this.requestRamps;
        data["requestLiftGate"] = this.requestLiftGate;
        data["lastTelematicsReceived"] = this.lastTelematicsReceived ? this.lastTelematicsReceived.toISOString() : undefined as any;
        data["unitModeDetail"] = this.unitModeDetail;
        data["zone1SetPoint"] = this.zone1SetPoint;
        data["zone2SetPoint"] = this.zone2SetPoint;
        data["zone3SetPoint"] = this.zone3SetPoint;
        data["operatingMode1"] = this.operatingMode1;
        data["operatingMode2"] = this.operatingMode2;
        data["operatingMode3"] = this.operatingMode3;
        data["zone1DischargeAir"] = this.zone1DischargeAir;
        data["zone1ReturnAir"] = this.zone1ReturnAir;
        data["zone2DischargeAir"] = this.zone2DischargeAir;
        data["zone2ReturnAir"] = this.zone2ReturnAir;
        data["zone3DischargeAir"] = this.zone3DischargeAir;
        data["zone3ReturnAir"] = this.zone3ReturnAir;
        if (Array.isArray(this.activeAlarms)) {
            data["activeAlarms"] = [];
            for (let item of this.activeAlarms)
                data["activeAlarms"].push(item ? item.toJSON() : undefined as any);
        }
        data["isTelematicsOn"] = this.isTelematicsOn;
        data["rescheduledDeliveryDate"] = this.rescheduledDeliveryDate ? this.rescheduledDeliveryDate.toISOString() : undefined as any;
        data["lastTelemetryRefuelDate"] = this.lastTelemetryRefuelDate ? this.lastTelemetryRefuelDate.toISOString() : undefined as any;
        data["invoiceDelivery"] = this.invoiceDelivery;
        data["invoicePickup"] = this.invoicePickup;
        data["invoiceRentalRuntime"] = this.invoiceRentalRuntime;
        data["deliveryInvoiceNumber"] = this.deliveryInvoiceNumber;
        data["pickupInvoiceNumber"] = this.pickupInvoiceNumber;
        data["deliveryInvoicedDate"] = this.deliveryInvoicedDate ? this.deliveryInvoicedDate.toISOString() : undefined as any;
        data["deliveryCosmosInvoiceId"] = this.deliveryCosmosInvoiceId;
        data["pickupInvoicedDate"] = this.pickupInvoicedDate ? this.pickupInvoicedDate.toISOString() : undefined as any;
        data["pickupCosmosInvoiceId"] = this.pickupCosmosInvoiceId;
        data["emergencyInvoicedDate"] = this.emergencyInvoicedDate ? this.emergencyInvoicedDate.toISOString() : undefined as any;
        data["emergencyCosmosInvoiceId"] = this.emergencyCosmosInvoiceId;
        if (Array.isArray(this.loads)) {
            data["loads"] = [];
            for (let item of this.loads)
                data["loads"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.charges)) {
            data["charges"] = [];
            for (let item of this.charges)
                data["charges"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAsset {
    assetID?: number;
    orderID?: number;
    lateReason?: string | undefined;
    legacyAssetID?: string | undefined;
    trailerNumber?: string | undefined;
    trailerNumberOverrideNote?: string | undefined;
    status?: string | undefined;
    assetType?: string | undefined;
    temperatureType?: string | undefined;
    doorType?: string | undefined;
    requestDoorType?: string | undefined;
    powerType?: string | undefined;
    refrigeratorType?: string | undefined;
    poLineItem?: number | undefined;
    providerID?: string | undefined;
    providerMileage?: number | undefined;
    size?: number | undefined;
    sizeNote?: string | undefined;
    tankSize?: number | undefined;
    monitoredTankCategory?: string | undefined;
    telemetryProvider?: string | undefined;
    telemetryVendorDeviceId?: string | undefined;
    telemetryMinimumFuelPercent?: number | undefined;
    telemetryActive?: boolean;
    voltage?: number | undefined;
    engineHoursIn?: number | undefined;
    engineHoursOut?: number | undefined;
    noDrop?: boolean;
    rentalCostDaily?: number | undefined;
    rentalCostWeekly?: number | undefined;
    rentalCostMonthly?: number | undefined;
    hourlyRuntimeRate?: number | undefined;
    mileageCost?: number | undefined;
    deliveryDriverType?: string | undefined;
    deliveryRequiredDate?: Date | undefined;
    deliveryScheduledDate?: Date | undefined;
    deliveryActualDate?: Date | undefined;
    deliveryMiles?: number | undefined;
    deliveryQuote?: number | undefined;
    deliveryCost?: number | undefined;
    deliveryEmergency?: boolean;
    pickupDriverType?: string | undefined;
    pickupScheduledDate?: Date | undefined;
    pickupActualDate?: Date | undefined;
    pickupBillingEnd?: Date | undefined;
    pickupContractedRemoval?: Date | undefined;
    pickupRequestedRemoval?: Date | undefined;
    pickupMiles?: number | undefined;
    pickupQuote?: number | undefined;
    pickupCost?: number | undefined;
    pickupEmergency?: boolean;
    verificationDate?: Date | undefined;
    notes?: string | undefined;
    auditNotes?: string | undefined;
    deliveryComplete?: boolean;
    noDropReasonID?: number | undefined;
    noDropNotes?: string | undefined;
    deleted?: boolean;
    assetExceptions?: AssetException[] | undefined;
    serviceEvents?: ServiceEvent[] | undefined;
    onPeriods?: OnPeriod[] | undefined;
    ambientTemperatures?: AssetAmbientTemps[] | undefined;
    provider?: Provider | undefined;
    order?: Order | undefined;
    noDropReason?: NoDropReason | undefined;
    turnedOn?: boolean;
    fuelServiceActive?: boolean;
    zone1TempRangeID?: number | undefined;
    zone2TempRangeID?: number | undefined;
    zone3TempRangeID?: number | undefined;
    fuelBurnRateDays?: number | undefined;
    fuelBurnRateHours?: number | undefined;
    fuelOut?: number | undefined;
    fuelIn?: number | undefined;
    fuelSchedule?: FuelDeliveryDaysEnum;
    createdDate?: Date;
    createdUser?: string | undefined;
    lastModifiedDate?: Date;
    lastModifiedUser?: string | undefined;
    noDropDate?: Date | undefined;
    anticipatedRemovalDate?: Date | undefined;
    notMaintained?: boolean | undefined;
    unitValue?: number | undefined;
    requestStairs?: boolean;
    mileageIn?: number | undefined;
    mileageOut?: number | undefined;
    noPickup?: boolean;
    associatedAssetID?: number | undefined;
    accessoryType?: string | undefined;
    monthlyBillRate?: number | undefined;
    modName?: string | undefined;
    modDeclined?: boolean;
    requestReminderSent?: Date | undefined;
    noiseOrdinance?: string | undefined;
    endOfLife?: string | undefined;
    expectedTurnOnDate?: Date | undefined;
    requestRamps?: boolean;
    requestLiftGate?: boolean;
    lastTelematicsReceived?: Date | undefined;
    unitModeDetail?: string | undefined;
    zone1SetPoint?: number | undefined;
    zone2SetPoint?: number | undefined;
    zone3SetPoint?: number | undefined;
    operatingMode1?: string | undefined;
    operatingMode2?: string | undefined;
    operatingMode3?: string | undefined;
    zone1DischargeAir?: number | undefined;
    zone1ReturnAir?: number | undefined;
    zone2DischargeAir?: number | undefined;
    zone2ReturnAir?: number | undefined;
    zone3DischargeAir?: number | undefined;
    zone3ReturnAir?: number | undefined;
    activeAlarms?: AssetActiveAlarm[] | undefined;
    isTelematicsOn?: boolean;
    rescheduledDeliveryDate?: Date | undefined;
    lastTelemetryRefuelDate?: Date | undefined;
    invoiceDelivery?: boolean;
    invoicePickup?: boolean;
    invoiceRentalRuntime?: boolean;
    deliveryInvoiceNumber?: string | undefined;
    pickupInvoiceNumber?: string | undefined;
    deliveryInvoicedDate?: Date | undefined;
    deliveryCosmosInvoiceId?: string | undefined;
    pickupInvoicedDate?: Date | undefined;
    pickupCosmosInvoiceId?: string | undefined;
    emergencyInvoicedDate?: Date | undefined;
    emergencyCosmosInvoiceId?: string | undefined;
    loads?: AssetLoad[] | undefined;
    charges?: AssetCharges[] | undefined;
}

export class ServiceEvent implements IServiceEvent {
    serviceEventID?: number;
    assetID?: number;
    providerID!: string;
    issueTypeID?: number;
    isBillable?: boolean | undefined;
    hadProductLoss?: boolean | undefined;
    requestedDate?: Date | undefined;
    arrivalDate?: Date | undefined;
    departedDate?: Date | undefined;
    closedDate?: Date | undefined;
    issueResolutionID?: number | undefined;
    status?: string | undefined;
    substatus?: string | undefined;
    createdDate?: Date;
    createdUser!: string;
    lastModifiedDate?: Date;
    lastModifiedUser!: string;
    providerNote?: string | undefined;
    responsibleParty?: string | undefined;
    vendorBillID?: number | undefined;
    vendorBillItemId?: number | undefined;
    expectedCostOfService?: number | undefined;
    resolutionNote?: string | undefined;
    issueResolution?: IssueResolution | undefined;
    issueType?: IssueType | undefined;
    asset?: Asset | undefined;
    provider?: Provider | undefined;
    serviceEventNotes?: ServiceEventNote[] | undefined;
    ignoredUser?: string | undefined;
    ignoredDate?: Date | undefined;
    lastCommunicationDate?: Date | undefined;
    alarmCode?: string | undefined;
    serviceEventAlarmCodes?: ServiceEventAlarmCode[] | undefined;

    constructor(data?: IServiceEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceEventID = _data["serviceEventID"];
            this.assetID = _data["assetID"];
            this.providerID = _data["providerID"];
            this.issueTypeID = _data["issueTypeID"];
            this.isBillable = _data["isBillable"];
            this.hadProductLoss = _data["hadProductLoss"];
            this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : undefined as any;
            this.arrivalDate = _data["arrivalDate"] ? new Date(_data["arrivalDate"].toString()) : undefined as any;
            this.departedDate = _data["departedDate"] ? new Date(_data["departedDate"].toString()) : undefined as any;
            this.closedDate = _data["closedDate"] ? new Date(_data["closedDate"].toString()) : undefined as any;
            this.issueResolutionID = _data["issueResolutionID"];
            this.status = _data["status"];
            this.substatus = _data["substatus"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.lastModifiedUser = _data["lastModifiedUser"];
            this.providerNote = _data["providerNote"];
            this.responsibleParty = _data["responsibleParty"];
            this.vendorBillID = _data["vendorBillID"];
            this.vendorBillItemId = _data["vendorBillItemId"];
            this.expectedCostOfService = _data["expectedCostOfService"];
            this.resolutionNote = _data["resolutionNote"];
            this.issueResolution = _data["issueResolution"] ? IssueResolution.fromJS(_data["issueResolution"]) : undefined as any;
            this.issueType = _data["issueType"] ? IssueType.fromJS(_data["issueType"]) : undefined as any;
            this.asset = _data["asset"] ? Asset.fromJS(_data["asset"]) : undefined as any;
            this.provider = _data["provider"] ? Provider.fromJS(_data["provider"]) : undefined as any;
            if (Array.isArray(_data["serviceEventNotes"])) {
                this.serviceEventNotes = [] as any;
                for (let item of _data["serviceEventNotes"])
                    this.serviceEventNotes!.push(ServiceEventNote.fromJS(item));
            }
            this.ignoredUser = _data["ignoredUser"];
            this.ignoredDate = _data["ignoredDate"] ? new Date(_data["ignoredDate"].toString()) : undefined as any;
            this.lastCommunicationDate = _data["lastCommunicationDate"] ? new Date(_data["lastCommunicationDate"].toString()) : undefined as any;
            this.alarmCode = _data["alarmCode"];
            if (Array.isArray(_data["serviceEventAlarmCodes"])) {
                this.serviceEventAlarmCodes = [] as any;
                for (let item of _data["serviceEventAlarmCodes"])
                    this.serviceEventAlarmCodes!.push(ServiceEventAlarmCode.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceEvent {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceEventID"] = this.serviceEventID;
        data["assetID"] = this.assetID;
        data["providerID"] = this.providerID;
        data["issueTypeID"] = this.issueTypeID;
        data["isBillable"] = this.isBillable;
        data["hadProductLoss"] = this.hadProductLoss;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : undefined as any;
        data["arrivalDate"] = this.arrivalDate ? this.arrivalDate.toISOString() : undefined as any;
        data["departedDate"] = this.departedDate ? this.departedDate.toISOString() : undefined as any;
        data["closedDate"] = this.closedDate ? this.closedDate.toISOString() : undefined as any;
        data["issueResolutionID"] = this.issueResolutionID;
        data["status"] = this.status;
        data["substatus"] = this.substatus;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdUser"] = this.createdUser;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["lastModifiedUser"] = this.lastModifiedUser;
        data["providerNote"] = this.providerNote;
        data["responsibleParty"] = this.responsibleParty;
        data["vendorBillID"] = this.vendorBillID;
        data["vendorBillItemId"] = this.vendorBillItemId;
        data["expectedCostOfService"] = this.expectedCostOfService;
        data["resolutionNote"] = this.resolutionNote;
        data["issueResolution"] = this.issueResolution ? this.issueResolution.toJSON() : undefined as any;
        data["issueType"] = this.issueType ? this.issueType.toJSON() : undefined as any;
        data["asset"] = this.asset ? this.asset.toJSON() : undefined as any;
        data["provider"] = this.provider ? this.provider.toJSON() : undefined as any;
        if (Array.isArray(this.serviceEventNotes)) {
            data["serviceEventNotes"] = [];
            for (let item of this.serviceEventNotes)
                data["serviceEventNotes"].push(item ? item.toJSON() : undefined as any);
        }
        data["ignoredUser"] = this.ignoredUser;
        data["ignoredDate"] = this.ignoredDate ? this.ignoredDate.toISOString() : undefined as any;
        data["lastCommunicationDate"] = this.lastCommunicationDate ? this.lastCommunicationDate.toISOString() : undefined as any;
        data["alarmCode"] = this.alarmCode;
        if (Array.isArray(this.serviceEventAlarmCodes)) {
            data["serviceEventAlarmCodes"] = [];
            for (let item of this.serviceEventAlarmCodes)
                data["serviceEventAlarmCodes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IServiceEvent {
    serviceEventID?: number;
    assetID?: number;
    providerID: string;
    issueTypeID?: number;
    isBillable?: boolean | undefined;
    hadProductLoss?: boolean | undefined;
    requestedDate?: Date | undefined;
    arrivalDate?: Date | undefined;
    departedDate?: Date | undefined;
    closedDate?: Date | undefined;
    issueResolutionID?: number | undefined;
    status?: string | undefined;
    substatus?: string | undefined;
    createdDate?: Date;
    createdUser: string;
    lastModifiedDate?: Date;
    lastModifiedUser: string;
    providerNote?: string | undefined;
    responsibleParty?: string | undefined;
    vendorBillID?: number | undefined;
    vendorBillItemId?: number | undefined;
    expectedCostOfService?: number | undefined;
    resolutionNote?: string | undefined;
    issueResolution?: IssueResolution | undefined;
    issueType?: IssueType | undefined;
    asset?: Asset | undefined;
    provider?: Provider | undefined;
    serviceEventNotes?: ServiceEventNote[] | undefined;
    ignoredUser?: string | undefined;
    ignoredDate?: Date | undefined;
    lastCommunicationDate?: Date | undefined;
    alarmCode?: string | undefined;
    serviceEventAlarmCodes?: ServiceEventAlarmCode[] | undefined;
}

export class IssueResolution implements IIssueResolution {
    issueResolutionID?: number;
    description!: string;
    isDeleted?: boolean;

    constructor(data?: IIssueResolution) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueResolutionID = _data["issueResolutionID"];
            this.description = _data["description"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): IssueResolution {
        data = typeof data === 'object' ? data : {};
        let result = new IssueResolution();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueResolutionID"] = this.issueResolutionID;
        data["description"] = this.description;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IIssueResolution {
    issueResolutionID?: number;
    description: string;
    isDeleted?: boolean;
}

export class IssueType implements IIssueType {
    issueTypeID?: number;
    description!: string;
    isAvailableExternally?: boolean | undefined;
    isDeleted?: boolean;
    createdDate?: Date;
    createdUser?: string | undefined;
    lastModifiedDate?: Date;
    lastModifiedUser?: string | undefined;

    constructor(data?: IIssueType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issueTypeID = _data["issueTypeID"];
            this.description = _data["description"];
            this.isAvailableExternally = _data["isAvailableExternally"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.lastModifiedUser = _data["lastModifiedUser"];
        }
    }

    static fromJS(data: any): IssueType {
        data = typeof data === 'object' ? data : {};
        let result = new IssueType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueTypeID"] = this.issueTypeID;
        data["description"] = this.description;
        data["isAvailableExternally"] = this.isAvailableExternally;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdUser"] = this.createdUser;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["lastModifiedUser"] = this.lastModifiedUser;
        return data;
    }
}

export interface IIssueType {
    issueTypeID?: number;
    description: string;
    isAvailableExternally?: boolean | undefined;
    isDeleted?: boolean;
    createdDate?: Date;
    createdUser?: string | undefined;
    lastModifiedDate?: Date;
    lastModifiedUser?: string | undefined;
}

export class Provider implements IProvider {
    id?: string | undefined;
    name?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    contact?: string | undefined;
    mainPhone?: string | undefined;
    mainPhoneExt?: string | undefined;
    emergencyPhone?: string | undefined;
    emergencyPhoneExt?: string | undefined;
    alternatePhone?: string | undefined;
    alternatePhoneExt?: string | undefined;
    fax?: string | undefined;
    email?: string | undefined;
    dryContainers?: boolean;
    dryVans?: boolean;
    dieselRefrigeratedTrailers?: boolean;
    electricRefrigeratedTrailers?: boolean;
    remoteFuel?: boolean;
    serviceAndRepair?: boolean;
    servicePrimeAndRestart?: boolean;
    towTrailerContainer?: boolean;
    emergencyService?: boolean;
    ltlCarrier?: boolean;
    smallParcelCarrier?: boolean;
    wmrtDistCtr?: boolean;
    mobileGenerators?: boolean;
    electrician?: boolean;
    accessory?: boolean;
    isCarrier?: boolean;
    dailyRentalFee?: number | undefined;
    weeklyRentalFee?: number | undefined;
    monthlyRentalFee?: number | undefined;
    hourlyRuntimeFee?: number | undefined;
    stopChargeFee?: number | undefined;
    perGallonFuelRate?: number | undefined;
    latitude?: number;
    longitude?: number;
    notes?: string | undefined;
    officeHours?: string | undefined;
    yardHours?: string | undefined;
    weekdayYardTimeStart?: string | undefined;
    weekdayYardTimeEnd?: string | undefined;
    weekendYardTimeStart?: string | undefined;
    weekendYardTimeEnd?: string | undefined;
    deleted?: boolean;
    doNotUseDate?: Date | undefined;
    doNotUseReason?: string | undefined;
    doNotUseUser?: string | undefined;
    cid?: string | undefined;
    billToCID?: string | undefined;
    paymentType?: string | undefined;
    doNotSendFuelEmails?: boolean;
    createdDate?: Date | undefined;
    createdUser?: string | undefined;
    lastModifiedDate?: Date | undefined;
    lastModifiedUser?: string | undefined;
    providerStates?: ProviderState[] | undefined;
    providerContacts?: ProviderContact[] | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    customerID?: string | undefined;
    externalVendorID?: string | undefined;
    nsSentDate?: Date | undefined;
    locationDispatchInformation?: string | undefined;
    statusNowID?: number | undefined;
    locationStatusNowID?: number | undefined;
    streetOrigonal?: string | undefined;
    termsID?: number | undefined;
    effectiveTermsID?: number | undefined;
    lastGeoRefreshDate?: Date | undefined;
    multiDieselReefers?: boolean;
    lastNetSuiteCheckDate?: Date | undefined;
    rateNotes?: string | undefined;
    fuelBillNotes?: string | undefined;
    autoFuelDeliveryCalls?: boolean;
    isInactive?: boolean;
    fireSuppressionFueler?: boolean;
    insuranceCoverageAmount?: number | undefined;
    insuranceReceivedDate?: Date | undefined;
    w9ReceivedDate?: Date | undefined;
    providerOrganizationID?: number | undefined;
    locationName?: string | undefined;
    lastNote?: string | undefined;
    lastNoteDate?: Date | undefined;

    constructor(data?: IProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.contact = _data["contact"];
            this.mainPhone = _data["mainPhone"];
            this.mainPhoneExt = _data["mainPhoneExt"];
            this.emergencyPhone = _data["emergencyPhone"];
            this.emergencyPhoneExt = _data["emergencyPhoneExt"];
            this.alternatePhone = _data["alternatePhone"];
            this.alternatePhoneExt = _data["alternatePhoneExt"];
            this.fax = _data["fax"];
            this.email = _data["email"];
            this.dryContainers = _data["dryContainers"];
            this.dryVans = _data["dryVans"];
            this.dieselRefrigeratedTrailers = _data["dieselRefrigeratedTrailers"];
            this.electricRefrigeratedTrailers = _data["electricRefrigeratedTrailers"];
            this.remoteFuel = _data["remoteFuel"];
            this.serviceAndRepair = _data["serviceAndRepair"];
            this.servicePrimeAndRestart = _data["servicePrimeAndRestart"];
            this.towTrailerContainer = _data["towTrailerContainer"];
            this.emergencyService = _data["emergencyService"];
            this.ltlCarrier = _data["ltlCarrier"];
            this.smallParcelCarrier = _data["smallParcelCarrier"];
            this.wmrtDistCtr = _data["wmrtDistCtr"];
            this.mobileGenerators = _data["mobileGenerators"];
            this.electrician = _data["electrician"];
            this.accessory = _data["accessory"];
            this.isCarrier = _data["isCarrier"];
            this.dailyRentalFee = _data["dailyRentalFee"];
            this.weeklyRentalFee = _data["weeklyRentalFee"];
            this.monthlyRentalFee = _data["monthlyRentalFee"];
            this.hourlyRuntimeFee = _data["hourlyRuntimeFee"];
            this.stopChargeFee = _data["stopChargeFee"];
            this.perGallonFuelRate = _data["perGallonFuelRate"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.notes = _data["notes"];
            this.officeHours = _data["officeHours"];
            this.yardHours = _data["yardHours"];
            this.weekdayYardTimeStart = _data["weekdayYardTimeStart"];
            this.weekdayYardTimeEnd = _data["weekdayYardTimeEnd"];
            this.weekendYardTimeStart = _data["weekendYardTimeStart"];
            this.weekendYardTimeEnd = _data["weekendYardTimeEnd"];
            this.deleted = _data["deleted"];
            this.doNotUseDate = _data["doNotUseDate"] ? new Date(_data["doNotUseDate"].toString()) : undefined as any;
            this.doNotUseReason = _data["doNotUseReason"];
            this.doNotUseUser = _data["doNotUseUser"];
            this.cid = _data["cid"];
            this.billToCID = _data["billToCID"];
            this.paymentType = _data["paymentType"];
            this.doNotSendFuelEmails = _data["doNotSendFuelEmails"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.lastModifiedUser = _data["lastModifiedUser"];
            if (Array.isArray(_data["providerStates"])) {
                this.providerStates = [] as any;
                for (let item of _data["providerStates"])
                    this.providerStates!.push(ProviderState.fromJS(item));
            }
            if (Array.isArray(_data["providerContacts"])) {
                this.providerContacts = [] as any;
                for (let item of _data["providerContacts"])
                    this.providerContacts!.push(ProviderContact.fromJS(item));
            }
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.customerID = _data["customerID"];
            this.externalVendorID = _data["externalVendorID"];
            this.nsSentDate = _data["nsSentDate"] ? new Date(_data["nsSentDate"].toString()) : undefined as any;
            this.locationDispatchInformation = _data["locationDispatchInformation"];
            this.statusNowID = _data["statusNowID"];
            this.locationStatusNowID = _data["locationStatusNowID"];
            this.streetOrigonal = _data["streetOrigonal"];
            this.termsID = _data["termsID"];
            this.effectiveTermsID = _data["effectiveTermsID"];
            this.lastGeoRefreshDate = _data["lastGeoRefreshDate"] ? new Date(_data["lastGeoRefreshDate"].toString()) : undefined as any;
            this.multiDieselReefers = _data["multiDieselReefers"];
            this.lastNetSuiteCheckDate = _data["lastNetSuiteCheckDate"] ? new Date(_data["lastNetSuiteCheckDate"].toString()) : undefined as any;
            this.rateNotes = _data["rateNotes"];
            this.fuelBillNotes = _data["fuelBillNotes"];
            this.autoFuelDeliveryCalls = _data["autoFuelDeliveryCalls"];
            this.isInactive = _data["isInactive"];
            this.fireSuppressionFueler = _data["fireSuppressionFueler"];
            this.insuranceCoverageAmount = _data["insuranceCoverageAmount"];
            this.insuranceReceivedDate = _data["insuranceReceivedDate"] ? new Date(_data["insuranceReceivedDate"].toString()) : undefined as any;
            this.w9ReceivedDate = _data["w9ReceivedDate"] ? new Date(_data["w9ReceivedDate"].toString()) : undefined as any;
            this.providerOrganizationID = _data["providerOrganizationID"];
            this.locationName = _data["locationName"];
            this.lastNote = _data["lastNote"];
            this.lastNoteDate = _data["lastNoteDate"] ? new Date(_data["lastNoteDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): Provider {
        data = typeof data === 'object' ? data : {};
        let result = new Provider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["street"] = this.street;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["contact"] = this.contact;
        data["mainPhone"] = this.mainPhone;
        data["mainPhoneExt"] = this.mainPhoneExt;
        data["emergencyPhone"] = this.emergencyPhone;
        data["emergencyPhoneExt"] = this.emergencyPhoneExt;
        data["alternatePhone"] = this.alternatePhone;
        data["alternatePhoneExt"] = this.alternatePhoneExt;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["dryContainers"] = this.dryContainers;
        data["dryVans"] = this.dryVans;
        data["dieselRefrigeratedTrailers"] = this.dieselRefrigeratedTrailers;
        data["electricRefrigeratedTrailers"] = this.electricRefrigeratedTrailers;
        data["remoteFuel"] = this.remoteFuel;
        data["serviceAndRepair"] = this.serviceAndRepair;
        data["servicePrimeAndRestart"] = this.servicePrimeAndRestart;
        data["towTrailerContainer"] = this.towTrailerContainer;
        data["emergencyService"] = this.emergencyService;
        data["ltlCarrier"] = this.ltlCarrier;
        data["smallParcelCarrier"] = this.smallParcelCarrier;
        data["wmrtDistCtr"] = this.wmrtDistCtr;
        data["mobileGenerators"] = this.mobileGenerators;
        data["electrician"] = this.electrician;
        data["accessory"] = this.accessory;
        data["isCarrier"] = this.isCarrier;
        data["dailyRentalFee"] = this.dailyRentalFee;
        data["weeklyRentalFee"] = this.weeklyRentalFee;
        data["monthlyRentalFee"] = this.monthlyRentalFee;
        data["hourlyRuntimeFee"] = this.hourlyRuntimeFee;
        data["stopChargeFee"] = this.stopChargeFee;
        data["perGallonFuelRate"] = this.perGallonFuelRate;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["notes"] = this.notes;
        data["officeHours"] = this.officeHours;
        data["yardHours"] = this.yardHours;
        data["weekdayYardTimeStart"] = this.weekdayYardTimeStart;
        data["weekdayYardTimeEnd"] = this.weekdayYardTimeEnd;
        data["weekendYardTimeStart"] = this.weekendYardTimeStart;
        data["weekendYardTimeEnd"] = this.weekendYardTimeEnd;
        data["deleted"] = this.deleted;
        data["doNotUseDate"] = this.doNotUseDate ? this.doNotUseDate.toISOString() : undefined as any;
        data["doNotUseReason"] = this.doNotUseReason;
        data["doNotUseUser"] = this.doNotUseUser;
        data["cid"] = this.cid;
        data["billToCID"] = this.billToCID;
        data["paymentType"] = this.paymentType;
        data["doNotSendFuelEmails"] = this.doNotSendFuelEmails;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdUser"] = this.createdUser;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["lastModifiedUser"] = this.lastModifiedUser;
        if (Array.isArray(this.providerStates)) {
            data["providerStates"] = [];
            for (let item of this.providerStates)
                data["providerStates"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.providerContacts)) {
            data["providerContacts"] = [];
            for (let item of this.providerContacts)
                data["providerContacts"].push(item ? item.toJSON() : undefined as any);
        }
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["customerID"] = this.customerID;
        data["externalVendorID"] = this.externalVendorID;
        data["nsSentDate"] = this.nsSentDate ? this.nsSentDate.toISOString() : undefined as any;
        data["locationDispatchInformation"] = this.locationDispatchInformation;
        data["statusNowID"] = this.statusNowID;
        data["locationStatusNowID"] = this.locationStatusNowID;
        data["streetOrigonal"] = this.streetOrigonal;
        data["termsID"] = this.termsID;
        data["effectiveTermsID"] = this.effectiveTermsID;
        data["lastGeoRefreshDate"] = this.lastGeoRefreshDate ? this.lastGeoRefreshDate.toISOString() : undefined as any;
        data["multiDieselReefers"] = this.multiDieselReefers;
        data["lastNetSuiteCheckDate"] = this.lastNetSuiteCheckDate ? this.lastNetSuiteCheckDate.toISOString() : undefined as any;
        data["rateNotes"] = this.rateNotes;
        data["fuelBillNotes"] = this.fuelBillNotes;
        data["autoFuelDeliveryCalls"] = this.autoFuelDeliveryCalls;
        data["isInactive"] = this.isInactive;
        data["fireSuppressionFueler"] = this.fireSuppressionFueler;
        data["insuranceCoverageAmount"] = this.insuranceCoverageAmount;
        data["insuranceReceivedDate"] = this.insuranceReceivedDate ? this.insuranceReceivedDate.toISOString() : undefined as any;
        data["w9ReceivedDate"] = this.w9ReceivedDate ? this.w9ReceivedDate.toISOString() : undefined as any;
        data["providerOrganizationID"] = this.providerOrganizationID;
        data["locationName"] = this.locationName;
        data["lastNote"] = this.lastNote;
        data["lastNoteDate"] = this.lastNoteDate ? this.lastNoteDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IProvider {
    id?: string | undefined;
    name?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    contact?: string | undefined;
    mainPhone?: string | undefined;
    mainPhoneExt?: string | undefined;
    emergencyPhone?: string | undefined;
    emergencyPhoneExt?: string | undefined;
    alternatePhone?: string | undefined;
    alternatePhoneExt?: string | undefined;
    fax?: string | undefined;
    email?: string | undefined;
    dryContainers?: boolean;
    dryVans?: boolean;
    dieselRefrigeratedTrailers?: boolean;
    electricRefrigeratedTrailers?: boolean;
    remoteFuel?: boolean;
    serviceAndRepair?: boolean;
    servicePrimeAndRestart?: boolean;
    towTrailerContainer?: boolean;
    emergencyService?: boolean;
    ltlCarrier?: boolean;
    smallParcelCarrier?: boolean;
    wmrtDistCtr?: boolean;
    mobileGenerators?: boolean;
    electrician?: boolean;
    accessory?: boolean;
    isCarrier?: boolean;
    dailyRentalFee?: number | undefined;
    weeklyRentalFee?: number | undefined;
    monthlyRentalFee?: number | undefined;
    hourlyRuntimeFee?: number | undefined;
    stopChargeFee?: number | undefined;
    perGallonFuelRate?: number | undefined;
    latitude?: number;
    longitude?: number;
    notes?: string | undefined;
    officeHours?: string | undefined;
    yardHours?: string | undefined;
    weekdayYardTimeStart?: string | undefined;
    weekdayYardTimeEnd?: string | undefined;
    weekendYardTimeStart?: string | undefined;
    weekendYardTimeEnd?: string | undefined;
    deleted?: boolean;
    doNotUseDate?: Date | undefined;
    doNotUseReason?: string | undefined;
    doNotUseUser?: string | undefined;
    cid?: string | undefined;
    billToCID?: string | undefined;
    paymentType?: string | undefined;
    doNotSendFuelEmails?: boolean;
    createdDate?: Date | undefined;
    createdUser?: string | undefined;
    lastModifiedDate?: Date | undefined;
    lastModifiedUser?: string | undefined;
    providerStates?: ProviderState[] | undefined;
    providerContacts?: ProviderContact[] | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    customerID?: string | undefined;
    externalVendorID?: string | undefined;
    nsSentDate?: Date | undefined;
    locationDispatchInformation?: string | undefined;
    statusNowID?: number | undefined;
    locationStatusNowID?: number | undefined;
    streetOrigonal?: string | undefined;
    termsID?: number | undefined;
    effectiveTermsID?: number | undefined;
    lastGeoRefreshDate?: Date | undefined;
    multiDieselReefers?: boolean;
    lastNetSuiteCheckDate?: Date | undefined;
    rateNotes?: string | undefined;
    fuelBillNotes?: string | undefined;
    autoFuelDeliveryCalls?: boolean;
    isInactive?: boolean;
    fireSuppressionFueler?: boolean;
    insuranceCoverageAmount?: number | undefined;
    insuranceReceivedDate?: Date | undefined;
    w9ReceivedDate?: Date | undefined;
    providerOrganizationID?: number | undefined;
    locationName?: string | undefined;
    lastNote?: string | undefined;
    lastNoteDate?: Date | undefined;
}

export class ProviderState implements IProviderState {
    providerStateID?: number;
    providerID?: string | undefined;
    stateID?: number;
    createdDate?: Date | undefined;
    createdUser?: string | undefined;
    lastModifiedDate?: Date | undefined;
    lastModifiedUser?: string | undefined;
    provider?: Provider | undefined;
    state?: State | undefined;

    constructor(data?: IProviderState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerStateID = _data["providerStateID"];
            this.providerID = _data["providerID"];
            this.stateID = _data["stateID"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.lastModifiedUser = _data["lastModifiedUser"];
            this.provider = _data["provider"] ? Provider.fromJS(_data["provider"]) : undefined as any;
            this.state = _data["state"] ? State.fromJS(_data["state"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProviderState {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerStateID"] = this.providerStateID;
        data["providerID"] = this.providerID;
        data["stateID"] = this.stateID;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdUser"] = this.createdUser;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["lastModifiedUser"] = this.lastModifiedUser;
        data["provider"] = this.provider ? this.provider.toJSON() : undefined as any;
        data["state"] = this.state ? this.state.toJSON() : undefined as any;
        return data;
    }
}

export interface IProviderState {
    providerStateID?: number;
    providerID?: string | undefined;
    stateID?: number;
    createdDate?: Date | undefined;
    createdUser?: string | undefined;
    lastModifiedDate?: Date | undefined;
    lastModifiedUser?: string | undefined;
    provider?: Provider | undefined;
    state?: State | undefined;
}

export class State implements IState {
    stateID?: number;
    code?: string | undefined;
    name?: string | undefined;
    taxExemptTrailers?: boolean;
    taxExemptContainers?: boolean;

    constructor(data?: IState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stateID = _data["stateID"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.taxExemptTrailers = _data["taxExemptTrailers"];
            this.taxExemptContainers = _data["taxExemptContainers"];
        }
    }

    static fromJS(data: any): State {
        data = typeof data === 'object' ? data : {};
        let result = new State();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stateID"] = this.stateID;
        data["code"] = this.code;
        data["name"] = this.name;
        data["taxExemptTrailers"] = this.taxExemptTrailers;
        data["taxExemptContainers"] = this.taxExemptContainers;
        return data;
    }
}

export interface IState {
    stateID?: number;
    code?: string | undefined;
    name?: string | undefined;
    taxExemptTrailers?: boolean;
    taxExemptContainers?: boolean;
}

export class ProviderContact implements IProviderContact {
    providerContactID?: number;
    providerID?: string | undefined;
    name?: string | undefined;
    providerContactTypeID?: number;
    phone?: string | undefined;
    extension?: string | undefined;
    email?: string | undefined;
    isDeleted?: boolean;
    createdDate?: Date | undefined;
    createdUser?: string | undefined;
    lastModifiedDate?: Date | undefined;
    lastModifiedUser?: string | undefined;
    isDefault?: boolean | undefined;
    providerContactType?: ProviderContactType | undefined;

    constructor(data?: IProviderContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerContactID = _data["providerContactID"];
            this.providerID = _data["providerID"];
            this.name = _data["name"];
            this.providerContactTypeID = _data["providerContactTypeID"];
            this.phone = _data["phone"];
            this.extension = _data["extension"];
            this.email = _data["email"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.lastModifiedUser = _data["lastModifiedUser"];
            this.isDefault = _data["isDefault"];
            this.providerContactType = _data["providerContactType"] ? ProviderContactType.fromJS(_data["providerContactType"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProviderContact {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerContactID"] = this.providerContactID;
        data["providerID"] = this.providerID;
        data["name"] = this.name;
        data["providerContactTypeID"] = this.providerContactTypeID;
        data["phone"] = this.phone;
        data["extension"] = this.extension;
        data["email"] = this.email;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdUser"] = this.createdUser;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["lastModifiedUser"] = this.lastModifiedUser;
        data["isDefault"] = this.isDefault;
        data["providerContactType"] = this.providerContactType ? this.providerContactType.toJSON() : undefined as any;
        return data;
    }
}

export interface IProviderContact {
    providerContactID?: number;
    providerID?: string | undefined;
    name?: string | undefined;
    providerContactTypeID?: number;
    phone?: string | undefined;
    extension?: string | undefined;
    email?: string | undefined;
    isDeleted?: boolean;
    createdDate?: Date | undefined;
    createdUser?: string | undefined;
    lastModifiedDate?: Date | undefined;
    lastModifiedUser?: string | undefined;
    isDefault?: boolean | undefined;
    providerContactType?: ProviderContactType | undefined;
}

export class ProviderContactType implements IProviderContactType {
    providerContactTypeID?: number;
    description?: string | undefined;

    constructor(data?: IProviderContactType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerContactTypeID = _data["providerContactTypeID"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ProviderContactType {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderContactType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerContactTypeID"] = this.providerContactTypeID;
        data["description"] = this.description;
        return data;
    }
}

export interface IProviderContactType {
    providerContactTypeID?: number;
    description?: string | undefined;
}

export class ServiceEventNote implements IServiceEventNote {
    serviceEventNoteID?: number;
    serviceEventID?: number;
    text?: string | undefined;
    createdDate?: Date;
    createdUser?: string | undefined;
    lastModifiedDate?: Date;
    lastModifiedUser?: string | undefined;

    constructor(data?: IServiceEventNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceEventNoteID = _data["serviceEventNoteID"];
            this.serviceEventID = _data["serviceEventID"];
            this.text = _data["text"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.lastModifiedUser = _data["lastModifiedUser"];
        }
    }

    static fromJS(data: any): ServiceEventNote {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceEventNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceEventNoteID"] = this.serviceEventNoteID;
        data["serviceEventID"] = this.serviceEventID;
        data["text"] = this.text;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdUser"] = this.createdUser;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["lastModifiedUser"] = this.lastModifiedUser;
        return data;
    }
}

export interface IServiceEventNote {
    serviceEventNoteID?: number;
    serviceEventID?: number;
    text?: string | undefined;
    createdDate?: Date;
    createdUser?: string | undefined;
    lastModifiedDate?: Date;
    lastModifiedUser?: string | undefined;
}

export class ServiceEventAlarmCode implements IServiceEventAlarmCode {
    id?: number;
    serviceEventID?: number;
    alarmCode?: string | undefined;
    refrigeratorType?: string | undefined;
    createdDate?: Date;
    createdUser?: string | undefined;
    lastModifiedDate?: Date;
    lastModifiedUser?: string | undefined;

    constructor(data?: IServiceEventAlarmCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceEventID = _data["serviceEventID"];
            this.alarmCode = _data["alarmCode"];
            this.refrigeratorType = _data["refrigeratorType"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.lastModifiedUser = _data["lastModifiedUser"];
        }
    }

    static fromJS(data: any): ServiceEventAlarmCode {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceEventAlarmCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceEventID"] = this.serviceEventID;
        data["alarmCode"] = this.alarmCode;
        data["refrigeratorType"] = this.refrigeratorType;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdUser"] = this.createdUser;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["lastModifiedUser"] = this.lastModifiedUser;
        return data;
    }
}

export interface IServiceEventAlarmCode {
    id?: number;
    serviceEventID?: number;
    alarmCode?: string | undefined;
    refrigeratorType?: string | undefined;
    createdDate?: Date;
    createdUser?: string | undefined;
    lastModifiedDate?: Date;
    lastModifiedUser?: string | undefined;
}

export class OnPeriod implements IOnPeriod {
    onPeriodID?: number;
    assetID?: number | undefined;
    beginDate?: Date;
    endDate?: Date | undefined;
    durationHours?: number | undefined;
    asset?: Asset | undefined;

    constructor(data?: IOnPeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onPeriodID = _data["onPeriodID"];
            this.assetID = _data["assetID"];
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.durationHours = _data["durationHours"];
            this.asset = _data["asset"] ? Asset.fromJS(_data["asset"]) : undefined as any;
        }
    }

    static fromJS(data: any): OnPeriod {
        data = typeof data === 'object' ? data : {};
        let result = new OnPeriod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onPeriodID"] = this.onPeriodID;
        data["assetID"] = this.assetID;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["durationHours"] = this.durationHours;
        data["asset"] = this.asset ? this.asset.toJSON() : undefined as any;
        return data;
    }
}

export interface IOnPeriod {
    onPeriodID?: number;
    assetID?: number | undefined;
    beginDate?: Date;
    endDate?: Date | undefined;
    durationHours?: number | undefined;
    asset?: Asset | undefined;
}

export class AssetAmbientTemps implements IAssetAmbientTemps {
    assetTempID?: number;
    assetID?: number;
    temperature?: number;
    recordedDate?: Date;
    asset?: Asset | undefined;

    constructor(data?: IAssetAmbientTemps) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetTempID = _data["assetTempID"];
            this.assetID = _data["assetID"];
            this.temperature = _data["temperature"];
            this.recordedDate = _data["recordedDate"] ? new Date(_data["recordedDate"].toString()) : undefined as any;
            this.asset = _data["asset"] ? Asset.fromJS(_data["asset"]) : undefined as any;
        }
    }

    static fromJS(data: any): AssetAmbientTemps {
        data = typeof data === 'object' ? data : {};
        let result = new AssetAmbientTemps();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetTempID"] = this.assetTempID;
        data["assetID"] = this.assetID;
        data["temperature"] = this.temperature;
        data["recordedDate"] = this.recordedDate ? this.recordedDate.toISOString() : undefined as any;
        data["asset"] = this.asset ? this.asset.toJSON() : undefined as any;
        return data;
    }
}

export interface IAssetAmbientTemps {
    assetTempID?: number;
    assetID?: number;
    temperature?: number;
    recordedDate?: Date;
    asset?: Asset | undefined;
}

export class Order implements IOrder {
    orderID?: number;
    legacyOrderID?: number | undefined;
    idx?: string | undefined;
    customerID?: string | undefined;
    locationID?: string | undefined;
    locID?: number | undefined;
    status?: string | undefined;
    category?: string | undefined;
    poNumber?: string | undefined;
    notes?: string | undefined;
    deleted?: boolean | undefined;
    workOrderNumber?: string | undefined;
    requestRequirement?: string | undefined;
    requestPriority?: string | undefined;
    requestQuantity?: number | undefined;
    requestReceived?: Date | undefined;
    requestReminderSent?: Date | undefined;
    requestMissedETA?: Date | undefined;
    requestDescription?: string | undefined;
    requestOrderedBy?: string | undefined;
    requestOrderedByDirector?: string | undefined;
    requestOrderedByPhone?: string | undefined;
    requestOrderedByEmail?: string | undefined;
    deliveryFulfillmentBidQuantity?: number | undefined;
    deliveryFulfillmentBidAmount?: number | undefined;
    deliveryFulfillmentBidTax?: number | undefined;
    deliveryFulfillmentBidTotal?: number | undefined;
    deliveryFulfillmentQuoteProposal?: string | undefined;
    deliveryFulfillmentQuoteNTE?: number | undefined;
    requiresReview?: boolean;
    orderTags?: string | undefined;
    orderTagIDs?: string | undefined;
    originalCategory?: string | undefined;
    assets?: Asset[] | undefined;
    orderProviders?: OrderProvider[] | undefined;
    orderModifications?: OrderModification[] | undefined;
    customerReferences?: CustomerReference[] | undefined;
    rateOverrides?: RateOverrides | undefined;
    location?: Location | undefined;
    customer?: Customer | undefined;
    tags?: OrderTag[] | undefined;
    createdDate?: Date;
    createdUser?: string | undefined;
    lastModifiedDate?: Date;
    lastModifiedUser?: string | undefined;
    cancelDate?: Date | undefined;
    serviceChannelStatus?: string | undefined;
    serviceChannelLastUpdate?: string | undefined;
    serviceChannelLastUpdateDate?: Date | undefined;
    pricingModel?: string | undefined;
    orderNotice?: string | undefined;
    linkedOrderID?: number | undefined;
    approvedBy?: string | undefined;
    cancelResolution?: string | undefined;
    declinedDate?: Date | undefined;
    salesRepId?: number | undefined;
    requireReviewNote?: string | undefined;
    lastNote?: string | undefined;
    lastNoteDate?: Date | undefined;

    constructor(data?: IOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderID = _data["orderID"];
            this.legacyOrderID = _data["legacyOrderID"];
            this.idx = _data["idx"];
            this.customerID = _data["customerID"];
            this.locationID = _data["locationID"];
            this.locID = _data["locID"];
            this.status = _data["status"];
            this.category = _data["category"];
            this.poNumber = _data["poNumber"];
            this.notes = _data["notes"];
            this.deleted = _data["deleted"];
            this.workOrderNumber = _data["workOrderNumber"];
            this.requestRequirement = _data["requestRequirement"];
            this.requestPriority = _data["requestPriority"];
            this.requestQuantity = _data["requestQuantity"];
            this.requestReceived = _data["requestReceived"] ? new Date(_data["requestReceived"].toString()) : undefined as any;
            this.requestReminderSent = _data["requestReminderSent"] ? new Date(_data["requestReminderSent"].toString()) : undefined as any;
            this.requestMissedETA = _data["requestMissedETA"] ? new Date(_data["requestMissedETA"].toString()) : undefined as any;
            this.requestDescription = _data["requestDescription"];
            this.requestOrderedBy = _data["requestOrderedBy"];
            this.requestOrderedByDirector = _data["requestOrderedByDirector"];
            this.requestOrderedByPhone = _data["requestOrderedByPhone"];
            this.requestOrderedByEmail = _data["requestOrderedByEmail"];
            this.deliveryFulfillmentBidQuantity = _data["deliveryFulfillmentBidQuantity"];
            this.deliveryFulfillmentBidAmount = _data["deliveryFulfillmentBidAmount"];
            this.deliveryFulfillmentBidTax = _data["deliveryFulfillmentBidTax"];
            this.deliveryFulfillmentBidTotal = _data["deliveryFulfillmentBidTotal"];
            this.deliveryFulfillmentQuoteProposal = _data["deliveryFulfillmentQuoteProposal"];
            this.deliveryFulfillmentQuoteNTE = _data["deliveryFulfillmentQuoteNTE"];
            this.requiresReview = _data["requiresReview"];
            this.orderTags = _data["orderTags"];
            this.orderTagIDs = _data["orderTagIDs"];
            this.originalCategory = _data["originalCategory"];
            if (Array.isArray(_data["assets"])) {
                this.assets = [] as any;
                for (let item of _data["assets"])
                    this.assets!.push(Asset.fromJS(item));
            }
            if (Array.isArray(_data["orderProviders"])) {
                this.orderProviders = [] as any;
                for (let item of _data["orderProviders"])
                    this.orderProviders!.push(OrderProvider.fromJS(item));
            }
            if (Array.isArray(_data["orderModifications"])) {
                this.orderModifications = [] as any;
                for (let item of _data["orderModifications"])
                    this.orderModifications!.push(OrderModification.fromJS(item));
            }
            if (Array.isArray(_data["customerReferences"])) {
                this.customerReferences = [] as any;
                for (let item of _data["customerReferences"])
                    this.customerReferences!.push(CustomerReference.fromJS(item));
            }
            this.rateOverrides = _data["rateOverrides"] ? RateOverrides.fromJS(_data["rateOverrides"]) : undefined as any;
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : undefined as any;
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : undefined as any;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(OrderTag.fromJS(item));
            }
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.lastModifiedUser = _data["lastModifiedUser"];
            this.cancelDate = _data["cancelDate"] ? new Date(_data["cancelDate"].toString()) : undefined as any;
            this.serviceChannelStatus = _data["serviceChannelStatus"];
            this.serviceChannelLastUpdate = _data["serviceChannelLastUpdate"];
            this.serviceChannelLastUpdateDate = _data["serviceChannelLastUpdateDate"] ? new Date(_data["serviceChannelLastUpdateDate"].toString()) : undefined as any;
            this.pricingModel = _data["pricingModel"];
            this.orderNotice = _data["orderNotice"];
            this.linkedOrderID = _data["linkedOrderID"];
            this.approvedBy = _data["approvedBy"];
            this.cancelResolution = _data["cancelResolution"];
            this.declinedDate = _data["declinedDate"] ? new Date(_data["declinedDate"].toString()) : undefined as any;
            this.salesRepId = _data["salesRepId"];
            this.requireReviewNote = _data["requireReviewNote"];
            this.lastNote = _data["lastNote"];
            this.lastNoteDate = _data["lastNoteDate"] ? new Date(_data["lastNoteDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): Order {
        data = typeof data === 'object' ? data : {};
        let result = new Order();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderID"] = this.orderID;
        data["legacyOrderID"] = this.legacyOrderID;
        data["idx"] = this.idx;
        data["customerID"] = this.customerID;
        data["locationID"] = this.locationID;
        data["locID"] = this.locID;
        data["status"] = this.status;
        data["category"] = this.category;
        data["poNumber"] = this.poNumber;
        data["notes"] = this.notes;
        data["deleted"] = this.deleted;
        data["workOrderNumber"] = this.workOrderNumber;
        data["requestRequirement"] = this.requestRequirement;
        data["requestPriority"] = this.requestPriority;
        data["requestQuantity"] = this.requestQuantity;
        data["requestReceived"] = this.requestReceived ? this.requestReceived.toISOString() : undefined as any;
        data["requestReminderSent"] = this.requestReminderSent ? this.requestReminderSent.toISOString() : undefined as any;
        data["requestMissedETA"] = this.requestMissedETA ? this.requestMissedETA.toISOString() : undefined as any;
        data["requestDescription"] = this.requestDescription;
        data["requestOrderedBy"] = this.requestOrderedBy;
        data["requestOrderedByDirector"] = this.requestOrderedByDirector;
        data["requestOrderedByPhone"] = this.requestOrderedByPhone;
        data["requestOrderedByEmail"] = this.requestOrderedByEmail;
        data["deliveryFulfillmentBidQuantity"] = this.deliveryFulfillmentBidQuantity;
        data["deliveryFulfillmentBidAmount"] = this.deliveryFulfillmentBidAmount;
        data["deliveryFulfillmentBidTax"] = this.deliveryFulfillmentBidTax;
        data["deliveryFulfillmentBidTotal"] = this.deliveryFulfillmentBidTotal;
        data["deliveryFulfillmentQuoteProposal"] = this.deliveryFulfillmentQuoteProposal;
        data["deliveryFulfillmentQuoteNTE"] = this.deliveryFulfillmentQuoteNTE;
        data["requiresReview"] = this.requiresReview;
        data["orderTags"] = this.orderTags;
        data["orderTagIDs"] = this.orderTagIDs;
        data["originalCategory"] = this.originalCategory;
        if (Array.isArray(this.assets)) {
            data["assets"] = [];
            for (let item of this.assets)
                data["assets"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.orderProviders)) {
            data["orderProviders"] = [];
            for (let item of this.orderProviders)
                data["orderProviders"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.orderModifications)) {
            data["orderModifications"] = [];
            for (let item of this.orderModifications)
                data["orderModifications"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.customerReferences)) {
            data["customerReferences"] = [];
            for (let item of this.customerReferences)
                data["customerReferences"].push(item ? item.toJSON() : undefined as any);
        }
        data["rateOverrides"] = this.rateOverrides ? this.rateOverrides.toJSON() : undefined as any;
        data["location"] = this.location ? this.location.toJSON() : undefined as any;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdUser"] = this.createdUser;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["lastModifiedUser"] = this.lastModifiedUser;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : undefined as any;
        data["serviceChannelStatus"] = this.serviceChannelStatus;
        data["serviceChannelLastUpdate"] = this.serviceChannelLastUpdate;
        data["serviceChannelLastUpdateDate"] = this.serviceChannelLastUpdateDate ? this.serviceChannelLastUpdateDate.toISOString() : undefined as any;
        data["pricingModel"] = this.pricingModel;
        data["orderNotice"] = this.orderNotice;
        data["linkedOrderID"] = this.linkedOrderID;
        data["approvedBy"] = this.approvedBy;
        data["cancelResolution"] = this.cancelResolution;
        data["declinedDate"] = this.declinedDate ? this.declinedDate.toISOString() : undefined as any;
        data["salesRepId"] = this.salesRepId;
        data["requireReviewNote"] = this.requireReviewNote;
        data["lastNote"] = this.lastNote;
        data["lastNoteDate"] = this.lastNoteDate ? this.lastNoteDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IOrder {
    orderID?: number;
    legacyOrderID?: number | undefined;
    idx?: string | undefined;
    customerID?: string | undefined;
    locationID?: string | undefined;
    locID?: number | undefined;
    status?: string | undefined;
    category?: string | undefined;
    poNumber?: string | undefined;
    notes?: string | undefined;
    deleted?: boolean | undefined;
    workOrderNumber?: string | undefined;
    requestRequirement?: string | undefined;
    requestPriority?: string | undefined;
    requestQuantity?: number | undefined;
    requestReceived?: Date | undefined;
    requestReminderSent?: Date | undefined;
    requestMissedETA?: Date | undefined;
    requestDescription?: string | undefined;
    requestOrderedBy?: string | undefined;
    requestOrderedByDirector?: string | undefined;
    requestOrderedByPhone?: string | undefined;
    requestOrderedByEmail?: string | undefined;
    deliveryFulfillmentBidQuantity?: number | undefined;
    deliveryFulfillmentBidAmount?: number | undefined;
    deliveryFulfillmentBidTax?: number | undefined;
    deliveryFulfillmentBidTotal?: number | undefined;
    deliveryFulfillmentQuoteProposal?: string | undefined;
    deliveryFulfillmentQuoteNTE?: number | undefined;
    requiresReview?: boolean;
    orderTags?: string | undefined;
    orderTagIDs?: string | undefined;
    originalCategory?: string | undefined;
    assets?: Asset[] | undefined;
    orderProviders?: OrderProvider[] | undefined;
    orderModifications?: OrderModification[] | undefined;
    customerReferences?: CustomerReference[] | undefined;
    rateOverrides?: RateOverrides | undefined;
    location?: Location | undefined;
    customer?: Customer | undefined;
    tags?: OrderTag[] | undefined;
    createdDate?: Date;
    createdUser?: string | undefined;
    lastModifiedDate?: Date;
    lastModifiedUser?: string | undefined;
    cancelDate?: Date | undefined;
    serviceChannelStatus?: string | undefined;
    serviceChannelLastUpdate?: string | undefined;
    serviceChannelLastUpdateDate?: Date | undefined;
    pricingModel?: string | undefined;
    orderNotice?: string | undefined;
    linkedOrderID?: number | undefined;
    approvedBy?: string | undefined;
    cancelResolution?: string | undefined;
    declinedDate?: Date | undefined;
    salesRepId?: number | undefined;
    requireReviewNote?: string | undefined;
    lastNote?: string | undefined;
    lastNoteDate?: Date | undefined;
}

export class OrderProvider implements IOrderProvider {
    orderProviderID?: number;
    orderID?: number;
    providerID?: string | undefined;
    providerType?: string | undefined;
    mileage?: number | undefined;
    signNowJson?: string | undefined;
    confirmDate?: Date | undefined;
    confirmUser?: string | undefined;
    providerConfirmDate?: Date | undefined;
    fuelOrderRequestSentDate?: Date | undefined;
    fuelTeamFollowUpSentDate?: Date | undefined;
    order?: Order | undefined;
    provider?: Provider | undefined;

    constructor(data?: IOrderProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderProviderID = _data["orderProviderID"];
            this.orderID = _data["orderID"];
            this.providerID = _data["providerID"];
            this.providerType = _data["providerType"];
            this.mileage = _data["mileage"];
            this.signNowJson = _data["signNowJson"];
            this.confirmDate = _data["confirmDate"] ? new Date(_data["confirmDate"].toString()) : undefined as any;
            this.confirmUser = _data["confirmUser"];
            this.providerConfirmDate = _data["providerConfirmDate"] ? new Date(_data["providerConfirmDate"].toString()) : undefined as any;
            this.fuelOrderRequestSentDate = _data["fuelOrderRequestSentDate"] ? new Date(_data["fuelOrderRequestSentDate"].toString()) : undefined as any;
            this.fuelTeamFollowUpSentDate = _data["fuelTeamFollowUpSentDate"] ? new Date(_data["fuelTeamFollowUpSentDate"].toString()) : undefined as any;
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : undefined as any;
            this.provider = _data["provider"] ? Provider.fromJS(_data["provider"]) : undefined as any;
        }
    }

    static fromJS(data: any): OrderProvider {
        data = typeof data === 'object' ? data : {};
        let result = new OrderProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderProviderID"] = this.orderProviderID;
        data["orderID"] = this.orderID;
        data["providerID"] = this.providerID;
        data["providerType"] = this.providerType;
        data["mileage"] = this.mileage;
        data["signNowJson"] = this.signNowJson;
        data["confirmDate"] = this.confirmDate ? this.confirmDate.toISOString() : undefined as any;
        data["confirmUser"] = this.confirmUser;
        data["providerConfirmDate"] = this.providerConfirmDate ? this.providerConfirmDate.toISOString() : undefined as any;
        data["fuelOrderRequestSentDate"] = this.fuelOrderRequestSentDate ? this.fuelOrderRequestSentDate.toISOString() : undefined as any;
        data["fuelTeamFollowUpSentDate"] = this.fuelTeamFollowUpSentDate ? this.fuelTeamFollowUpSentDate.toISOString() : undefined as any;
        data["order"] = this.order ? this.order.toJSON() : undefined as any;
        data["provider"] = this.provider ? this.provider.toJSON() : undefined as any;
        return data;
    }
}

export interface IOrderProvider {
    orderProviderID?: number;
    orderID?: number;
    providerID?: string | undefined;
    providerType?: string | undefined;
    mileage?: number | undefined;
    signNowJson?: string | undefined;
    confirmDate?: Date | undefined;
    confirmUser?: string | undefined;
    providerConfirmDate?: Date | undefined;
    fuelOrderRequestSentDate?: Date | undefined;
    fuelTeamFollowUpSentDate?: Date | undefined;
    order?: Order | undefined;
    provider?: Provider | undefined;
}

export class OrderModification implements IOrderModification {
    modificationID?: number;
    orderID?: number;
    modificationType!: string;
    userID!: string;
    timeStamp?: Date;
    notes?: string | undefined;
    order?: Order | undefined;
    displayNote?: string | undefined;

    constructor(data?: IOrderModification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modificationID = _data["modificationID"];
            this.orderID = _data["orderID"];
            this.modificationType = _data["modificationType"];
            this.userID = _data["userID"];
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : undefined as any;
            this.notes = _data["notes"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : undefined as any;
            this.displayNote = _data["displayNote"];
        }
    }

    static fromJS(data: any): OrderModification {
        data = typeof data === 'object' ? data : {};
        let result = new OrderModification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modificationID"] = this.modificationID;
        data["orderID"] = this.orderID;
        data["modificationType"] = this.modificationType;
        data["userID"] = this.userID;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : undefined as any;
        data["notes"] = this.notes;
        data["order"] = this.order ? this.order.toJSON() : undefined as any;
        data["displayNote"] = this.displayNote;
        return data;
    }
}

export interface IOrderModification {
    modificationID?: number;
    orderID?: number;
    modificationType: string;
    userID: string;
    timeStamp?: Date;
    notes?: string | undefined;
    order?: Order | undefined;
    displayNote?: string | undefined;
}

export class CustomerReference implements ICustomerReference {
    customerReferenceID?: number;
    orderID?: number;
    referenceType?: string | undefined;
    reference?: string | undefined;
    lineItem?: string | undefined;
    originalAmount?: number | undefined;
    remainingAmount?: number | undefined;
    customerRemainingAmount?: number | undefined;
    lastCustomerUpdate?: Date | undefined;
    createdDate?: Date;
    createdUser?: string | undefined;
    lastModifiedDate?: Date;
    lastModifiedUser?: string | undefined;
    order?: Order | undefined;
    customerReferenceTypes?: CustomerReferenceType[] | undefined;

    constructor(data?: ICustomerReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerReferenceID = _data["customerReferenceID"];
            this.orderID = _data["orderID"];
            this.referenceType = _data["referenceType"];
            this.reference = _data["reference"];
            this.lineItem = _data["lineItem"];
            this.originalAmount = _data["originalAmount"];
            this.remainingAmount = _data["remainingAmount"];
            this.customerRemainingAmount = _data["customerRemainingAmount"];
            this.lastCustomerUpdate = _data["lastCustomerUpdate"] ? new Date(_data["lastCustomerUpdate"].toString()) : undefined as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.lastModifiedUser = _data["lastModifiedUser"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : undefined as any;
            if (Array.isArray(_data["customerReferenceTypes"])) {
                this.customerReferenceTypes = [] as any;
                for (let item of _data["customerReferenceTypes"])
                    this.customerReferenceTypes!.push(CustomerReferenceType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerReference {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerReference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerReferenceID"] = this.customerReferenceID;
        data["orderID"] = this.orderID;
        data["referenceType"] = this.referenceType;
        data["reference"] = this.reference;
        data["lineItem"] = this.lineItem;
        data["originalAmount"] = this.originalAmount;
        data["remainingAmount"] = this.remainingAmount;
        data["customerRemainingAmount"] = this.customerRemainingAmount;
        data["lastCustomerUpdate"] = this.lastCustomerUpdate ? this.lastCustomerUpdate.toISOString() : undefined as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdUser"] = this.createdUser;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["lastModifiedUser"] = this.lastModifiedUser;
        data["order"] = this.order ? this.order.toJSON() : undefined as any;
        if (Array.isArray(this.customerReferenceTypes)) {
            data["customerReferenceTypes"] = [];
            for (let item of this.customerReferenceTypes)
                data["customerReferenceTypes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICustomerReference {
    customerReferenceID?: number;
    orderID?: number;
    referenceType?: string | undefined;
    reference?: string | undefined;
    lineItem?: string | undefined;
    originalAmount?: number | undefined;
    remainingAmount?: number | undefined;
    customerRemainingAmount?: number | undefined;
    lastCustomerUpdate?: Date | undefined;
    createdDate?: Date;
    createdUser?: string | undefined;
    lastModifiedDate?: Date;
    lastModifiedUser?: string | undefined;
    order?: Order | undefined;
    customerReferenceTypes?: CustomerReferenceType[] | undefined;
}

export class CustomerReferenceType implements ICustomerReferenceType {
    customerReferenceTypeID?: number;
    customerReferenceID?: number;
    invoiceTypeID?: number;
    customerReference?: CustomerReference | undefined;
    invoiceType?: NewInvoiceType | undefined;

    constructor(data?: ICustomerReferenceType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerReferenceTypeID = _data["customerReferenceTypeID"];
            this.customerReferenceID = _data["customerReferenceID"];
            this.invoiceTypeID = _data["invoiceTypeID"];
            this.customerReference = _data["customerReference"] ? CustomerReference.fromJS(_data["customerReference"]) : undefined as any;
            this.invoiceType = _data["invoiceType"] ? NewInvoiceType.fromJS(_data["invoiceType"]) : undefined as any;
        }
    }

    static fromJS(data: any): CustomerReferenceType {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerReferenceType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerReferenceTypeID"] = this.customerReferenceTypeID;
        data["customerReferenceID"] = this.customerReferenceID;
        data["invoiceTypeID"] = this.invoiceTypeID;
        data["customerReference"] = this.customerReference ? this.customerReference.toJSON() : undefined as any;
        data["invoiceType"] = this.invoiceType ? this.invoiceType.toJSON() : undefined as any;
        return data;
    }
}

export interface ICustomerReferenceType {
    customerReferenceTypeID?: number;
    customerReferenceID?: number;
    invoiceTypeID?: number;
    customerReference?: CustomerReference | undefined;
    invoiceType?: NewInvoiceType | undefined;
}

export class NewInvoiceType implements INewInvoiceType {
    invoiceTypeId?: number;
    description!: string;
    customerReferenceType?: boolean;

    constructor(data?: INewInvoiceType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceTypeId = _data["invoiceTypeId"];
            this.description = _data["description"];
            this.customerReferenceType = _data["customerReferenceType"];
        }
    }

    static fromJS(data: any): NewInvoiceType {
        data = typeof data === 'object' ? data : {};
        let result = new NewInvoiceType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceTypeId"] = this.invoiceTypeId;
        data["description"] = this.description;
        data["customerReferenceType"] = this.customerReferenceType;
        return data;
    }
}

export interface INewInvoiceType {
    invoiceTypeId?: number;
    description: string;
    customerReferenceType?: boolean;
}

export class RateOverrides implements IRateOverrides {
    rateOverrideID?: number;
    orderID?: number;
    rentalMonthly?: number | undefined;
    rentalWeekly?: number | undefined;
    rentalDaily?: number | undefined;
    emergencyWeekday?: number | undefined;
    emergencyWeekend?: number | undefined;
    emergencyHoliday?: number | undefined;
    deliveryFee?: number | undefined;
    pickupFee?: number | undefined;
    fuelDeliveryFee?: number | undefined;
    fuelWeekday?: number | undefined;
    fuelWeekend?: number | undefined;
    fuelHoliday?: number | undefined;
    rentalMinimumDays?: number | undefined;
    createdDate?: Date;
    createdUser?: string | undefined;
    lastModifiedDate?: Date;
    lastModifiedUser?: string | undefined;
    order?: Order | undefined;

    constructor(data?: IRateOverrides) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rateOverrideID = _data["rateOverrideID"];
            this.orderID = _data["orderID"];
            this.rentalMonthly = _data["rentalMonthly"];
            this.rentalWeekly = _data["rentalWeekly"];
            this.rentalDaily = _data["rentalDaily"];
            this.emergencyWeekday = _data["emergencyWeekday"];
            this.emergencyWeekend = _data["emergencyWeekend"];
            this.emergencyHoliday = _data["emergencyHoliday"];
            this.deliveryFee = _data["deliveryFee"];
            this.pickupFee = _data["pickupFee"];
            this.fuelDeliveryFee = _data["fuelDeliveryFee"];
            this.fuelWeekday = _data["fuelWeekday"];
            this.fuelWeekend = _data["fuelWeekend"];
            this.fuelHoliday = _data["fuelHoliday"];
            this.rentalMinimumDays = _data["rentalMinimumDays"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.lastModifiedUser = _data["lastModifiedUser"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : undefined as any;
        }
    }

    static fromJS(data: any): RateOverrides {
        data = typeof data === 'object' ? data : {};
        let result = new RateOverrides();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rateOverrideID"] = this.rateOverrideID;
        data["orderID"] = this.orderID;
        data["rentalMonthly"] = this.rentalMonthly;
        data["rentalWeekly"] = this.rentalWeekly;
        data["rentalDaily"] = this.rentalDaily;
        data["emergencyWeekday"] = this.emergencyWeekday;
        data["emergencyWeekend"] = this.emergencyWeekend;
        data["emergencyHoliday"] = this.emergencyHoliday;
        data["deliveryFee"] = this.deliveryFee;
        data["pickupFee"] = this.pickupFee;
        data["fuelDeliveryFee"] = this.fuelDeliveryFee;
        data["fuelWeekday"] = this.fuelWeekday;
        data["fuelWeekend"] = this.fuelWeekend;
        data["fuelHoliday"] = this.fuelHoliday;
        data["rentalMinimumDays"] = this.rentalMinimumDays;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdUser"] = this.createdUser;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["lastModifiedUser"] = this.lastModifiedUser;
        data["order"] = this.order ? this.order.toJSON() : undefined as any;
        return data;
    }
}

export interface IRateOverrides {
    rateOverrideID?: number;
    orderID?: number;
    rentalMonthly?: number | undefined;
    rentalWeekly?: number | undefined;
    rentalDaily?: number | undefined;
    emergencyWeekday?: number | undefined;
    emergencyWeekend?: number | undefined;
    emergencyHoliday?: number | undefined;
    deliveryFee?: number | undefined;
    pickupFee?: number | undefined;
    fuelDeliveryFee?: number | undefined;
    fuelWeekday?: number | undefined;
    fuelWeekend?: number | undefined;
    fuelHoliday?: number | undefined;
    rentalMinimumDays?: number | undefined;
    createdDate?: Date;
    createdUser?: string | undefined;
    lastModifiedDate?: Date;
    lastModifiedUser?: string | undefined;
    order?: Order | undefined;
}

export class Location implements ILocation {
    id?: string | undefined;
    locID?: number;
    idx?: string | undefined;
    name?: string | undefined;
    customerId?: string | undefined;
    newCustomerId?: number | undefined;
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    primaryContact?: string | undefined;
    secondaryContact?: string | undefined;
    primaryPhone?: string | undefined;
    primaryPhoneExt?: string | undefined;
    secondaryPhone?: string | undefined;
    secondaryPhoneExt?: string | undefined;
    fax?: string | undefined;
    email?: string | undefined;
    longitude?: number;
    latitude?: number;
    geoValidatedAt?: Date | undefined;
    lastRateUpdateDate?: Date | undefined;
    timeZone?: string | undefined;
    ianaZoneName?: string | undefined;
    standardTimeZone?: string | undefined;
    standardUTCOffset?: string | undefined;
    daylightTimeZone?: string | undefined;
    daylightUTCOffset?: string | undefined;
    usesDST?: boolean | undefined;
    notes?: string | undefined;
    deleted?: boolean;
    weekdayAuditScheduleID?: number | undefined;
    weekendAuditScheduleID?: number | undefined;
    weekdayAuditSchedule?: AuditSchedule | undefined;
    weekendAuditSchedule?: AuditSchedule | undefined;
    createdDate?: Date | undefined;
    createdUser?: string | undefined;
    lastModifiedDate?: Date | undefined;
    lastModifiedUser?: string | undefined;
    allowPortalReefers?: boolean;
    allowPortalDryVans?: boolean;
    allowPortalDryContainers?: boolean;
    orders?: Order[] | undefined;
    categories?: LocationCategory[] | undefined;
    qbCustomerName?: string | undefined;
    externalCustomerID?: number | undefined;
    fullAddress?: string | undefined;
    standardUTCOffsetTimeSpan?: string | undefined;
    daylightUTCOffsetTimeSpan?: string | undefined;
    lastRateCheckDate?: Date | undefined;
    county?: string | undefined;
    customer?: Customer | undefined;
    nsSentDate?: Date | undefined;
    weekdayDropOffTimeStart?: string | undefined;
    weekdayDropOffTimeEnd?: string | undefined;
    weekendDropOffTimeStart?: string | undefined;
    weekendDropOffTimeEnd?: string | undefined;
    fireSuppressionScheduleWeek?: number | undefined;
    statusNowID?: number | undefined;
    locationContactStatusNowID?: number | undefined;
    shouldAudit?: string | undefined;
    shouldRemindEmail?: boolean | undefined;
    shouldRemindNumber?: boolean | undefined;
    shouldRemindPortal?: boolean | undefined;
    brandName?: string | undefined;
    preferredTrailerFuelerID?: string | undefined;
    preferredFireSuppressionFuelerID?: string | undefined;
    preferredTrailerFueler?: Provider | undefined;
    preferredFireSuppressionFueler?: Provider | undefined;
    lastNote?: string | undefined;
    lastNoteDate?: Date | undefined;
    taxRate?: number | undefined;

    constructor(data?: ILocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locID = _data["locID"];
            this.idx = _data["idx"];
            this.name = _data["name"];
            this.customerId = _data["customerId"];
            this.newCustomerId = _data["newCustomerId"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.primaryContact = _data["primaryContact"];
            this.secondaryContact = _data["secondaryContact"];
            this.primaryPhone = _data["primaryPhone"];
            this.primaryPhoneExt = _data["primaryPhoneExt"];
            this.secondaryPhone = _data["secondaryPhone"];
            this.secondaryPhoneExt = _data["secondaryPhoneExt"];
            this.fax = _data["fax"];
            this.email = _data["email"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.geoValidatedAt = _data["geoValidatedAt"] ? new Date(_data["geoValidatedAt"].toString()) : undefined as any;
            this.lastRateUpdateDate = _data["lastRateUpdateDate"] ? new Date(_data["lastRateUpdateDate"].toString()) : undefined as any;
            this.timeZone = _data["timeZone"];
            this.ianaZoneName = _data["ianaZoneName"];
            this.standardTimeZone = _data["standardTimeZone"];
            this.standardUTCOffset = _data["standardUTCOffset"];
            this.daylightTimeZone = _data["daylightTimeZone"];
            this.daylightUTCOffset = _data["daylightUTCOffset"];
            this.usesDST = _data["usesDST"];
            this.notes = _data["notes"];
            this.deleted = _data["deleted"];
            this.weekdayAuditScheduleID = _data["weekdayAuditScheduleID"];
            this.weekendAuditScheduleID = _data["weekendAuditScheduleID"];
            this.weekdayAuditSchedule = _data["weekdayAuditSchedule"] ? AuditSchedule.fromJS(_data["weekdayAuditSchedule"]) : undefined as any;
            this.weekendAuditSchedule = _data["weekendAuditSchedule"] ? AuditSchedule.fromJS(_data["weekendAuditSchedule"]) : undefined as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.lastModifiedUser = _data["lastModifiedUser"];
            this.allowPortalReefers = _data["allowPortalReefers"];
            this.allowPortalDryVans = _data["allowPortalDryVans"];
            this.allowPortalDryContainers = _data["allowPortalDryContainers"];
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(Order.fromJS(item));
            }
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(LocationCategory.fromJS(item));
            }
            this.qbCustomerName = _data["qbCustomerName"];
            this.externalCustomerID = _data["externalCustomerID"];
            this.fullAddress = _data["fullAddress"];
            this.standardUTCOffsetTimeSpan = _data["standardUTCOffsetTimeSpan"];
            this.daylightUTCOffsetTimeSpan = _data["daylightUTCOffsetTimeSpan"];
            this.lastRateCheckDate = _data["lastRateCheckDate"] ? new Date(_data["lastRateCheckDate"].toString()) : undefined as any;
            this.county = _data["county"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : undefined as any;
            this.nsSentDate = _data["nsSentDate"] ? new Date(_data["nsSentDate"].toString()) : undefined as any;
            this.weekdayDropOffTimeStart = _data["weekdayDropOffTimeStart"];
            this.weekdayDropOffTimeEnd = _data["weekdayDropOffTimeEnd"];
            this.weekendDropOffTimeStart = _data["weekendDropOffTimeStart"];
            this.weekendDropOffTimeEnd = _data["weekendDropOffTimeEnd"];
            this.fireSuppressionScheduleWeek = _data["fireSuppressionScheduleWeek"];
            this.statusNowID = _data["statusNowID"];
            this.locationContactStatusNowID = _data["locationContactStatusNowID"];
            this.shouldAudit = _data["shouldAudit"];
            this.shouldRemindEmail = _data["shouldRemindEmail"];
            this.shouldRemindNumber = _data["shouldRemindNumber"];
            this.shouldRemindPortal = _data["shouldRemindPortal"];
            this.brandName = _data["brandName"];
            this.preferredTrailerFuelerID = _data["preferredTrailerFuelerID"];
            this.preferredFireSuppressionFuelerID = _data["preferredFireSuppressionFuelerID"];
            this.preferredTrailerFueler = _data["preferredTrailerFueler"] ? Provider.fromJS(_data["preferredTrailerFueler"]) : undefined as any;
            this.preferredFireSuppressionFueler = _data["preferredFireSuppressionFueler"] ? Provider.fromJS(_data["preferredFireSuppressionFueler"]) : undefined as any;
            this.lastNote = _data["lastNote"];
            this.lastNoteDate = _data["lastNoteDate"] ? new Date(_data["lastNoteDate"].toString()) : undefined as any;
            this.taxRate = _data["taxRate"];
        }
    }

    static fromJS(data: any): Location {
        data = typeof data === 'object' ? data : {};
        let result = new Location();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locID"] = this.locID;
        data["idx"] = this.idx;
        data["name"] = this.name;
        data["customerId"] = this.customerId;
        data["newCustomerId"] = this.newCustomerId;
        data["street"] = this.street;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["primaryContact"] = this.primaryContact;
        data["secondaryContact"] = this.secondaryContact;
        data["primaryPhone"] = this.primaryPhone;
        data["primaryPhoneExt"] = this.primaryPhoneExt;
        data["secondaryPhone"] = this.secondaryPhone;
        data["secondaryPhoneExt"] = this.secondaryPhoneExt;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["geoValidatedAt"] = this.geoValidatedAt ? this.geoValidatedAt.toISOString() : undefined as any;
        data["lastRateUpdateDate"] = this.lastRateUpdateDate ? this.lastRateUpdateDate.toISOString() : undefined as any;
        data["timeZone"] = this.timeZone;
        data["ianaZoneName"] = this.ianaZoneName;
        data["standardTimeZone"] = this.standardTimeZone;
        data["standardUTCOffset"] = this.standardUTCOffset;
        data["daylightTimeZone"] = this.daylightTimeZone;
        data["daylightUTCOffset"] = this.daylightUTCOffset;
        data["usesDST"] = this.usesDST;
        data["notes"] = this.notes;
        data["deleted"] = this.deleted;
        data["weekdayAuditScheduleID"] = this.weekdayAuditScheduleID;
        data["weekendAuditScheduleID"] = this.weekendAuditScheduleID;
        data["weekdayAuditSchedule"] = this.weekdayAuditSchedule ? this.weekdayAuditSchedule.toJSON() : undefined as any;
        data["weekendAuditSchedule"] = this.weekendAuditSchedule ? this.weekendAuditSchedule.toJSON() : undefined as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdUser"] = this.createdUser;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["lastModifiedUser"] = this.lastModifiedUser;
        data["allowPortalReefers"] = this.allowPortalReefers;
        data["allowPortalDryVans"] = this.allowPortalDryVans;
        data["allowPortalDryContainers"] = this.allowPortalDryContainers;
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item ? item.toJSON() : undefined as any);
        }
        data["qbCustomerName"] = this.qbCustomerName;
        data["externalCustomerID"] = this.externalCustomerID;
        data["fullAddress"] = this.fullAddress;
        data["standardUTCOffsetTimeSpan"] = this.standardUTCOffsetTimeSpan;
        data["daylightUTCOffsetTimeSpan"] = this.daylightUTCOffsetTimeSpan;
        data["lastRateCheckDate"] = this.lastRateCheckDate ? this.lastRateCheckDate.toISOString() : undefined as any;
        data["county"] = this.county;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["nsSentDate"] = this.nsSentDate ? this.nsSentDate.toISOString() : undefined as any;
        data["weekdayDropOffTimeStart"] = this.weekdayDropOffTimeStart;
        data["weekdayDropOffTimeEnd"] = this.weekdayDropOffTimeEnd;
        data["weekendDropOffTimeStart"] = this.weekendDropOffTimeStart;
        data["weekendDropOffTimeEnd"] = this.weekendDropOffTimeEnd;
        data["fireSuppressionScheduleWeek"] = this.fireSuppressionScheduleWeek;
        data["statusNowID"] = this.statusNowID;
        data["locationContactStatusNowID"] = this.locationContactStatusNowID;
        data["shouldAudit"] = this.shouldAudit;
        data["shouldRemindEmail"] = this.shouldRemindEmail;
        data["shouldRemindNumber"] = this.shouldRemindNumber;
        data["shouldRemindPortal"] = this.shouldRemindPortal;
        data["brandName"] = this.brandName;
        data["preferredTrailerFuelerID"] = this.preferredTrailerFuelerID;
        data["preferredFireSuppressionFuelerID"] = this.preferredFireSuppressionFuelerID;
        data["preferredTrailerFueler"] = this.preferredTrailerFueler ? this.preferredTrailerFueler.toJSON() : undefined as any;
        data["preferredFireSuppressionFueler"] = this.preferredFireSuppressionFueler ? this.preferredFireSuppressionFueler.toJSON() : undefined as any;
        data["lastNote"] = this.lastNote;
        data["lastNoteDate"] = this.lastNoteDate ? this.lastNoteDate.toISOString() : undefined as any;
        data["taxRate"] = this.taxRate;
        return data;
    }
}

export interface ILocation {
    id?: string | undefined;
    locID?: number;
    idx?: string | undefined;
    name?: string | undefined;
    customerId?: string | undefined;
    newCustomerId?: number | undefined;
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    primaryContact?: string | undefined;
    secondaryContact?: string | undefined;
    primaryPhone?: string | undefined;
    primaryPhoneExt?: string | undefined;
    secondaryPhone?: string | undefined;
    secondaryPhoneExt?: string | undefined;
    fax?: string | undefined;
    email?: string | undefined;
    longitude?: number;
    latitude?: number;
    geoValidatedAt?: Date | undefined;
    lastRateUpdateDate?: Date | undefined;
    timeZone?: string | undefined;
    ianaZoneName?: string | undefined;
    standardTimeZone?: string | undefined;
    standardUTCOffset?: string | undefined;
    daylightTimeZone?: string | undefined;
    daylightUTCOffset?: string | undefined;
    usesDST?: boolean | undefined;
    notes?: string | undefined;
    deleted?: boolean;
    weekdayAuditScheduleID?: number | undefined;
    weekendAuditScheduleID?: number | undefined;
    weekdayAuditSchedule?: AuditSchedule | undefined;
    weekendAuditSchedule?: AuditSchedule | undefined;
    createdDate?: Date | undefined;
    createdUser?: string | undefined;
    lastModifiedDate?: Date | undefined;
    lastModifiedUser?: string | undefined;
    allowPortalReefers?: boolean;
    allowPortalDryVans?: boolean;
    allowPortalDryContainers?: boolean;
    orders?: Order[] | undefined;
    categories?: LocationCategory[] | undefined;
    qbCustomerName?: string | undefined;
    externalCustomerID?: number | undefined;
    fullAddress?: string | undefined;
    standardUTCOffsetTimeSpan?: string | undefined;
    daylightUTCOffsetTimeSpan?: string | undefined;
    lastRateCheckDate?: Date | undefined;
    county?: string | undefined;
    customer?: Customer | undefined;
    nsSentDate?: Date | undefined;
    weekdayDropOffTimeStart?: string | undefined;
    weekdayDropOffTimeEnd?: string | undefined;
    weekendDropOffTimeStart?: string | undefined;
    weekendDropOffTimeEnd?: string | undefined;
    fireSuppressionScheduleWeek?: number | undefined;
    statusNowID?: number | undefined;
    locationContactStatusNowID?: number | undefined;
    shouldAudit?: string | undefined;
    shouldRemindEmail?: boolean | undefined;
    shouldRemindNumber?: boolean | undefined;
    shouldRemindPortal?: boolean | undefined;
    brandName?: string | undefined;
    preferredTrailerFuelerID?: string | undefined;
    preferredFireSuppressionFuelerID?: string | undefined;
    preferredTrailerFueler?: Provider | undefined;
    preferredFireSuppressionFueler?: Provider | undefined;
    lastNote?: string | undefined;
    lastNoteDate?: Date | undefined;
    taxRate?: number | undefined;
}

export class LocationCategory implements ILocationCategory {
    locationCategoryID?: number;
    locationID?: string | undefined;
    category?: string | undefined;
    value?: string | undefined;
    createdDate?: Date | undefined;
    createdUser?: string | undefined;
    lastModifiedDate?: Date | undefined;
    lastModifiedUser?: string | undefined;
    location?: Location | undefined;

    constructor(data?: ILocationCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationCategoryID = _data["locationCategoryID"];
            this.locationID = _data["locationID"];
            this.category = _data["category"];
            this.value = _data["value"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.lastModifiedUser = _data["lastModifiedUser"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : undefined as any;
        }
    }

    static fromJS(data: any): LocationCategory {
        data = typeof data === 'object' ? data : {};
        let result = new LocationCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationCategoryID"] = this.locationCategoryID;
        data["locationID"] = this.locationID;
        data["category"] = this.category;
        data["value"] = this.value;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdUser"] = this.createdUser;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["lastModifiedUser"] = this.lastModifiedUser;
        data["location"] = this.location ? this.location.toJSON() : undefined as any;
        return data;
    }
}

export interface ILocationCategory {
    locationCategoryID?: number;
    locationID?: string | undefined;
    category?: string | undefined;
    value?: string | undefined;
    createdDate?: Date | undefined;
    createdUser?: string | undefined;
    lastModifiedDate?: Date | undefined;
    lastModifiedUser?: string | undefined;
    location?: Location | undefined;
}

export class Customer implements ICustomer {
    id?: string | undefined;
    customerID?: number;
    name?: string | undefined;
    fuelIVRPhoneNumber?: string | undefined;
    auditIVRPhoneNumber?: string | undefined;
    trailerProceduresUri?: string | undefined;
    emailSignature?: string | undefined;
    useStoreName?: boolean;
    createdDate?: Date;
    createdUser!: string;
    lastModifiedDate?: Date;
    lastModifiedUser!: string;
    externalCustomerID?: number | undefined;
    statusNowID?: number | undefined;
    allowRequestStairs?: boolean | undefined;
    allowRequestRamps?: boolean | undefined;
    associatedDomains?: string | undefined;
    hasStorePortal?: boolean;
    sendDeliveryInspectionEmail?: boolean;
    orderDisclaimer?: string | undefined;
    allowRequestLiftGate?: boolean | undefined;
    resourceGuideUri?: string | undefined;
    orders?: Order[] | undefined;
    users?: AppUser[] | undefined;
    isDeleted?: boolean;
    useParentCustomerID?: boolean;
    useParentBillingAddress?: boolean;
    usesNumber?: boolean;

    constructor(data?: ICustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerID = _data["customerID"];
            this.name = _data["name"];
            this.fuelIVRPhoneNumber = _data["fuelIVRPhoneNumber"];
            this.auditIVRPhoneNumber = _data["auditIVRPhoneNumber"];
            this.trailerProceduresUri = _data["trailerProceduresUri"];
            this.emailSignature = _data["emailSignature"];
            this.useStoreName = _data["useStoreName"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.lastModifiedUser = _data["lastModifiedUser"];
            this.externalCustomerID = _data["externalCustomerID"];
            this.statusNowID = _data["statusNowID"];
            this.allowRequestStairs = _data["allowRequestStairs"];
            this.allowRequestRamps = _data["allowRequestRamps"];
            this.associatedDomains = _data["associatedDomains"];
            this.hasStorePortal = _data["hasStorePortal"];
            this.sendDeliveryInspectionEmail = _data["sendDeliveryInspectionEmail"];
            this.orderDisclaimer = _data["orderDisclaimer"];
            this.allowRequestLiftGate = _data["allowRequestLiftGate"];
            this.resourceGuideUri = _data["resourceGuideUri"];
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(Order.fromJS(item));
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(AppUser.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.useParentCustomerID = _data["useParentCustomerID"];
            this.useParentBillingAddress = _data["useParentBillingAddress"];
            this.usesNumber = _data["usesNumber"];
        }
    }

    static fromJS(data: any): Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerID"] = this.customerID;
        data["name"] = this.name;
        data["fuelIVRPhoneNumber"] = this.fuelIVRPhoneNumber;
        data["auditIVRPhoneNumber"] = this.auditIVRPhoneNumber;
        data["trailerProceduresUri"] = this.trailerProceduresUri;
        data["emailSignature"] = this.emailSignature;
        data["useStoreName"] = this.useStoreName;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdUser"] = this.createdUser;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["lastModifiedUser"] = this.lastModifiedUser;
        data["externalCustomerID"] = this.externalCustomerID;
        data["statusNowID"] = this.statusNowID;
        data["allowRequestStairs"] = this.allowRequestStairs;
        data["allowRequestRamps"] = this.allowRequestRamps;
        data["associatedDomains"] = this.associatedDomains;
        data["hasStorePortal"] = this.hasStorePortal;
        data["sendDeliveryInspectionEmail"] = this.sendDeliveryInspectionEmail;
        data["orderDisclaimer"] = this.orderDisclaimer;
        data["allowRequestLiftGate"] = this.allowRequestLiftGate;
        data["resourceGuideUri"] = this.resourceGuideUri;
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        data["isDeleted"] = this.isDeleted;
        data["useParentCustomerID"] = this.useParentCustomerID;
        data["useParentBillingAddress"] = this.useParentBillingAddress;
        data["usesNumber"] = this.usesNumber;
        return data;
    }
}

export interface ICustomer {
    id?: string | undefined;
    customerID?: number;
    name?: string | undefined;
    fuelIVRPhoneNumber?: string | undefined;
    auditIVRPhoneNumber?: string | undefined;
    trailerProceduresUri?: string | undefined;
    emailSignature?: string | undefined;
    useStoreName?: boolean;
    createdDate?: Date;
    createdUser: string;
    lastModifiedDate?: Date;
    lastModifiedUser: string;
    externalCustomerID?: number | undefined;
    statusNowID?: number | undefined;
    allowRequestStairs?: boolean | undefined;
    allowRequestRamps?: boolean | undefined;
    associatedDomains?: string | undefined;
    hasStorePortal?: boolean;
    sendDeliveryInspectionEmail?: boolean;
    orderDisclaimer?: string | undefined;
    allowRequestLiftGate?: boolean | undefined;
    resourceGuideUri?: string | undefined;
    orders?: Order[] | undefined;
    users?: AppUser[] | undefined;
    isDeleted?: boolean;
    useParentCustomerID?: boolean;
    useParentBillingAddress?: boolean;
    usesNumber?: boolean;
}

export class AppUser implements IAppUser {
    username?: string | undefined;
    isSystemAdmin?: boolean;
    isDeveloper?: boolean;
    fname?: string | undefined;
    lname?: string | undefined;
    smsNumber?: string | undefined;
    receiveEmergencySMS?: boolean;
    isDeleted?: boolean;
    lastAccessedDate?: Date | undefined;
    createDate?: Date;
    createBy?: string | undefined;
    roles?: Role[] | undefined;
    assignedCustomers?: Customer[] | undefined;

    constructor(data?: IAppUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.isSystemAdmin = _data["isSystemAdmin"];
            this.isDeveloper = _data["isDeveloper"];
            this.fname = _data["fname"];
            this.lname = _data["lname"];
            this.smsNumber = _data["smsNumber"];
            this.receiveEmergencySMS = _data["receiveEmergencySMS"];
            this.isDeleted = _data["isDeleted"];
            this.lastAccessedDate = _data["lastAccessedDate"] ? new Date(_data["lastAccessedDate"].toString()) : undefined as any;
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : undefined as any;
            this.createBy = _data["createBy"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(Role.fromJS(item));
            }
            if (Array.isArray(_data["assignedCustomers"])) {
                this.assignedCustomers = [] as any;
                for (let item of _data["assignedCustomers"])
                    this.assignedCustomers!.push(Customer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppUser {
        data = typeof data === 'object' ? data : {};
        let result = new AppUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["isSystemAdmin"] = this.isSystemAdmin;
        data["isDeveloper"] = this.isDeveloper;
        data["fname"] = this.fname;
        data["lname"] = this.lname;
        data["smsNumber"] = this.smsNumber;
        data["receiveEmergencySMS"] = this.receiveEmergencySMS;
        data["isDeleted"] = this.isDeleted;
        data["lastAccessedDate"] = this.lastAccessedDate ? this.lastAccessedDate.toISOString() : undefined as any;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : undefined as any;
        data["createBy"] = this.createBy;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assignedCustomers)) {
            data["assignedCustomers"] = [];
            for (let item of this.assignedCustomers)
                data["assignedCustomers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAppUser {
    username?: string | undefined;
    isSystemAdmin?: boolean;
    isDeveloper?: boolean;
    fname?: string | undefined;
    lname?: string | undefined;
    smsNumber?: string | undefined;
    receiveEmergencySMS?: boolean;
    isDeleted?: boolean;
    lastAccessedDate?: Date | undefined;
    createDate?: Date;
    createBy?: string | undefined;
    roles?: Role[] | undefined;
    assignedCustomers?: Customer[] | undefined;
}

export class Role implements IRole {
    roleID?: number;
    roleKey?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    createdDate?: Date | undefined;
    createdUser?: string | undefined;
    lastModifiedDate?: Date | undefined;
    lastModifiedUser?: string | undefined;
    systemRole?: boolean;
    users?: AppUser[] | undefined;
    permissions?: Permission[] | undefined;

    constructor(data?: IRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleID = _data["roleID"];
            this.roleKey = _data["roleKey"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.lastModifiedUser = _data["lastModifiedUser"];
            this.systemRole = _data["systemRole"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(AppUser.fromJS(item));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(Permission.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Role {
        data = typeof data === 'object' ? data : {};
        let result = new Role();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleID"] = this.roleID;
        data["roleKey"] = this.roleKey;
        data["name"] = this.name;
        data["description"] = this.description;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdUser"] = this.createdUser;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["lastModifiedUser"] = this.lastModifiedUser;
        data["systemRole"] = this.systemRole;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRole {
    roleID?: number;
    roleKey?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    createdDate?: Date | undefined;
    createdUser?: string | undefined;
    lastModifiedDate?: Date | undefined;
    lastModifiedUser?: string | undefined;
    systemRole?: boolean;
    users?: AppUser[] | undefined;
    permissions?: Permission[] | undefined;
}

export class Permission implements IPermission {
    permissionID?: number;
    permissionGroupID?: number;
    permissionKey?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    createdDate?: Date | undefined;
    createdUser?: string | undefined;
    lastModifiedDate?: Date | undefined;
    lastModifiedUser?: string | undefined;
    adminOnlyAssignment?: boolean;
    permissionGroup?: PermissionGroup | undefined;
    roles?: Role[] | undefined;

    constructor(data?: IPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.permissionID = _data["permissionID"];
            this.permissionGroupID = _data["permissionGroupID"];
            this.permissionKey = _data["permissionKey"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.lastModifiedUser = _data["lastModifiedUser"];
            this.adminOnlyAssignment = _data["adminOnlyAssignment"];
            this.permissionGroup = _data["permissionGroup"] ? PermissionGroup.fromJS(_data["permissionGroup"]) : undefined as any;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(Role.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Permission {
        data = typeof data === 'object' ? data : {};
        let result = new Permission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["permissionID"] = this.permissionID;
        data["permissionGroupID"] = this.permissionGroupID;
        data["permissionKey"] = this.permissionKey;
        data["name"] = this.name;
        data["description"] = this.description;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdUser"] = this.createdUser;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["lastModifiedUser"] = this.lastModifiedUser;
        data["adminOnlyAssignment"] = this.adminOnlyAssignment;
        data["permissionGroup"] = this.permissionGroup ? this.permissionGroup.toJSON() : undefined as any;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPermission {
    permissionID?: number;
    permissionGroupID?: number;
    permissionKey?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    createdDate?: Date | undefined;
    createdUser?: string | undefined;
    lastModifiedDate?: Date | undefined;
    lastModifiedUser?: string | undefined;
    adminOnlyAssignment?: boolean;
    permissionGroup?: PermissionGroup | undefined;
    roles?: Role[] | undefined;
}

export class PermissionGroup implements IPermissionGroup {
    permissionGroupID?: number;
    name?: string | undefined;
    description?: string | undefined;
    createdDate?: Date | undefined;
    createdUser?: string | undefined;
    lastModifiedDate?: Date | undefined;
    lastModifiedUser?: string | undefined;
    permissions?: Permission[] | undefined;

    constructor(data?: IPermissionGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.permissionGroupID = _data["permissionGroupID"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.lastModifiedUser = _data["lastModifiedUser"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(Permission.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionGroup {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["permissionGroupID"] = this.permissionGroupID;
        data["name"] = this.name;
        data["description"] = this.description;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdUser"] = this.createdUser;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["lastModifiedUser"] = this.lastModifiedUser;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPermissionGroup {
    permissionGroupID?: number;
    name?: string | undefined;
    description?: string | undefined;
    createdDate?: Date | undefined;
    createdUser?: string | undefined;
    lastModifiedDate?: Date | undefined;
    lastModifiedUser?: string | undefined;
    permissions?: Permission[] | undefined;
}

export class OrderTag implements IOrderTag {
    orderTagID?: number;
    orderID?: number;
    tagID?: number;
    order?: Order | undefined;
    tag?: Tag | undefined;

    constructor(data?: IOrderTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderTagID = _data["orderTagID"];
            this.orderID = _data["orderID"];
            this.tagID = _data["tagID"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : undefined as any;
            this.tag = _data["tag"] ? Tag.fromJS(_data["tag"]) : undefined as any;
        }
    }

    static fromJS(data: any): OrderTag {
        data = typeof data === 'object' ? data : {};
        let result = new OrderTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderTagID"] = this.orderTagID;
        data["orderID"] = this.orderID;
        data["tagID"] = this.tagID;
        data["order"] = this.order ? this.order.toJSON() : undefined as any;
        data["tag"] = this.tag ? this.tag.toJSON() : undefined as any;
        return data;
    }
}

export interface IOrderTag {
    orderTagID?: number;
    orderID?: number;
    tagID?: number;
    order?: Order | undefined;
    tag?: Tag | undefined;
}

export class Tag implements ITag {
    tagID?: number;
    tagTypeID?: number;
    customerID?: string | undefined;
    text?: string | undefined;
    expiryDate?: Date | undefined;
    createdDate?: Date | undefined;
    createdUser?: string | undefined;
    lastModifiedDate?: Date | undefined;
    lastModifiedUser?: string | undefined;

    constructor(data?: ITag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagID = _data["tagID"];
            this.tagTypeID = _data["tagTypeID"];
            this.customerID = _data["customerID"];
            this.text = _data["text"];
            this.expiryDate = _data["expiryDate"] ? new Date(_data["expiryDate"].toString()) : undefined as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.lastModifiedUser = _data["lastModifiedUser"];
        }
    }

    static fromJS(data: any): Tag {
        data = typeof data === 'object' ? data : {};
        let result = new Tag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagID"] = this.tagID;
        data["tagTypeID"] = this.tagTypeID;
        data["customerID"] = this.customerID;
        data["text"] = this.text;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : undefined as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdUser"] = this.createdUser;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["lastModifiedUser"] = this.lastModifiedUser;
        return data;
    }
}

export interface ITag {
    tagID?: number;
    tagTypeID?: number;
    customerID?: string | undefined;
    text?: string | undefined;
    expiryDate?: Date | undefined;
    createdDate?: Date | undefined;
    createdUser?: string | undefined;
    lastModifiedDate?: Date | undefined;
    lastModifiedUser?: string | undefined;
}

export class NoDropReason implements INoDropReason {
    noDropReasonID?: number;
    description!: string;

    constructor(data?: INoDropReason) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noDropReasonID = _data["noDropReasonID"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): NoDropReason {
        data = typeof data === 'object' ? data : {};
        let result = new NoDropReason();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noDropReasonID"] = this.noDropReasonID;
        data["description"] = this.description;
        return data;
    }
}

export interface INoDropReason {
    noDropReasonID?: number;
    description: string;
}

export enum FuelDeliveryDaysEnum {
    None = 0,
    Sunday = 1,
    Monday = 2,
    Tuesday = 4,
    Wednesday = 8,
    Thursday = 16,
    Friday = 32,
    WeekDays = 62,
    Saturday = 64,
    WeekEndDays = 65,
    All = 127,
    EveryOther = 128,
}

export class AssetActiveAlarm implements IAssetActiveAlarm {
    assetActiveAlarmID?: number;
    assetID?: number;
    alarmCode?: number;
    alarmDate?: Date;
    alarmDescription?: string | undefined;
    alarmSeverity?: string | undefined;
    alarmZone?: number | undefined;
    alarmRecommendation?: string | undefined;
    asset?: Asset | undefined;

    constructor(data?: IAssetActiveAlarm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetActiveAlarmID = _data["assetActiveAlarmID"];
            this.assetID = _data["assetID"];
            this.alarmCode = _data["alarmCode"];
            this.alarmDate = _data["alarmDate"] ? new Date(_data["alarmDate"].toString()) : undefined as any;
            this.alarmDescription = _data["alarmDescription"];
            this.alarmSeverity = _data["alarmSeverity"];
            this.alarmZone = _data["alarmZone"];
            this.alarmRecommendation = _data["alarmRecommendation"];
            this.asset = _data["asset"] ? Asset.fromJS(_data["asset"]) : undefined as any;
        }
    }

    static fromJS(data: any): AssetActiveAlarm {
        data = typeof data === 'object' ? data : {};
        let result = new AssetActiveAlarm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetActiveAlarmID"] = this.assetActiveAlarmID;
        data["assetID"] = this.assetID;
        data["alarmCode"] = this.alarmCode;
        data["alarmDate"] = this.alarmDate ? this.alarmDate.toISOString() : undefined as any;
        data["alarmDescription"] = this.alarmDescription;
        data["alarmSeverity"] = this.alarmSeverity;
        data["alarmZone"] = this.alarmZone;
        data["alarmRecommendation"] = this.alarmRecommendation;
        data["asset"] = this.asset ? this.asset.toJSON() : undefined as any;
        return data;
    }
}

export interface IAssetActiveAlarm {
    assetActiveAlarmID?: number;
    assetID?: number;
    alarmCode?: number;
    alarmDate?: Date;
    alarmDescription?: string | undefined;
    alarmSeverity?: string | undefined;
    alarmZone?: number | undefined;
    alarmRecommendation?: string | undefined;
    asset?: Asset | undefined;
}

export class AssetLoad implements IAssetLoad {
    assetLoadID?: number;
    assetID?: number;
    statusNowID?: number;
    loadType?: string | undefined;
    carrierName?: string | undefined;
    status?: string | undefined;
    loadCost?: number | undefined;
    createdDate?: Date;
    createdUser!: string;
    lastModifiedDate?: Date;
    lastModifiedUser!: string;
    isDeleted?: boolean;
    estimatedDeliveryDate?: Date | undefined;
    estimatedPickupDate?: Date | undefined;
    invoicedDate?: Date | undefined;
    cosmosInvoiceId?: string | undefined;
    billingClaimId?: string | undefined;
    billingClaimedDate?: Date | undefined;
    asset?: Asset | undefined;

    constructor(data?: IAssetLoad) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetLoadID = _data["assetLoadID"];
            this.assetID = _data["assetID"];
            this.statusNowID = _data["statusNowID"];
            this.loadType = _data["loadType"];
            this.carrierName = _data["carrierName"];
            this.status = _data["status"];
            this.loadCost = _data["loadCost"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.lastModifiedUser = _data["lastModifiedUser"];
            this.isDeleted = _data["isDeleted"];
            this.estimatedDeliveryDate = _data["estimatedDeliveryDate"] ? new Date(_data["estimatedDeliveryDate"].toString()) : undefined as any;
            this.estimatedPickupDate = _data["estimatedPickupDate"] ? new Date(_data["estimatedPickupDate"].toString()) : undefined as any;
            this.invoicedDate = _data["invoicedDate"] ? new Date(_data["invoicedDate"].toString()) : undefined as any;
            this.cosmosInvoiceId = _data["cosmosInvoiceId"];
            this.billingClaimId = _data["billingClaimId"];
            this.billingClaimedDate = _data["billingClaimedDate"] ? new Date(_data["billingClaimedDate"].toString()) : undefined as any;
            this.asset = _data["asset"] ? Asset.fromJS(_data["asset"]) : undefined as any;
        }
    }

    static fromJS(data: any): AssetLoad {
        data = typeof data === 'object' ? data : {};
        let result = new AssetLoad();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetLoadID"] = this.assetLoadID;
        data["assetID"] = this.assetID;
        data["statusNowID"] = this.statusNowID;
        data["loadType"] = this.loadType;
        data["carrierName"] = this.carrierName;
        data["status"] = this.status;
        data["loadCost"] = this.loadCost;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdUser"] = this.createdUser;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["lastModifiedUser"] = this.lastModifiedUser;
        data["isDeleted"] = this.isDeleted;
        data["estimatedDeliveryDate"] = this.estimatedDeliveryDate ? this.estimatedDeliveryDate.toISOString() : undefined as any;
        data["estimatedPickupDate"] = this.estimatedPickupDate ? this.estimatedPickupDate.toISOString() : undefined as any;
        data["invoicedDate"] = this.invoicedDate ? this.invoicedDate.toISOString() : undefined as any;
        data["cosmosInvoiceId"] = this.cosmosInvoiceId;
        data["billingClaimId"] = this.billingClaimId;
        data["billingClaimedDate"] = this.billingClaimedDate ? this.billingClaimedDate.toISOString() : undefined as any;
        data["asset"] = this.asset ? this.asset.toJSON() : undefined as any;
        return data;
    }
}

export interface IAssetLoad {
    assetLoadID?: number;
    assetID?: number;
    statusNowID?: number;
    loadType?: string | undefined;
    carrierName?: string | undefined;
    status?: string | undefined;
    loadCost?: number | undefined;
    createdDate?: Date;
    createdUser: string;
    lastModifiedDate?: Date;
    lastModifiedUser: string;
    isDeleted?: boolean;
    estimatedDeliveryDate?: Date | undefined;
    estimatedPickupDate?: Date | undefined;
    invoicedDate?: Date | undefined;
    cosmosInvoiceId?: string | undefined;
    billingClaimId?: string | undefined;
    billingClaimedDate?: Date | undefined;
    asset?: Asset | undefined;
}

export class AssetCharges implements IAssetCharges {
    assetChargeID?: number;
    assetID?: number;
    orderID?: number;
    chargeDate?: Date;
    amount?: number;
    note?: string | undefined;
    invoiceItemID?: number | undefined;
    vendorBillID?: number | undefined;
    itemTypeID?: number;
    providerID?: string | undefined;
    ignoredUser?: string | undefined;
    ignoredDate?: Date | undefined;
    lastCommunicationDate?: Date | undefined;
    invoiceItemType?: InvoiceItemType | undefined;
    asset?: Asset | undefined;
    provider?: Provider | undefined;

    constructor(data?: IAssetCharges) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetChargeID = _data["assetChargeID"];
            this.assetID = _data["assetID"];
            this.orderID = _data["orderID"];
            this.chargeDate = _data["chargeDate"] ? new Date(_data["chargeDate"].toString()) : undefined as any;
            this.amount = _data["amount"];
            this.note = _data["note"];
            this.invoiceItemID = _data["invoiceItemID"];
            this.vendorBillID = _data["vendorBillID"];
            this.itemTypeID = _data["itemTypeID"];
            this.providerID = _data["providerID"];
            this.ignoredUser = _data["ignoredUser"];
            this.ignoredDate = _data["ignoredDate"] ? new Date(_data["ignoredDate"].toString()) : undefined as any;
            this.lastCommunicationDate = _data["lastCommunicationDate"] ? new Date(_data["lastCommunicationDate"].toString()) : undefined as any;
            this.invoiceItemType = _data["invoiceItemType"] ? InvoiceItemType.fromJS(_data["invoiceItemType"]) : undefined as any;
            this.asset = _data["asset"] ? Asset.fromJS(_data["asset"]) : undefined as any;
            this.provider = _data["provider"] ? Provider.fromJS(_data["provider"]) : undefined as any;
        }
    }

    static fromJS(data: any): AssetCharges {
        data = typeof data === 'object' ? data : {};
        let result = new AssetCharges();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetChargeID"] = this.assetChargeID;
        data["assetID"] = this.assetID;
        data["orderID"] = this.orderID;
        data["chargeDate"] = this.chargeDate ? this.chargeDate.toISOString() : undefined as any;
        data["amount"] = this.amount;
        data["note"] = this.note;
        data["invoiceItemID"] = this.invoiceItemID;
        data["vendorBillID"] = this.vendorBillID;
        data["itemTypeID"] = this.itemTypeID;
        data["providerID"] = this.providerID;
        data["ignoredUser"] = this.ignoredUser;
        data["ignoredDate"] = this.ignoredDate ? this.ignoredDate.toISOString() : undefined as any;
        data["lastCommunicationDate"] = this.lastCommunicationDate ? this.lastCommunicationDate.toISOString() : undefined as any;
        data["invoiceItemType"] = this.invoiceItemType ? this.invoiceItemType.toJSON() : undefined as any;
        data["asset"] = this.asset ? this.asset.toJSON() : undefined as any;
        data["provider"] = this.provider ? this.provider.toJSON() : undefined as any;
        return data;
    }
}

export interface IAssetCharges {
    assetChargeID?: number;
    assetID?: number;
    orderID?: number;
    chargeDate?: Date;
    amount?: number;
    note?: string | undefined;
    invoiceItemID?: number | undefined;
    vendorBillID?: number | undefined;
    itemTypeID?: number;
    providerID?: string | undefined;
    ignoredUser?: string | undefined;
    ignoredDate?: Date | undefined;
    lastCommunicationDate?: Date | undefined;
    invoiceItemType?: InvoiceItemType | undefined;
    asset?: Asset | undefined;
    provider?: Provider | undefined;
}

export class InvoiceItemType implements IInvoiceItemType {
    itemTypeID?: number;
    invoiceTypeID?: number;
    description!: string;
    category!: string;
    accountingSystemItemID?: string | undefined;
    accountingSystemClass?: string | undefined;
    createdDate?: Date;
    createdUser!: string;
    lastModifiedDate?: Date;
    lastModifiedUser!: string;
    invoiceType?: NewInvoiceType | undefined;
    netSuiteItemId?: ItemTypeEnum | undefined;
    isChargeType?: boolean | undefined;
    isDeliveryInvoicedType?: boolean;
    isPickupInvoicedType?: boolean;
    invoiceItems?: InvoiceItem[] | undefined;
    assetCharge?: AssetCharges[] | undefined;

    constructor(data?: IInvoiceItemType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemTypeID = _data["itemTypeID"];
            this.invoiceTypeID = _data["invoiceTypeID"];
            this.description = _data["description"];
            this.category = _data["category"];
            this.accountingSystemItemID = _data["accountingSystemItemID"];
            this.accountingSystemClass = _data["accountingSystemClass"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.lastModifiedUser = _data["lastModifiedUser"];
            this.invoiceType = _data["invoiceType"] ? NewInvoiceType.fromJS(_data["invoiceType"]) : undefined as any;
            this.netSuiteItemId = _data["netSuiteItemId"];
            this.isChargeType = _data["isChargeType"];
            this.isDeliveryInvoicedType = _data["isDeliveryInvoicedType"];
            this.isPickupInvoicedType = _data["isPickupInvoicedType"];
            if (Array.isArray(_data["invoiceItems"])) {
                this.invoiceItems = [] as any;
                for (let item of _data["invoiceItems"])
                    this.invoiceItems!.push(InvoiceItem.fromJS(item));
            }
            if (Array.isArray(_data["assetCharge"])) {
                this.assetCharge = [] as any;
                for (let item of _data["assetCharge"])
                    this.assetCharge!.push(AssetCharges.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoiceItemType {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceItemType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemTypeID"] = this.itemTypeID;
        data["invoiceTypeID"] = this.invoiceTypeID;
        data["description"] = this.description;
        data["category"] = this.category;
        data["accountingSystemItemID"] = this.accountingSystemItemID;
        data["accountingSystemClass"] = this.accountingSystemClass;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdUser"] = this.createdUser;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["lastModifiedUser"] = this.lastModifiedUser;
        data["invoiceType"] = this.invoiceType ? this.invoiceType.toJSON() : undefined as any;
        data["netSuiteItemId"] = this.netSuiteItemId;
        data["isChargeType"] = this.isChargeType;
        data["isDeliveryInvoicedType"] = this.isDeliveryInvoicedType;
        data["isPickupInvoicedType"] = this.isPickupInvoicedType;
        if (Array.isArray(this.invoiceItems)) {
            data["invoiceItems"] = [];
            for (let item of this.invoiceItems)
                data["invoiceItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assetCharge)) {
            data["assetCharge"] = [];
            for (let item of this.assetCharge)
                data["assetCharge"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInvoiceItemType {
    itemTypeID?: number;
    invoiceTypeID?: number;
    description: string;
    category: string;
    accountingSystemItemID?: string | undefined;
    accountingSystemClass?: string | undefined;
    createdDate?: Date;
    createdUser: string;
    lastModifiedDate?: Date;
    lastModifiedUser: string;
    invoiceType?: NewInvoiceType | undefined;
    netSuiteItemId?: ItemTypeEnum | undefined;
    isChargeType?: boolean | undefined;
    isDeliveryInvoicedType?: boolean;
    isPickupInvoicedType?: boolean;
    invoiceItems?: InvoiceItem[] | undefined;
    assetCharge?: AssetCharges[] | undefined;
}

export enum ItemTypeEnum {
    Delivery = 309,
    WarehousingStorage = 310,
    IntegrationServices = 311,
    RefrigeratedTrailer_DeliveryPickup = 407,
    RefrigeratedTrailer_Rental = 408,
    RefrigeratedTrailer_FuelDelivery = 409,
    RefrigeratedTrailer_Service = 410,
    RefrigeratedTrailer_HubMiles = 411,
    RefrigeratedTrailer_Other = 412,
    DryTrailer_DeliveryPickup = 413,
    DryTrailer_Rental = 414,
    DryTrailer_FuelDelivery = 415,
    DryTrailer_Service = 416,
    DryTrailer_HubMiles = 417,
    DryTrailer_Other = 418,
    Load_Truckload = 419,
    Load_LTL = 420,
    Load_SmallParcel = 421,
    Fuel_Gallons = 508,
    Emergency_Delivery = 509,
    TEST_SOMETHING = 510,
    Fuel_Tax_Surcharge = 511,
    Engine_Runtime = 512,
    Generator = 523,
    Emergency_CancellationCharge = 524,
}

export class InvoiceItem implements IInvoiceItem {
    invoiceItemID?: number;
    itemTypeID?: number;
    invoiceID?: number;
    referenceID?: string | undefined;
    description?: string | undefined;
    itemDate?: Date | undefined;
    quantity?: number;
    rate?: number;
    amount?: number;
    notes?: string | undefined;
    billingDate?: Date | undefined;
    qbOther?: string | undefined;
    createdDate?: Date;
    createdUser!: string;
    lastModifiedDate?: Date;
    lastModifiedUser!: string;
    generationData?: string | undefined;
    invoiceItemType?: InvoiceItemType | undefined;
    invoice?: Invoice | undefined;
    nonTaxableOverride?: boolean;
    generationId?: string | undefined;

    constructor(data?: IInvoiceItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceItemID = _data["invoiceItemID"];
            this.itemTypeID = _data["itemTypeID"];
            this.invoiceID = _data["invoiceID"];
            this.referenceID = _data["referenceID"];
            this.description = _data["description"];
            this.itemDate = _data["itemDate"] ? new Date(_data["itemDate"].toString()) : undefined as any;
            this.quantity = _data["quantity"];
            this.rate = _data["rate"];
            this.amount = _data["amount"];
            this.notes = _data["notes"];
            this.billingDate = _data["billingDate"] ? new Date(_data["billingDate"].toString()) : undefined as any;
            this.qbOther = _data["qbOther"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.lastModifiedUser = _data["lastModifiedUser"];
            this.generationData = _data["generationData"];
            this.invoiceItemType = _data["invoiceItemType"] ? InvoiceItemType.fromJS(_data["invoiceItemType"]) : undefined as any;
            this.invoice = _data["invoice"] ? Invoice.fromJS(_data["invoice"]) : undefined as any;
            this.nonTaxableOverride = _data["nonTaxableOverride"];
            this.generationId = _data["generationId"];
        }
    }

    static fromJS(data: any): InvoiceItem {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceItemID"] = this.invoiceItemID;
        data["itemTypeID"] = this.itemTypeID;
        data["invoiceID"] = this.invoiceID;
        data["referenceID"] = this.referenceID;
        data["description"] = this.description;
        data["itemDate"] = this.itemDate ? this.itemDate.toISOString() : undefined as any;
        data["quantity"] = this.quantity;
        data["rate"] = this.rate;
        data["amount"] = this.amount;
        data["notes"] = this.notes;
        data["billingDate"] = this.billingDate ? this.billingDate.toISOString() : undefined as any;
        data["qbOther"] = this.qbOther;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdUser"] = this.createdUser;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["lastModifiedUser"] = this.lastModifiedUser;
        data["generationData"] = this.generationData;
        data["invoiceItemType"] = this.invoiceItemType ? this.invoiceItemType.toJSON() : undefined as any;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : undefined as any;
        data["nonTaxableOverride"] = this.nonTaxableOverride;
        data["generationId"] = this.generationId;
        return data;
    }
}

export interface IInvoiceItem {
    invoiceItemID?: number;
    itemTypeID?: number;
    invoiceID?: number;
    referenceID?: string | undefined;
    description?: string | undefined;
    itemDate?: Date | undefined;
    quantity?: number;
    rate?: number;
    amount?: number;
    notes?: string | undefined;
    billingDate?: Date | undefined;
    qbOther?: string | undefined;
    createdDate?: Date;
    createdUser: string;
    lastModifiedDate?: Date;
    lastModifiedUser: string;
    generationData?: string | undefined;
    invoiceItemType?: InvoiceItemType | undefined;
    invoice?: Invoice | undefined;
    nonTaxableOverride?: boolean;
    generationId?: string | undefined;
}

export class Invoice implements IInvoice {
    invoiceID?: number;
    customerID!: string;
    customerName!: string;
    storeID?: string | undefined;
    locID?: number | undefined;
    asmInvoiceID?: string | undefined;
    invoiceTypeID?: number;
    netDays?: number;
    amount?: number;
    tax?: number;
    total?: number;
    status!: string;
    memo?: string | undefined;
    poNumber?: string | undefined;
    acctInvoiceID?: string | undefined;
    toPrint?: boolean;
    errorMessage?: string | undefined;
    approvedDate?: Date | undefined;
    holdDate?: Date | undefined;
    approvedUser?: string | undefined;
    pendingDate?: Date | undefined;
    requestedDate?: Date | undefined;
    postedDate?: Date | undefined;
    submittedDate?: Date | undefined;
    paidDate?: Date | undefined;
    voidDate?: Date | undefined;
    voidReason?: string | undefined;
    voidUser?: string | undefined;
    customerReferenceID?: number | undefined;
    customerReferenceApprovedBy?: string | undefined;
    customerReferenceApprovedDate?: Date | undefined;
    createdDate?: Date;
    createdUser!: string;
    lastModifiedDate?: Date;
    lastModifiedUser!: string;
    qbInvoiceResponse?: string | undefined;
    invoiceItems?: InvoiceItem[] | undefined;
    invoiceReferences?: InvoiceReference[] | undefined;
    invoiceNotes?: InvoiceNote[] | undefined;
    invoiceType?: NewInvoiceType | undefined;
    generationID?: string | undefined;

    constructor(data?: IInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceID = _data["invoiceID"];
            this.customerID = _data["customerID"];
            this.customerName = _data["customerName"];
            this.storeID = _data["storeID"];
            this.locID = _data["locID"];
            this.asmInvoiceID = _data["asmInvoiceID"];
            this.invoiceTypeID = _data["invoiceTypeID"];
            this.netDays = _data["netDays"];
            this.amount = _data["amount"];
            this.tax = _data["tax"];
            this.total = _data["total"];
            this.status = _data["status"];
            this.memo = _data["memo"];
            this.poNumber = _data["poNumber"];
            this.acctInvoiceID = _data["acctInvoiceID"];
            this.toPrint = _data["toPrint"];
            this.errorMessage = _data["errorMessage"];
            this.approvedDate = _data["approvedDate"] ? new Date(_data["approvedDate"].toString()) : undefined as any;
            this.holdDate = _data["holdDate"] ? new Date(_data["holdDate"].toString()) : undefined as any;
            this.approvedUser = _data["approvedUser"];
            this.pendingDate = _data["pendingDate"] ? new Date(_data["pendingDate"].toString()) : undefined as any;
            this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : undefined as any;
            this.postedDate = _data["postedDate"] ? new Date(_data["postedDate"].toString()) : undefined as any;
            this.submittedDate = _data["submittedDate"] ? new Date(_data["submittedDate"].toString()) : undefined as any;
            this.paidDate = _data["paidDate"] ? new Date(_data["paidDate"].toString()) : undefined as any;
            this.voidDate = _data["voidDate"] ? new Date(_data["voidDate"].toString()) : undefined as any;
            this.voidReason = _data["voidReason"];
            this.voidUser = _data["voidUser"];
            this.customerReferenceID = _data["customerReferenceID"];
            this.customerReferenceApprovedBy = _data["customerReferenceApprovedBy"];
            this.customerReferenceApprovedDate = _data["customerReferenceApprovedDate"] ? new Date(_data["customerReferenceApprovedDate"].toString()) : undefined as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.lastModifiedUser = _data["lastModifiedUser"];
            this.qbInvoiceResponse = _data["qbInvoiceResponse"];
            if (Array.isArray(_data["invoiceItems"])) {
                this.invoiceItems = [] as any;
                for (let item of _data["invoiceItems"])
                    this.invoiceItems!.push(InvoiceItem.fromJS(item));
            }
            if (Array.isArray(_data["invoiceReferences"])) {
                this.invoiceReferences = [] as any;
                for (let item of _data["invoiceReferences"])
                    this.invoiceReferences!.push(InvoiceReference.fromJS(item));
            }
            if (Array.isArray(_data["invoiceNotes"])) {
                this.invoiceNotes = [] as any;
                for (let item of _data["invoiceNotes"])
                    this.invoiceNotes!.push(InvoiceNote.fromJS(item));
            }
            this.invoiceType = _data["invoiceType"] ? NewInvoiceType.fromJS(_data["invoiceType"]) : undefined as any;
            this.generationID = _data["generationID"];
        }
    }

    static fromJS(data: any): Invoice {
        data = typeof data === 'object' ? data : {};
        let result = new Invoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceID"] = this.invoiceID;
        data["customerID"] = this.customerID;
        data["customerName"] = this.customerName;
        data["storeID"] = this.storeID;
        data["locID"] = this.locID;
        data["asmInvoiceID"] = this.asmInvoiceID;
        data["invoiceTypeID"] = this.invoiceTypeID;
        data["netDays"] = this.netDays;
        data["amount"] = this.amount;
        data["tax"] = this.tax;
        data["total"] = this.total;
        data["status"] = this.status;
        data["memo"] = this.memo;
        data["poNumber"] = this.poNumber;
        data["acctInvoiceID"] = this.acctInvoiceID;
        data["toPrint"] = this.toPrint;
        data["errorMessage"] = this.errorMessage;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : undefined as any;
        data["holdDate"] = this.holdDate ? this.holdDate.toISOString() : undefined as any;
        data["approvedUser"] = this.approvedUser;
        data["pendingDate"] = this.pendingDate ? this.pendingDate.toISOString() : undefined as any;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : undefined as any;
        data["postedDate"] = this.postedDate ? this.postedDate.toISOString() : undefined as any;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : undefined as any;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : undefined as any;
        data["voidDate"] = this.voidDate ? this.voidDate.toISOString() : undefined as any;
        data["voidReason"] = this.voidReason;
        data["voidUser"] = this.voidUser;
        data["customerReferenceID"] = this.customerReferenceID;
        data["customerReferenceApprovedBy"] = this.customerReferenceApprovedBy;
        data["customerReferenceApprovedDate"] = this.customerReferenceApprovedDate ? this.customerReferenceApprovedDate.toISOString() : undefined as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdUser"] = this.createdUser;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["lastModifiedUser"] = this.lastModifiedUser;
        data["qbInvoiceResponse"] = this.qbInvoiceResponse;
        if (Array.isArray(this.invoiceItems)) {
            data["invoiceItems"] = [];
            for (let item of this.invoiceItems)
                data["invoiceItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.invoiceReferences)) {
            data["invoiceReferences"] = [];
            for (let item of this.invoiceReferences)
                data["invoiceReferences"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.invoiceNotes)) {
            data["invoiceNotes"] = [];
            for (let item of this.invoiceNotes)
                data["invoiceNotes"].push(item ? item.toJSON() : undefined as any);
        }
        data["invoiceType"] = this.invoiceType ? this.invoiceType.toJSON() : undefined as any;
        data["generationID"] = this.generationID;
        return data;
    }
}

export interface IInvoice {
    invoiceID?: number;
    customerID: string;
    customerName: string;
    storeID?: string | undefined;
    locID?: number | undefined;
    asmInvoiceID?: string | undefined;
    invoiceTypeID?: number;
    netDays?: number;
    amount?: number;
    tax?: number;
    total?: number;
    status: string;
    memo?: string | undefined;
    poNumber?: string | undefined;
    acctInvoiceID?: string | undefined;
    toPrint?: boolean;
    errorMessage?: string | undefined;
    approvedDate?: Date | undefined;
    holdDate?: Date | undefined;
    approvedUser?: string | undefined;
    pendingDate?: Date | undefined;
    requestedDate?: Date | undefined;
    postedDate?: Date | undefined;
    submittedDate?: Date | undefined;
    paidDate?: Date | undefined;
    voidDate?: Date | undefined;
    voidReason?: string | undefined;
    voidUser?: string | undefined;
    customerReferenceID?: number | undefined;
    customerReferenceApprovedBy?: string | undefined;
    customerReferenceApprovedDate?: Date | undefined;
    createdDate?: Date;
    createdUser: string;
    lastModifiedDate?: Date;
    lastModifiedUser: string;
    qbInvoiceResponse?: string | undefined;
    invoiceItems?: InvoiceItem[] | undefined;
    invoiceReferences?: InvoiceReference[] | undefined;
    invoiceNotes?: InvoiceNote[] | undefined;
    invoiceType?: NewInvoiceType | undefined;
    generationID?: string | undefined;
}

export class InvoiceReference implements IInvoiceReference {
    invoiceReferenceID?: number;
    invoiceID?: number;
    referenceType?: string | undefined;
    referenceID!: string;

    constructor(data?: IInvoiceReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceReferenceID = _data["invoiceReferenceID"];
            this.invoiceID = _data["invoiceID"];
            this.referenceType = _data["referenceType"];
            this.referenceID = _data["referenceID"];
        }
    }

    static fromJS(data: any): InvoiceReference {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceReference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceReferenceID"] = this.invoiceReferenceID;
        data["invoiceID"] = this.invoiceID;
        data["referenceType"] = this.referenceType;
        data["referenceID"] = this.referenceID;
        return data;
    }
}

export interface IInvoiceReference {
    invoiceReferenceID?: number;
    invoiceID?: number;
    referenceType?: string | undefined;
    referenceID: string;
}

export class InvoiceNote implements IInvoiceNote {
    invoiceNoteID?: number;
    invoiceID?: number;
    text?: string | undefined;
    createdDate?: Date;
    createdUser!: string;
    lastModifiedDate?: Date;
    lastModifiedUser!: string;

    constructor(data?: IInvoiceNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceNoteID = _data["invoiceNoteID"];
            this.invoiceID = _data["invoiceID"];
            this.text = _data["text"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.lastModifiedUser = _data["lastModifiedUser"];
        }
    }

    static fromJS(data: any): InvoiceNote {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceNoteID"] = this.invoiceNoteID;
        data["invoiceID"] = this.invoiceID;
        data["text"] = this.text;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdUser"] = this.createdUser;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["lastModifiedUser"] = this.lastModifiedUser;
        return data;
    }
}

export interface IInvoiceNote {
    invoiceNoteID?: number;
    invoiceID?: number;
    text?: string | undefined;
    createdDate?: Date;
    createdUser: string;
    lastModifiedDate?: Date;
    lastModifiedUser: string;
}

export class TrailerSummaryProviderDto implements ITrailerSummaryProviderDto {
    id?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;

    constructor(data?: ITrailerSummaryProviderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): TrailerSummaryProviderDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrailerSummaryProviderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        return data;
    }
}

export interface ITrailerSummaryProviderDto {
    id?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
}

export class FuelDeliveryDTO implements IFuelDeliveryDTO {
    assetID?: number;
    sunday?: boolean;
    monday?: boolean;
    tuesday?: boolean;
    wednesday?: boolean;
    thursday?: boolean;
    friday?: boolean;
    saturday?: boolean;
    everyOtherDay?: boolean;

    constructor(data?: IFuelDeliveryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetID = _data["assetID"];
            this.sunday = _data["sunday"];
            this.monday = _data["monday"];
            this.tuesday = _data["tuesday"];
            this.wednesday = _data["wednesday"];
            this.thursday = _data["thursday"];
            this.friday = _data["friday"];
            this.saturday = _data["saturday"];
            this.everyOtherDay = _data["everyOtherDay"];
        }
    }

    static fromJS(data: any): FuelDeliveryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FuelDeliveryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetID"] = this.assetID;
        data["sunday"] = this.sunday;
        data["monday"] = this.monday;
        data["tuesday"] = this.tuesday;
        data["wednesday"] = this.wednesday;
        data["thursday"] = this.thursday;
        data["friday"] = this.friday;
        data["saturday"] = this.saturday;
        data["everyOtherDay"] = this.everyOtherDay;
        return data;
    }
}

export interface IFuelDeliveryDTO {
    assetID?: number;
    sunday?: boolean;
    monday?: boolean;
    tuesday?: boolean;
    wednesday?: boolean;
    thursday?: boolean;
    friday?: boolean;
    saturday?: boolean;
    everyOtherDay?: boolean;
}

export class StoreTrailerSettingsDTO implements IStoreTrailerSettingsDTO {
    assetID?: number;
    trailerNumber?: string | undefined;
    assetType?: string | undefined;
    temperatureType?: string | undefined;
    auditNotes?: string | undefined;
    turnedOn?: boolean;
    isTelematicsOn?: boolean;
    zone1TempRangeID?: number | undefined;
    zone2TempRangeID?: number | undefined;
    zone1TemperatureRange?: string;
    zone2TemperatureRange?: string;
    fuelDelivery?: FuelDeliveryDTO;
    deliveryScheduleString?: string;
    expectedTurnOnDate?: Date | undefined;

    constructor(data?: IStoreTrailerSettingsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetID = _data["assetID"];
            this.trailerNumber = _data["trailerNumber"];
            this.assetType = _data["assetType"];
            this.temperatureType = _data["temperatureType"];
            this.auditNotes = _data["auditNotes"];
            this.turnedOn = _data["turnedOn"];
            this.isTelematicsOn = _data["isTelematicsOn"];
            this.zone1TempRangeID = _data["zone1TempRangeID"];
            this.zone2TempRangeID = _data["zone2TempRangeID"];
            this.zone1TemperatureRange = _data["zone1TemperatureRange"];
            this.zone2TemperatureRange = _data["zone2TemperatureRange"];
            this.fuelDelivery = _data["fuelDelivery"] ? FuelDeliveryDTO.fromJS(_data["fuelDelivery"]) : undefined as any;
            this.deliveryScheduleString = _data["deliveryScheduleString"];
            this.expectedTurnOnDate = _data["expectedTurnOnDate"] ? new Date(_data["expectedTurnOnDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): StoreTrailerSettingsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StoreTrailerSettingsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetID"] = this.assetID;
        data["trailerNumber"] = this.trailerNumber;
        data["assetType"] = this.assetType;
        data["temperatureType"] = this.temperatureType;
        data["auditNotes"] = this.auditNotes;
        data["turnedOn"] = this.turnedOn;
        data["isTelematicsOn"] = this.isTelematicsOn;
        data["zone1TempRangeID"] = this.zone1TempRangeID;
        data["zone2TempRangeID"] = this.zone2TempRangeID;
        data["zone1TemperatureRange"] = this.zone1TemperatureRange;
        data["zone2TemperatureRange"] = this.zone2TemperatureRange;
        data["fuelDelivery"] = this.fuelDelivery ? this.fuelDelivery.toJSON() : undefined as any;
        data["deliveryScheduleString"] = this.deliveryScheduleString;
        data["expectedTurnOnDate"] = this.expectedTurnOnDate ? this.expectedTurnOnDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IStoreTrailerSettingsDTO {
    assetID?: number;
    trailerNumber?: string | undefined;
    assetType?: string | undefined;
    temperatureType?: string | undefined;
    auditNotes?: string | undefined;
    turnedOn?: boolean;
    isTelematicsOn?: boolean;
    zone1TempRangeID?: number | undefined;
    zone2TempRangeID?: number | undefined;
    zone1TemperatureRange?: string;
    zone2TemperatureRange?: string;
    fuelDelivery?: FuelDeliveryDTO;
    deliveryScheduleString?: string;
    expectedTurnOnDate?: Date | undefined;
}

export class AuditAssetDetailDTO implements IAuditAssetDetailDTO {
    assetID?: number;
    auditNotes?: string | undefined;
    turnedOn?: boolean;
    isTelematicsOn?: boolean;
    zone1TempRangeID?: number | undefined;
    zone2TempRangeID?: number | undefined;
    zone3TempRangeID?: number | undefined;
    weekdayAuditSchedule?: string | undefined;
    weekendAuditSchedule?: string | undefined;
    fuelDelivery?: FuelDeliveryDTO | undefined;
    expectedTurnOnDate?: Date | undefined;
    needAssistanceZone1?: boolean | undefined;
    needAssistanceZone2?: boolean | undefined;
    fuelServiceActive?: boolean | undefined;
    notify?: boolean;
    fuelingDate?: Date | undefined;

    constructor(data?: IAuditAssetDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetID = _data["assetID"];
            this.auditNotes = _data["auditNotes"];
            this.turnedOn = _data["turnedOn"];
            this.isTelematicsOn = _data["isTelematicsOn"];
            this.zone1TempRangeID = _data["zone1TempRangeID"];
            this.zone2TempRangeID = _data["zone2TempRangeID"];
            this.zone3TempRangeID = _data["zone3TempRangeID"];
            this.weekdayAuditSchedule = _data["weekdayAuditSchedule"];
            this.weekendAuditSchedule = _data["weekendAuditSchedule"];
            this.fuelDelivery = _data["fuelDelivery"] ? FuelDeliveryDTO.fromJS(_data["fuelDelivery"]) : undefined as any;
            this.expectedTurnOnDate = _data["expectedTurnOnDate"] ? new Date(_data["expectedTurnOnDate"].toString()) : undefined as any;
            this.needAssistanceZone1 = _data["needAssistanceZone1"];
            this.needAssistanceZone2 = _data["needAssistanceZone2"];
            this.fuelServiceActive = _data["fuelServiceActive"];
            this.notify = _data["notify"];
            this.fuelingDate = _data["fuelingDate"] ? new Date(_data["fuelingDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AuditAssetDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AuditAssetDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetID"] = this.assetID;
        data["auditNotes"] = this.auditNotes;
        data["turnedOn"] = this.turnedOn;
        data["isTelematicsOn"] = this.isTelematicsOn;
        data["zone1TempRangeID"] = this.zone1TempRangeID;
        data["zone2TempRangeID"] = this.zone2TempRangeID;
        data["zone3TempRangeID"] = this.zone3TempRangeID;
        data["weekdayAuditSchedule"] = this.weekdayAuditSchedule;
        data["weekendAuditSchedule"] = this.weekendAuditSchedule;
        data["fuelDelivery"] = this.fuelDelivery ? this.fuelDelivery.toJSON() : undefined as any;
        data["expectedTurnOnDate"] = this.expectedTurnOnDate ? this.expectedTurnOnDate.toISOString() : undefined as any;
        data["needAssistanceZone1"] = this.needAssistanceZone1;
        data["needAssistanceZone2"] = this.needAssistanceZone2;
        data["fuelServiceActive"] = this.fuelServiceActive;
        data["notify"] = this.notify;
        data["fuelingDate"] = this.fuelingDate ? this.fuelingDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IAuditAssetDetailDTO {
    assetID?: number;
    auditNotes?: string | undefined;
    turnedOn?: boolean;
    isTelematicsOn?: boolean;
    zone1TempRangeID?: number | undefined;
    zone2TempRangeID?: number | undefined;
    zone3TempRangeID?: number | undefined;
    weekdayAuditSchedule?: string | undefined;
    weekendAuditSchedule?: string | undefined;
    fuelDelivery?: FuelDeliveryDTO | undefined;
    expectedTurnOnDate?: Date | undefined;
    needAssistanceZone1?: boolean | undefined;
    needAssistanceZone2?: boolean | undefined;
    fuelServiceActive?: boolean | undefined;
    notify?: boolean;
    fuelingDate?: Date | undefined;
}

export class AuditTempRange implements IAuditTempRange {
    rangeID?: number;
    customerID?: string | undefined;
    description!: string;
    minRange?: number;
    maxRange?: number;
    createdDate?: Date;
    createdUser?: string | undefined;
    lastModifiedDate?: Date | undefined;
    lastModifiedUser?: string | undefined;

    constructor(data?: IAuditTempRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rangeID = _data["rangeID"];
            this.customerID = _data["customerID"];
            this.description = _data["description"];
            this.minRange = _data["minRange"];
            this.maxRange = _data["maxRange"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.lastModifiedUser = _data["lastModifiedUser"];
        }
    }

    static fromJS(data: any): AuditTempRange {
        data = typeof data === 'object' ? data : {};
        let result = new AuditTempRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rangeID"] = this.rangeID;
        data["customerID"] = this.customerID;
        data["description"] = this.description;
        data["minRange"] = this.minRange;
        data["maxRange"] = this.maxRange;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdUser"] = this.createdUser;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["lastModifiedUser"] = this.lastModifiedUser;
        return data;
    }
}

export interface IAuditTempRange {
    rangeID?: number;
    customerID?: string | undefined;
    description: string;
    minRange?: number;
    maxRange?: number;
    createdDate?: Date;
    createdUser?: string | undefined;
    lastModifiedDate?: Date | undefined;
    lastModifiedUser?: string | undefined;
}

export class LocationTrailerSetupRequestDTO implements ILocationTrailerSetupRequestDTO {
    locationID?: string | undefined;
    locID?: number;
    weekdayAuditScheduleID?: number | undefined;
    weekendAuditScheduleID?: number | undefined;
    shouldAudit?: string | undefined;
    shouldRemindEmail?: boolean | undefined;
    shouldRemindNumber?: boolean | undefined;
    shouldRemindPortal?: boolean | undefined;

    constructor(data?: ILocationTrailerSetupRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationID = _data["locationID"];
            this.locID = _data["locID"];
            this.weekdayAuditScheduleID = _data["weekdayAuditScheduleID"];
            this.weekendAuditScheduleID = _data["weekendAuditScheduleID"];
            this.shouldAudit = _data["shouldAudit"];
            this.shouldRemindEmail = _data["shouldRemindEmail"];
            this.shouldRemindNumber = _data["shouldRemindNumber"];
            this.shouldRemindPortal = _data["shouldRemindPortal"];
        }
    }

    static fromJS(data: any): LocationTrailerSetupRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LocationTrailerSetupRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationID"] = this.locationID;
        data["locID"] = this.locID;
        data["weekdayAuditScheduleID"] = this.weekdayAuditScheduleID;
        data["weekendAuditScheduleID"] = this.weekendAuditScheduleID;
        data["shouldAudit"] = this.shouldAudit;
        data["shouldRemindEmail"] = this.shouldRemindEmail;
        data["shouldRemindNumber"] = this.shouldRemindNumber;
        data["shouldRemindPortal"] = this.shouldRemindPortal;
        return data;
    }
}

export interface ILocationTrailerSetupRequestDTO {
    locationID?: string | undefined;
    locID?: number;
    weekdayAuditScheduleID?: number | undefined;
    weekendAuditScheduleID?: number | undefined;
    shouldAudit?: string | undefined;
    shouldRemindEmail?: boolean | undefined;
    shouldRemindNumber?: boolean | undefined;
    shouldRemindPortal?: boolean | undefined;
}

export class StoreCustomerDTO implements IStoreCustomerDTO {
    trailerProceduresUri?: string | undefined;
    resourceGuideUri?: string | undefined;

    constructor(data?: IStoreCustomerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trailerProceduresUri = _data["trailerProceduresUri"];
            this.resourceGuideUri = _data["resourceGuideUri"];
        }
    }

    static fromJS(data: any): StoreCustomerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StoreCustomerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trailerProceduresUri"] = this.trailerProceduresUri;
        data["resourceGuideUri"] = this.resourceGuideUri;
        return data;
    }
}

export interface IStoreCustomerDTO {
    trailerProceduresUri?: string | undefined;
    resourceGuideUri?: string | undefined;
}

export class RequestInformationDTO implements IRequestInformationDTO {
    locationID?: string | undefined;
    locID?: number;
    email?: string | undefined;
    request?: string | undefined;

    constructor(data?: IRequestInformationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationID = _data["locationID"];
            this.locID = _data["locID"];
            this.email = _data["email"];
            this.request = _data["request"];
        }
    }

    static fromJS(data: any): RequestInformationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RequestInformationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationID"] = this.locationID;
        data["locID"] = this.locID;
        data["email"] = this.email;
        data["request"] = this.request;
        return data;
    }
}

export interface IRequestInformationDTO {
    locationID?: string | undefined;
    locID?: number;
    email?: string | undefined;
    request?: string | undefined;
}

export class StorePortalCustomerDTO implements IStorePortalCustomerDTO {
    id?: string | undefined;
    name?: string | undefined;
    usesNumber?: boolean;

    constructor(data?: IStorePortalCustomerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.usesNumber = _data["usesNumber"];
        }
    }

    static fromJS(data: any): StorePortalCustomerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StorePortalCustomerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["usesNumber"] = this.usesNumber;
        return data;
    }
}

export interface IStorePortalCustomerDTO {
    id?: string | undefined;
    name?: string | undefined;
    usesNumber?: boolean;
}

export class CustomerOrderCategory implements ICustomerOrderCategory {
    id?: number;
    customerID?: string | undefined;
    orderCategory?: string | undefined;
    descriptionText?: string | undefined;
    effectiveDate?: Date;
    termDate?: Date | undefined;
    createdDate?: Date;
    createdUser?: string | undefined;
    lastModifiedDate?: Date;
    lastModifiedUser?: string | undefined;

    constructor(data?: ICustomerOrderCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerID = _data["customerID"];
            this.orderCategory = _data["orderCategory"];
            this.descriptionText = _data["descriptionText"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : undefined as any;
            this.termDate = _data["termDate"] ? new Date(_data["termDate"].toString()) : undefined as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.lastModifiedUser = _data["lastModifiedUser"];
        }
    }

    static fromJS(data: any): CustomerOrderCategory {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerOrderCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerID"] = this.customerID;
        data["orderCategory"] = this.orderCategory;
        data["descriptionText"] = this.descriptionText;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : undefined as any;
        data["termDate"] = this.termDate ? this.termDate.toISOString() : undefined as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdUser"] = this.createdUser;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["lastModifiedUser"] = this.lastModifiedUser;
        return data;
    }
}

export interface ICustomerOrderCategory {
    id?: number;
    customerID?: string | undefined;
    orderCategory?: string | undefined;
    descriptionText?: string | undefined;
    effectiveDate?: Date;
    termDate?: Date | undefined;
    createdDate?: Date;
    createdUser?: string | undefined;
    lastModifiedDate?: Date;
    lastModifiedUser?: string | undefined;
}

export class LocationDto implements ILocationDto {
    timeZoneLookupOutcome?: GeoLookupOutcome | undefined;
    id?: string | undefined;
    locID?: number;
    idx?: string | undefined;
    name?: string | undefined;
    customerId?: string | undefined;
    newCustomerId?: number | undefined;
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    primaryContact?: string | undefined;
    secondaryContact?: string | undefined;
    primaryPhone?: string | undefined;
    primaryPhoneExt?: string | undefined;
    secondaryPhone?: string | undefined;
    secondaryPhoneExt?: string | undefined;
    fax?: string | undefined;
    email?: string | undefined;
    longitude?: number;
    latitude?: number;
    lastRateUpdateDate?: Date | undefined;
    timeZone?: string | undefined;
    ianaZoneName?: string | undefined;
    standardTimeZone?: string | undefined;
    standardUTCOffset?: string | undefined;
    daylightTimeZone?: string | undefined;
    daylightUTCOffset?: string | undefined;
    usesDST?: boolean | undefined;
    notes?: string | undefined;
    taxRate?: number | undefined;
    deleted?: boolean;
    weekdayAuditScheduleID?: number | undefined;
    weekendAuditScheduleID?: number | undefined;
    weekdayAuditSchedule?: AuditSchedule | undefined;
    weekendAuditSchedule?: AuditSchedule | undefined;
    createdDate?: Date;
    createdUser?: string | undefined;
    lastModifiedDate?: Date;
    lastModifiedUser?: string | undefined;
    allowPortalReefers?: boolean;
    allowPortalDryVans?: boolean;
    allowPortalDryContainers?: boolean;
    qbCustomerName?: string | undefined;
    externalCustomerID?: number | undefined;
    lastRateCheckDate?: Date | undefined;
    county?: string | undefined;
    customer?: Customer | undefined;
    nsSentDate?: Date | undefined;
    weekdayDropOffTimeStart?: string | undefined;
    weekdayDropOffTimeEnd?: string | undefined;
    weekendDropOffTimeStart?: string | undefined;
    weekendDropOffTimeEnd?: string | undefined;
    fireSuppressionScheduleWeek?: number | undefined;
    statusNowID?: number | undefined;
    locationContactStatusNowID?: number | undefined;
    shouldAudit?: string | undefined;
    shouldRemindEmail?: boolean | undefined;
    shouldRemindNumber?: boolean | undefined;
    shouldRemindPortal?: boolean | undefined;
    brandName?: string | undefined;
    preferredTrailerFuelerID?: string | undefined;
    preferredFireSuppressionFuelerID?: string | undefined;
    preferredTrailerFueler?: Provider | undefined;
    preferredFireSuppressionFueler?: Provider | undefined;
    lastNote?: string | undefined;
    lastNoteDate?: Date | undefined;

    constructor(data?: ILocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeZoneLookupOutcome = _data["timeZoneLookupOutcome"];
            this.id = _data["id"];
            this.locID = _data["locID"];
            this.idx = _data["idx"];
            this.name = _data["name"];
            this.customerId = _data["customerId"];
            this.newCustomerId = _data["newCustomerId"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.primaryContact = _data["primaryContact"];
            this.secondaryContact = _data["secondaryContact"];
            this.primaryPhone = _data["primaryPhone"];
            this.primaryPhoneExt = _data["primaryPhoneExt"];
            this.secondaryPhone = _data["secondaryPhone"];
            this.secondaryPhoneExt = _data["secondaryPhoneExt"];
            this.fax = _data["fax"];
            this.email = _data["email"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.lastRateUpdateDate = _data["lastRateUpdateDate"] ? new Date(_data["lastRateUpdateDate"].toString()) : undefined as any;
            this.timeZone = _data["timeZone"];
            this.ianaZoneName = _data["ianaZoneName"];
            this.standardTimeZone = _data["standardTimeZone"];
            this.standardUTCOffset = _data["standardUTCOffset"];
            this.daylightTimeZone = _data["daylightTimeZone"];
            this.daylightUTCOffset = _data["daylightUTCOffset"];
            this.usesDST = _data["usesDST"];
            this.notes = _data["notes"];
            this.taxRate = _data["taxRate"];
            this.deleted = _data["deleted"];
            this.weekdayAuditScheduleID = _data["weekdayAuditScheduleID"];
            this.weekendAuditScheduleID = _data["weekendAuditScheduleID"];
            this.weekdayAuditSchedule = _data["weekdayAuditSchedule"] ? AuditSchedule.fromJS(_data["weekdayAuditSchedule"]) : undefined as any;
            this.weekendAuditSchedule = _data["weekendAuditSchedule"] ? AuditSchedule.fromJS(_data["weekendAuditSchedule"]) : undefined as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.lastModifiedUser = _data["lastModifiedUser"];
            this.allowPortalReefers = _data["allowPortalReefers"];
            this.allowPortalDryVans = _data["allowPortalDryVans"];
            this.allowPortalDryContainers = _data["allowPortalDryContainers"];
            this.qbCustomerName = _data["qbCustomerName"];
            this.externalCustomerID = _data["externalCustomerID"];
            this.lastRateCheckDate = _data["lastRateCheckDate"] ? new Date(_data["lastRateCheckDate"].toString()) : undefined as any;
            this.county = _data["county"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : undefined as any;
            this.nsSentDate = _data["nsSentDate"] ? new Date(_data["nsSentDate"].toString()) : undefined as any;
            this.weekdayDropOffTimeStart = _data["weekdayDropOffTimeStart"];
            this.weekdayDropOffTimeEnd = _data["weekdayDropOffTimeEnd"];
            this.weekendDropOffTimeStart = _data["weekendDropOffTimeStart"];
            this.weekendDropOffTimeEnd = _data["weekendDropOffTimeEnd"];
            this.fireSuppressionScheduleWeek = _data["fireSuppressionScheduleWeek"];
            this.statusNowID = _data["statusNowID"];
            this.locationContactStatusNowID = _data["locationContactStatusNowID"];
            this.shouldAudit = _data["shouldAudit"];
            this.shouldRemindEmail = _data["shouldRemindEmail"];
            this.shouldRemindNumber = _data["shouldRemindNumber"];
            this.shouldRemindPortal = _data["shouldRemindPortal"];
            this.brandName = _data["brandName"];
            this.preferredTrailerFuelerID = _data["preferredTrailerFuelerID"];
            this.preferredFireSuppressionFuelerID = _data["preferredFireSuppressionFuelerID"];
            this.preferredTrailerFueler = _data["preferredTrailerFueler"] ? Provider.fromJS(_data["preferredTrailerFueler"]) : undefined as any;
            this.preferredFireSuppressionFueler = _data["preferredFireSuppressionFueler"] ? Provider.fromJS(_data["preferredFireSuppressionFueler"]) : undefined as any;
            this.lastNote = _data["lastNote"];
            this.lastNoteDate = _data["lastNoteDate"] ? new Date(_data["lastNoteDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): LocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZoneLookupOutcome"] = this.timeZoneLookupOutcome;
        data["id"] = this.id;
        data["locID"] = this.locID;
        data["idx"] = this.idx;
        data["name"] = this.name;
        data["customerId"] = this.customerId;
        data["newCustomerId"] = this.newCustomerId;
        data["street"] = this.street;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["primaryContact"] = this.primaryContact;
        data["secondaryContact"] = this.secondaryContact;
        data["primaryPhone"] = this.primaryPhone;
        data["primaryPhoneExt"] = this.primaryPhoneExt;
        data["secondaryPhone"] = this.secondaryPhone;
        data["secondaryPhoneExt"] = this.secondaryPhoneExt;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["lastRateUpdateDate"] = this.lastRateUpdateDate ? this.lastRateUpdateDate.toISOString() : undefined as any;
        data["timeZone"] = this.timeZone;
        data["ianaZoneName"] = this.ianaZoneName;
        data["standardTimeZone"] = this.standardTimeZone;
        data["standardUTCOffset"] = this.standardUTCOffset;
        data["daylightTimeZone"] = this.daylightTimeZone;
        data["daylightUTCOffset"] = this.daylightUTCOffset;
        data["usesDST"] = this.usesDST;
        data["notes"] = this.notes;
        data["taxRate"] = this.taxRate;
        data["deleted"] = this.deleted;
        data["weekdayAuditScheduleID"] = this.weekdayAuditScheduleID;
        data["weekendAuditScheduleID"] = this.weekendAuditScheduleID;
        data["weekdayAuditSchedule"] = this.weekdayAuditSchedule ? this.weekdayAuditSchedule.toJSON() : undefined as any;
        data["weekendAuditSchedule"] = this.weekendAuditSchedule ? this.weekendAuditSchedule.toJSON() : undefined as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdUser"] = this.createdUser;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["lastModifiedUser"] = this.lastModifiedUser;
        data["allowPortalReefers"] = this.allowPortalReefers;
        data["allowPortalDryVans"] = this.allowPortalDryVans;
        data["allowPortalDryContainers"] = this.allowPortalDryContainers;
        data["qbCustomerName"] = this.qbCustomerName;
        data["externalCustomerID"] = this.externalCustomerID;
        data["lastRateCheckDate"] = this.lastRateCheckDate ? this.lastRateCheckDate.toISOString() : undefined as any;
        data["county"] = this.county;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["nsSentDate"] = this.nsSentDate ? this.nsSentDate.toISOString() : undefined as any;
        data["weekdayDropOffTimeStart"] = this.weekdayDropOffTimeStart;
        data["weekdayDropOffTimeEnd"] = this.weekdayDropOffTimeEnd;
        data["weekendDropOffTimeStart"] = this.weekendDropOffTimeStart;
        data["weekendDropOffTimeEnd"] = this.weekendDropOffTimeEnd;
        data["fireSuppressionScheduleWeek"] = this.fireSuppressionScheduleWeek;
        data["statusNowID"] = this.statusNowID;
        data["locationContactStatusNowID"] = this.locationContactStatusNowID;
        data["shouldAudit"] = this.shouldAudit;
        data["shouldRemindEmail"] = this.shouldRemindEmail;
        data["shouldRemindNumber"] = this.shouldRemindNumber;
        data["shouldRemindPortal"] = this.shouldRemindPortal;
        data["brandName"] = this.brandName;
        data["preferredTrailerFuelerID"] = this.preferredTrailerFuelerID;
        data["preferredFireSuppressionFuelerID"] = this.preferredFireSuppressionFuelerID;
        data["preferredTrailerFueler"] = this.preferredTrailerFueler ? this.preferredTrailerFueler.toJSON() : undefined as any;
        data["preferredFireSuppressionFueler"] = this.preferredFireSuppressionFueler ? this.preferredFireSuppressionFueler.toJSON() : undefined as any;
        data["lastNote"] = this.lastNote;
        data["lastNoteDate"] = this.lastNoteDate ? this.lastNoteDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ILocationDto {
    timeZoneLookupOutcome?: GeoLookupOutcome | undefined;
    id?: string | undefined;
    locID?: number;
    idx?: string | undefined;
    name?: string | undefined;
    customerId?: string | undefined;
    newCustomerId?: number | undefined;
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    primaryContact?: string | undefined;
    secondaryContact?: string | undefined;
    primaryPhone?: string | undefined;
    primaryPhoneExt?: string | undefined;
    secondaryPhone?: string | undefined;
    secondaryPhoneExt?: string | undefined;
    fax?: string | undefined;
    email?: string | undefined;
    longitude?: number;
    latitude?: number;
    lastRateUpdateDate?: Date | undefined;
    timeZone?: string | undefined;
    ianaZoneName?: string | undefined;
    standardTimeZone?: string | undefined;
    standardUTCOffset?: string | undefined;
    daylightTimeZone?: string | undefined;
    daylightUTCOffset?: string | undefined;
    usesDST?: boolean | undefined;
    notes?: string | undefined;
    taxRate?: number | undefined;
    deleted?: boolean;
    weekdayAuditScheduleID?: number | undefined;
    weekendAuditScheduleID?: number | undefined;
    weekdayAuditSchedule?: AuditSchedule | undefined;
    weekendAuditSchedule?: AuditSchedule | undefined;
    createdDate?: Date;
    createdUser?: string | undefined;
    lastModifiedDate?: Date;
    lastModifiedUser?: string | undefined;
    allowPortalReefers?: boolean;
    allowPortalDryVans?: boolean;
    allowPortalDryContainers?: boolean;
    qbCustomerName?: string | undefined;
    externalCustomerID?: number | undefined;
    lastRateCheckDate?: Date | undefined;
    county?: string | undefined;
    customer?: Customer | undefined;
    nsSentDate?: Date | undefined;
    weekdayDropOffTimeStart?: string | undefined;
    weekdayDropOffTimeEnd?: string | undefined;
    weekendDropOffTimeStart?: string | undefined;
    weekendDropOffTimeEnd?: string | undefined;
    fireSuppressionScheduleWeek?: number | undefined;
    statusNowID?: number | undefined;
    locationContactStatusNowID?: number | undefined;
    shouldAudit?: string | undefined;
    shouldRemindEmail?: boolean | undefined;
    shouldRemindNumber?: boolean | undefined;
    shouldRemindPortal?: boolean | undefined;
    brandName?: string | undefined;
    preferredTrailerFuelerID?: string | undefined;
    preferredFireSuppressionFuelerID?: string | undefined;
    preferredTrailerFueler?: Provider | undefined;
    preferredFireSuppressionFueler?: Provider | undefined;
    lastNote?: string | undefined;
    lastNoteDate?: Date | undefined;
}

export enum GeoLookupOutcome {
    Success = 0,
    NoMatch = 1,
    Rejected = 2,
    InvalidInput = 3,
    Unavailable = 4,
    ConfigurationFailure = 5,
    Cancelled = 6,
}

export class StoreLocationInformationDto implements IStoreLocationInformationDto {
    customerID?: string | undefined;
    brandName?: string | undefined;
    name?: string | undefined;
    idx?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    primaryContact?: string | undefined;
    email?: string | undefined;
    primaryPhone?: string | undefined;
    primaryPhoneExt?: string | undefined;
    usesNumber?: boolean;

    constructor(data?: IStoreLocationInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerID = _data["customerID"];
            this.brandName = _data["brandName"];
            this.name = _data["name"];
            this.idx = _data["idx"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.primaryContact = _data["primaryContact"];
            this.email = _data["email"];
            this.primaryPhone = _data["primaryPhone"];
            this.primaryPhoneExt = _data["primaryPhoneExt"];
            this.usesNumber = _data["usesNumber"];
        }
    }

    static fromJS(data: any): StoreLocationInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new StoreLocationInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerID"] = this.customerID;
        data["brandName"] = this.brandName;
        data["name"] = this.name;
        data["idx"] = this.idx;
        data["street"] = this.street;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["primaryContact"] = this.primaryContact;
        data["email"] = this.email;
        data["primaryPhone"] = this.primaryPhone;
        data["primaryPhoneExt"] = this.primaryPhoneExt;
        data["usesNumber"] = this.usesNumber;
        return data;
    }
}

export interface IStoreLocationInformationDto {
    customerID?: string | undefined;
    brandName?: string | undefined;
    name?: string | undefined;
    idx?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    primaryContact?: string | undefined;
    email?: string | undefined;
    primaryPhone?: string | undefined;
    primaryPhoneExt?: string | undefined;
    usesNumber?: boolean;
}

export class StorePortalLocationDTO implements IStorePortalLocationDTO {
    location?: LocationSlimDto | undefined;
    onsiteAssetCount?: number;
    scheduledAssetCount?: number;
    orderChangeCount?: number;
    nonFuelOnlyAssetCount?: number;
    hasDeliveryInspectionAssets?: boolean;

    constructor(data?: IStorePortalLocationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"] ? LocationSlimDto.fromJS(_data["location"]) : undefined as any;
            this.onsiteAssetCount = _data["onsiteAssetCount"];
            this.scheduledAssetCount = _data["scheduledAssetCount"];
            this.orderChangeCount = _data["orderChangeCount"];
            this.nonFuelOnlyAssetCount = _data["nonFuelOnlyAssetCount"];
            this.hasDeliveryInspectionAssets = _data["hasDeliveryInspectionAssets"];
        }
    }

    static fromJS(data: any): StorePortalLocationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StorePortalLocationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location ? this.location.toJSON() : undefined as any;
        data["onsiteAssetCount"] = this.onsiteAssetCount;
        data["scheduledAssetCount"] = this.scheduledAssetCount;
        data["orderChangeCount"] = this.orderChangeCount;
        data["nonFuelOnlyAssetCount"] = this.nonFuelOnlyAssetCount;
        data["hasDeliveryInspectionAssets"] = this.hasDeliveryInspectionAssets;
        return data;
    }
}

export interface IStorePortalLocationDTO {
    location?: LocationSlimDto | undefined;
    onsiteAssetCount?: number;
    scheduledAssetCount?: number;
    orderChangeCount?: number;
    nonFuelOnlyAssetCount?: number;
    hasDeliveryInspectionAssets?: boolean;
}

export class LocationSlimDto implements ILocationSlimDto {
    id?: string | undefined;
    locID?: number;
    idx?: string | undefined;
    name?: string | undefined;
    customerId?: string | undefined;
    customerTrailerProceduresUri?: string | undefined;
    customerResourceGuideUri?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    primaryContact?: string | undefined;
    primaryPhone?: string | undefined;
    primaryPhoneExt?: string | undefined;
    email?: string | undefined;
    brandName?: string | undefined;

    constructor(data?: ILocationSlimDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locID = _data["locID"];
            this.idx = _data["idx"];
            this.name = _data["name"];
            this.customerId = _data["customerId"];
            this.customerTrailerProceduresUri = _data["customerTrailerProceduresUri"];
            this.customerResourceGuideUri = _data["customerResourceGuideUri"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.primaryContact = _data["primaryContact"];
            this.primaryPhone = _data["primaryPhone"];
            this.primaryPhoneExt = _data["primaryPhoneExt"];
            this.email = _data["email"];
            this.brandName = _data["brandName"];
        }
    }

    static fromJS(data: any): LocationSlimDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationSlimDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locID"] = this.locID;
        data["idx"] = this.idx;
        data["name"] = this.name;
        data["customerId"] = this.customerId;
        data["customerTrailerProceduresUri"] = this.customerTrailerProceduresUri;
        data["customerResourceGuideUri"] = this.customerResourceGuideUri;
        data["street"] = this.street;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["primaryContact"] = this.primaryContact;
        data["primaryPhone"] = this.primaryPhone;
        data["primaryPhoneExt"] = this.primaryPhoneExt;
        data["email"] = this.email;
        data["brandName"] = this.brandName;
        return data;
    }
}

export interface ILocationSlimDto {
    id?: string | undefined;
    locID?: number;
    idx?: string | undefined;
    name?: string | undefined;
    customerId?: string | undefined;
    customerTrailerProceduresUri?: string | undefined;
    customerResourceGuideUri?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    primaryContact?: string | undefined;
    primaryPhone?: string | undefined;
    primaryPhoneExt?: string | undefined;
    email?: string | undefined;
    brandName?: string | undefined;
}

export class AssetChangeForApprovalDTO implements IAssetChangeForApprovalDTO {
    assetID?: number;
    auditID?: number;
    trailerNumber?: string | undefined;
    fieldName?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    approvedDate?: Date | undefined;
    approverName?: string | undefined;
    approverEmail?: string | undefined;
    changeDate?: Date;
    friendlyFieldName?: string | undefined;
    orderID?: number;
    changeID?: number;

    constructor(data?: IAssetChangeForApprovalDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetID = _data["assetID"];
            this.auditID = _data["auditID"];
            this.trailerNumber = _data["trailerNumber"];
            this.fieldName = _data["fieldName"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
            this.approvedDate = _data["approvedDate"] ? new Date(_data["approvedDate"].toString()) : undefined as any;
            this.approverName = _data["approverName"];
            this.approverEmail = _data["approverEmail"];
            this.changeDate = _data["changeDate"] ? new Date(_data["changeDate"].toString()) : undefined as any;
            this.friendlyFieldName = _data["friendlyFieldName"];
            this.orderID = _data["orderID"];
            this.changeID = _data["changeID"];
        }
    }

    static fromJS(data: any): AssetChangeForApprovalDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssetChangeForApprovalDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetID"] = this.assetID;
        data["auditID"] = this.auditID;
        data["trailerNumber"] = this.trailerNumber;
        data["fieldName"] = this.fieldName;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : undefined as any;
        data["approverName"] = this.approverName;
        data["approverEmail"] = this.approverEmail;
        data["changeDate"] = this.changeDate ? this.changeDate.toISOString() : undefined as any;
        data["friendlyFieldName"] = this.friendlyFieldName;
        data["orderID"] = this.orderID;
        data["changeID"] = this.changeID;
        return data;
    }
}

export interface IAssetChangeForApprovalDTO {
    assetID?: number;
    auditID?: number;
    trailerNumber?: string | undefined;
    fieldName?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    approvedDate?: Date | undefined;
    approverName?: string | undefined;
    approverEmail?: string | undefined;
    changeDate?: Date;
    friendlyFieldName?: string | undefined;
    orderID?: number;
    changeID?: number;
}

export class LocationAlertDTO implements ILocationAlertDTO {
    alertID?: string;
    title?: string | undefined;
    referenceID?: string | undefined;
    type?: LocationAlertType;
    message?: string | undefined;

    constructor(data?: ILocationAlertDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alertID = _data["alertID"];
            this.title = _data["title"];
            this.referenceID = _data["referenceID"];
            this.type = _data["type"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): LocationAlertDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LocationAlertDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alertID"] = this.alertID;
        data["title"] = this.title;
        data["referenceID"] = this.referenceID;
        data["type"] = this.type;
        data["message"] = this.message;
        return data;
    }
}

export interface ILocationAlertDTO {
    alertID?: string;
    title?: string | undefined;
    referenceID?: string | undefined;
    type?: LocationAlertType;
    message?: string | undefined;
}

export enum LocationAlertType {
    General = 0,
    NoDeliveryAcknowledgement = 1,
    NoPickup = 2,
    RequestedRemoval = 3,
    AuditTimeMissed = 4,
}

export class StoreSelectionLocationDto implements IStoreSelectionLocationDto {
    locID?: number;
    customerID?: string | undefined;
    name?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;

    constructor(data?: IStoreSelectionLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locID = _data["locID"];
            this.customerID = _data["customerID"];
            this.name = _data["name"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
        }
    }

    static fromJS(data: any): StoreSelectionLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new StoreSelectionLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locID"] = this.locID;
        data["customerID"] = this.customerID;
        data["name"] = this.name;
        data["street"] = this.street;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        return data;
    }
}

export interface IStoreSelectionLocationDto {
    locID?: number;
    customerID?: string | undefined;
    name?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
}

export class AssetDTO implements IAssetDTO {
    assetID?: number;
    trailerNumber?: string | undefined;
    tempType?: string | undefined;
    powerType?: string | undefined;
    size?: number | undefined;
    zone1RangeID?: number | undefined;
    zone1Min?: number;
    zone1Max?: number;
    zone2RangeID?: number | undefined;
    zone2Min?: number;
    zone2Max?: number;
    sizeNote?: string | undefined;
    orderID?: number;
    deliveryDate?: Date | undefined;
    pickupDate?: Date | undefined;
    requestedRemoval?: Date | undefined;
    assetType?: string | undefined;
    modDeclined?: boolean | undefined;
    modName?: string | undefined;
    expectedTurnOnDate?: Date | undefined;
    noiseOrdinance?: string | undefined;
    endOfLife?: string | undefined;
    hasAcknowledgement?: boolean | undefined;

    constructor(data?: IAssetDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetID = _data["assetID"];
            this.trailerNumber = _data["trailerNumber"];
            this.tempType = _data["tempType"];
            this.powerType = _data["powerType"];
            this.size = _data["size"];
            this.zone1RangeID = _data["zone1RangeID"];
            this.zone1Min = _data["zone1Min"];
            this.zone1Max = _data["zone1Max"];
            this.zone2RangeID = _data["zone2RangeID"];
            this.zone2Min = _data["zone2Min"];
            this.zone2Max = _data["zone2Max"];
            this.sizeNote = _data["sizeNote"];
            this.orderID = _data["orderID"];
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : undefined as any;
            this.pickupDate = _data["pickupDate"] ? new Date(_data["pickupDate"].toString()) : undefined as any;
            this.requestedRemoval = _data["requestedRemoval"] ? new Date(_data["requestedRemoval"].toString()) : undefined as any;
            this.assetType = _data["assetType"];
            this.modDeclined = _data["modDeclined"];
            this.modName = _data["modName"];
            this.expectedTurnOnDate = _data["expectedTurnOnDate"] ? new Date(_data["expectedTurnOnDate"].toString()) : undefined as any;
            this.noiseOrdinance = _data["noiseOrdinance"];
            this.endOfLife = _data["endOfLife"];
            this.hasAcknowledgement = _data["hasAcknowledgement"];
        }
    }

    static fromJS(data: any): AssetDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetID"] = this.assetID;
        data["trailerNumber"] = this.trailerNumber;
        data["tempType"] = this.tempType;
        data["powerType"] = this.powerType;
        data["size"] = this.size;
        data["zone1RangeID"] = this.zone1RangeID;
        data["zone1Min"] = this.zone1Min;
        data["zone1Max"] = this.zone1Max;
        data["zone2RangeID"] = this.zone2RangeID;
        data["zone2Min"] = this.zone2Min;
        data["zone2Max"] = this.zone2Max;
        data["sizeNote"] = this.sizeNote;
        data["orderID"] = this.orderID;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : undefined as any;
        data["pickupDate"] = this.pickupDate ? this.pickupDate.toISOString() : undefined as any;
        data["requestedRemoval"] = this.requestedRemoval ? this.requestedRemoval.toISOString() : undefined as any;
        data["assetType"] = this.assetType;
        data["modDeclined"] = this.modDeclined;
        data["modName"] = this.modName;
        data["expectedTurnOnDate"] = this.expectedTurnOnDate ? this.expectedTurnOnDate.toISOString() : undefined as any;
        data["noiseOrdinance"] = this.noiseOrdinance;
        data["endOfLife"] = this.endOfLife;
        data["hasAcknowledgement"] = this.hasAcknowledgement;
        return data;
    }
}

export interface IAssetDTO {
    assetID?: number;
    trailerNumber?: string | undefined;
    tempType?: string | undefined;
    powerType?: string | undefined;
    size?: number | undefined;
    zone1RangeID?: number | undefined;
    zone1Min?: number;
    zone1Max?: number;
    zone2RangeID?: number | undefined;
    zone2Min?: number;
    zone2Max?: number;
    sizeNote?: string | undefined;
    orderID?: number;
    deliveryDate?: Date | undefined;
    pickupDate?: Date | undefined;
    requestedRemoval?: Date | undefined;
    assetType?: string | undefined;
    modDeclined?: boolean | undefined;
    modName?: string | undefined;
    expectedTurnOnDate?: Date | undefined;
    noiseOrdinance?: string | undefined;
    endOfLife?: string | undefined;
    hasAcknowledgement?: boolean | undefined;
}

export class ScheduledAssetRequestDTO implements IScheduledAssetRequestDTO {
    requestor?: string | undefined;
    requestorEmail?: string | undefined;
    assets?: ScheduledAssetDTO[] | undefined;

    constructor(data?: IScheduledAssetRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestor = _data["requestor"];
            this.requestorEmail = _data["requestorEmail"];
            if (Array.isArray(_data["assets"])) {
                this.assets = [] as any;
                for (let item of _data["assets"])
                    this.assets!.push(ScheduledAssetDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScheduledAssetRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledAssetRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestor"] = this.requestor;
        data["requestorEmail"] = this.requestorEmail;
        if (Array.isArray(this.assets)) {
            data["assets"] = [];
            for (let item of this.assets)
                data["assets"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IScheduledAssetRequestDTO {
    requestor?: string | undefined;
    requestorEmail?: string | undefined;
    assets?: ScheduledAssetDTO[] | undefined;
}

export class ScheduledAssetDTO implements IScheduledAssetDTO {
    assetID?: number;
    trailerNumber?: string | undefined;
    orderID?: number;
    assetType?: string | undefined;
    temperatureType?: string | undefined;
    requestDoorType?: string | undefined;
    powerType?: string | undefined;
    refrigeratorType?: string | undefined;
    size?: number | undefined;
    sizeNote?: string | undefined;
    deliveryScheduledDate?: Date | undefined;
    anticipatedRemovalDate?: Date | undefined;
    orderCreatedDate?: Date;

    constructor(data?: IScheduledAssetDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetID = _data["assetID"];
            this.trailerNumber = _data["trailerNumber"];
            this.orderID = _data["orderID"];
            this.assetType = _data["assetType"];
            this.temperatureType = _data["temperatureType"];
            this.requestDoorType = _data["requestDoorType"];
            this.powerType = _data["powerType"];
            this.refrigeratorType = _data["refrigeratorType"];
            this.size = _data["size"];
            this.sizeNote = _data["sizeNote"];
            this.deliveryScheduledDate = _data["deliveryScheduledDate"] ? new Date(_data["deliveryScheduledDate"].toString()) : undefined as any;
            this.anticipatedRemovalDate = _data["anticipatedRemovalDate"] ? new Date(_data["anticipatedRemovalDate"].toString()) : undefined as any;
            this.orderCreatedDate = _data["orderCreatedDate"] ? new Date(_data["orderCreatedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ScheduledAssetDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledAssetDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetID"] = this.assetID;
        data["trailerNumber"] = this.trailerNumber;
        data["orderID"] = this.orderID;
        data["assetType"] = this.assetType;
        data["temperatureType"] = this.temperatureType;
        data["requestDoorType"] = this.requestDoorType;
        data["powerType"] = this.powerType;
        data["refrigeratorType"] = this.refrigeratorType;
        data["size"] = this.size;
        data["sizeNote"] = this.sizeNote;
        data["deliveryScheduledDate"] = this.deliveryScheduledDate ? this.deliveryScheduledDate.toISOString() : undefined as any;
        data["anticipatedRemovalDate"] = this.anticipatedRemovalDate ? this.anticipatedRemovalDate.toISOString() : undefined as any;
        data["orderCreatedDate"] = this.orderCreatedDate ? this.orderCreatedDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IScheduledAssetDTO {
    assetID?: number;
    trailerNumber?: string | undefined;
    orderID?: number;
    assetType?: string | undefined;
    temperatureType?: string | undefined;
    requestDoorType?: string | undefined;
    powerType?: string | undefined;
    refrigeratorType?: string | undefined;
    size?: number | undefined;
    sizeNote?: string | undefined;
    deliveryScheduledDate?: Date | undefined;
    anticipatedRemovalDate?: Date | undefined;
    orderCreatedDate?: Date;
}

export class LocationContactDTO implements ILocationContactDTO {
    locationContactID?: number;
    locationID?: string | undefined;
    locID?: number;
    name?: string | undefined;
    phone?: string | undefined;
    extension?: string | undefined;
    email?: string | undefined;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    isNotification?: boolean | undefined;
    preferredNotificationType?: string | undefined;

    constructor(data?: ILocationContactDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationContactID = _data["locationContactID"];
            this.locationID = _data["locationID"];
            this.locID = _data["locID"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.extension = _data["extension"];
            this.email = _data["email"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.isNotification = _data["isNotification"];
            this.preferredNotificationType = _data["preferredNotificationType"];
        }
    }

    static fromJS(data: any): LocationContactDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LocationContactDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationContactID"] = this.locationContactID;
        data["locationID"] = this.locationID;
        data["locID"] = this.locID;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["extension"] = this.extension;
        data["email"] = this.email;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["isNotification"] = this.isNotification;
        data["preferredNotificationType"] = this.preferredNotificationType;
        return data;
    }
}

export interface ILocationContactDTO {
    locationContactID?: number;
    locationID?: string | undefined;
    locID?: number;
    name?: string | undefined;
    phone?: string | undefined;
    extension?: string | undefined;
    email?: string | undefined;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    isNotification?: boolean | undefined;
    preferredNotificationType?: string | undefined;
}

export class PrimeGridResultOfLocationContactDTO implements IPrimeGridResultOfLocationContactDTO {
    totalRecords?: number;
    data?: LocationContactDTO[] | undefined;

    constructor(data?: IPrimeGridResultOfLocationContactDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LocationContactDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PrimeGridResultOfLocationContactDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PrimeGridResultOfLocationContactDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPrimeGridResultOfLocationContactDTO {
    totalRecords?: number;
    data?: LocationContactDTO[] | undefined;
}

export class PrimeGridRequest implements IPrimeGridRequest {
    first?: number | undefined;
    rows?: number;
    sortField?: string | undefined;
    sortOrder?: PrimeSortDirection | undefined;
    filters?: { [key: string]: PrimeFilter; } | undefined;
    meta?: string | undefined;

    constructor(data?: IPrimeGridRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.first = _data["first"];
            this.rows = _data["rows"];
            this.sortField = _data["sortField"];
            this.sortOrder = _data["sortOrder"];
            if (_data["filters"]) {
                this.filters = {} as any;
                for (let key in _data["filters"]) {
                    if (_data["filters"].hasOwnProperty(key))
                        (this.filters as any)![key] = _data["filters"][key] ? PrimeFilter.fromJS(_data["filters"][key]) : new PrimeFilter();
                }
            }
            this.meta = _data["meta"];
        }
    }

    static fromJS(data: any): PrimeGridRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PrimeGridRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["first"] = this.first;
        data["rows"] = this.rows;
        data["sortField"] = this.sortField;
        data["sortOrder"] = this.sortOrder;
        if (this.filters) {
            data["filters"] = {};
            for (let key in this.filters) {
                if (this.filters.hasOwnProperty(key))
                    (data["filters"] as any)[key] = this.filters[key] ? this.filters[key].toJSON() : undefined as any;
            }
        }
        data["meta"] = this.meta;
        return data;
    }
}

export interface IPrimeGridRequest {
    first?: number | undefined;
    rows?: number;
    sortField?: string | undefined;
    sortOrder?: PrimeSortDirection | undefined;
    filters?: { [key: string]: PrimeFilter; } | undefined;
    meta?: string | undefined;
}

export enum PrimeSortDirection {
    Ascending = 1,
    Descending = 2,
}

export class PrimeFilter implements IPrimeFilter {
    value?: string[] | undefined;
    matchMode?: string | undefined;

    constructor(data?: IPrimeFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
            this.matchMode = _data["matchMode"];
        }
    }

    static fromJS(data: any): PrimeFilter {
        data = typeof data === 'object' ? data : {};
        let result = new PrimeFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        data["matchMode"] = this.matchMode;
        return data;
    }
}

export interface IPrimeFilter {
    value?: string[] | undefined;
    matchMode?: string | undefined;
}

export class Auth0UserDto implements IAuth0UserDto {
    auth0User?: Auth0User | undefined;
    storeId?: string | undefined;
    locID?: number;
    customerId?: string | undefined;
    mobileNumber?: string | undefined;
    defaultLanguage?: string | undefined;

    constructor(data?: IAuth0UserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auth0User = _data["auth0User"] ? Auth0User.fromJS(_data["auth0User"]) : undefined as any;
            this.storeId = _data["storeId"];
            this.locID = _data["locID"];
            this.customerId = _data["customerId"];
            this.mobileNumber = _data["mobileNumber"];
            this.defaultLanguage = _data["defaultLanguage"];
        }
    }

    static fromJS(data: any): Auth0UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new Auth0UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auth0User"] = this.auth0User ? this.auth0User.toJSON() : undefined as any;
        data["storeId"] = this.storeId;
        data["locID"] = this.locID;
        data["customerId"] = this.customerId;
        data["mobileNumber"] = this.mobileNumber;
        data["defaultLanguage"] = this.defaultLanguage;
        return data;
    }
}

export interface IAuth0UserDto {
    auth0User?: Auth0User | undefined;
    storeId?: string | undefined;
    locID?: number;
    customerId?: string | undefined;
    mobileNumber?: string | undefined;
    defaultLanguage?: string | undefined;
}

export class Auth0User implements IAuth0User {
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    lastLogin?: Date | undefined;
    userId?: string | undefined;
    email?: string | undefined;
    emailVerified?: boolean;
    identities?: Identity[] | undefined;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    nickname?: string | undefined;
    picture?: string | undefined;
    phoneNumber?: string | undefined;
    lastIp?: string | undefined;
    loginsCount?: number;
    blocked?: boolean;
    isASM?: boolean;
    userMetadata?: any | undefined;

    constructor(data?: IAuth0User) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
            this.lastLogin = _data["lastLogin"] ? new Date(_data["lastLogin"].toString()) : undefined as any;
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.emailVerified = _data["emailVerified"];
            if (Array.isArray(_data["identities"])) {
                this.identities = [] as any;
                for (let item of _data["identities"])
                    this.identities!.push(Identity.fromJS(item));
            }
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.nickname = _data["nickname"];
            this.picture = _data["picture"];
            this.phoneNumber = _data["phoneNumber"];
            this.lastIp = _data["lastIp"];
            this.loginsCount = _data["loginsCount"];
            this.blocked = _data["blocked"];
            this.isASM = _data["isASM"];
            this.userMetadata = _data["userMetadata"];
        }
    }

    static fromJS(data: any): Auth0User {
        data = typeof data === 'object' ? data : {};
        let result = new Auth0User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        data["lastLogin"] = this.lastLogin ? this.lastLogin.toISOString() : undefined as any;
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["emailVerified"] = this.emailVerified;
        if (Array.isArray(this.identities)) {
            data["identities"] = [];
            for (let item of this.identities)
                data["identities"].push(item ? item.toJSON() : undefined as any);
        }
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["nickname"] = this.nickname;
        data["picture"] = this.picture;
        data["phoneNumber"] = this.phoneNumber;
        data["lastIp"] = this.lastIp;
        data["loginsCount"] = this.loginsCount;
        data["blocked"] = this.blocked;
        data["isASM"] = this.isASM;
        data["userMetadata"] = this.userMetadata;
        return data;
    }
}

export interface IAuth0User {
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    lastLogin?: Date | undefined;
    userId?: string | undefined;
    email?: string | undefined;
    emailVerified?: boolean;
    identities?: Identity[] | undefined;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    nickname?: string | undefined;
    picture?: string | undefined;
    phoneNumber?: string | undefined;
    lastIp?: string | undefined;
    loginsCount?: number;
    blocked?: boolean;
    isASM?: boolean;
    userMetadata?: any | undefined;
}

export class Identity implements IIdentity {
    provider?: string | undefined;
    accessToken?: string | undefined;
    expiresIn?: number;
    userId?: string | undefined;
    connection?: string | undefined;
    isSocial?: boolean;

    constructor(data?: IIdentity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.provider = _data["provider"];
            this.accessToken = _data["accessToken"];
            this.expiresIn = _data["expiresIn"];
            this.userId = _data["userId"];
            this.connection = _data["connection"];
            this.isSocial = _data["isSocial"];
        }
    }

    static fromJS(data: any): Identity {
        data = typeof data === 'object' ? data : {};
        let result = new Identity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provider"] = this.provider;
        data["accessToken"] = this.accessToken;
        data["expiresIn"] = this.expiresIn;
        data["userId"] = this.userId;
        data["connection"] = this.connection;
        data["isSocial"] = this.isSocial;
        return data;
    }
}

export interface IIdentity {
    provider?: string | undefined;
    accessToken?: string | undefined;
    expiresIn?: number;
    userId?: string | undefined;
    connection?: string | undefined;
    isSocial?: boolean;
}

export class PagedResponseDtoOfNotificationV2DeliveryDto implements IPagedResponseDtoOfNotificationV2DeliveryDto {
    count?: number;
    records?: NotificationV2DeliveryDto[] | undefined;

    constructor(data?: IPagedResponseDtoOfNotificationV2DeliveryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(NotificationV2DeliveryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResponseDtoOfNotificationV2DeliveryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseDtoOfNotificationV2DeliveryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPagedResponseDtoOfNotificationV2DeliveryDto {
    count?: number;
    records?: NotificationV2DeliveryDto[] | undefined;
}

export class NotificationV2DeliveryDto implements INotificationV2DeliveryDto {
    assignment?: NotificationAssignment | undefined;
    id?: string | undefined;
    recordId?: string | undefined;
    recipientKey?: string | undefined;
    recipientAddress?: string | undefined;
    sourceSystem?: SourceSystemEnum;
    kind?: NotificationKind;
    notificationType?: NotificationTypeEnum;
    status?: NotificationDeliveryStatus;
    notificationPriority?: NotificationPriorityEnum;
    role?: string | undefined;
    category?: string | undefined;
    title?: string | undefined;
    bodyPreview?: string | undefined;
    content?: string | undefined;
    isRichText?: boolean;
    directLink?: string | undefined;
    relativeLink?: string | undefined;
    expiresWhen?: Date | undefined;
    publishedWhen?: Date | undefined;
    deliveredWhen?: Date;
    viewedWhen?: Date | undefined;
    dismissedWhen?: Date | undefined;
    acceptedWhen?: Date | undefined;
    completedWhen?: Date | undefined;
    snoozedUntil?: Date | undefined;
    snoozeScope?: NotificationSnoozeScope | undefined;
    snoozeCount?: number;
    lastRealertedWhen?: Date | undefined;
    realertCount?: number;
    sourceReference?: NotificationSourceReference | undefined;
    channels?: NotificationChannelStates | undefined;
    actionHints?: NotificationActionHint[] | undefined;

    constructor(data?: INotificationV2DeliveryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignment = _data["assignment"] ? NotificationAssignment.fromJS(_data["assignment"]) : undefined as any;
            this.id = _data["id"];
            this.recordId = _data["recordId"];
            this.recipientKey = _data["recipientKey"];
            this.recipientAddress = _data["recipientAddress"];
            this.sourceSystem = _data["sourceSystem"];
            this.kind = _data["kind"];
            this.notificationType = _data["notificationType"];
            this.status = _data["status"];
            this.notificationPriority = _data["notificationPriority"];
            this.role = _data["role"];
            this.category = _data["category"];
            this.title = _data["title"];
            this.bodyPreview = _data["bodyPreview"];
            this.content = _data["content"];
            this.isRichText = _data["isRichText"];
            this.directLink = _data["directLink"];
            this.relativeLink = _data["relativeLink"];
            this.expiresWhen = _data["expiresWhen"] ? new Date(_data["expiresWhen"].toString()) : undefined as any;
            this.publishedWhen = _data["publishedWhen"] ? new Date(_data["publishedWhen"].toString()) : undefined as any;
            this.deliveredWhen = _data["deliveredWhen"] ? new Date(_data["deliveredWhen"].toString()) : undefined as any;
            this.viewedWhen = _data["viewedWhen"] ? new Date(_data["viewedWhen"].toString()) : undefined as any;
            this.dismissedWhen = _data["dismissedWhen"] ? new Date(_data["dismissedWhen"].toString()) : undefined as any;
            this.acceptedWhen = _data["acceptedWhen"] ? new Date(_data["acceptedWhen"].toString()) : undefined as any;
            this.completedWhen = _data["completedWhen"] ? new Date(_data["completedWhen"].toString()) : undefined as any;
            this.snoozedUntil = _data["snoozedUntil"] ? new Date(_data["snoozedUntil"].toString()) : undefined as any;
            this.snoozeScope = _data["snoozeScope"];
            this.snoozeCount = _data["snoozeCount"];
            this.lastRealertedWhen = _data["lastRealertedWhen"] ? new Date(_data["lastRealertedWhen"].toString()) : undefined as any;
            this.realertCount = _data["realertCount"];
            this.sourceReference = _data["sourceReference"] ? NotificationSourceReference.fromJS(_data["sourceReference"]) : undefined as any;
            this.channels = _data["channels"] ? NotificationChannelStates.fromJS(_data["channels"]) : undefined as any;
            if (Array.isArray(_data["actionHints"])) {
                this.actionHints = [] as any;
                for (let item of _data["actionHints"])
                    this.actionHints!.push(NotificationActionHint.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NotificationV2DeliveryDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationV2DeliveryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignment"] = this.assignment ? this.assignment.toJSON() : undefined as any;
        data["id"] = this.id;
        data["recordId"] = this.recordId;
        data["recipientKey"] = this.recipientKey;
        data["recipientAddress"] = this.recipientAddress;
        data["sourceSystem"] = this.sourceSystem;
        data["kind"] = this.kind;
        data["notificationType"] = this.notificationType;
        data["status"] = this.status;
        data["notificationPriority"] = this.notificationPriority;
        data["role"] = this.role;
        data["category"] = this.category;
        data["title"] = this.title;
        data["bodyPreview"] = this.bodyPreview;
        data["content"] = this.content;
        data["isRichText"] = this.isRichText;
        data["directLink"] = this.directLink;
        data["relativeLink"] = this.relativeLink;
        data["expiresWhen"] = this.expiresWhen ? this.expiresWhen.toISOString() : undefined as any;
        data["publishedWhen"] = this.publishedWhen ? this.publishedWhen.toISOString() : undefined as any;
        data["deliveredWhen"] = this.deliveredWhen ? this.deliveredWhen.toISOString() : undefined as any;
        data["viewedWhen"] = this.viewedWhen ? this.viewedWhen.toISOString() : undefined as any;
        data["dismissedWhen"] = this.dismissedWhen ? this.dismissedWhen.toISOString() : undefined as any;
        data["acceptedWhen"] = this.acceptedWhen ? this.acceptedWhen.toISOString() : undefined as any;
        data["completedWhen"] = this.completedWhen ? this.completedWhen.toISOString() : undefined as any;
        data["snoozedUntil"] = this.snoozedUntil ? this.snoozedUntil.toISOString() : undefined as any;
        data["snoozeScope"] = this.snoozeScope;
        data["snoozeCount"] = this.snoozeCount;
        data["lastRealertedWhen"] = this.lastRealertedWhen ? this.lastRealertedWhen.toISOString() : undefined as any;
        data["realertCount"] = this.realertCount;
        data["sourceReference"] = this.sourceReference ? this.sourceReference.toJSON() : undefined as any;
        data["channels"] = this.channels ? this.channels.toJSON() : undefined as any;
        if (Array.isArray(this.actionHints)) {
            data["actionHints"] = [];
            for (let item of this.actionHints)
                data["actionHints"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface INotificationV2DeliveryDto {
    assignment?: NotificationAssignment | undefined;
    id?: string | undefined;
    recordId?: string | undefined;
    recipientKey?: string | undefined;
    recipientAddress?: string | undefined;
    sourceSystem?: SourceSystemEnum;
    kind?: NotificationKind;
    notificationType?: NotificationTypeEnum;
    status?: NotificationDeliveryStatus;
    notificationPriority?: NotificationPriorityEnum;
    role?: string | undefined;
    category?: string | undefined;
    title?: string | undefined;
    bodyPreview?: string | undefined;
    content?: string | undefined;
    isRichText?: boolean;
    directLink?: string | undefined;
    relativeLink?: string | undefined;
    expiresWhen?: Date | undefined;
    publishedWhen?: Date | undefined;
    deliveredWhen?: Date;
    viewedWhen?: Date | undefined;
    dismissedWhen?: Date | undefined;
    acceptedWhen?: Date | undefined;
    completedWhen?: Date | undefined;
    snoozedUntil?: Date | undefined;
    snoozeScope?: NotificationSnoozeScope | undefined;
    snoozeCount?: number;
    lastRealertedWhen?: Date | undefined;
    realertCount?: number;
    sourceReference?: NotificationSourceReference | undefined;
    channels?: NotificationChannelStates | undefined;
    actionHints?: NotificationActionHint[] | undefined;
}

export class NotificationAssignment implements INotificationAssignment {
    kind?: NotificationAssignmentKind;
    targetId?: string | undefined;
    displayName?: string | undefined;
    createdBy?: string | undefined;
    createdByName?: string | undefined;
    includeCreator?: boolean;
    recipientCount?: number;

    constructor(data?: INotificationAssignment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kind = _data["kind"];
            this.targetId = _data["targetId"];
            this.displayName = _data["displayName"];
            this.createdBy = _data["createdBy"];
            this.createdByName = _data["createdByName"];
            this.includeCreator = _data["includeCreator"];
            this.recipientCount = _data["recipientCount"];
        }
    }

    static fromJS(data: any): NotificationAssignment {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationAssignment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        data["targetId"] = this.targetId;
        data["displayName"] = this.displayName;
        data["createdBy"] = this.createdBy;
        data["createdByName"] = this.createdByName;
        data["includeCreator"] = this.includeCreator;
        data["recipientCount"] = this.recipientCount;
        return data;
    }
}

export interface INotificationAssignment {
    kind?: NotificationAssignmentKind;
    targetId?: string | undefined;
    displayName?: string | undefined;
    createdBy?: string | undefined;
    createdByName?: string | undefined;
    includeCreator?: boolean;
    recipientCount?: number;
}

export enum NotificationAssignmentKind {
    Self = 0,
    Person = 1,
    Team = 2,
    People = 3,
}

export enum SourceSystemEnum {
    STM = 0,
    Portal = 1,
    TestHarness = 3,
    Store = 4,
    AnalyticsDashboard = 5,
    Billing = 6,
}

export enum NotificationKind {
    Notification = 0,
    Alert = 1,
    Alarm = 2,
}

export enum NotificationTypeEnum {
    General = 0,
    WhatsNew = 1,
    Automated = 2,
    TermsAndConditions = 3,
}

export enum NotificationDeliveryStatus {
    Active = 0,
    Snoozed = 1,
    Dismissed = 2,
    Completed = 3,
    Expired = 4,
    Cancelled = 5,
}

export enum NotificationPriorityEnum {
    Normal = 0,
    High = 1,
    Critical = 2,
}

export enum NotificationSnoozeScope {
    User = 0,
    Source = 1,
}

export class NotificationSourceReference implements INotificationSourceReference {
    sourceSystem?: SourceSystemEnum;
    sourceType?: string | undefined;
    sourceId?: string | undefined;
    deduplicationKey?: string | undefined;
    supportsSourceSnooze?: boolean;

    constructor(data?: INotificationSourceReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceSystem = _data["sourceSystem"];
            this.sourceType = _data["sourceType"];
            this.sourceId = _data["sourceId"];
            this.deduplicationKey = _data["deduplicationKey"];
            this.supportsSourceSnooze = _data["supportsSourceSnooze"];
        }
    }

    static fromJS(data: any): NotificationSourceReference {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSourceReference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceSystem"] = this.sourceSystem;
        data["sourceType"] = this.sourceType;
        data["sourceId"] = this.sourceId;
        data["deduplicationKey"] = this.deduplicationKey;
        data["supportsSourceSnooze"] = this.supportsSourceSnooze;
        return data;
    }
}

export interface INotificationSourceReference {
    sourceSystem?: SourceSystemEnum;
    sourceType?: string | undefined;
    sourceId?: string | undefined;
    deduplicationKey?: string | undefined;
    supportsSourceSnooze?: boolean;
}

export class NotificationChannelStates implements INotificationChannelStates {
    inApp?: NotificationChannelState | undefined;
    signalR?: NotificationChannelState | undefined;
    webPush?: NotificationChannelState | undefined;
    email?: NotificationChannelState | undefined;
    teams?: NotificationChannelState | undefined;
    sms?: NotificationChannelState | undefined;

    constructor(data?: INotificationChannelStates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inApp = _data["inApp"] ? NotificationChannelState.fromJS(_data["inApp"]) : undefined as any;
            this.signalR = _data["signalR"] ? NotificationChannelState.fromJS(_data["signalR"]) : undefined as any;
            this.webPush = _data["webPush"] ? NotificationChannelState.fromJS(_data["webPush"]) : undefined as any;
            this.email = _data["email"] ? NotificationChannelState.fromJS(_data["email"]) : undefined as any;
            this.teams = _data["teams"] ? NotificationChannelState.fromJS(_data["teams"]) : undefined as any;
            this.sms = _data["sms"] ? NotificationChannelState.fromJS(_data["sms"]) : undefined as any;
        }
    }

    static fromJS(data: any): NotificationChannelStates {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationChannelStates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inApp"] = this.inApp ? this.inApp.toJSON() : undefined as any;
        data["signalR"] = this.signalR ? this.signalR.toJSON() : undefined as any;
        data["webPush"] = this.webPush ? this.webPush.toJSON() : undefined as any;
        data["email"] = this.email ? this.email.toJSON() : undefined as any;
        data["teams"] = this.teams ? this.teams.toJSON() : undefined as any;
        data["sms"] = this.sms ? this.sms.toJSON() : undefined as any;
        return data;
    }
}

export interface INotificationChannelStates {
    inApp?: NotificationChannelState | undefined;
    signalR?: NotificationChannelState | undefined;
    webPush?: NotificationChannelState | undefined;
    email?: NotificationChannelState | undefined;
    teams?: NotificationChannelState | undefined;
    sms?: NotificationChannelState | undefined;
}

export class NotificationChannelState implements INotificationChannelState {
    enabled?: boolean;
    lastSentWhen?: Date | undefined;
    lastFailedWhen?: Date | undefined;
    lastSuppressedWhen?: Date | undefined;
    lastFailure?: string | undefined;
    attemptCount?: number;

    constructor(data?: INotificationChannelState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.lastSentWhen = _data["lastSentWhen"] ? new Date(_data["lastSentWhen"].toString()) : undefined as any;
            this.lastFailedWhen = _data["lastFailedWhen"] ? new Date(_data["lastFailedWhen"].toString()) : undefined as any;
            this.lastSuppressedWhen = _data["lastSuppressedWhen"] ? new Date(_data["lastSuppressedWhen"].toString()) : undefined as any;
            this.lastFailure = _data["lastFailure"];
            this.attemptCount = _data["attemptCount"];
        }
    }

    static fromJS(data: any): NotificationChannelState {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationChannelState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["lastSentWhen"] = this.lastSentWhen ? this.lastSentWhen.toISOString() : undefined as any;
        data["lastFailedWhen"] = this.lastFailedWhen ? this.lastFailedWhen.toISOString() : undefined as any;
        data["lastSuppressedWhen"] = this.lastSuppressedWhen ? this.lastSuppressedWhen.toISOString() : undefined as any;
        data["lastFailure"] = this.lastFailure;
        data["attemptCount"] = this.attemptCount;
        return data;
    }
}

export interface INotificationChannelState {
    enabled?: boolean;
    lastSentWhen?: Date | undefined;
    lastFailedWhen?: Date | undefined;
    lastSuppressedWhen?: Date | undefined;
    lastFailure?: string | undefined;
    attemptCount?: number;
}

export class NotificationActionHint implements INotificationActionHint {
    action?: string | undefined;
    label?: string | undefined;
    url?: string | undefined;

    constructor(data?: INotificationActionHint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            this.label = _data["label"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): NotificationActionHint {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationActionHint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["label"] = this.label;
        data["url"] = this.url;
        return data;
    }
}

export interface INotificationActionHint {
    action?: string | undefined;
    label?: string | undefined;
    url?: string | undefined;
}

export class NotificationV2SnoozeRequest implements INotificationV2SnoozeRequest {
    snoozedUntilUtc?: Date;
    scope?: NotificationSnoozeScope;

    constructor(data?: INotificationV2SnoozeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.snoozedUntilUtc = _data["snoozedUntilUtc"] ? new Date(_data["snoozedUntilUtc"].toString()) : undefined as any;
            this.scope = _data["scope"];
        }
    }

    static fromJS(data: any): NotificationV2SnoozeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationV2SnoozeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["snoozedUntilUtc"] = this.snoozedUntilUtc ? this.snoozedUntilUtc.toISOString() : undefined as any;
        data["scope"] = this.scope;
        return data;
    }
}

export interface INotificationV2SnoozeRequest {
    snoozedUntilUtc?: Date;
    scope?: NotificationSnoozeScope;
}

export class NotificationV2DispatchDto implements INotificationV2DispatchDto {
    id?: string | undefined;
    deliveryId?: string | undefined;
    recordId?: string | undefined;
    recipientKey?: string | undefined;
    dueWhen?: Date;
    reason?: NotificationDispatchReason;
    status?: NotificationDispatchStatus;
    attemptCount?: number;
    createdWhen?: Date;
    completedWhen?: Date | undefined;
    lastAttemptWhen?: Date | undefined;
    lastFailure?: string | undefined;

    constructor(data?: INotificationV2DispatchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deliveryId = _data["deliveryId"];
            this.recordId = _data["recordId"];
            this.recipientKey = _data["recipientKey"];
            this.dueWhen = _data["dueWhen"] ? new Date(_data["dueWhen"].toString()) : undefined as any;
            this.reason = _data["reason"];
            this.status = _data["status"];
            this.attemptCount = _data["attemptCount"];
            this.createdWhen = _data["createdWhen"] ? new Date(_data["createdWhen"].toString()) : undefined as any;
            this.completedWhen = _data["completedWhen"] ? new Date(_data["completedWhen"].toString()) : undefined as any;
            this.lastAttemptWhen = _data["lastAttemptWhen"] ? new Date(_data["lastAttemptWhen"].toString()) : undefined as any;
            this.lastFailure = _data["lastFailure"];
        }
    }

    static fromJS(data: any): NotificationV2DispatchDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationV2DispatchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deliveryId"] = this.deliveryId;
        data["recordId"] = this.recordId;
        data["recipientKey"] = this.recipientKey;
        data["dueWhen"] = this.dueWhen ? this.dueWhen.toISOString() : undefined as any;
        data["reason"] = this.reason;
        data["status"] = this.status;
        data["attemptCount"] = this.attemptCount;
        data["createdWhen"] = this.createdWhen ? this.createdWhen.toISOString() : undefined as any;
        data["completedWhen"] = this.completedWhen ? this.completedWhen.toISOString() : undefined as any;
        data["lastAttemptWhen"] = this.lastAttemptWhen ? this.lastAttemptWhen.toISOString() : undefined as any;
        data["lastFailure"] = this.lastFailure;
        return data;
    }
}

export interface INotificationV2DispatchDto {
    id?: string | undefined;
    deliveryId?: string | undefined;
    recordId?: string | undefined;
    recipientKey?: string | undefined;
    dueWhen?: Date;
    reason?: NotificationDispatchReason;
    status?: NotificationDispatchStatus;
    attemptCount?: number;
    createdWhen?: Date;
    completedWhen?: Date | undefined;
    lastAttemptWhen?: Date | undefined;
    lastFailure?: string | undefined;
}

export enum NotificationDispatchReason {
    Published = 0,
    SnoozeDue = 1,
    SourceUpdated = 2,
    ScheduledDue = 3,
}

export enum NotificationDispatchStatus {
    Pending = 0,
    Completed = 1,
    Failed = 2,
    Cancelled = 3,
    Processing = 4,
}

export class OrderSubmissionError implements IOrderSubmissionError {
    status?: number;
    code?: string | undefined;
    error?: string | undefined;
    detail?: string | undefined;
    errorType?: string | undefined;
    ruleName?: string | undefined;
    canRetry?: boolean;
    traceId?: string | undefined;

    constructor(data?: IOrderSubmissionError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.code = _data["code"];
            this.error = _data["error"];
            this.detail = _data["detail"];
            this.errorType = _data["errorType"];
            this.ruleName = _data["ruleName"];
            this.canRetry = _data["canRetry"];
            this.traceId = _data["traceId"];
        }
    }

    static fromJS(data: any): OrderSubmissionError {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSubmissionError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["code"] = this.code;
        data["error"] = this.error;
        data["detail"] = this.detail;
        data["errorType"] = this.errorType;
        data["ruleName"] = this.ruleName;
        data["canRetry"] = this.canRetry;
        data["traceId"] = this.traceId;
        return data;
    }
}

export interface IOrderSubmissionError {
    status?: number;
    code?: string | undefined;
    error?: string | undefined;
    detail?: string | undefined;
    errorType?: string | undefined;
    ruleName?: string | undefined;
    canRetry?: boolean;
    traceId?: string | undefined;
}

export class CreateOrderDTO implements ICreateOrderDTO {
    customerID?: string | undefined;
    locationID?: string | undefined;
    locID?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    cellPhoneNumber?: string | undefined;
    emailAddress?: string | undefined;
    poNumber?: string | undefined;
    defaultAsset?: DefaultAsset | undefined;
    assets?: DefaultAsset[] | undefined;
    notes?: string | undefined;
    orderType?: string | undefined;
    orderCategoryString?: string | undefined;
    storeInformation?: StoreInformationDTO | undefined;
    isDeliveryEmergency!: boolean;
    allowPastDeliveryDate?: boolean;

    constructor(data?: ICreateOrderDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.isDeliveryEmergency = false;
            this.allowPastDeliveryDate = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerID = _data["customerID"];
            this.locationID = _data["locationID"];
            this.locID = _data["locID"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.cellPhoneNumber = _data["cellPhoneNumber"];
            this.emailAddress = _data["emailAddress"];
            this.poNumber = _data["poNumber"];
            this.defaultAsset = _data["defaultAsset"] ? DefaultAsset.fromJS(_data["defaultAsset"]) : undefined as any;
            if (Array.isArray(_data["assets"])) {
                this.assets = [] as any;
                for (let item of _data["assets"])
                    this.assets!.push(DefaultAsset.fromJS(item));
            }
            this.notes = _data["notes"];
            this.orderType = _data["orderType"];
            this.orderCategoryString = _data["orderCategoryString"];
            this.storeInformation = _data["storeInformation"] ? StoreInformationDTO.fromJS(_data["storeInformation"]) : undefined as any;
            this.isDeliveryEmergency = _data["isDeliveryEmergency"] !== undefined ? _data["isDeliveryEmergency"] : false;
            this.allowPastDeliveryDate = _data["allowPastDeliveryDate"] !== undefined ? _data["allowPastDeliveryDate"] : false;
        }
    }

    static fromJS(data: any): CreateOrderDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerID"] = this.customerID;
        data["locationID"] = this.locationID;
        data["locID"] = this.locID;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["cellPhoneNumber"] = this.cellPhoneNumber;
        data["emailAddress"] = this.emailAddress;
        data["poNumber"] = this.poNumber;
        data["defaultAsset"] = this.defaultAsset ? this.defaultAsset.toJSON() : undefined as any;
        if (Array.isArray(this.assets)) {
            data["assets"] = [];
            for (let item of this.assets)
                data["assets"].push(item ? item.toJSON() : undefined as any);
        }
        data["notes"] = this.notes;
        data["orderType"] = this.orderType;
        data["orderCategoryString"] = this.orderCategoryString;
        data["storeInformation"] = this.storeInformation ? this.storeInformation.toJSON() : undefined as any;
        data["isDeliveryEmergency"] = this.isDeliveryEmergency;
        data["allowPastDeliveryDate"] = this.allowPastDeliveryDate;
        return data;
    }
}

export interface ICreateOrderDTO {
    customerID?: string | undefined;
    locationID?: string | undefined;
    locID?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    cellPhoneNumber?: string | undefined;
    emailAddress?: string | undefined;
    poNumber?: string | undefined;
    defaultAsset?: DefaultAsset | undefined;
    assets?: DefaultAsset[] | undefined;
    notes?: string | undefined;
    orderType?: string | undefined;
    orderCategoryString?: string | undefined;
    storeInformation?: StoreInformationDTO | undefined;
    isDeliveryEmergency: boolean;
    allowPastDeliveryDate?: boolean;
}

export class DefaultAsset implements IDefaultAsset {
    assetType?: string | undefined;
    size?: number;
    tempType?: string | undefined;
    zone1TempRangeID?: number | undefined;
    zone2TempRangeID?: number | undefined;
    quantity?: number;
    requestedDropOff?: Date;
    anticipatedRemoval?: Date | undefined;
    powerType?: string | undefined;
    sizeNote?: string | undefined;
    voltage?: number | undefined;
    requestDoorType?: string | undefined;
    requestStairs?: boolean;
    stairNotes?: string | undefined;
    noiseOrdinance?: string | undefined;
    endOfLife?: string | undefined;
    expectedTurnOnDate?: Date | undefined;
    requestRamps?: boolean;
    rampNotes?: string | undefined;
    requestLiftGate?: boolean;
    additionalNotes?: string | undefined;

    constructor(data?: IDefaultAsset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetType = _data["assetType"];
            this.size = _data["size"];
            this.tempType = _data["tempType"];
            this.zone1TempRangeID = _data["zone1TempRangeID"];
            this.zone2TempRangeID = _data["zone2TempRangeID"];
            this.quantity = _data["quantity"];
            this.requestedDropOff = _data["requestedDropOff"] ? new Date(_data["requestedDropOff"].toString()) : undefined as any;
            this.anticipatedRemoval = _data["anticipatedRemoval"] ? new Date(_data["anticipatedRemoval"].toString()) : undefined as any;
            this.powerType = _data["powerType"];
            this.sizeNote = _data["sizeNote"];
            this.voltage = _data["voltage"];
            this.requestDoorType = _data["requestDoorType"];
            this.requestStairs = _data["requestStairs"];
            this.stairNotes = _data["stairNotes"];
            this.noiseOrdinance = _data["noiseOrdinance"];
            this.endOfLife = _data["endOfLife"];
            this.expectedTurnOnDate = _data["expectedTurnOnDate"] ? new Date(_data["expectedTurnOnDate"].toString()) : undefined as any;
            this.requestRamps = _data["requestRamps"];
            this.rampNotes = _data["rampNotes"];
            this.requestLiftGate = _data["requestLiftGate"];
            this.additionalNotes = _data["additionalNotes"];
        }
    }

    static fromJS(data: any): DefaultAsset {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultAsset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetType"] = this.assetType;
        data["size"] = this.size;
        data["tempType"] = this.tempType;
        data["zone1TempRangeID"] = this.zone1TempRangeID;
        data["zone2TempRangeID"] = this.zone2TempRangeID;
        data["quantity"] = this.quantity;
        data["requestedDropOff"] = this.requestedDropOff ? this.requestedDropOff.toISOString() : undefined as any;
        data["anticipatedRemoval"] = this.anticipatedRemoval ? this.anticipatedRemoval.toISOString() : undefined as any;
        data["powerType"] = this.powerType;
        data["sizeNote"] = this.sizeNote;
        data["voltage"] = this.voltage;
        data["requestDoorType"] = this.requestDoorType;
        data["requestStairs"] = this.requestStairs;
        data["stairNotes"] = this.stairNotes;
        data["noiseOrdinance"] = this.noiseOrdinance;
        data["endOfLife"] = this.endOfLife;
        data["expectedTurnOnDate"] = this.expectedTurnOnDate ? this.expectedTurnOnDate.toISOString() : undefined as any;
        data["requestRamps"] = this.requestRamps;
        data["rampNotes"] = this.rampNotes;
        data["requestLiftGate"] = this.requestLiftGate;
        data["additionalNotes"] = this.additionalNotes;
        return data;
    }
}

export interface IDefaultAsset {
    assetType?: string | undefined;
    size?: number;
    tempType?: string | undefined;
    zone1TempRangeID?: number | undefined;
    zone2TempRangeID?: number | undefined;
    quantity?: number;
    requestedDropOff?: Date;
    anticipatedRemoval?: Date | undefined;
    powerType?: string | undefined;
    sizeNote?: string | undefined;
    voltage?: number | undefined;
    requestDoorType?: string | undefined;
    requestStairs?: boolean;
    stairNotes?: string | undefined;
    noiseOrdinance?: string | undefined;
    endOfLife?: string | undefined;
    expectedTurnOnDate?: Date | undefined;
    requestRamps?: boolean;
    rampNotes?: string | undefined;
    requestLiftGate?: boolean;
    additionalNotes?: string | undefined;
}

export class StoreInformationDTO implements IStoreInformationDTO {
    shouldAudit?: string | undefined;
    weekdayCompleteAuditScheduleID?: number | undefined;
    weekdayDescription?: string | undefined;
    weekendCompleteAuditScheduleID?: number | undefined;
    weekendDescription?: string | undefined;
    shouldRemindEmail?: boolean | undefined;
    shouldRemindNumber?: boolean | undefined;
    shouldRemindPortal?: boolean | undefined;
    existingContacts?: LocationContactDTO[] | undefined;
    newContacts?: LocationContactDTO[] | undefined;

    constructor(data?: IStoreInformationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shouldAudit = _data["shouldAudit"];
            this.weekdayCompleteAuditScheduleID = _data["weekdayCompleteAuditScheduleID"];
            this.weekdayDescription = _data["weekdayDescription"];
            this.weekendCompleteAuditScheduleID = _data["weekendCompleteAuditScheduleID"];
            this.weekendDescription = _data["weekendDescription"];
            this.shouldRemindEmail = _data["shouldRemindEmail"];
            this.shouldRemindNumber = _data["shouldRemindNumber"];
            this.shouldRemindPortal = _data["shouldRemindPortal"];
            if (Array.isArray(_data["existingContacts"])) {
                this.existingContacts = [] as any;
                for (let item of _data["existingContacts"])
                    this.existingContacts!.push(LocationContactDTO.fromJS(item));
            }
            if (Array.isArray(_data["newContacts"])) {
                this.newContacts = [] as any;
                for (let item of _data["newContacts"])
                    this.newContacts!.push(LocationContactDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StoreInformationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StoreInformationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shouldAudit"] = this.shouldAudit;
        data["weekdayCompleteAuditScheduleID"] = this.weekdayCompleteAuditScheduleID;
        data["weekdayDescription"] = this.weekdayDescription;
        data["weekendCompleteAuditScheduleID"] = this.weekendCompleteAuditScheduleID;
        data["weekendDescription"] = this.weekendDescription;
        data["shouldRemindEmail"] = this.shouldRemindEmail;
        data["shouldRemindNumber"] = this.shouldRemindNumber;
        data["shouldRemindPortal"] = this.shouldRemindPortal;
        if (Array.isArray(this.existingContacts)) {
            data["existingContacts"] = [];
            for (let item of this.existingContacts)
                data["existingContacts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.newContacts)) {
            data["newContacts"] = [];
            for (let item of this.newContacts)
                data["newContacts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IStoreInformationDTO {
    shouldAudit?: string | undefined;
    weekdayCompleteAuditScheduleID?: number | undefined;
    weekdayDescription?: string | undefined;
    weekendCompleteAuditScheduleID?: number | undefined;
    weekendDescription?: string | undefined;
    shouldRemindEmail?: boolean | undefined;
    shouldRemindNumber?: boolean | undefined;
    shouldRemindPortal?: boolean | undefined;
    existingContacts?: LocationContactDTO[] | undefined;
    newContacts?: LocationContactDTO[] | undefined;
}

export class AssetRemovalDTO implements IAssetRemovalDTO {
    assetID?: number;
    requestedRemovalDate?: Date;

    constructor(data?: IAssetRemovalDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetID = _data["assetID"];
            this.requestedRemovalDate = _data["requestedRemovalDate"] ? new Date(_data["requestedRemovalDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AssetRemovalDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssetRemovalDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetID"] = this.assetID;
        data["requestedRemovalDate"] = this.requestedRemovalDate ? this.requestedRemovalDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IAssetRemovalDTO {
    assetID?: number;
    requestedRemovalDate?: Date;
}

export class RequestDTO implements IRequestDTO {
    requestID?: number;
    customerID?: string | undefined;
    type?: string | undefined;
    createdDate?: Date | undefined;
    description?: string | undefined;
    locationID?: string | undefined;
    locID?: number;
    assetID?: number;
    email?: string | undefined;
    referenceID?: string | undefined;
    contactName?: string | undefined;
    contactPhoneNumber?: string | undefined;
    reminderDate?: Date | undefined;
    closeDate?: Date | undefined;
    notes?: string | undefined;
    auditAlertID?: number;

    constructor(data?: IRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestID = _data["requestID"];
            this.customerID = _data["customerID"];
            this.type = _data["type"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.description = _data["description"];
            this.locationID = _data["locationID"];
            this.locID = _data["locID"];
            this.assetID = _data["assetID"];
            this.email = _data["email"];
            this.referenceID = _data["referenceID"];
            this.contactName = _data["contactName"];
            this.contactPhoneNumber = _data["contactPhoneNumber"];
            this.reminderDate = _data["reminderDate"] ? new Date(_data["reminderDate"].toString()) : undefined as any;
            this.closeDate = _data["closeDate"] ? new Date(_data["closeDate"].toString()) : undefined as any;
            this.notes = _data["notes"];
            this.auditAlertID = _data["auditAlertID"];
        }
    }

    static fromJS(data: any): RequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestID"] = this.requestID;
        data["customerID"] = this.customerID;
        data["type"] = this.type;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["description"] = this.description;
        data["locationID"] = this.locationID;
        data["locID"] = this.locID;
        data["assetID"] = this.assetID;
        data["email"] = this.email;
        data["referenceID"] = this.referenceID;
        data["contactName"] = this.contactName;
        data["contactPhoneNumber"] = this.contactPhoneNumber;
        data["reminderDate"] = this.reminderDate ? this.reminderDate.toISOString() : undefined as any;
        data["closeDate"] = this.closeDate ? this.closeDate.toISOString() : undefined as any;
        data["notes"] = this.notes;
        data["auditAlertID"] = this.auditAlertID;
        return data;
    }
}

export interface IRequestDTO {
    requestID?: number;
    customerID?: string | undefined;
    type?: string | undefined;
    createdDate?: Date | undefined;
    description?: string | undefined;
    locationID?: string | undefined;
    locID?: number;
    assetID?: number;
    email?: string | undefined;
    referenceID?: string | undefined;
    contactName?: string | undefined;
    contactPhoneNumber?: string | undefined;
    reminderDate?: Date | undefined;
    closeDate?: Date | undefined;
    notes?: string | undefined;
    auditAlertID?: number;
}

export class ReorderDefaultValuesDTO implements IReorderDefaultValuesDTO {
    size?: number | undefined;
    power?: string | undefined;
    door?: string | undefined;
    tempType?: string | undefined;
    zone1TempRangeID?: number | undefined;
    zone2TempRangeID?: number | undefined;
    placementType?: string | undefined;
    placementNotes?: string | undefined;
    placementContact?: string | undefined;
    placementContactNumber?: string | undefined;

    constructor(data?: IReorderDefaultValuesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.size = _data["size"];
            this.power = _data["power"];
            this.door = _data["door"];
            this.tempType = _data["tempType"];
            this.zone1TempRangeID = _data["zone1TempRangeID"];
            this.zone2TempRangeID = _data["zone2TempRangeID"];
            this.placementType = _data["placementType"];
            this.placementNotes = _data["placementNotes"];
            this.placementContact = _data["placementContact"];
            this.placementContactNumber = _data["placementContactNumber"];
        }
    }

    static fromJS(data: any): ReorderDefaultValuesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderDefaultValuesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["size"] = this.size;
        data["power"] = this.power;
        data["door"] = this.door;
        data["tempType"] = this.tempType;
        data["zone1TempRangeID"] = this.zone1TempRangeID;
        data["zone2TempRangeID"] = this.zone2TempRangeID;
        data["placementType"] = this.placementType;
        data["placementNotes"] = this.placementNotes;
        data["placementContact"] = this.placementContact;
        data["placementContactNumber"] = this.placementContactNumber;
        return data;
    }
}

export interface IReorderDefaultValuesDTO {
    size?: number | undefined;
    power?: string | undefined;
    door?: string | undefined;
    tempType?: string | undefined;
    zone1TempRangeID?: number | undefined;
    zone2TempRangeID?: number | undefined;
    placementType?: string | undefined;
    placementNotes?: string | undefined;
    placementContact?: string | undefined;
    placementContactNumber?: string | undefined;
}

export class AssetDto implements IAssetDto {
    showPanel?: boolean;
    associatedAssetName?: string | undefined;
    loadingRentalRates?: boolean;
    providerDeliveryEstimate?: number | undefined;
    providerPickupEstimate?: number | undefined;
    isVerifiedTrailerNumber?: boolean | undefined;
    fuelReading?: number | undefined;
    isDoorOperational?: boolean | undefined;
    isBulkheadCorrect?: boolean | undefined;
    verifiedBy?: string | undefined;
    verifiedOn?: Date | undefined;
    hasInvoice?: boolean;
    assetID?: number;
    orderID?: number;
    orderCustomerID?: string | undefined;
    orderLocationState?: string | undefined;
    orderLocationIANAZoneName?: string | undefined;
    orderHasPrimaryContact?: boolean;
    isAssetReadonly?: boolean;
    orderRequestReceived?: Date | undefined;
    lateReason?: string | undefined;
    legacyAssetID?: string | undefined;
    trailerNumber?: string | undefined;
    trailerNumberOverrideNote?: string | undefined;
    status?: string | undefined;
    assetType?: string | undefined;
    temperatureType?: string | undefined;
    doorType?: string | undefined;
    requestDoorType?: string | undefined;
    powerType?: string | undefined;
    refrigeratorType?: string | undefined;
    poLineItem?: number | undefined;
    providerID?: string | undefined;
    providerName?: string | undefined;
    providerOrganizationID?: number | undefined;
    providerMileage?: number | undefined;
    size?: number | undefined;
    sizeNote?: string | undefined;
    tankSize?: number | undefined;
    monitoredTankCategory?: string | undefined;
    telemetryProvider?: string | undefined;
    telemetryVendorDeviceId?: string | undefined;
    telemetryMinimumFuelPercent?: number | undefined;
    telemetryActive?: boolean;
    voltage?: number | undefined;
    engineHoursIn?: number | undefined;
    engineHoursOut?: number | undefined;
    noDrop?: boolean;
    rentalCostDaily?: number | undefined;
    rentalCostWeekly?: number | undefined;
    rentalCostMonthly?: number | undefined;
    hourlyRuntimeRate?: number | undefined;
    mileageCost?: number | undefined;
    deliveryDriverType?: string | undefined;
    deliveryRequiredDate?: Date | undefined;
    deliveryScheduledDate?: Date | undefined;
    deliveryActualDate?: Date | undefined;
    deliveryMiles?: number | undefined;
    deliveryQuote?: number | undefined;
    deliveryCost?: number | undefined;
    deliveryEmergency?: boolean;
    pickupDriverType?: string | undefined;
    pickupScheduledDate?: Date | undefined;
    pickupActualDate?: Date | undefined;
    pickupBillingEnd?: Date | undefined;
    pickupContractedRemoval?: Date | undefined;
    pickupRequestedRemoval?: Date | undefined;
    pickupMiles?: number | undefined;
    pickupQuote?: number | undefined;
    pickupCost?: number | undefined;
    pickupEmergency?: boolean;
    verificationDate?: Date | undefined;
    notes?: string | undefined;
    auditNotes?: string | undefined;
    deliveryComplete?: boolean;
    noDropReasonID?: number | undefined;
    noDropNotes?: string | undefined;
    deleted?: boolean;
    turnedOn?: boolean;
    fuelServiceActive?: boolean;
    zone1TempRangeID?: number | undefined;
    zone2TempRangeID?: number | undefined;
    zone3TempRangeID?: number | undefined;
    fuelBurnRateDays?: number | undefined;
    fuelBurnRateHours?: number | undefined;
    fuelOut?: number | undefined;
    fuelIn?: number | undefined;
    fuelSchedule?: FuelDeliveryDaysEnum;
    createdDate?: Date;
    createdUser?: string | undefined;
    lastModifiedDate?: Date;
    lastModifiedUser?: string | undefined;
    noDropDate?: Date | undefined;
    anticipatedRemovalDate?: Date | undefined;
    notMaintained?: boolean | undefined;
    unitValue?: number | undefined;
    requestStairs?: boolean;
    mileageIn?: number | undefined;
    mileageOut?: number | undefined;
    noPickup?: boolean;
    associatedAssetID?: number | undefined;
    accessoryType?: string | undefined;
    monthlyBillRate?: number | undefined;
    modDeclined?: boolean;
    modName?: string | undefined;
    requestReminderSent?: Date | undefined;
    noiseOrdinance?: string | undefined;
    endOfLife?: string | undefined;
    expectedTurnOnDate?: Date | undefined;
    requestRamps?: boolean;
    requestLiftGate?: boolean;
    lastTelematicsReceived?: Date | undefined;
    unitModeDetail?: string | undefined;
    zone1SetPoint?: number | undefined;
    zone2SetPoint?: number | undefined;
    zone3SetPoint?: number | undefined;
    operatingMode1?: string | undefined;
    operatingMode2?: string | undefined;
    operatingMode3?: string | undefined;
    zone1DischargeAir?: number | undefined;
    zone1ReturnAir?: number | undefined;
    zone2DischargeAir?: number | undefined;
    zone2ReturnAir?: number | undefined;
    zone3DischargeAir?: number | undefined;
    zone3ReturnAir?: number | undefined;
    isTelematicsOn?: boolean;
    rescheduledDeliveryDate?: Date | undefined;
    lastTelemetryRefuelDate?: Date | undefined;
    invoiceDelivery?: boolean | undefined;
    invoicePickup?: boolean | undefined;
    invoiceRentalRuntime?: boolean | undefined;
    deliveryInvoiceNumber?: string | undefined;
    pickupInvoiceNumber?: string | undefined;
    activeAlarms?: AssetActiveAlarmDto[] | undefined;
    assetExceptions?: AssetExceptionDto[] | undefined;
    onPeriods?: AssetOnPeriodDto[] | undefined;
    usageSummary?: AssetUsageSummaryDTO | undefined;
    charges?: AssetChargeDTO[] | undefined;
    loads?: AssetLoadDto[] | undefined;
    financials?: V_OrderAssetsCostWithRevenue | undefined;
    customerRates?: CustomerRate[] | undefined;
    customerRentalRate?: RentalRate | undefined;
    noDropReason?: NoDropReason | undefined;

    constructor(data?: IAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.showPanel = _data["showPanel"];
            this.associatedAssetName = _data["associatedAssetName"];
            this.loadingRentalRates = _data["loadingRentalRates"];
            this.providerDeliveryEstimate = _data["providerDeliveryEstimate"];
            this.providerPickupEstimate = _data["providerPickupEstimate"];
            this.isVerifiedTrailerNumber = _data["isVerifiedTrailerNumber"];
            this.fuelReading = _data["fuelReading"];
            this.isDoorOperational = _data["isDoorOperational"];
            this.isBulkheadCorrect = _data["isBulkheadCorrect"];
            this.verifiedBy = _data["verifiedBy"];
            this.verifiedOn = _data["verifiedOn"] ? new Date(_data["verifiedOn"].toString()) : undefined as any;
            this.hasInvoice = _data["hasInvoice"];
            this.assetID = _data["assetID"];
            this.orderID = _data["orderID"];
            this.orderCustomerID = _data["orderCustomerID"];
            this.orderLocationState = _data["orderLocationState"];
            this.orderLocationIANAZoneName = _data["orderLocationIANAZoneName"];
            this.orderHasPrimaryContact = _data["orderHasPrimaryContact"];
            this.isAssetReadonly = _data["isAssetReadonly"];
            this.orderRequestReceived = _data["orderRequestReceived"] ? new Date(_data["orderRequestReceived"].toString()) : undefined as any;
            this.lateReason = _data["lateReason"];
            this.legacyAssetID = _data["legacyAssetID"];
            this.trailerNumber = _data["trailerNumber"];
            this.trailerNumberOverrideNote = _data["trailerNumberOverrideNote"];
            this.status = _data["status"];
            this.assetType = _data["assetType"];
            this.temperatureType = _data["temperatureType"];
            this.doorType = _data["doorType"];
            this.requestDoorType = _data["requestDoorType"];
            this.powerType = _data["powerType"];
            this.refrigeratorType = _data["refrigeratorType"];
            this.poLineItem = _data["poLineItem"];
            this.providerID = _data["providerID"];
            this.providerName = _data["providerName"];
            this.providerOrganizationID = _data["providerOrganizationID"];
            this.providerMileage = _data["providerMileage"];
            this.size = _data["size"];
            this.sizeNote = _data["sizeNote"];
            this.tankSize = _data["tankSize"];
            this.monitoredTankCategory = _data["monitoredTankCategory"];
            this.telemetryProvider = _data["telemetryProvider"];
            this.telemetryVendorDeviceId = _data["telemetryVendorDeviceId"];
            this.telemetryMinimumFuelPercent = _data["telemetryMinimumFuelPercent"];
            this.telemetryActive = _data["telemetryActive"];
            this.voltage = _data["voltage"];
            this.engineHoursIn = _data["engineHoursIn"];
            this.engineHoursOut = _data["engineHoursOut"];
            this.noDrop = _data["noDrop"];
            this.rentalCostDaily = _data["rentalCostDaily"];
            this.rentalCostWeekly = _data["rentalCostWeekly"];
            this.rentalCostMonthly = _data["rentalCostMonthly"];
            this.hourlyRuntimeRate = _data["hourlyRuntimeRate"];
            this.mileageCost = _data["mileageCost"];
            this.deliveryDriverType = _data["deliveryDriverType"];
            this.deliveryRequiredDate = _data["deliveryRequiredDate"] ? new Date(_data["deliveryRequiredDate"].toString()) : undefined as any;
            this.deliveryScheduledDate = _data["deliveryScheduledDate"] ? new Date(_data["deliveryScheduledDate"].toString()) : undefined as any;
            this.deliveryActualDate = _data["deliveryActualDate"] ? new Date(_data["deliveryActualDate"].toString()) : undefined as any;
            this.deliveryMiles = _data["deliveryMiles"];
            this.deliveryQuote = _data["deliveryQuote"];
            this.deliveryCost = _data["deliveryCost"];
            this.deliveryEmergency = _data["deliveryEmergency"];
            this.pickupDriverType = _data["pickupDriverType"];
            this.pickupScheduledDate = _data["pickupScheduledDate"] ? new Date(_data["pickupScheduledDate"].toString()) : undefined as any;
            this.pickupActualDate = _data["pickupActualDate"] ? new Date(_data["pickupActualDate"].toString()) : undefined as any;
            this.pickupBillingEnd = _data["pickupBillingEnd"] ? new Date(_data["pickupBillingEnd"].toString()) : undefined as any;
            this.pickupContractedRemoval = _data["pickupContractedRemoval"] ? new Date(_data["pickupContractedRemoval"].toString()) : undefined as any;
            this.pickupRequestedRemoval = _data["pickupRequestedRemoval"] ? new Date(_data["pickupRequestedRemoval"].toString()) : undefined as any;
            this.pickupMiles = _data["pickupMiles"];
            this.pickupQuote = _data["pickupQuote"];
            this.pickupCost = _data["pickupCost"];
            this.pickupEmergency = _data["pickupEmergency"];
            this.verificationDate = _data["verificationDate"] ? new Date(_data["verificationDate"].toString()) : undefined as any;
            this.notes = _data["notes"];
            this.auditNotes = _data["auditNotes"];
            this.deliveryComplete = _data["deliveryComplete"];
            this.noDropReasonID = _data["noDropReasonID"];
            this.noDropNotes = _data["noDropNotes"];
            this.deleted = _data["deleted"];
            this.turnedOn = _data["turnedOn"];
            this.fuelServiceActive = _data["fuelServiceActive"];
            this.zone1TempRangeID = _data["zone1TempRangeID"];
            this.zone2TempRangeID = _data["zone2TempRangeID"];
            this.zone3TempRangeID = _data["zone3TempRangeID"];
            this.fuelBurnRateDays = _data["fuelBurnRateDays"];
            this.fuelBurnRateHours = _data["fuelBurnRateHours"];
            this.fuelOut = _data["fuelOut"];
            this.fuelIn = _data["fuelIn"];
            this.fuelSchedule = _data["fuelSchedule"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.lastModifiedUser = _data["lastModifiedUser"];
            this.noDropDate = _data["noDropDate"] ? new Date(_data["noDropDate"].toString()) : undefined as any;
            this.anticipatedRemovalDate = _data["anticipatedRemovalDate"] ? new Date(_data["anticipatedRemovalDate"].toString()) : undefined as any;
            this.notMaintained = _data["notMaintained"];
            this.unitValue = _data["unitValue"];
            this.requestStairs = _data["requestStairs"];
            this.mileageIn = _data["mileageIn"];
            this.mileageOut = _data["mileageOut"];
            this.noPickup = _data["noPickup"];
            this.associatedAssetID = _data["associatedAssetID"];
            this.accessoryType = _data["accessoryType"];
            this.monthlyBillRate = _data["monthlyBillRate"];
            this.modDeclined = _data["modDeclined"];
            this.modName = _data["modName"];
            this.requestReminderSent = _data["requestReminderSent"] ? new Date(_data["requestReminderSent"].toString()) : undefined as any;
            this.noiseOrdinance = _data["noiseOrdinance"];
            this.endOfLife = _data["endOfLife"];
            this.expectedTurnOnDate = _data["expectedTurnOnDate"] ? new Date(_data["expectedTurnOnDate"].toString()) : undefined as any;
            this.requestRamps = _data["requestRamps"];
            this.requestLiftGate = _data["requestLiftGate"];
            this.lastTelematicsReceived = _data["lastTelematicsReceived"] ? new Date(_data["lastTelematicsReceived"].toString()) : undefined as any;
            this.unitModeDetail = _data["unitModeDetail"];
            this.zone1SetPoint = _data["zone1SetPoint"];
            this.zone2SetPoint = _data["zone2SetPoint"];
            this.zone3SetPoint = _data["zone3SetPoint"];
            this.operatingMode1 = _data["operatingMode1"];
            this.operatingMode2 = _data["operatingMode2"];
            this.operatingMode3 = _data["operatingMode3"];
            this.zone1DischargeAir = _data["zone1DischargeAir"];
            this.zone1ReturnAir = _data["zone1ReturnAir"];
            this.zone2DischargeAir = _data["zone2DischargeAir"];
            this.zone2ReturnAir = _data["zone2ReturnAir"];
            this.zone3DischargeAir = _data["zone3DischargeAir"];
            this.zone3ReturnAir = _data["zone3ReturnAir"];
            this.isTelematicsOn = _data["isTelematicsOn"];
            this.rescheduledDeliveryDate = _data["rescheduledDeliveryDate"] ? new Date(_data["rescheduledDeliveryDate"].toString()) : undefined as any;
            this.lastTelemetryRefuelDate = _data["lastTelemetryRefuelDate"] ? new Date(_data["lastTelemetryRefuelDate"].toString()) : undefined as any;
            this.invoiceDelivery = _data["invoiceDelivery"];
            this.invoicePickup = _data["invoicePickup"];
            this.invoiceRentalRuntime = _data["invoiceRentalRuntime"];
            this.deliveryInvoiceNumber = _data["deliveryInvoiceNumber"];
            this.pickupInvoiceNumber = _data["pickupInvoiceNumber"];
            if (Array.isArray(_data["activeAlarms"])) {
                this.activeAlarms = [] as any;
                for (let item of _data["activeAlarms"])
                    this.activeAlarms!.push(AssetActiveAlarmDto.fromJS(item));
            }
            if (Array.isArray(_data["assetExceptions"])) {
                this.assetExceptions = [] as any;
                for (let item of _data["assetExceptions"])
                    this.assetExceptions!.push(AssetExceptionDto.fromJS(item));
            }
            if (Array.isArray(_data["onPeriods"])) {
                this.onPeriods = [] as any;
                for (let item of _data["onPeriods"])
                    this.onPeriods!.push(AssetOnPeriodDto.fromJS(item));
            }
            this.usageSummary = _data["usageSummary"] ? AssetUsageSummaryDTO.fromJS(_data["usageSummary"]) : undefined as any;
            if (Array.isArray(_data["charges"])) {
                this.charges = [] as any;
                for (let item of _data["charges"])
                    this.charges!.push(AssetChargeDTO.fromJS(item));
            }
            if (Array.isArray(_data["loads"])) {
                this.loads = [] as any;
                for (let item of _data["loads"])
                    this.loads!.push(AssetLoadDto.fromJS(item));
            }
            this.financials = _data["financials"] ? V_OrderAssetsCostWithRevenue.fromJS(_data["financials"]) : undefined as any;
            if (Array.isArray(_data["customerRates"])) {
                this.customerRates = [] as any;
                for (let item of _data["customerRates"])
                    this.customerRates!.push(CustomerRate.fromJS(item));
            }
            this.customerRentalRate = _data["customerRentalRate"] ? RentalRate.fromJS(_data["customerRentalRate"]) : undefined as any;
            this.noDropReason = _data["noDropReason"] ? NoDropReason.fromJS(_data["noDropReason"]) : undefined as any;
        }
    }

    static fromJS(data: any): AssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showPanel"] = this.showPanel;
        data["associatedAssetName"] = this.associatedAssetName;
        data["loadingRentalRates"] = this.loadingRentalRates;
        data["providerDeliveryEstimate"] = this.providerDeliveryEstimate;
        data["providerPickupEstimate"] = this.providerPickupEstimate;
        data["isVerifiedTrailerNumber"] = this.isVerifiedTrailerNumber;
        data["fuelReading"] = this.fuelReading;
        data["isDoorOperational"] = this.isDoorOperational;
        data["isBulkheadCorrect"] = this.isBulkheadCorrect;
        data["verifiedBy"] = this.verifiedBy;
        data["verifiedOn"] = this.verifiedOn ? this.verifiedOn.toISOString() : undefined as any;
        data["hasInvoice"] = this.hasInvoice;
        data["assetID"] = this.assetID;
        data["orderID"] = this.orderID;
        data["orderCustomerID"] = this.orderCustomerID;
        data["orderLocationState"] = this.orderLocationState;
        data["orderLocationIANAZoneName"] = this.orderLocationIANAZoneName;
        data["orderHasPrimaryContact"] = this.orderHasPrimaryContact;
        data["isAssetReadonly"] = this.isAssetReadonly;
        data["orderRequestReceived"] = this.orderRequestReceived ? this.orderRequestReceived.toISOString() : undefined as any;
        data["lateReason"] = this.lateReason;
        data["legacyAssetID"] = this.legacyAssetID;
        data["trailerNumber"] = this.trailerNumber;
        data["trailerNumberOverrideNote"] = this.trailerNumberOverrideNote;
        data["status"] = this.status;
        data["assetType"] = this.assetType;
        data["temperatureType"] = this.temperatureType;
        data["doorType"] = this.doorType;
        data["requestDoorType"] = this.requestDoorType;
        data["powerType"] = this.powerType;
        data["refrigeratorType"] = this.refrigeratorType;
        data["poLineItem"] = this.poLineItem;
        data["providerID"] = this.providerID;
        data["providerName"] = this.providerName;
        data["providerOrganizationID"] = this.providerOrganizationID;
        data["providerMileage"] = this.providerMileage;
        data["size"] = this.size;
        data["sizeNote"] = this.sizeNote;
        data["tankSize"] = this.tankSize;
        data["monitoredTankCategory"] = this.monitoredTankCategory;
        data["telemetryProvider"] = this.telemetryProvider;
        data["telemetryVendorDeviceId"] = this.telemetryVendorDeviceId;
        data["telemetryMinimumFuelPercent"] = this.telemetryMinimumFuelPercent;
        data["telemetryActive"] = this.telemetryActive;
        data["voltage"] = this.voltage;
        data["engineHoursIn"] = this.engineHoursIn;
        data["engineHoursOut"] = this.engineHoursOut;
        data["noDrop"] = this.noDrop;
        data["rentalCostDaily"] = this.rentalCostDaily;
        data["rentalCostWeekly"] = this.rentalCostWeekly;
        data["rentalCostMonthly"] = this.rentalCostMonthly;
        data["hourlyRuntimeRate"] = this.hourlyRuntimeRate;
        data["mileageCost"] = this.mileageCost;
        data["deliveryDriverType"] = this.deliveryDriverType;
        data["deliveryRequiredDate"] = this.deliveryRequiredDate ? this.deliveryRequiredDate.toISOString() : undefined as any;
        data["deliveryScheduledDate"] = this.deliveryScheduledDate ? this.deliveryScheduledDate.toISOString() : undefined as any;
        data["deliveryActualDate"] = this.deliveryActualDate ? this.deliveryActualDate.toISOString() : undefined as any;
        data["deliveryMiles"] = this.deliveryMiles;
        data["deliveryQuote"] = this.deliveryQuote;
        data["deliveryCost"] = this.deliveryCost;
        data["deliveryEmergency"] = this.deliveryEmergency;
        data["pickupDriverType"] = this.pickupDriverType;
        data["pickupScheduledDate"] = this.pickupScheduledDate ? this.pickupScheduledDate.toISOString() : undefined as any;
        data["pickupActualDate"] = this.pickupActualDate ? this.pickupActualDate.toISOString() : undefined as any;
        data["pickupBillingEnd"] = this.pickupBillingEnd ? this.pickupBillingEnd.toISOString() : undefined as any;
        data["pickupContractedRemoval"] = this.pickupContractedRemoval ? this.pickupContractedRemoval.toISOString() : undefined as any;
        data["pickupRequestedRemoval"] = this.pickupRequestedRemoval ? this.pickupRequestedRemoval.toISOString() : undefined as any;
        data["pickupMiles"] = this.pickupMiles;
        data["pickupQuote"] = this.pickupQuote;
        data["pickupCost"] = this.pickupCost;
        data["pickupEmergency"] = this.pickupEmergency;
        data["verificationDate"] = this.verificationDate ? this.verificationDate.toISOString() : undefined as any;
        data["notes"] = this.notes;
        data["auditNotes"] = this.auditNotes;
        data["deliveryComplete"] = this.deliveryComplete;
        data["noDropReasonID"] = this.noDropReasonID;
        data["noDropNotes"] = this.noDropNotes;
        data["deleted"] = this.deleted;
        data["turnedOn"] = this.turnedOn;
        data["fuelServiceActive"] = this.fuelServiceActive;
        data["zone1TempRangeID"] = this.zone1TempRangeID;
        data["zone2TempRangeID"] = this.zone2TempRangeID;
        data["zone3TempRangeID"] = this.zone3TempRangeID;
        data["fuelBurnRateDays"] = this.fuelBurnRateDays;
        data["fuelBurnRateHours"] = this.fuelBurnRateHours;
        data["fuelOut"] = this.fuelOut;
        data["fuelIn"] = this.fuelIn;
        data["fuelSchedule"] = this.fuelSchedule;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdUser"] = this.createdUser;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["lastModifiedUser"] = this.lastModifiedUser;
        data["noDropDate"] = this.noDropDate ? this.noDropDate.toISOString() : undefined as any;
        data["anticipatedRemovalDate"] = this.anticipatedRemovalDate ? this.anticipatedRemovalDate.toISOString() : undefined as any;
        data["notMaintained"] = this.notMaintained;
        data["unitValue"] = this.unitValue;
        data["requestStairs"] = this.requestStairs;
        data["mileageIn"] = this.mileageIn;
        data["mileageOut"] = this.mileageOut;
        data["noPickup"] = this.noPickup;
        data["associatedAssetID"] = this.associatedAssetID;
        data["accessoryType"] = this.accessoryType;
        data["monthlyBillRate"] = this.monthlyBillRate;
        data["modDeclined"] = this.modDeclined;
        data["modName"] = this.modName;
        data["requestReminderSent"] = this.requestReminderSent ? this.requestReminderSent.toISOString() : undefined as any;
        data["noiseOrdinance"] = this.noiseOrdinance;
        data["endOfLife"] = this.endOfLife;
        data["expectedTurnOnDate"] = this.expectedTurnOnDate ? this.expectedTurnOnDate.toISOString() : undefined as any;
        data["requestRamps"] = this.requestRamps;
        data["requestLiftGate"] = this.requestLiftGate;
        data["lastTelematicsReceived"] = this.lastTelematicsReceived ? this.lastTelematicsReceived.toISOString() : undefined as any;
        data["unitModeDetail"] = this.unitModeDetail;
        data["zone1SetPoint"] = this.zone1SetPoint;
        data["zone2SetPoint"] = this.zone2SetPoint;
        data["zone3SetPoint"] = this.zone3SetPoint;
        data["operatingMode1"] = this.operatingMode1;
        data["operatingMode2"] = this.operatingMode2;
        data["operatingMode3"] = this.operatingMode3;
        data["zone1DischargeAir"] = this.zone1DischargeAir;
        data["zone1ReturnAir"] = this.zone1ReturnAir;
        data["zone2DischargeAir"] = this.zone2DischargeAir;
        data["zone2ReturnAir"] = this.zone2ReturnAir;
        data["zone3DischargeAir"] = this.zone3DischargeAir;
        data["zone3ReturnAir"] = this.zone3ReturnAir;
        data["isTelematicsOn"] = this.isTelematicsOn;
        data["rescheduledDeliveryDate"] = this.rescheduledDeliveryDate ? this.rescheduledDeliveryDate.toISOString() : undefined as any;
        data["lastTelemetryRefuelDate"] = this.lastTelemetryRefuelDate ? this.lastTelemetryRefuelDate.toISOString() : undefined as any;
        data["invoiceDelivery"] = this.invoiceDelivery;
        data["invoicePickup"] = this.invoicePickup;
        data["invoiceRentalRuntime"] = this.invoiceRentalRuntime;
        data["deliveryInvoiceNumber"] = this.deliveryInvoiceNumber;
        data["pickupInvoiceNumber"] = this.pickupInvoiceNumber;
        if (Array.isArray(this.activeAlarms)) {
            data["activeAlarms"] = [];
            for (let item of this.activeAlarms)
                data["activeAlarms"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assetExceptions)) {
            data["assetExceptions"] = [];
            for (let item of this.assetExceptions)
                data["assetExceptions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.onPeriods)) {
            data["onPeriods"] = [];
            for (let item of this.onPeriods)
                data["onPeriods"].push(item ? item.toJSON() : undefined as any);
        }
        data["usageSummary"] = this.usageSummary ? this.usageSummary.toJSON() : undefined as any;
        if (Array.isArray(this.charges)) {
            data["charges"] = [];
            for (let item of this.charges)
                data["charges"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.loads)) {
            data["loads"] = [];
            for (let item of this.loads)
                data["loads"].push(item ? item.toJSON() : undefined as any);
        }
        data["financials"] = this.financials ? this.financials.toJSON() : undefined as any;
        if (Array.isArray(this.customerRates)) {
            data["customerRates"] = [];
            for (let item of this.customerRates)
                data["customerRates"].push(item ? item.toJSON() : undefined as any);
        }
        data["customerRentalRate"] = this.customerRentalRate ? this.customerRentalRate.toJSON() : undefined as any;
        data["noDropReason"] = this.noDropReason ? this.noDropReason.toJSON() : undefined as any;
        return data;
    }
}

export interface IAssetDto {
    showPanel?: boolean;
    associatedAssetName?: string | undefined;
    loadingRentalRates?: boolean;
    providerDeliveryEstimate?: number | undefined;
    providerPickupEstimate?: number | undefined;
    isVerifiedTrailerNumber?: boolean | undefined;
    fuelReading?: number | undefined;
    isDoorOperational?: boolean | undefined;
    isBulkheadCorrect?: boolean | undefined;
    verifiedBy?: string | undefined;
    verifiedOn?: Date | undefined;
    hasInvoice?: boolean;
    assetID?: number;
    orderID?: number;
    orderCustomerID?: string | undefined;
    orderLocationState?: string | undefined;
    orderLocationIANAZoneName?: string | undefined;
    orderHasPrimaryContact?: boolean;
    isAssetReadonly?: boolean;
    orderRequestReceived?: Date | undefined;
    lateReason?: string | undefined;
    legacyAssetID?: string | undefined;
    trailerNumber?: string | undefined;
    trailerNumberOverrideNote?: string | undefined;
    status?: string | undefined;
    assetType?: string | undefined;
    temperatureType?: string | undefined;
    doorType?: string | undefined;
    requestDoorType?: string | undefined;
    powerType?: string | undefined;
    refrigeratorType?: string | undefined;
    poLineItem?: number | undefined;
    providerID?: string | undefined;
    providerName?: string | undefined;
    providerOrganizationID?: number | undefined;
    providerMileage?: number | undefined;
    size?: number | undefined;
    sizeNote?: string | undefined;
    tankSize?: number | undefined;
    monitoredTankCategory?: string | undefined;
    telemetryProvider?: string | undefined;
    telemetryVendorDeviceId?: string | undefined;
    telemetryMinimumFuelPercent?: number | undefined;
    telemetryActive?: boolean;
    voltage?: number | undefined;
    engineHoursIn?: number | undefined;
    engineHoursOut?: number | undefined;
    noDrop?: boolean;
    rentalCostDaily?: number | undefined;
    rentalCostWeekly?: number | undefined;
    rentalCostMonthly?: number | undefined;
    hourlyRuntimeRate?: number | undefined;
    mileageCost?: number | undefined;
    deliveryDriverType?: string | undefined;
    deliveryRequiredDate?: Date | undefined;
    deliveryScheduledDate?: Date | undefined;
    deliveryActualDate?: Date | undefined;
    deliveryMiles?: number | undefined;
    deliveryQuote?: number | undefined;
    deliveryCost?: number | undefined;
    deliveryEmergency?: boolean;
    pickupDriverType?: string | undefined;
    pickupScheduledDate?: Date | undefined;
    pickupActualDate?: Date | undefined;
    pickupBillingEnd?: Date | undefined;
    pickupContractedRemoval?: Date | undefined;
    pickupRequestedRemoval?: Date | undefined;
    pickupMiles?: number | undefined;
    pickupQuote?: number | undefined;
    pickupCost?: number | undefined;
    pickupEmergency?: boolean;
    verificationDate?: Date | undefined;
    notes?: string | undefined;
    auditNotes?: string | undefined;
    deliveryComplete?: boolean;
    noDropReasonID?: number | undefined;
    noDropNotes?: string | undefined;
    deleted?: boolean;
    turnedOn?: boolean;
    fuelServiceActive?: boolean;
    zone1TempRangeID?: number | undefined;
    zone2TempRangeID?: number | undefined;
    zone3TempRangeID?: number | undefined;
    fuelBurnRateDays?: number | undefined;
    fuelBurnRateHours?: number | undefined;
    fuelOut?: number | undefined;
    fuelIn?: number | undefined;
    fuelSchedule?: FuelDeliveryDaysEnum;
    createdDate?: Date;
    createdUser?: string | undefined;
    lastModifiedDate?: Date;
    lastModifiedUser?: string | undefined;
    noDropDate?: Date | undefined;
    anticipatedRemovalDate?: Date | undefined;
    notMaintained?: boolean | undefined;
    unitValue?: number | undefined;
    requestStairs?: boolean;
    mileageIn?: number | undefined;
    mileageOut?: number | undefined;
    noPickup?: boolean;
    associatedAssetID?: number | undefined;
    accessoryType?: string | undefined;
    monthlyBillRate?: number | undefined;
    modDeclined?: boolean;
    modName?: string | undefined;
    requestReminderSent?: Date | undefined;
    noiseOrdinance?: string | undefined;
    endOfLife?: string | undefined;
    expectedTurnOnDate?: Date | undefined;
    requestRamps?: boolean;
    requestLiftGate?: boolean;
    lastTelematicsReceived?: Date | undefined;
    unitModeDetail?: string | undefined;
    zone1SetPoint?: number | undefined;
    zone2SetPoint?: number | undefined;
    zone3SetPoint?: number | undefined;
    operatingMode1?: string | undefined;
    operatingMode2?: string | undefined;
    operatingMode3?: string | undefined;
    zone1DischargeAir?: number | undefined;
    zone1ReturnAir?: number | undefined;
    zone2DischargeAir?: number | undefined;
    zone2ReturnAir?: number | undefined;
    zone3DischargeAir?: number | undefined;
    zone3ReturnAir?: number | undefined;
    isTelematicsOn?: boolean;
    rescheduledDeliveryDate?: Date | undefined;
    lastTelemetryRefuelDate?: Date | undefined;
    invoiceDelivery?: boolean | undefined;
    invoicePickup?: boolean | undefined;
    invoiceRentalRuntime?: boolean | undefined;
    deliveryInvoiceNumber?: string | undefined;
    pickupInvoiceNumber?: string | undefined;
    activeAlarms?: AssetActiveAlarmDto[] | undefined;
    assetExceptions?: AssetExceptionDto[] | undefined;
    onPeriods?: AssetOnPeriodDto[] | undefined;
    usageSummary?: AssetUsageSummaryDTO | undefined;
    charges?: AssetChargeDTO[] | undefined;
    loads?: AssetLoadDto[] | undefined;
    financials?: V_OrderAssetsCostWithRevenue | undefined;
    customerRates?: CustomerRate[] | undefined;
    customerRentalRate?: RentalRate | undefined;
    noDropReason?: NoDropReason | undefined;
}

export class AssetActiveAlarmDto implements IAssetActiveAlarmDto {
    assetActiveAlarmID?: number;
    assetID?: number;
    alarmCode?: number;
    alarmDate?: Date;
    alarmDescription?: string | undefined;
    alarmSeverity?: string | undefined;
    alarmZone?: number | undefined;
    alarmRecommendation?: string | undefined;

    constructor(data?: IAssetActiveAlarmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetActiveAlarmID = _data["assetActiveAlarmID"];
            this.assetID = _data["assetID"];
            this.alarmCode = _data["alarmCode"];
            this.alarmDate = _data["alarmDate"] ? new Date(_data["alarmDate"].toString()) : undefined as any;
            this.alarmDescription = _data["alarmDescription"];
            this.alarmSeverity = _data["alarmSeverity"];
            this.alarmZone = _data["alarmZone"];
            this.alarmRecommendation = _data["alarmRecommendation"];
        }
    }

    static fromJS(data: any): AssetActiveAlarmDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetActiveAlarmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetActiveAlarmID"] = this.assetActiveAlarmID;
        data["assetID"] = this.assetID;
        data["alarmCode"] = this.alarmCode;
        data["alarmDate"] = this.alarmDate ? this.alarmDate.toISOString() : undefined as any;
        data["alarmDescription"] = this.alarmDescription;
        data["alarmSeverity"] = this.alarmSeverity;
        data["alarmZone"] = this.alarmZone;
        data["alarmRecommendation"] = this.alarmRecommendation;
        return data;
    }
}

export interface IAssetActiveAlarmDto {
    assetActiveAlarmID?: number;
    assetID?: number;
    alarmCode?: number;
    alarmDate?: Date;
    alarmDescription?: string | undefined;
    alarmSeverity?: string | undefined;
    alarmZone?: number | undefined;
    alarmRecommendation?: string | undefined;
}

export class AssetExceptionDto implements IAssetExceptionDto {
    assetExceptionID?: number;
    assetID?: number;
    exception?: string | undefined;
    friendlyName?: string | undefined;

    constructor(data?: IAssetExceptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetExceptionID = _data["assetExceptionID"];
            this.assetID = _data["assetID"];
            this.exception = _data["exception"];
            this.friendlyName = _data["friendlyName"];
        }
    }

    static fromJS(data: any): AssetExceptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetExceptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetExceptionID"] = this.assetExceptionID;
        data["assetID"] = this.assetID;
        data["exception"] = this.exception;
        data["friendlyName"] = this.friendlyName;
        return data;
    }
}

export interface IAssetExceptionDto {
    assetExceptionID?: number;
    assetID?: number;
    exception?: string | undefined;
    friendlyName?: string | undefined;
}

export class AssetOnPeriodDto implements IAssetOnPeriodDto {
    onPeriodID?: number;
    assetID?: number;
    beginDate?: Date;
    endDate?: Date | undefined;
    durationHours?: number;

    constructor(data?: IAssetOnPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onPeriodID = _data["onPeriodID"];
            this.assetID = _data["assetID"];
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.durationHours = _data["durationHours"];
        }
    }

    static fromJS(data: any): AssetOnPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetOnPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onPeriodID"] = this.onPeriodID;
        data["assetID"] = this.assetID;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["durationHours"] = this.durationHours;
        return data;
    }
}

export interface IAssetOnPeriodDto {
    onPeriodID?: number;
    assetID?: number;
    beginDate?: Date;
    endDate?: Date | undefined;
    durationHours?: number;
}

export class AssetUsageSummaryDTO implements IAssetUsageSummaryDTO {
    assetID?: number;
    fuelings?: number | undefined;
    averageGallons?: number | undefined;
    averageRate?: number | undefined;
    totalGallons?: number | undefined;
    totalFuelBilled?: number | undefined;
    totalDelivery?: number | undefined;
    totalOther?: number | undefined;
    totalBilled?: number | undefined;
    onDurationHours?: number | undefined;

    constructor(data?: IAssetUsageSummaryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetID = _data["assetID"];
            this.fuelings = _data["fuelings"];
            this.averageGallons = _data["averageGallons"];
            this.averageRate = _data["averageRate"];
            this.totalGallons = _data["totalGallons"];
            this.totalFuelBilled = _data["totalFuelBilled"];
            this.totalDelivery = _data["totalDelivery"];
            this.totalOther = _data["totalOther"];
            this.totalBilled = _data["totalBilled"];
            this.onDurationHours = _data["onDurationHours"];
        }
    }

    static fromJS(data: any): AssetUsageSummaryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssetUsageSummaryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetID"] = this.assetID;
        data["fuelings"] = this.fuelings;
        data["averageGallons"] = this.averageGallons;
        data["averageRate"] = this.averageRate;
        data["totalGallons"] = this.totalGallons;
        data["totalFuelBilled"] = this.totalFuelBilled;
        data["totalDelivery"] = this.totalDelivery;
        data["totalOther"] = this.totalOther;
        data["totalBilled"] = this.totalBilled;
        data["onDurationHours"] = this.onDurationHours;
        return data;
    }
}

export interface IAssetUsageSummaryDTO {
    assetID?: number;
    fuelings?: number | undefined;
    averageGallons?: number | undefined;
    averageRate?: number | undefined;
    totalGallons?: number | undefined;
    totalFuelBilled?: number | undefined;
    totalDelivery?: number | undefined;
    totalOther?: number | undefined;
    totalBilled?: number | undefined;
    onDurationHours?: number | undefined;
}

export class AssetChargeDTO implements IAssetChargeDTO {
    assetChargeID?: number;
    assetID?: number;
    orderID?: number;
    itemTypeID?: number;
    itemTypeDescription?: string | undefined;
    chargeDate?: Date;
    amount?: number;
    note?: string | undefined;
    invoiceItemID?: number | undefined;
    providerID?: string | undefined;
    providerName?: string | undefined;

    constructor(data?: IAssetChargeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetChargeID = _data["assetChargeID"];
            this.assetID = _data["assetID"];
            this.orderID = _data["orderID"];
            this.itemTypeID = _data["itemTypeID"];
            this.itemTypeDescription = _data["itemTypeDescription"];
            this.chargeDate = _data["chargeDate"] ? new Date(_data["chargeDate"].toString()) : undefined as any;
            this.amount = _data["amount"];
            this.note = _data["note"];
            this.invoiceItemID = _data["invoiceItemID"];
            this.providerID = _data["providerID"];
            this.providerName = _data["providerName"];
        }
    }

    static fromJS(data: any): AssetChargeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssetChargeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetChargeID"] = this.assetChargeID;
        data["assetID"] = this.assetID;
        data["orderID"] = this.orderID;
        data["itemTypeID"] = this.itemTypeID;
        data["itemTypeDescription"] = this.itemTypeDescription;
        data["chargeDate"] = this.chargeDate ? this.chargeDate.toISOString() : undefined as any;
        data["amount"] = this.amount;
        data["note"] = this.note;
        data["invoiceItemID"] = this.invoiceItemID;
        data["providerID"] = this.providerID;
        data["providerName"] = this.providerName;
        return data;
    }
}

export interface IAssetChargeDTO {
    assetChargeID?: number;
    assetID?: number;
    orderID?: number;
    itemTypeID?: number;
    itemTypeDescription?: string | undefined;
    chargeDate?: Date;
    amount?: number;
    note?: string | undefined;
    invoiceItemID?: number | undefined;
    providerID?: string | undefined;
    providerName?: string | undefined;
}

export class AssetLoadDto implements IAssetLoadDto {
    assetLoadID?: number;
    assetID?: number;
    statusNowID?: number;
    loadType?: string | undefined;
    status?: string | undefined;
    loadCost?: number | undefined;
    carrierName?: string | undefined;
    createdDate?: Date;
    createdUser?: string | undefined;
    estimatedDeliveryDate?: Date | undefined;
    estimatedPickupDate?: Date | undefined;
    invoicedDate?: Date | undefined;
    cosmosInvoiceId?: string | undefined;

    constructor(data?: IAssetLoadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetLoadID = _data["assetLoadID"];
            this.assetID = _data["assetID"];
            this.statusNowID = _data["statusNowID"];
            this.loadType = _data["loadType"];
            this.status = _data["status"];
            this.loadCost = _data["loadCost"];
            this.carrierName = _data["carrierName"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.estimatedDeliveryDate = _data["estimatedDeliveryDate"] ? new Date(_data["estimatedDeliveryDate"].toString()) : undefined as any;
            this.estimatedPickupDate = _data["estimatedPickupDate"] ? new Date(_data["estimatedPickupDate"].toString()) : undefined as any;
            this.invoicedDate = _data["invoicedDate"] ? new Date(_data["invoicedDate"].toString()) : undefined as any;
            this.cosmosInvoiceId = _data["cosmosInvoiceId"];
        }
    }

    static fromJS(data: any): AssetLoadDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetLoadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetLoadID"] = this.assetLoadID;
        data["assetID"] = this.assetID;
        data["statusNowID"] = this.statusNowID;
        data["loadType"] = this.loadType;
        data["status"] = this.status;
        data["loadCost"] = this.loadCost;
        data["carrierName"] = this.carrierName;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdUser"] = this.createdUser;
        data["estimatedDeliveryDate"] = this.estimatedDeliveryDate ? this.estimatedDeliveryDate.toISOString() : undefined as any;
        data["estimatedPickupDate"] = this.estimatedPickupDate ? this.estimatedPickupDate.toISOString() : undefined as any;
        data["invoicedDate"] = this.invoicedDate ? this.invoicedDate.toISOString() : undefined as any;
        data["cosmosInvoiceId"] = this.cosmosInvoiceId;
        return data;
    }
}

export interface IAssetLoadDto {
    assetLoadID?: number;
    assetID?: number;
    statusNowID?: number;
    loadType?: string | undefined;
    status?: string | undefined;
    loadCost?: number | undefined;
    carrierName?: string | undefined;
    createdDate?: Date;
    createdUser?: string | undefined;
    estimatedDeliveryDate?: Date | undefined;
    estimatedPickupDate?: Date | undefined;
    invoicedDate?: Date | undefined;
    cosmosInvoiceId?: string | undefined;
}

export class V_OrderAssetsCostWithRevenue implements IV_OrderAssetsCostWithRevenue {
    assetID?: number;
    orderID?: number;
    emergencyAmount?: number | undefined;
    deliveryAmount?: number | undefined;
    pickupAmount?: number | undefined;
    rentalAmount?: number | undefined;
    runtimeAmount?: number | undefined;
    fuelAmount?: number | undefined;
    serviceAmount?: number | undefined;
    fuelBilledAmount?: number | undefined;
    serviceBilledAmount?: number | undefined;
    deliveryBilledAmount?: number | undefined;
    pickupBilledAmount?: number | undefined;
    rentalBilledAmount?: number | undefined;
    runtimeBilledAmount?: number | undefined;
    totalInvoiced?: number | undefined;
    totalBilled?: number | undefined;

    constructor(data?: IV_OrderAssetsCostWithRevenue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetID = _data["assetID"];
            this.orderID = _data["orderID"];
            this.emergencyAmount = _data["emergencyAmount"];
            this.deliveryAmount = _data["deliveryAmount"];
            this.pickupAmount = _data["pickupAmount"];
            this.rentalAmount = _data["rentalAmount"];
            this.runtimeAmount = _data["runtimeAmount"];
            this.fuelAmount = _data["fuelAmount"];
            this.serviceAmount = _data["serviceAmount"];
            this.fuelBilledAmount = _data["fuelBilledAmount"];
            this.serviceBilledAmount = _data["serviceBilledAmount"];
            this.deliveryBilledAmount = _data["deliveryBilledAmount"];
            this.pickupBilledAmount = _data["pickupBilledAmount"];
            this.rentalBilledAmount = _data["rentalBilledAmount"];
            this.runtimeBilledAmount = _data["runtimeBilledAmount"];
            this.totalInvoiced = _data["totalInvoiced"];
            this.totalBilled = _data["totalBilled"];
        }
    }

    static fromJS(data: any): V_OrderAssetsCostWithRevenue {
        data = typeof data === 'object' ? data : {};
        let result = new V_OrderAssetsCostWithRevenue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetID"] = this.assetID;
        data["orderID"] = this.orderID;
        data["emergencyAmount"] = this.emergencyAmount;
        data["deliveryAmount"] = this.deliveryAmount;
        data["pickupAmount"] = this.pickupAmount;
        data["rentalAmount"] = this.rentalAmount;
        data["runtimeAmount"] = this.runtimeAmount;
        data["fuelAmount"] = this.fuelAmount;
        data["serviceAmount"] = this.serviceAmount;
        data["fuelBilledAmount"] = this.fuelBilledAmount;
        data["serviceBilledAmount"] = this.serviceBilledAmount;
        data["deliveryBilledAmount"] = this.deliveryBilledAmount;
        data["pickupBilledAmount"] = this.pickupBilledAmount;
        data["rentalBilledAmount"] = this.rentalBilledAmount;
        data["runtimeBilledAmount"] = this.runtimeBilledAmount;
        data["totalInvoiced"] = this.totalInvoiced;
        data["totalBilled"] = this.totalBilled;
        return data;
    }
}

export interface IV_OrderAssetsCostWithRevenue {
    assetID?: number;
    orderID?: number;
    emergencyAmount?: number | undefined;
    deliveryAmount?: number | undefined;
    pickupAmount?: number | undefined;
    rentalAmount?: number | undefined;
    runtimeAmount?: number | undefined;
    fuelAmount?: number | undefined;
    serviceAmount?: number | undefined;
    fuelBilledAmount?: number | undefined;
    serviceBilledAmount?: number | undefined;
    deliveryBilledAmount?: number | undefined;
    pickupBilledAmount?: number | undefined;
    rentalBilledAmount?: number | undefined;
    runtimeBilledAmount?: number | undefined;
    totalInvoiced?: number | undefined;
    totalBilled?: number | undefined;
}

export class CustomerRate implements ICustomerRate {
    customerRateID?: number;
    customerID!: string;
    service?: string | undefined;
    assetType?: string | undefined;
    size?: string | undefined;
    power?: string | undefined;
    temp?: string | undefined;
    minMiles?: number | undefined;
    maxMiles?: number | undefined;
    rateTypeID?: number;
    state?: string | undefined;
    rate?: number;
    effectiveDate?: Date;
    termDate?: Date;
    createdDate?: Date;
    createdUser!: string;
    lastModifiedDate?: Date;
    lastModifiedUser!: string;
    rateType?: RateType | undefined;
    hasLiftGate?: boolean;

    constructor(data?: ICustomerRate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerRateID = _data["customerRateID"];
            this.customerID = _data["customerID"];
            this.service = _data["service"];
            this.assetType = _data["assetType"];
            this.size = _data["size"];
            this.power = _data["power"];
            this.temp = _data["temp"];
            this.minMiles = _data["minMiles"];
            this.maxMiles = _data["maxMiles"];
            this.rateTypeID = _data["rateTypeID"];
            this.state = _data["state"];
            this.rate = _data["rate"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : undefined as any;
            this.termDate = _data["termDate"] ? new Date(_data["termDate"].toString()) : undefined as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.lastModifiedUser = _data["lastModifiedUser"];
            this.rateType = _data["rateType"] ? RateType.fromJS(_data["rateType"]) : undefined as any;
            this.hasLiftGate = _data["hasLiftGate"];
        }
    }

    static fromJS(data: any): CustomerRate {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerRate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerRateID"] = this.customerRateID;
        data["customerID"] = this.customerID;
        data["service"] = this.service;
        data["assetType"] = this.assetType;
        data["size"] = this.size;
        data["power"] = this.power;
        data["temp"] = this.temp;
        data["minMiles"] = this.minMiles;
        data["maxMiles"] = this.maxMiles;
        data["rateTypeID"] = this.rateTypeID;
        data["state"] = this.state;
        data["rate"] = this.rate;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : undefined as any;
        data["termDate"] = this.termDate ? this.termDate.toISOString() : undefined as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdUser"] = this.createdUser;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["lastModifiedUser"] = this.lastModifiedUser;
        data["rateType"] = this.rateType ? this.rateType.toJSON() : undefined as any;
        data["hasLiftGate"] = this.hasLiftGate;
        return data;
    }
}

export interface ICustomerRate {
    customerRateID?: number;
    customerID: string;
    service?: string | undefined;
    assetType?: string | undefined;
    size?: string | undefined;
    power?: string | undefined;
    temp?: string | undefined;
    minMiles?: number | undefined;
    maxMiles?: number | undefined;
    rateTypeID?: number;
    state?: string | undefined;
    rate?: number;
    effectiveDate?: Date;
    termDate?: Date;
    createdDate?: Date;
    createdUser: string;
    lastModifiedDate?: Date;
    lastModifiedUser: string;
    rateType?: RateType | undefined;
    hasLiftGate?: boolean;
}

export class RateType implements IRateType {
    rateTypeID?: number;
    description?: string | undefined;

    constructor(data?: IRateType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rateTypeID = _data["rateTypeID"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): RateType {
        data = typeof data === 'object' ? data : {};
        let result = new RateType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rateTypeID"] = this.rateTypeID;
        data["description"] = this.description;
        return data;
    }
}

export interface IRateType {
    rateTypeID?: number;
    description?: string | undefined;
}

export class RentalRate implements IRentalRate {
    customerID?: string | undefined;
    service?: string | undefined;
    assetType?: string | undefined;
    size?: string | undefined;
    power?: string | undefined;
    temp?: string | undefined;
    hasLiftGate?: boolean;
    daily?: number | undefined;
    weekly?: number | undefined;
    monthly?: number | undefined;
    effectiveDate?: Date;
    termDate?: Date;

    constructor(data?: IRentalRate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerID = _data["customerID"];
            this.service = _data["service"];
            this.assetType = _data["assetType"];
            this.size = _data["size"];
            this.power = _data["power"];
            this.temp = _data["temp"];
            this.hasLiftGate = _data["hasLiftGate"];
            this.daily = _data["daily"];
            this.weekly = _data["weekly"];
            this.monthly = _data["monthly"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : undefined as any;
            this.termDate = _data["termDate"] ? new Date(_data["termDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RentalRate {
        data = typeof data === 'object' ? data : {};
        let result = new RentalRate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerID"] = this.customerID;
        data["service"] = this.service;
        data["assetType"] = this.assetType;
        data["size"] = this.size;
        data["power"] = this.power;
        data["temp"] = this.temp;
        data["hasLiftGate"] = this.hasLiftGate;
        data["daily"] = this.daily;
        data["weekly"] = this.weekly;
        data["monthly"] = this.monthly;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : undefined as any;
        data["termDate"] = this.termDate ? this.termDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IRentalRate {
    customerID?: string | undefined;
    service?: string | undefined;
    assetType?: string | undefined;
    size?: string | undefined;
    power?: string | undefined;
    temp?: string | undefined;
    hasLiftGate?: boolean;
    daily?: number | undefined;
    weekly?: number | undefined;
    monthly?: number | undefined;
    effectiveDate?: Date;
    termDate?: Date;
}

export class AssetNoDropDto implements IAssetNoDropDto {
    isModDecline?: boolean;
    modName?: string | undefined;
    noDrop?: boolean;
    noDropReasonId?: number;
    noDropNotes?: string | undefined;
    lastModifiedDate?: Date | undefined;

    constructor(data?: IAssetNoDropDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isModDecline = _data["isModDecline"];
            this.modName = _data["modName"];
            this.noDrop = _data["noDrop"];
            this.noDropReasonId = _data["noDropReasonId"];
            this.noDropNotes = _data["noDropNotes"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AssetNoDropDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetNoDropDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isModDecline"] = this.isModDecline;
        data["modName"] = this.modName;
        data["noDrop"] = this.noDrop;
        data["noDropReasonId"] = this.noDropReasonId;
        data["noDropNotes"] = this.noDropNotes;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IAssetNoDropDto {
    isModDecline?: boolean;
    modName?: string | undefined;
    noDrop?: boolean;
    noDropReasonId?: number;
    noDropNotes?: string | undefined;
    lastModifiedDate?: Date | undefined;
}

export class AssetRequestRemovalDto implements IAssetRequestRemovalDto {
    assetIDList?: number[] | undefined;
    pickupRequestedRemoval?: Date;
    assetTimestamps?: { [key: string]: Date; } | undefined;

    constructor(data?: IAssetRequestRemovalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assetIDList"])) {
                this.assetIDList = [] as any;
                for (let item of _data["assetIDList"])
                    this.assetIDList!.push(item);
            }
            this.pickupRequestedRemoval = _data["pickupRequestedRemoval"] ? new Date(_data["pickupRequestedRemoval"].toString()) : undefined as any;
            if (_data["assetTimestamps"]) {
                this.assetTimestamps = {} as any;
                for (let key in _data["assetTimestamps"]) {
                    if (_data["assetTimestamps"].hasOwnProperty(key))
                        (this.assetTimestamps as any)![key] = _data["assetTimestamps"][key] ? new Date(_data["assetTimestamps"][key].toString()) : undefined as any;
                }
            }
        }
    }

    static fromJS(data: any): AssetRequestRemovalDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetRequestRemovalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assetIDList)) {
            data["assetIDList"] = [];
            for (let item of this.assetIDList)
                data["assetIDList"].push(item);
        }
        data["pickupRequestedRemoval"] = this.pickupRequestedRemoval ? this.pickupRequestedRemoval.toISOString() : undefined as any;
        if (this.assetTimestamps) {
            data["assetTimestamps"] = {};
            for (let key in this.assetTimestamps) {
                if (this.assetTimestamps.hasOwnProperty(key))
                    (data["assetTimestamps"] as any)[key] = this.assetTimestamps[key] ? this.assetTimestamps[key].toISOString() : undefined as any;
            }
        }
        return data;
    }
}

export interface IAssetRequestRemovalDto {
    assetIDList?: number[] | undefined;
    pickupRequestedRemoval?: Date;
    assetTimestamps?: { [key: string]: Date; } | undefined;
}

export class AssetBulkProviderUpdateDto implements IAssetBulkProviderUpdateDto {
    assetIDList?: number[] | undefined;
    providerID?: string | undefined;
    assetTimestamps?: { [key: string]: Date; } | undefined;

    constructor(data?: IAssetBulkProviderUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assetIDList"])) {
                this.assetIDList = [] as any;
                for (let item of _data["assetIDList"])
                    this.assetIDList!.push(item);
            }
            this.providerID = _data["providerID"];
            if (_data["assetTimestamps"]) {
                this.assetTimestamps = {} as any;
                for (let key in _data["assetTimestamps"]) {
                    if (_data["assetTimestamps"].hasOwnProperty(key))
                        (this.assetTimestamps as any)![key] = _data["assetTimestamps"][key] ? new Date(_data["assetTimestamps"][key].toString()) : undefined as any;
                }
            }
        }
    }

    static fromJS(data: any): AssetBulkProviderUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetBulkProviderUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assetIDList)) {
            data["assetIDList"] = [];
            for (let item of this.assetIDList)
                data["assetIDList"].push(item);
        }
        data["providerID"] = this.providerID;
        if (this.assetTimestamps) {
            data["assetTimestamps"] = {};
            for (let key in this.assetTimestamps) {
                if (this.assetTimestamps.hasOwnProperty(key))
                    (data["assetTimestamps"] as any)[key] = this.assetTimestamps[key] ? this.assetTimestamps[key].toISOString() : undefined as any;
            }
        }
        return data;
    }
}

export interface IAssetBulkProviderUpdateDto {
    assetIDList?: number[] | undefined;
    providerID?: string | undefined;
    assetTimestamps?: { [key: string]: Date; } | undefined;
}

export class SystemMessage implements ISystemMessage {
    id?: number;
    messageType?: string | undefined;
    message?: string | undefined;
    createdDate?: Date;
    createdUser?: string | undefined;
    lastModifiedDate?: Date;
    lastModifiedUser?: string | undefined;
    isDeleted?: boolean;

    constructor(data?: ISystemMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.messageType = _data["messageType"];
            this.message = _data["message"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : undefined as any;
            this.lastModifiedUser = _data["lastModifiedUser"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): SystemMessage {
        data = typeof data === 'object' ? data : {};
        let result = new SystemMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["messageType"] = this.messageType;
        data["message"] = this.message;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["createdUser"] = this.createdUser;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : undefined as any;
        data["lastModifiedUser"] = this.lastModifiedUser;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface ISystemMessage {
    id?: number;
    messageType?: string | undefined;
    message?: string | undefined;
    createdDate?: Date;
    createdUser?: string | undefined;
    lastModifiedDate?: Date;
    lastModifiedUser?: string | undefined;
    isDeleted?: boolean;
}

export class SeasonalOrderInfo implements ISeasonalOrderInfo {
    message?: string | undefined;
    dateStart?: Date;
    dateEnd?: Date;

    constructor(data?: ISeasonalOrderInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.dateStart = _data["dateStart"] ? new Date(_data["dateStart"].toString()) : undefined as any;
            this.dateEnd = _data["dateEnd"] ? new Date(_data["dateEnd"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SeasonalOrderInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SeasonalOrderInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : undefined as any;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : undefined as any;
        return data;
    }
}

export interface ISeasonalOrderInfo {
    message?: string | undefined;
    dateStart?: Date;
    dateEnd?: Date;
}

export class UserDTO implements IUserDTO {
    username?: string | undefined;
    isSystemAdmin?: boolean;
    isDeveloper?: boolean;
    fname?: string | undefined;
    lname?: string | undefined;
    smsNumber?: string | undefined;
    lastAccessedDate?: Date | undefined;
    createDate?: Date;
    createBy?: string | undefined;
    isDeleted?: boolean;
    roles?: string[] | undefined;
    permissions?: string[] | undefined;
    assignedCustomers?: STMCustomerDTO[] | undefined;

    constructor(data?: IUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.isSystemAdmin = _data["isSystemAdmin"];
            this.isDeveloper = _data["isDeveloper"];
            this.fname = _data["fname"];
            this.lname = _data["lname"];
            this.smsNumber = _data["smsNumber"];
            this.lastAccessedDate = _data["lastAccessedDate"] ? new Date(_data["lastAccessedDate"].toString()) : undefined as any;
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : undefined as any;
            this.createBy = _data["createBy"];
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            if (Array.isArray(_data["assignedCustomers"])) {
                this.assignedCustomers = [] as any;
                for (let item of _data["assignedCustomers"])
                    this.assignedCustomers!.push(STMCustomerDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["isSystemAdmin"] = this.isSystemAdmin;
        data["isDeveloper"] = this.isDeveloper;
        data["fname"] = this.fname;
        data["lname"] = this.lname;
        data["smsNumber"] = this.smsNumber;
        data["lastAccessedDate"] = this.lastAccessedDate ? this.lastAccessedDate.toISOString() : undefined as any;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : undefined as any;
        data["createBy"] = this.createBy;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        if (Array.isArray(this.assignedCustomers)) {
            data["assignedCustomers"] = [];
            for (let item of this.assignedCustomers)
                data["assignedCustomers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserDTO {
    username?: string | undefined;
    isSystemAdmin?: boolean;
    isDeveloper?: boolean;
    fname?: string | undefined;
    lname?: string | undefined;
    smsNumber?: string | undefined;
    lastAccessedDate?: Date | undefined;
    createDate?: Date;
    createBy?: string | undefined;
    isDeleted?: boolean;
    roles?: string[] | undefined;
    permissions?: string[] | undefined;
    assignedCustomers?: STMCustomerDTO[] | undefined;
}

export class UserSetting implements IUserSetting {
    userSettingId?: number;
    username!: string;
    key!: string;
    settings?: string | undefined;

    constructor(data?: IUserSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userSettingId = _data["userSettingId"];
            this.username = _data["username"];
            this.key = _data["key"];
            this.settings = _data["settings"];
        }
    }

    static fromJS(data: any): UserSetting {
        data = typeof data === 'object' ? data : {};
        let result = new UserSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userSettingId"] = this.userSettingId;
        data["username"] = this.username;
        data["key"] = this.key;
        data["settings"] = this.settings;
        return data;
    }
}

export interface IUserSetting {
    userSettingId?: number;
    username: string;
    key: string;
    settings?: string | undefined;
}

export class Auth0UserUpdateResponseDto implements IAuth0UserUpdateResponseDto {
    storeNumber?: string | undefined;
    locID?: number;

    constructor(data?: IAuth0UserUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeNumber = _data["storeNumber"];
            this.locID = _data["locID"];
        }
    }

    static fromJS(data: any): Auth0UserUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new Auth0UserUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeNumber"] = this.storeNumber;
        data["locID"] = this.locID;
        return data;
    }
}

export interface IAuth0UserUpdateResponseDto {
    storeNumber?: string | undefined;
    locID?: number;
}

export class WhatsNewDto implements IWhatsNewDto {
    targetStores?: string[] | undefined;
    id?: string | undefined;
    eTag?: string | undefined;
    title?: string | undefined;
    status?: WhatsNewStatus;
    features?: WhatsNewFeatureDto[] | undefined;
    createdWhen?: Date;
    publishedWhen?: Date | undefined;
    viewedWhen?: Date | undefined;
    dismissedWhen?: Date | undefined;
    deliveryCount?: number | undefined;
    viewedCount?: number | undefined;

    constructor(data?: IWhatsNewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["targetStores"])) {
                this.targetStores = [] as any;
                for (let item of _data["targetStores"])
                    this.targetStores!.push(item);
            }
            this.id = _data["id"];
            this.eTag = _data["eTag"];
            this.title = _data["title"];
            this.status = _data["status"];
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(WhatsNewFeatureDto.fromJS(item));
            }
            this.createdWhen = _data["createdWhen"] ? new Date(_data["createdWhen"].toString()) : undefined as any;
            this.publishedWhen = _data["publishedWhen"] ? new Date(_data["publishedWhen"].toString()) : undefined as any;
            this.viewedWhen = _data["viewedWhen"] ? new Date(_data["viewedWhen"].toString()) : undefined as any;
            this.dismissedWhen = _data["dismissedWhen"] ? new Date(_data["dismissedWhen"].toString()) : undefined as any;
            this.deliveryCount = _data["deliveryCount"];
            this.viewedCount = _data["viewedCount"];
        }
    }

    static fromJS(data: any): WhatsNewDto {
        data = typeof data === 'object' ? data : {};
        let result = new WhatsNewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.targetStores)) {
            data["targetStores"] = [];
            for (let item of this.targetStores)
                data["targetStores"].push(item);
        }
        data["id"] = this.id;
        data["eTag"] = this.eTag;
        data["title"] = this.title;
        data["status"] = this.status;
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item ? item.toJSON() : undefined as any);
        }
        data["createdWhen"] = this.createdWhen ? this.createdWhen.toISOString() : undefined as any;
        data["publishedWhen"] = this.publishedWhen ? this.publishedWhen.toISOString() : undefined as any;
        data["viewedWhen"] = this.viewedWhen ? this.viewedWhen.toISOString() : undefined as any;
        data["dismissedWhen"] = this.dismissedWhen ? this.dismissedWhen.toISOString() : undefined as any;
        data["deliveryCount"] = this.deliveryCount;
        data["viewedCount"] = this.viewedCount;
        return data;
    }
}

export interface IWhatsNewDto {
    targetStores?: string[] | undefined;
    id?: string | undefined;
    eTag?: string | undefined;
    title?: string | undefined;
    status?: WhatsNewStatus;
    features?: WhatsNewFeatureDto[] | undefined;
    createdWhen?: Date;
    publishedWhen?: Date | undefined;
    viewedWhen?: Date | undefined;
    dismissedWhen?: Date | undefined;
    deliveryCount?: number | undefined;
    viewedCount?: number | undefined;
}

export enum WhatsNewStatus {
    Draft = 0,
    Test = 1,
    Published = 2,
}

export class WhatsNewFeatureDto implements IWhatsNewFeatureDto {
    id?: string | undefined;
    title?: string | undefined;
    audience?: WhatsNewAudience;
    isUserRequested?: boolean;
    content?: any;

    constructor(data?: IWhatsNewFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.audience = _data["audience"];
            this.isUserRequested = _data["isUserRequested"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): WhatsNewFeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new WhatsNewFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["audience"] = this.audience;
        data["isUserRequested"] = this.isUserRequested;
        data["content"] = this.content;
        return data;
    }
}

export interface IWhatsNewFeatureDto {
    id?: string | undefined;
    title?: string | undefined;
    audience?: WhatsNewAudience;
    isUserRequested?: boolean;
    content?: any;
}

export enum WhatsNewAudience {
    Internal = 0,
    External = 1,
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; };

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (this.extensions as any)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (data["extensions"] as any)[key] = (this.extensions as any)[key];
            }
        }
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; };

    [key: string]: any;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}